
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2438"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2438"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("45yGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");

var $2fa288efaf06e11e$var$_classnames = $2fa288efaf06e11e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $04wYO = parcelRequire("04wYO");
function $2fa288efaf06e11e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2fa288efaf06e11e$var$alwaysPassThroughProps = [
    "disabled"
];
/**
 * @param {{
 *   tagName?: string
 *   baseClasses?: string
 *   options?: any
 *   style?: any
 *   fn?: any
 *   passThroughProps?: any
 *   defaultProps?: any
 *   renderChildren?: any
 * }} args
 * @returns {import('preact').Component}
 */ var $2fa288efaf06e11e$var$_default = (args)=>{
    const { tagName: tagName = "div", baseClasses: baseClasses = "", options: options = {}, style: style, fn: fn, passThroughProps: passThroughProps = [], defaultProps: defaultProps, renderChildren: renderChildren } = args;
    const defaults = Object.assign({}, defaultProps);
    const propsToRemove = [
        "className",
        "tagName"
    ];
    const allOptionValues = Object.keys(options).reduce((result, key)=>{
        const value = options[key];
        if (typeof value !== "object") {
            defaults[key] = value;
            propsToRemove.push(key);
            result.push(value);
        } else result.push(...value);
        return result;
    }, []);
    propsToRemove.push(...allOptionValues.filter((key)=>!passThroughProps.includes(key) && !$2fa288efaf06e11e$var$alwaysPassThroughProps.includes(key)));
    const componentFn = (incomingProps)=>{
        const props = Object.assign({}, defaults, incomingProps);
        const finalTagName = props.tagName || tagName;
        const passThroughProps = (0, $04wYO.omit)(props, propsToRemove);
        const className = (0, $2fa288efaf06e11e$var$_classnames.default)(baseClasses, fn && fn(props), props.className);
        const combinedStyle = Object.assign({}, style, props.style);
        const renderedChildren = renderChildren ? renderChildren(props) : props.children;
        return (0, $767w7.h)(finalTagName, Object.assign({
            className: className,
            style: combinedStyle
        }, passThroughProps), renderedChildren);
    };
    componentFn.definition = args;
    return componentFn;
};
module.exports.default = $2fa288efaf06e11e$var$_default;

});
parcelRegister("767w7", function(module, exports) {

$parcel$export(module.exports, "options", () => $52aeecae1553ebb1$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $52aeecae1553ebb1$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $52aeecae1553ebb1$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $52aeecae1553ebb1$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $52aeecae1553ebb1$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $52aeecae1553ebb1$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $52aeecae1553ebb1$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $52aeecae1553ebb1$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $52aeecae1553ebb1$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $52aeecae1553ebb1$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "h", () => $52aeecae1553ebb1$export$c8a8987d4410bf2d);
var $52aeecae1553ebb1$export$41c562ebe57d11e2, $52aeecae1553ebb1$export$a8257692ac88316c, $52aeecae1553ebb1$var$u, $52aeecae1553ebb1$var$i, $52aeecae1553ebb1$var$t, $52aeecae1553ebb1$var$o, $52aeecae1553ebb1$var$r = {}, $52aeecae1553ebb1$var$f = [], $52aeecae1553ebb1$var$e = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $52aeecae1553ebb1$var$c(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $52aeecae1553ebb1$var$s(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $52aeecae1553ebb1$export$c8a8987d4410bf2d(n, l, u) {
    var i, t, o, r = arguments, f = {};
    for(o in l)"key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o];
    if (arguments.length > 3) for(u = [
        u
    ], o = 3; o < arguments.length; o++)u.push(r[o]);
    if (null != u && (f.children = u), "function" == typeof n && null != n.defaultProps) for(o in n.defaultProps)void 0 === f[o] && (f[o] = n.defaultProps[o]);
    return $52aeecae1553ebb1$var$v(n, f, i, t, null);
}
function $52aeecae1553ebb1$var$v(l, u, i, t, o) {
    var r = {
        type: l,
        props: u,
        key: i,
        ref: t,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$52aeecae1553ebb1$export$41c562ebe57d11e2.__v : o
    };
    return null != $52aeecae1553ebb1$export$41c562ebe57d11e2.vnode && $52aeecae1553ebb1$export$41c562ebe57d11e2.vnode(r), r;
}
function $52aeecae1553ebb1$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $52aeecae1553ebb1$export$ffb0004e005737fa(n) {
    return n.children;
}
function $52aeecae1553ebb1$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $52aeecae1553ebb1$var$d(n, l) {
    if (null == l) return n.__ ? $52aeecae1553ebb1$var$d(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $52aeecae1553ebb1$var$d(n) : null;
}
function $52aeecae1553ebb1$var$_(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $52aeecae1553ebb1$var$_(n);
    }
}
function $52aeecae1553ebb1$var$k(l) {
    (!l.__d && (l.__d = !0) && $52aeecae1553ebb1$var$u.push(l) && !$52aeecae1553ebb1$var$b.__r++ || $52aeecae1553ebb1$var$t !== $52aeecae1553ebb1$export$41c562ebe57d11e2.debounceRendering) && (($52aeecae1553ebb1$var$t = $52aeecae1553ebb1$export$41c562ebe57d11e2.debounceRendering) || $52aeecae1553ebb1$var$i)($52aeecae1553ebb1$var$b);
}
function $52aeecae1553ebb1$var$b() {
    for(var n; $52aeecae1553ebb1$var$b.__r = $52aeecae1553ebb1$var$u.length;)n = $52aeecae1553ebb1$var$u.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $52aeecae1553ebb1$var$u = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $52aeecae1553ebb1$var$c({}, t)).__v = t.__v + 1, $52aeecae1553ebb1$var$I(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $52aeecae1553ebb1$var$d(t) : o, t.__h), $52aeecae1553ebb1$var$T(u, t), t.__e != o && $52aeecae1553ebb1$var$_(t)));
    });
}
function $52aeecae1553ebb1$var$m(n, l, u, i, t, o, e, c, s, a) {
    var h, p, _, k, b, m, w, A = i && i.__k || $52aeecae1553ebb1$var$f, P = A.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? $52aeecae1553ebb1$var$v(null, k, null, null, k) : Array.isArray(k) ? $52aeecae1553ebb1$var$v($52aeecae1553ebb1$export$ffb0004e005737fa, {
        children: k
    }, null, null, null) : k.__b > 0 ? $52aeecae1553ebb1$var$v(k.type, k.props, k.key, null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (_ = A[h]) || _ && k.key == _.key && k.type === _.type) A[h] = void 0;
        else for(p = 0; p < P; p++){
            if ((_ = A[p]) && k.key == _.key && k.type === _.type) {
                A[p] = void 0;
                break;
            }
            _ = null;
        }
        $52aeecae1553ebb1$var$I(n, k, _ = _ || $52aeecae1553ebb1$var$r, t, o, e, c, s, a), b = k.__e, (p = k.ref) && _.ref != p && (w || (w = []), _.ref && w.push(_.ref, null, k), w.push(p, k.__c || b, k)), null != b ? (null == m && (m = b), "function" == typeof k.type && null != k.__k && k.__k === _.__k ? k.__d = s = $52aeecae1553ebb1$var$g(k, s, n) : s = $52aeecae1553ebb1$var$x(n, k, _, A, b, s), a || "option" !== u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && _.__e == s && s.parentNode != n && (s = $52aeecae1553ebb1$var$d(_));
    }
    for(u.__e = m, h = P; h--;)null != A[h] && ("function" == typeof u.type && null != A[h].__e && A[h].__e == u.__d && (u.__d = $52aeecae1553ebb1$var$d(i, h + 1)), $52aeecae1553ebb1$var$L(A[h], A[h]));
    if (w) for(h = 0; h < w.length; h++)$52aeecae1553ebb1$var$z(w[h], w[++h], w[++h]);
}
function $52aeecae1553ebb1$var$g(n, l, u) {
    var i, t;
    for(i = 0; i < n.__k.length; i++)(t = n.__k[i]) && (t.__ = n, l = "function" == typeof t.type ? $52aeecae1553ebb1$var$g(t, l, u) : $52aeecae1553ebb1$var$x(u, t, t, n.__k, t.__e, l));
    return l;
}
function $52aeecae1553ebb1$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $52aeecae1553ebb1$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $52aeecae1553ebb1$var$x(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $52aeecae1553ebb1$var$A(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $52aeecae1553ebb1$var$C(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $52aeecae1553ebb1$var$C(n, o, l[o], u[o], i);
}
function $52aeecae1553ebb1$var$P(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $52aeecae1553ebb1$var$e.test(l) ? u : u + "px";
}
function $52aeecae1553ebb1$var$C(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $52aeecae1553ebb1$var$P(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $52aeecae1553ebb1$var$P(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $52aeecae1553ebb1$var$H : $52aeecae1553ebb1$var$$, o) : n.removeEventListener(l, o ? $52aeecae1553ebb1$var$H : $52aeecae1553ebb1$var$$, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $52aeecae1553ebb1$var$$(l) {
    this.l[l.type + !1]($52aeecae1553ebb1$export$41c562ebe57d11e2.event ? $52aeecae1553ebb1$export$41c562ebe57d11e2.event(l) : l);
}
function $52aeecae1553ebb1$var$H(l) {
    this.l[l.type + !0]($52aeecae1553ebb1$export$41c562ebe57d11e2.event ? $52aeecae1553ebb1$export$41c562ebe57d11e2.event(l) : l);
}
function $52aeecae1553ebb1$var$I(l, u, i, t, o, r, f, e, s) {
    var a, v, h, d, _, k, b, g, w, x, A, P = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (s = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (a = $52aeecae1553ebb1$export$41c562ebe57d11e2.__b) && a(u);
    try {
        n: if ("function" == typeof P) {
            if (g = u.props, w = (a = P.contextType) && t[a.__c], x = a ? w ? w.props.value : a.__ : t, i.__c ? b = (v = u.__c = i.__c).__ = v.__E : ("prototype" in P && P.prototype.render ? u.__c = v = new P(g, x) : (u.__c = v = new $52aeecae1553ebb1$export$16fa2f45be04daa8(g, x), v.constructor = P, v.render = $52aeecae1553ebb1$var$M), w && w.sub(v), v.props = g, v.state || (v.state = {}), v.context = x, v.__n = t, h = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != P.getDerivedStateFromProps && (v.__s == v.state && (v.__s = $52aeecae1553ebb1$var$c({}, v.__s)), $52aeecae1553ebb1$var$c(v.__s, P.getDerivedStateFromProps(g, v.__s))), d = v.props, _ = v.state, h) null == P.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && v.__h.push(v.componentDidMount);
            else {
                if (null == P.getDerivedStateFromProps && g !== d && null != v.componentWillReceiveProps && v.componentWillReceiveProps(g, x), !v.__e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(g, v.__s, x) || u.__v === i.__v) {
                    v.props = g, v.state = v.__s, u.__v !== i.__v && (v.__d = !1), v.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), v.__h.length && f.push(v);
                    break n;
                }
                null != v.componentWillUpdate && v.componentWillUpdate(g, v.__s, x), null != v.componentDidUpdate && v.__h.push(function() {
                    v.componentDidUpdate(d, _, k);
                });
            }
            v.context = x, v.props = g, v.state = v.__s, (a = $52aeecae1553ebb1$export$41c562ebe57d11e2.__r) && a(u), v.__d = !1, v.__v = u, v.__P = l, a = v.render(v.props, v.state, v.context), v.state = v.__s, null != v.getChildContext && (t = $52aeecae1553ebb1$var$c($52aeecae1553ebb1$var$c({}, t), v.getChildContext())), h || null == v.getSnapshotBeforeUpdate || (k = v.getSnapshotBeforeUpdate(d, _)), A = null != a && a.type === $52aeecae1553ebb1$export$ffb0004e005737fa && null == a.key ? a.props.children : a, $52aeecae1553ebb1$var$m(l, Array.isArray(A) ? A : [
                A
            ], u, i, t, o, r, f, e, s), v.base = u.__e, u.__h = null, v.__h.length && f.push(v), b && (v.__E = v.__ = null), v.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $52aeecae1553ebb1$var$j(i.__e, u, i, t, o, r, f, s);
        (a = $52aeecae1553ebb1$export$41c562ebe57d11e2.diffed) && a(u);
    } catch (l) {
        u.__v = null, (s || null != r) && (u.__e = e, u.__h = !!s, r[r.indexOf(e)] = null), $52aeecae1553ebb1$export$41c562ebe57d11e2.__e(l, u, i);
    }
}
function $52aeecae1553ebb1$var$T(l, u) {
    $52aeecae1553ebb1$export$41c562ebe57d11e2.__c && $52aeecae1553ebb1$export$41c562ebe57d11e2.__c(u, l), l.some(function(u) {
        try {
            l = u.__h, u.__h = [], l.some(function(n) {
                n.call(u);
            });
        } catch (l) {
            $52aeecae1553ebb1$export$41c562ebe57d11e2.__e(l, u.__v);
        }
    });
}
function $52aeecae1553ebb1$var$j(n, l, u, i, t, o, e, c) {
    var a, v, h, y, p = u.props, d = l.props, _ = l.type, k = 0;
    if ("svg" === _ && (t = !0), null != o) {
        for(; k < o.length; k++)if ((a = o[k]) && (a === n || (_ ? a.localName == _ : 3 == a.nodeType))) {
            n = a, o[k] = null;
            break;
        }
    }
    if (null == n) {
        if (null === _) return document.createTextNode(d);
        n = t ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, d.is && d), o = null, c = !1;
    }
    if (null === _) p === d || c && n.data === d || (n.data = d);
    else {
        if (o = o && $52aeecae1553ebb1$var$f.slice.call(n.childNodes), v = (p = u.props || $52aeecae1553ebb1$var$r).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !c) {
            if (null != o) for(p = {}, y = 0; y < n.attributes.length; y++)p[n.attributes[y].name] = n.attributes[y].value;
            (h || v) && (h && (v && h.__html == v.__html || h.__html === n.innerHTML) || (n.innerHTML = h && h.__html || ""));
        }
        if ($52aeecae1553ebb1$var$A(n, d, p, t, c), h) l.__k = [];
        else if (k = l.props.children, $52aeecae1553ebb1$var$m(n, Array.isArray(k) ? k : [
            k
        ], l, u, i, t && "foreignObject" !== _, o, e, n.firstChild, c), null != o) for(k = o.length; k--;)null != o[k] && $52aeecae1553ebb1$var$s(o[k]);
        c || ("value" in d && void 0 !== (k = d.value) && (k !== n.value || "progress" === _ && !k) && $52aeecae1553ebb1$var$C(n, "value", k, p.value, !1), "checked" in d && void 0 !== (k = d.checked) && k !== n.checked && $52aeecae1553ebb1$var$C(n, "checked", k, p.checked, !1));
    }
    return n;
}
function $52aeecae1553ebb1$var$z(l, u, i) {
    try {
        "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
        $52aeecae1553ebb1$export$41c562ebe57d11e2.__e(l, i);
    }
}
function $52aeecae1553ebb1$var$L(l, u, i) {
    var t, o, r;
    if ($52aeecae1553ebb1$export$41c562ebe57d11e2.unmount && $52aeecae1553ebb1$export$41c562ebe57d11e2.unmount(l), (t = l.ref) && (t.current && t.current !== l.__e || $52aeecae1553ebb1$var$z(t, null, u)), i || "function" == typeof l.type || (i = null != (o = l.__e)), l.__e = l.__d = void 0, null != (t = l.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (l) {
            $52aeecae1553ebb1$export$41c562ebe57d11e2.__e(l, u);
        }
        t.base = t.__P = null;
    }
    if (t = l.__k) for(r = 0; r < t.length; r++)t[r] && $52aeecae1553ebb1$var$L(t[r], u, i);
    null != o && $52aeecae1553ebb1$var$s(o);
}
function $52aeecae1553ebb1$var$M(n, l, u) {
    return this.constructor(n, u);
}
function $52aeecae1553ebb1$export$b3890eb0ae9dca99(l, u, i) {
    var t, o, e;
    $52aeecae1553ebb1$export$41c562ebe57d11e2.__ && $52aeecae1553ebb1$export$41c562ebe57d11e2.__(l, u), o = (t = "function" == typeof i) ? null : i && i.__k || u.__k, e = [], $52aeecae1553ebb1$var$I(u, l = (!t && i || u).__k = $52aeecae1553ebb1$export$c8a8987d4410bf2d($52aeecae1553ebb1$export$ffb0004e005737fa, null, [
        l
    ]), o || $52aeecae1553ebb1$var$r, $52aeecae1553ebb1$var$r, void 0 !== u.ownerSVGElement, !t && i ? [
        i
    ] : o ? null : u.firstChild ? $52aeecae1553ebb1$var$f.slice.call(u.childNodes) : null, e, !t && i ? i : o ? o.__e : u.firstChild, t), $52aeecae1553ebb1$var$T(e, l);
}
function $52aeecae1553ebb1$export$fa8d919ba61d84db(n, l) {
    $52aeecae1553ebb1$export$b3890eb0ae9dca99(n, l, $52aeecae1553ebb1$export$fa8d919ba61d84db);
}
function $52aeecae1553ebb1$export$e530037191fcd5d7(n, l, u) {
    var i, t, o, r = arguments, f = $52aeecae1553ebb1$var$c({}, n.props);
    for(o in l)"key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o];
    if (arguments.length > 3) for(u = [
        u
    ], o = 3; o < arguments.length; o++)u.push(r[o]);
    return null != u && (f.children = u), $52aeecae1553ebb1$var$v(n.type, f, i || n.key, t || n.ref, null);
}
function $52aeecae1553ebb1$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $52aeecae1553ebb1$var$o++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($52aeecae1553ebb1$var$k);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$52aeecae1553ebb1$export$41c562ebe57d11e2 = {
    __e: function(n, l) {
        for(var u, i, t; l = l.__;)if ((u = l.__c) && !u.__) try {
            if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
        } catch (l) {
            n = l;
        }
        throw n;
    },
    __v: 0
}, $52aeecae1553ebb1$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $52aeecae1553ebb1$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $52aeecae1553ebb1$var$c({}, this.state), "function" == typeof n && (n = n($52aeecae1553ebb1$var$c({}, u), this.props)), n && $52aeecae1553ebb1$var$c(u, n), null != n && this.__v && (l && this.__h.push(l), $52aeecae1553ebb1$var$k(this));
}, $52aeecae1553ebb1$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $52aeecae1553ebb1$var$k(this));
}, $52aeecae1553ebb1$export$16fa2f45be04daa8.prototype.render = $52aeecae1553ebb1$export$ffb0004e005737fa, $52aeecae1553ebb1$var$u = [], $52aeecae1553ebb1$var$i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $52aeecae1553ebb1$var$b.__r = 0, $52aeecae1553ebb1$var$o = 0;

});

parcelRegister("8g1PZ", function(module, exports) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === "object") {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("04wYO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nullIfEmpty = module.exports.omit = module.exports.pluck = module.exports.removeKeysWithNullishValues = module.exports.objectStringToNumber = module.exports.replaceObjectRawKeys = module.exports.arrayToObject = void 0;

var $fiq2I = parcelRequire("fiq2I");
function $00d9f4eeceab1d6a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $00d9f4eeceab1d6a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $00d9f4eeceab1d6a$var$ownKeys(Object(source), true).forEach(function(key) {
            $00d9f4eeceab1d6a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $00d9f4eeceab1d6a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $00d9f4eeceab1d6a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Takes an array of objects with a shared key and returns an object keyed by idPropName
 *
 * @param {array} arrayOfObjects Array of objects
 * @param {string} idPropName=id The keyname to use as the key in the resulting object
 * @returns {object} Keyed by idPropName
 */ const $00d9f4eeceab1d6a$var$arrayToObject = (arrayOfObjects, idPropName = "id")=>arrayOfObjects.reduce((result, item)=>{
        result[item[idPropName]] = item;
        return result;
    }, {});
/**
 * Takes an object of simple keys/values and returns a corresponding new object.
 * If there are any keys in the original object whose name end with "_raw" the
 * returned object will have a corresponding key (without the _raw suffix) but
 * with its value always converted into a JS number. If it cannot be converted
 * to a number the value will be zero. This way, you can always do math with the result
 *
 * @param {any} obj
 * @returns {object} Updated object
 */ module.exports.arrayToObject = $00d9f4eeceab1d6a$var$arrayToObject;
const $00d9f4eeceab1d6a$var$replaceObjectRawKeys = (obj)=>{
    const extraValues = {};
    for(const key in obj)if (key.endsWith("_raw")) extraValues[key.replace("_raw", "")] = (0, $fiq2I.toNumber)(obj[key]);
    return $00d9f4eeceab1d6a$var$_objectSpread($00d9f4eeceab1d6a$var$_objectSpread({}, obj), extraValues);
};
/**
 * When given an object of objects returns a new object where each "value
 * object" has been processed through `replaceObjectRawKeys`
 *
 * @param {object} obj
 * @returns {object}
 */ module.exports.replaceObjectRawKeys = $00d9f4eeceab1d6a$var$replaceObjectRawKeys;
const $00d9f4eeceab1d6a$var$objectStringToNumber = (obj)=>{
    const result = {};
    for(const key in obj)result[key] = $00d9f4eeceab1d6a$var$replaceObjectRawKeys(obj[key]);
    return result;
};
/**
 * Returns a new object where any keys whose values are == null are removed
 *
 * @param {object} obj
 * @returns {object} New object with nullish values removed
 */ module.exports.objectStringToNumber = $00d9f4eeceab1d6a$var$objectStringToNumber;
const $00d9f4eeceab1d6a$var$removeKeysWithNullishValues = (obj)=>{
    const result = {};
    for(const key in obj){
        const value = obj[key];
        if (value != null) result[key] = value;
    }
    return result;
};
/**
 * Construct new object with keys you care about from another object.
 *
 * @param {object} obj
 * @param {string[]} keys Array of keys to include in new object
 * @returns New object with only the keys specified in the second parameter
 */ module.exports.removeKeysWithNullishValues = $00d9f4eeceab1d6a$var$removeKeysWithNullishValues;
const $00d9f4eeceab1d6a$var$pluck = (obj, keys)=>keys.reduce((result, key)=>{
        if (obj.hasOwnProperty(key)) result[key] = obj[key];
        return result;
    }, {});
/**
 * Construct a new object without keys specified in second argument
 *
 * @param {object} obj Starting object
 * @param {string[]} keysToSkip Keys you don't want in the resulting object
 */ module.exports.pluck = $00d9f4eeceab1d6a$var$pluck;
const $00d9f4eeceab1d6a$var$omit = (obj, keysToSkip = [])=>{
    const copy = Object.assign({}, obj);
    keysToSkip.forEach((key)=>{
        delete copy[key];
    });
    return copy;
};
/**
 * Returns item or null if item is falsy, an empty array, or an empty object.
 *
 * @param {any} item Starting object
 * @returns {any} Returns passed item or null
 */ module.exports.omit = $00d9f4eeceab1d6a$var$omit;
const $00d9f4eeceab1d6a$var$nullIfEmpty = (item)=>{
    if (item == null) return null;
    if (item.length === 0) return null;
    if (Object.keys(item).length === 0) return null;
    return item;
};
module.exports.nullIfEmpty = $00d9f4eeceab1d6a$var$nullIfEmpty;

});
parcelRegister("fiq2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toNumber = void 0;
/**
 * Takes any import runs `Number(input)` returns the number or 0 if NaN
 *
 * @param {any} input
 * @returns {number}
 */ const $b22cbd069ffb8210$var$toNumber = (input)=>{
    const num = Number(input);
    return isNaN(num) ? 0 : num;
};
module.exports.toNumber = $b22cbd069ffb8210$var$toNumber;

});



parcelRegister("c6sws", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");
function $8cfc2b9085e43ca1$var$_extends() {
    $8cfc2b9085e43ca1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8cfc2b9085e43ca1$var$_extends.apply(this, arguments);
}
var $8cfc2b9085e43ca1$var$_default = (props)=>(0, $767w7.h)("svg", $8cfc2b9085e43ca1$var$_extends({
        viewBox: "0 0 24 24"
    }, props), (0, $767w7.h)("path", {
        d: "M20 12c0-2.2-2-4-4.5-4h-9C4 8 2 9.8 2 12s2 4 4.5 4h9c2.5 0 4.5-1.8 4.5-4zm-9.5 2.1V9.9h5.7c1.3.4 2 1 2 2.1 0 1-.7 1.7-2 2.1h-5.7z",
        "fill-rule": "nonzero"
    }));
module.exports.default = $8cfc2b9085e43ca1$var$_default;

});

parcelRegister("6zzev", function(module, exports) {
function $4c915780b4a76dc8$var$calc(m) {
    return function(n) {
        return Math.round(n * m);
    };
}
module.exports = {
    seconds: $4c915780b4a76dc8$var$calc(1e3),
    minutes: $4c915780b4a76dc8$var$calc(6e4),
    hours: $4c915780b4a76dc8$var$calc(36e5),
    days: $4c915780b4a76dc8$var$calc(864e5),
    weeks: $4c915780b4a76dc8$var$calc(6048e5),
    months: $4c915780b4a76dc8$var$calc(26298e5),
    years: $4c915780b4a76dc8$var$calc(315576e5)
};

});

parcelRegister("dRTL8", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => createSelector$1);
$parcel$export(module.exports, "IS_BROWSER", () => IS_BROWSER);
$parcel$export(module.exports, "ric", () => ric);
$parcel$export(module.exports, "debounce", () => debounce);
var appTime = {
    name: "appTime",
    reducer: function() {
        return Date.now();
    },
    selectAppTime: function(state) {
        return state.appTime;
    }
};
var changes = {
    STARTED: 1,
    FINISHED: -1,
    FAILED: -1
};
var re = /_(STARTED|FINISHED|FAILED)$/;
var asyncCount = {
    name: "asyncCount",
    reducer: function(state, ref) {
        if (state === void 0) state = 0;
        var type = ref.type;
        var result = re.exec(type);
        if (!result) return state;
        return state + changes[result[1]];
    },
    selectAsyncActive: function(state) {
        return state.asyncCount > 0;
    }
};
var namedActionMiddleware = function(store) {
    return function(next) {
        return function(action) {
            var actionCreator = action.actionCreator;
            var args = action.args;
            if (actionCreator) {
                var found = store.meta.unboundActionCreators[actionCreator];
                if (!found) throw Error("NoSuchActionCreator: " + actionCreator);
                return next(args ? found.apply(void 0, args) : found());
            }
            return next(action);
        };
    };
};
var thunkMiddleware = function(extraArgCreators) {
    return function(store) {
        var extraArgs = extraArgCreators.reduce(function(result, fn) {
            return Object.assign(result, fn(store));
        }, {});
        return function(next) {
            return function(action) {
                if (typeof action === "function") {
                    var getState = store.getState;
                    var dispatch = store.dispatch;
                    return action(Object.assign({}, {
                        getState: getState,
                        dispatch: dispatch,
                        store: store
                    }, extraArgs));
                }
                return next(action);
            };
        };
    };
};
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}
/* global window */ var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = symbolObservablePonyfill(root);
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function.");
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the reducer to be a function.");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected the listener to be a function.");
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function.");
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new TypeError("Expected the observer to be an object.");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[result] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionDescription = actionType && 'action "' + String(actionType) + '"' || "an action";
    return "Given " + actionDescription + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + ActionTypes.INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var errorMessage = getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) keys.push.apply(keys, Object.getOwnPropertySymbols(object));
    if (enumerableOnly) keys = keys.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return _objectSpread2({}, store, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
// Modified to expose all of `store` to middleware instead of just
var customApplyMiddleware = function() {
    var middlewares = [], len = arguments.length;
    while(len--)middlewares[len] = arguments[len];
    return function(createStore$$1) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore$$1(reducer, preloadedState, enhancer);
            var chain = middlewares.map(function(middleware) {
                return middleware(store);
            });
            store.dispatch = compose.apply(void 0, chain)(store.dispatch);
            return store;
        };
    };
};
function defaultEqualityCheck(a, b) {
    return a === b;
}
function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(", ");
        throw new Error("Selector creators expect all input-selectors to be functions, " + ("instead received the following types: [" + dependencyTypes + "]"));
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var createSelector = createSelectorCreator(defaultMemoize);
var ensureFn = function(obj, name) {
    if (typeof name !== "string") return name;
    var found = obj[name];
    if (!found) throw Error("No selector " + name + " found on the obj.");
    return found;
};
var createSelector$1 = function() {
    var fns = [], len = arguments.length;
    while(len--)fns[len] = arguments[len];
    var resultFunc = fns.slice(-1)[0];
    var deferredSelector = function(obj, deps) {
        var newArgs = deps.map(function(fn) {
            return ensureFn(obj, fn);
        });
        newArgs.push(resultFunc);
        return createSelector.apply(void 0, newArgs);
    };
    deferredSelector.deps = fns.slice(0, -1);
    deferredSelector.resultFunc = resultFunc;
    return deferredSelector;
};
var resolveSelectors = function(obj) {
    // an item is resolved if it is either a
    // function with no dependencies or if
    // it's on the object with no dependencies
    var isResolved = function(name) {
        return name.call && !name.deps || !obj[name].deps;
    }; // flag for checking if we have *any*
    var hasAtLeastOneResolved = false; // extract all deps and any resolved items
    var loop = function(selectorName) {
        var fn = obj[selectorName];
        if (!isResolved(selectorName)) fn.deps = fn.deps.map(function(val, index) {
            // if it is a function not a string
            if (val.call) {
                // look for it already on the object
                for(var key in obj){
                    if (obj[key] === val) // return its name if found
                    return key;
                } // we didn't find it and it doesn't have a name
                // but if it's a fully resolved selector that's ok
                if (!val.deps) {
                    hasAtLeastOneResolved = true;
                    return val;
                }
            } // the `val` is a string that exists on the object return the string
            // we'll resolve it later
            if (obj[val]) return val;
             // if we get here, its a string that doesn't exist on the object
            // which won't work, so we throw a helpful error
            throw Error("The input selector at index " + index + " for '" + selectorName + "' is missing from the object passed to resolveSelectors()");
        });
        else hasAtLeastOneResolved = true;
    };
    for(var selectorName in obj)loop(selectorName);
    if (!hasAtLeastOneResolved) throw Error("You must pass at least one real selector. If they're all string references there's no");
    var depsAreResolved = function(deps) {
        return deps.every(isResolved);
    };
    var resolve = function() {
        var hasUnresolved = false;
        for(var selectorName in obj){
            var fn = obj[selectorName];
            if (!isResolved(selectorName)) {
                hasUnresolved = true;
                if (depsAreResolved(fn.deps)) {
                    // we could just use `obj[selectorName] = fn(obj, fn.deps)`, but that
                    // has a significant performance impact when trying to perform this
                    // on a large object (> 1000). More on this here:
                    // http://2ality.com/2014/01/object-assign.html
                    var selectorFn = fn(obj, fn.deps);
                    delete obj[selectorName];
                    obj[selectorName] = selectorFn;
                }
            }
        }
        return hasUnresolved;
    };
    var startTime;
    while(resolve()){
        if (!startTime) startTime = Date.now();
        var duration = Date.now() - startTime;
        if (duration > 500) throw Error("Could not resolve selector dependencies.");
    }
    return obj;
};
var debug = false;
try {
    debug = !!window.localStorage.debug;
} catch (e) {}
var HAS_DEBUG_FLAG = debug || false;
var HAS_WINDOW = !!globalThis.window;
var IS_BROWSER = HAS_WINDOW || !!globalThis.navigator;
var IS_PROD = true;
var fallback = function(func) {
    return setTimeout(func, 0);
};
var raf = IS_BROWSER && globalThis.requestAnimationFrame ? globalThis.requestAnimationFrame.bind(globalThis) : fallback;
var ric = IS_BROWSER && globalThis.requestIdleCallback ? globalThis.requestIdleCallback.bind(globalThis) : fallback; // can dump this once IE 11 support is no longer necessary
var isPassiveSupported = function() {
    var passiveSupported = false;
    try {
        var options = Object.defineProperty({}, "passive", {
            /* eslint-disable getter-return */ get: function() {
                passiveSupported = true;
            }
        });
        globalThis.addEventListener("test", options, options);
        globalThis.removeEventListener("test", options, options);
    } catch (err) {
        passiveSupported = false;
    }
    return passiveSupported;
};
var PASSIVE_EVENTS_SUPPORTED = isPassiveSupported();
var startsWith = function(string, searchString) {
    return string.substr(0, searchString.length) === searchString;
};
var flattenExtractedToObject = function(extracted) {
    var result = {};
    for(var appName in extracted)Object.assign(result, extracted[appName]);
    return result;
};
var flattenExtractedToArray = function(extracted) {
    var accum = [];
    for(var appName in extracted)accum.push.apply(accum, extracted[appName]);
    return accum;
};
var addGlobalListener = function(eventName, handler, opts) {
    if (opts === void 0) opts = {
        passive: false
    };
    if (!IS_BROWSER) return function() {};
    var args = opts.passive ? PASSIVE_EVENTS_SUPPORTED ? [
        eventName,
        handler,
        {
            passive: true
        }
    ] : [
        eventName,
        debounce(handler, 200),
        false
    ] : [
        eventName,
        handler
    ];
    globalThis.addEventListener.apply(globalThis, args);
    return function() {
        return globalThis.removeEventListener.apply(globalThis, args);
    };
};
var selectorNameToValueName = function(name) {
    var start = name[0] === "s" ? 6 : 5;
    return name[start].toLowerCase() + name.slice(start + 1);
};
var debounce = function(fn, wait) {
    var timeout;
    var debounced = function() {
        var ctx = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn.apply(ctx, args);
        }, wait);
    };
    debounced.cancel = function() {
        clearTimeout(timeout);
    };
    return debounced;
};
var saveScrollPosition = function() {
    history.replaceState({
        height: window.innerHeight,
        width: window.innerWidth,
        y: window.scrollY,
        x: window.scrollX
    }, "");
};
var restoreScrollPosition = function() {
    var state = history.state;
    if (state) // we'll force it to our known height since the DOM rendering may
    // be async and the height may not be restored yet.
    setTimeout(function() {
        var newStyle = "height: " + state.height + "px; width: " + state.width + "px;";
        document.body.setAttribute("style", newStyle);
        window.scrollTo(state.x, state.y);
        ric(function() {
            return document.body.removeAttribute("style");
        });
    });
};
var initScrollPosition = function() {
    if (!HAS_WINDOW) return;
     // turn off browser scroll restoration if available
    if (history.scrollRestoration) history.scrollRestoration = "manual";
    var removePopstateListener = addGlobalListener("popstate", restoreScrollPosition);
    var removeScrollListener = addGlobalListener("scroll", debounce(saveScrollPosition, 300), {
        passive: true
    });
    restoreScrollPosition();
    return function() {
        removePopstateListener();
        removeScrollListener();
    };
};
var normalizeBundle = function(bundle) {
    var name = bundle.name;
    if (!name) throw TypeError('bundles must have a "name" property');
    var result = {
        name: name,
        reducer: bundle.reducer || bundle.getReducer && bundle.getReducer() || null,
        init: bundle.init || null,
        extraArgCreators: bundle.getExtraArgs || null,
        middlewareCreators: bundle.getMiddleware,
        actionCreators: null,
        selectors: null,
        reactorNames: null,
        rawBundle: bundle
    };
    Object.keys(bundle).forEach(function(key) {
        if (startsWith(key, "do")) {
            (result.actionCreators || (result.actionCreators = {}))[key] = bundle[key];
            return;
        }
        var isSelector = startsWith(key, "select");
        var isReactor = startsWith(key, "react");
        if (isSelector || isReactor) {
            (result.selectors || (result.selectors = {}))[key] = bundle[key];
            if (isReactor) (result.reactorNames || (result.reactorNames = [])).push(key);
        }
    });
    return result;
};
var createChunk = function(rawBundles) {
    var normalizedBundles = rawBundles.map(normalizeBundle);
    var result = {
        bundleNames: [],
        reducers: {},
        selectors: {},
        actionCreators: {},
        rawBundles: [],
        processedBundles: [],
        initMethods: [],
        destroyMethods: [],
        middlewareCreators: [],
        extraArgCreators: [],
        reactorNames: []
    };
    normalizedBundles.forEach(function(bundle) {
        var obj, ref;
        result.bundleNames.push(bundle.name);
        Object.assign(result.selectors, bundle.selectors);
        Object.assign(result.actionCreators, bundle.actionCreators);
        if (bundle.reducer) Object.assign(result.reducers, (obj = {}, obj[bundle.name] = bundle.reducer, obj));
        if (bundle.init) result.initMethods.push(bundle.init);
        if (bundle.middlewareCreators) result.middlewareCreators.push(bundle.middlewareCreators);
        if (bundle.extraArgCreators) result.extraArgCreators.push(bundle.extraArgCreators);
        if (bundle.reactorNames) (ref = result.reactorNames).push.apply(ref, bundle.reactorNames);
        result.processedBundles.push(bundle);
        result.rawBundles.push(bundle.rawBundle);
    });
    return result;
};
var addBindingMethods = function(store) {
    store.subscriptions = {
        watchedValues: {}
    };
    var subscriptions = store.subscriptions.set = new Set();
    var watchedSelectors = store.subscriptions.watchedSelectors = {};
    var watch = function(selectorName) {
        watchedSelectors[selectorName] = (watchedSelectors[selectorName] || 0) + 1;
    };
    var unwatch = function(selectorName) {
        var count = watchedSelectors[selectorName] - 1;
        if (count === 0) delete watchedSelectors[selectorName];
        else watchedSelectors[selectorName] = count;
    }; // add single store subscription for tracking watched changes
    store.subscribe(function() {
        var newValues = watchedSelectors.all ? store.selectAll() : store.select(Object.keys(watchedSelectors));
        var ref = store.subscriptions;
        var watchedValues = ref.watchedValues; // the only diffing in the app happens here
        var changed = {};
        for(var key in newValues){
            var val = newValues[key];
            if (val !== watchedValues[key]) changed[key] = val;
        }
        store.subscriptions.watchedValues = newValues; // look through subscriptions to trigger
        subscriptions.forEach(function(subscription) {
            var relevantChanges = {};
            var hasChanged = false;
            if (subscription.names === "all") {
                Object.assign(relevantChanges, changed);
                hasChanged = !!Object.keys(relevantChanges).length;
            } else subscription.names.forEach(function(name) {
                if (Object.prototype.hasOwnProperty.call(changed, name)) {
                    relevantChanges[name] = changed[name];
                    hasChanged = true;
                }
            });
            if (hasChanged) subscription.fn(relevantChanges);
        });
    }); // this exists separately in order to support
    // subscribing to all changes even after lazy-loading
    // additional bundles
    store.subscribeToAllChanges = function(callback) {
        return store.subscribeToSelectors("all", callback);
    }; // given an array of selector names, it will call the
    // callback any time those have changed with an object
    // containing only changed values
    store.subscribeToSelectors = function(keys, callback) {
        var isAll = keys === "all"; // re-use loop for double duty
        // extract names, but also ensure
        // selector actually exists on store
        var subscription = {
            fn: callback,
            names: isAll ? "all" : keys.map(selectorNameToValueName)
        };
        subscriptions.add(subscription);
        isAll ? watch("all") : keys.forEach(watch); // make sure starting values are in watched so we can
        // track changes
        Object.assign(store.subscriptions.watchedValues, isAll ? store.selectAll() : store.select(keys)); // return function that can be used to unsubscribe
        return function() {
            subscriptions.delete(subscription);
            isAll ? unwatch("all") : keys.forEach(unwatch);
        };
    };
};
var bindSelectorsToStore = function(store, selectors) {
    var loop = function(key) {
        var selector = selectors[key];
        if (!store[key]) store[key] = function() {
            return selector(store.getState());
        };
    };
    for(var key in selectors)loop(key);
};
var decorateStore = function(store, processed) {
    if (!store.meta) store.meta = {
        chunks: [],
        unboundSelectors: {},
        unboundActionCreators: {},
        reactorNames: [],
        destroyMethods: []
    };
    var meta = store.meta; // attach for reference
    meta.chunks.push(processed); // grab existing unbound (but resolved) selectors, combine with new ones
    var combinedSelectors = Object.assign(meta.unboundSelectors, processed.selectors); // run resolver
    resolveSelectors(combinedSelectors); // update collection of resolved selectors
    meta.unboundSelectors = combinedSelectors; // make sure all selectors are bound (won't overwrite if already bound)
    bindSelectorsToStore(store, combinedSelectors); // build our list of reactor names
    meta.reactorNames = meta.reactorNames.concat(processed.reactorNames); // extend global collections with new stuff
    Object.assign(meta.unboundActionCreators, processed.actionCreators); // bind and attach only the next action creators to the store
    Object.assign(store, bindActionCreators(processed.actionCreators, store.dispatch)); // build list of destroy methods
    meta.destroyMethods = meta.destroyMethods.concat(processed.destroyMethods); // run any new init methods. Use their return function as potential
    // destroy methods.
    processed.initMethods.forEach(function(init) {
        var destroy = init(store);
        if (typeof destroy === "function") meta.destroyMethods = meta.destroyMethods.concat(destroy);
    });
};
var enableBatchDispatch = function(reducer) {
    return function(state, action) {
        if (action.type === "BATCH_ACTIONS") return action.actions.reduce(reducer, state);
        return reducer(state, action);
    };
};
var enableReplaceState = function(reducer) {
    return function(state, action) {
        if (action.type === "REPLACE_STATE") return reducer(action.payload, action);
        return reducer(state, action);
    };
};
var enhanceReducer = compose(enableBatchDispatch, enableReplaceState);
var devTools = function() {
    return HAS_WINDOW && window.__REDUX_DEVTOOLS_EXTENSION__ && (HAS_DEBUG_FLAG || !IS_PROD) ? window.__REDUX_DEVTOOLS_EXTENSION__() : function(a) {
        return a;
    };
};
var composeBundles = function() {
    var bundles = [], len = arguments.length;
    while(len--)bundles[len] = arguments[len];
    // build out object of extracted bundle info
    var firstChunk = createChunk(bundles);
    return function(data) {
        // actually init our store
        var store = createStore(enhanceReducer(combineReducers(firstChunk.reducers)), data, compose(customApplyMiddleware.apply(void 0, [
            namedActionMiddleware,
            thunkMiddleware(firstChunk.extraArgCreators)
        ].concat(firstChunk.middlewareCreators.map(function(fn) {
            return fn(firstChunk);
        }))), devTools())); // get values from an array of selector names
        store.select = function(selectorNames) {
            return selectorNames.reduce(function(obj, name) {
                if (!store[name]) throw Error("SelectorNotFound " + name);
                obj[selectorNameToValueName(name)] = store[name]();
                return obj;
            }, {});
        }; // get all values from all available selectors (even if added later)
        store.selectAll = function() {
            return store.select(Object.keys(store.meta.unboundSelectors));
        }; // add support for dispatching an action by name
        store.action = function(name, args) {
            return store[name].apply(store, args);
        }; // adds support for subscribing to changes from an array of selector strings
        addBindingMethods(store); // add all the gathered bundle data into the store
        decorateStore(store, firstChunk); // add support for destroying the store (to remove event listeners, etc)
        store.destroy = function() {
            return store.meta.destroyMethods.forEach(function(destroy) {
                return destroy(store);
            });
        }; // defines method for integrating other bundles later
        store.integrateBundles = function() {
            var bundlesToIntegrate = [], len = arguments.length;
            while(len--)bundlesToIntegrate[len] = arguments[len];
            decorateStore(store, createChunk(bundlesToIntegrate));
            var allReducers = store.meta.chunks.reduce(function(accum, chunk) {
                return Object.assign(accum, chunk.reducers);
            }, {});
            store.replaceReducer(enhanceReducer(combineReducers(allReducers)));
            store.buildPersistActionMap && store.buildPersistActionMap();
        };
        return store;
    };
};
// regexes borrowed from backbone
var optionalParam = /\((.*?)\)/g;
var namedParam = /(\(\?)?:\w+/g;
// eslint-disable-next-line no-useless-escape
var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
var splatParam = /\*/g;
// Parses a URL pattern such as `/users/:id`
// and builds and returns a regex that can be used to
// match said pattern. Credit for these
// regexes belongs to Jeremy Ashkenas and the
// other maintainers of Backbone.js
//
// It has been modified for extraction of
// named parameters from the URL
var parsePattern = function(pattern) {
    var names = [];
    pattern = pattern.replace(escapeRegExp, "\\$&").replace(optionalParam, "(?:$1)?").replace(namedParam, function(match, optional) {
        names.push(match.slice(1));
        return optional ? match : "([^/?]+)";
    }).replace(splatParam, function() {
        names.push("path");
        return "([^?]*?)";
    });
    return {
        regExp: new RegExp("^" + pattern + "(?:\\?([\\s\\S]*))?$"),
        namedParams: names
    };
};
function createRouteMatcher(routes) {
    var keys = Object.keys(routes);
    var routeCache = {};
    // loop through each route we're
    // and build the shell of our
    // route cache.
    for(var item in routes)routeCache[item] = {
        value: routes[item]
    };
    // main result is a function that can be called
    // with the url
    return function(url) {
        var params;
        var route;
        // start looking for matches
        var matchFound = keys.some(function(key) {
            var parsed;
            // fetch the route pattern from the cache
            // there will always be one
            route = routeCache[key];
            // if the route doesn't already have
            // a regex we never generated one
            // so we do that here lazily.
            // Parse the pattern to generate the
            // regex once, and store the result
            // for next time.
            if (!route.regExp) {
                parsed = parsePattern(key);
                route.regExp = parsed.regExp;
                route.namedParams = parsed.namedParams;
                route.pattern = key;
            }
            // run our cached regex
            var result = route.regExp.exec(url);
            // if null there was no match
            // returning falsy here continues
            // the `Array.prototype.some` loop
            if (!result) return;
            // remove other cruft from result
            result = result.slice(1, -1);
            // reduce our match to an object of named parameters
            // we've extracted from the url
            params = result.reduce(function(obj, val, index) {
                if (val) obj[route.namedParams[index]] = val;
                return obj;
            }, {});
            // stops the loop
            return true;
        });
        // no routes matched
        if (!matchFound) return null;
        return {
            value: route.value,
            params: params,
            url: url,
            pattern: route.pattern
        };
    };
}
var defaults = {
    routeInfoSelector: "selectPathname"
};
var createRoutingBundle = function(routes, spec) {
    var opts = Object.assign({}, defaults, spec);
    var routeInfoSelector = opts.routeInfoSelector;
    var routeMatcher = createRouteMatcher(routes);
    return {
        name: "routes",
        selectRoutes: function() {
            return routes;
        },
        selectRouteMatcher: function() {
            return routeMatcher;
        },
        selectRouteInfo: createSelector$1(routeInfoSelector, routeMatcher),
        selectRouteParams: createSelector$1("selectRouteInfo", function(match) {
            return match && match.params || {};
        }),
        selectRoute: createSelector$1("selectRouteInfo", function(match) {
            return match && match.value || null;
        })
    };
};
var caching = function(ref) {
    var cacheFn = ref.cacheFn;
    var logger = ref.logger;
    var enabled = ref.enabled;
    if (enabled === void 0) enabled = IS_BROWSER;
    return {
        name: "localCache",
        init: function(store) {
            store.buildPersistActionMap = function() {
                store.meta.persistActionMap = store.meta.chunks.reduce(function(actionMap, chunk) {
                    chunk.rawBundles.forEach(function(bundle) {
                        if (bundle.persistActions) bundle.persistActions.forEach(function(type) {
                            actionMap[type] || (actionMap[type] = []);
                            actionMap[type].push(bundle.name);
                        });
                    });
                    return actionMap;
                }, {});
            };
            store.buildPersistActionMap();
        },
        getMiddleware: function() {
            return function(store) {
                return function(next) {
                    return function(action) {
                        var getState = store.getState;
                        var meta = store.meta;
                        var persistActionMap = meta.persistActionMap;
                        var reducersToPersist = persistActionMap[action.type];
                        var res = next(action);
                        var state = getState();
                        if (enabled && reducersToPersist) ric(function() {
                            Promise.all(reducersToPersist.map(function(key) {
                                return cacheFn(key, state[key]);
                            })).then(function() {
                                if (logger) logger("cached " + reducersToPersist.join(", ") + " due to " + action.type);
                            });
                        }, {
                            timeout: 500
                        });
                        return res;
                    };
                };
            };
        }
    };
};
var defaults$1 = {
    idleTimeout: 30000,
    idleAction: "APP_IDLE",
    doneCallback: null,
    stopWhenTabInactive: true,
    cancelIdleWhenDone: true,
    reactorPermissionCheck: null
};
var ricOptions = {
    timeout: 500
};
var getIdleDispatcher = function(stopWhenInactive, timeout, fn) {
    return debounce(function() {
        // the requestAnimationFrame ensures it doesn't run when tab isn't active
        stopWhenInactive ? raf(function() {
            return ric(fn, ricOptions);
        }) : ric(fn, ricOptions);
    }, timeout);
};
var reactors = function(spec) {
    return {
        name: "reactors",
        init: function(store) {
            var ref = Object.assign({}, defaults$1, spec);
            var idleAction = ref.idleAction;
            var idleTimeout = ref.idleTimeout;
            var cancelIdleWhenDone = ref.cancelIdleWhenDone;
            var doneCallback = ref.doneCallback;
            var stopWhenTabInactive = ref.stopWhenTabInactive;
            var reactorPermissionCheck = ref.reactorPermissionCheck;
            var idleDispatcher;
            if (idleTimeout) idleDispatcher = getIdleDispatcher(stopWhenTabInactive, idleTimeout, function() {
                return store.dispatch({
                    type: idleAction
                });
            });
            store.getNextReaction = function(skipPermissionCheck) {
                if (skipPermissionCheck === void 0) skipPermissionCheck = false;
                for(var i = 0, l = store.meta.reactorNames.length; i < l; i++){
                    var name = store.meta.reactorNames[i];
                    var result = store[name]();
                    if (result) {
                        // enable passing a fn to check whether a given reactor should be allowed
                        if (!skipPermissionCheck && reactorPermissionCheck && !reactorPermissionCheck(name, result)) continue;
                        return {
                            name: name,
                            result: result
                        };
                    }
                }
            };
            var cancelIfDone = function() {
                if (!IS_BROWSER && !store.nextReaction && (!store.selectAsyncActive || !store.selectAsyncActive())) {
                    idleDispatcher && idleDispatcher.cancel();
                    doneCallback && doneCallback();
                }
            };
            var dispatchNextReaction = function() {
                // make sure it's still relevant and store it
                // this time don't verify permission, we already
                // did once.
                store.nextReaction = store.getNextReaction(true);
                if (store.nextReaction) {
                    var nextReaction = store.nextReaction;
                    store.nextReaction = null;
                    store.dispatch(nextReaction.result);
                }
            };
            var dispatchNext = function() {
                // one at a time
                if (store.nextReaction) return;
                 // store next reaction for reference
                store.nextReaction = store.getNextReaction();
                if (store.nextReaction) ric(dispatchNextReaction, ricOptions);
            };
            var callback = function() {
                dispatchNext();
                if (idleDispatcher) {
                    idleDispatcher();
                    cancelIdleWhenDone && cancelIfDone();
                }
            };
            var unsubscribe = store.subscribe(callback);
            callback();
            return function() {
                idleDispatcher && idleDispatcher.cancel();
                unsubscribe();
            };
        }
    };
};
var has = Object.prototype.hasOwnProperty, undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = decode(part[1]), value = decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if (has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === undef || isNaN(value))) value = "";
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
//
// Expose the module.
//
var stringify = querystringify;
var parse = querystring;
var querystringify_1 = {
    stringify: stringify,
    parse: parse
};
var isString = function(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
var isDefined = function(thing) {
    return typeof thing !== "undefined";
};
var ensureString = function(input) {
    return isString(input) ? input : querystringify_1.stringify(input);
};
var IPRE = /^[0-9.]+$/;
var parseSubdomains = function(hostname, getBareHost) {
    if (IPRE.test(hostname)) return [];
    var parts = hostname.split(".");
    if (getBareHost) return parts.slice(-2).join(".");
    return hostname.split(".").slice(0, -2);
};
var removeLeading = function(char, string) {
    return string.charAt(0) === char ? string.slice(1) : string;
};
var ensureLeading = function(char, string) {
    if (string === char || string === "") return "";
    return string.charAt(0) !== char ? char + string : string;
};
var loc = function() {
    if (!HAS_WINDOW) return {};
    return window.location;
}();
var defaults$2 = {
    name: "url",
    inert: !HAS_WINDOW,
    actionType: "URL_UPDATED",
    handleScrollRestoration: true
};
var makeSerializable = function(url) {
    var result = {};
    for(var key in url){
        var val = url[key];
        if (isString(val)) result[key] = val;
    }
    return result;
};
var url = function(opts) {
    var config = Object.assign({}, defaults$2, opts);
    var actionType = config.actionType;
    var selectUrlRaw = function(state) {
        return state[config.name];
    };
    var selectUrlObject = createSelector$1(selectUrlRaw, function(urlState) {
        return makeSerializable(new URL(urlState.url));
    });
    var selectQueryObject = createSelector$1(selectUrlObject, function(urlObj) {
        return querystringify_1.parse(urlObj.search);
    });
    var selectQueryString = createSelector$1(selectQueryObject, function(queryObj) {
        return querystringify_1.stringify(queryObj);
    });
    var selectPathname = createSelector$1(selectUrlObject, function(urlObj) {
        return urlObj.pathname;
    });
    var selectHash = createSelector$1(selectUrlObject, function(urlObj) {
        return removeLeading("#", urlObj.hash);
    });
    var selectHashObject = createSelector$1(selectHash, function(hash) {
        return querystringify_1.parse(hash);
    });
    var selectHostname = createSelector$1(selectUrlObject, function(urlObj) {
        return urlObj.hostname;
    });
    var selectSubdomains = createSelector$1(selectHostname, function(hostname) {
        return parseSubdomains(hostname);
    });
    var doUpdateUrl = function(newState, opts) {
        if (opts === void 0) opts = {
            replace: false,
            maintainScrollPosition: false
        };
        return function(ref) {
            var dispatch = ref.dispatch;
            var getState = ref.getState;
            var state = newState;
            if (typeof newState === "string") {
                var parsed = new URL(newState.charAt(0) === "/" ? "http://example.com" + newState : newState);
                state = {
                    pathname: parsed.pathname,
                    query: parsed.search || "",
                    hash: parsed.hash || ""
                };
            }
            var url = new URL(selectUrlRaw(getState()).url);
            if (isDefined(state.pathname)) url.pathname = state.pathname;
            if (isDefined(state.hash)) url.hash = ensureString(state.hash);
            if (isDefined(state.query)) url.search = ensureString(state.query);
            dispatch({
                type: actionType,
                payload: {
                    url: url.href,
                    replace: opts.replace,
                    maintainScrollPosition: opts.maintainScrollPosition
                }
            });
        };
    };
    var doReplaceUrl = function(url) {
        return doUpdateUrl(url, {
            replace: true
        });
    };
    var doUpdateQuery = function(query, opts) {
        if (opts === void 0) opts = {
            replace: true
        };
        return doUpdateUrl({
            query: ensureString(query)
        }, opts);
    };
    var doUpdateHash = function(hash, opts) {
        if (opts === void 0) opts = {
            replace: false
        };
        return doUpdateUrl({
            hash: ensureLeading("#", ensureString(hash))
        }, opts);
    };
    return {
        name: config.name,
        init: function(store) {
            if (config.inert) return;
            var removeScrollPosition = config.handleScrollRestoration ? initScrollPosition() : null;
            var removePopstateListener = addGlobalListener("popstate", function() {
                store.doUpdateUrl({
                    pathname: loc.pathname,
                    hash: loc.hash,
                    query: loc.search
                });
            });
            var lastState = store.selectUrlRaw();
            var unsubscribe = store.subscribe(function() {
                var newState = store.selectUrlRaw();
                var newUrl = newState.url;
                if (lastState !== newState && newUrl !== loc.href) try {
                    window.history[newState.replace ? "replaceState" : "pushState"]({}, null, newState.url);
                    if (config.handleScrollRestoration) saveScrollPosition();
                    if (!newState.maintainScrollPosition) window.scrollTo(0, 0);
                } catch (e) {
                    console.error(e);
                }
                lastState = newState;
            });
            return function() {
                if (removeScrollPosition) removeScrollPosition();
                removePopstateListener();
                unsubscribe();
            };
        },
        getReducer: function() {
            var initialState = {
                url: !config.inert && HAS_WINDOW ? loc.href : "/",
                replace: false,
                maintainScrollPosition: false
            };
            return function(state, ref) {
                if (state === void 0) state = initialState;
                var type = ref.type;
                var payload = ref.payload;
                if (typeof state === "string") return {
                    url: state,
                    replace: false,
                    maintainScrollPosition: false
                };
                if (type === actionType) return Object.assign({
                    url: payload.url || payload,
                    replace: !!payload.replace,
                    maintainScrollPosition: !!payload.maintainScrollPosition
                });
                return state;
            };
        },
        doUpdateUrl: doUpdateUrl,
        doReplaceUrl: doReplaceUrl,
        doUpdateQuery: doUpdateQuery,
        doUpdateHash: doUpdateHash,
        selectUrlRaw: selectUrlRaw,
        selectUrlObject: selectUrlObject,
        selectQueryObject: selectQueryObject,
        selectQueryString: selectQueryString,
        selectPathname: selectPathname,
        selectHash: selectHash,
        selectHashObject: selectHashObject,
        selectHostname: selectHostname,
        selectSubdomains: selectSubdomains
    };
};
var version = "28.0.3";
var createDebug = function(spec) {
    var ENABLE = "DEBUG_ENABLED";
    var DISABLE = "DEBUG_DISABLED";
    var colorBlue = "color: #1676D2;";
    var colorGreen = "color: #4CAF50;";
    var colorOrange = "color: #F57C00;"; // cleans up color vars when used in node
    var log = function(toLog, ref) {
        var method = ref.method;
        if (method === void 0) method = "log";
        var label = ref.label;
        var color = ref.color;
        return console[method].apply(console, IS_BROWSER ? [
            "%c" + label,
            color,
            toLog
        ] : [
            label,
            toLog
        ]);
    };
    var defaultOpts = {
        logSelectors: true,
        logState: true,
        enabled: HAS_DEBUG_FLAG,
        actionFilter: null
    };
    var opts = Object.assign({}, defaultOpts, spec);
    return {
        name: "debug",
        reducer: function(state, ref) {
            if (state === void 0) state = opts.enabled;
            var type = ref.type;
            if (type === ENABLE) return true;
            if (type === DISABLE) return false;
            return state;
        },
        doEnableDebug: function() {
            return function(ref) {
                var dispatch = ref.dispatch;
                if (IS_BROWSER) try {
                    localStorage.debug = true;
                } catch (e) {}
                dispatch({
                    type: ENABLE
                });
            };
        },
        doDisableDebug: function() {
            return function(ref) {
                var dispatch = ref.dispatch;
                if (IS_BROWSER) try {
                    delete localStorage.debug;
                } catch (e) {}
                dispatch({
                    type: DISABLE
                });
            };
        },
        selectIsDebug: function(state) {
            return state.debug;
        },
        getMiddleware: function() {
            return function(store) {
                return function(next) {
                    return function(action) {
                        var isDebug = store.getState().debug;
                        if (!isDebug || opts.actionFilter && !opts.actionFilter(action)) return next(action);
                        console.group(action.type);
                        console.info("action:", action);
                        var result = next(action);
                        opts.logState && console.debug("state:", store.getState());
                        opts.logSelectors && store.doLogSelectors();
                        store.doLogNextReaction && store.doLogNextReaction();
                        console.groupEnd(action.type);
                        return result;
                    };
                };
            };
        },
        doLogBundles: function() {
            return function(ref) {
                var store = ref.store;
                log(store.meta.chunks.reduce(function(result, chunk) {
                    result.push.apply(result, chunk.bundleNames);
                    return result;
                }, []), {
                    label: "installed bundles:",
                    color: colorBlue
                });
            };
        },
        doLogSelectors: function() {
            return function(ref) {
                var store = ref.store;
                log(Object.keys(store.meta.unboundSelectors).sort().reduce(function(res, name$$1) {
                    res[name$$1] = store[name$$1]();
                    return res;
                }, {}), {
                    label: "selectors:",
                    color: colorGreen
                });
            };
        },
        doLogActionCreators: function() {
            return function(ref) {
                var store = ref.store;
                log(Object.keys(store.meta.unboundActionCreators).sort(), {
                    label: "action creators:",
                    color: colorOrange
                });
            };
        },
        doLogReactors: function() {
            return function(ref) {
                var store = ref.store;
                log(store.meta.reactorNames, {
                    label: "reactors:",
                    color: colorOrange
                });
            };
        },
        doLogNextReaction: function() {
            return function(ref) {
                var store = ref.store;
                var nextReaction = store.nextReaction;
                if (nextReaction) {
                    var name$$1 = nextReaction.name;
                    var result = nextReaction.result;
                    log(result, {
                        color: colorOrange,
                        label: "next reaction " + name$$1 + ":"
                    });
                }
            };
        },
        doLogDebugSummary: function() {
            return function(ref) {
                var store = ref.store;
                store.doLogBundles();
                store.doLogSelectors();
                store.doLogActionCreators();
                store.doLogReactors();
                store.doLogNextReaction();
            };
        },
        init: function(store) {
            if (store.selectIsDebug()) {
                if (IS_BROWSER) {
                    globalThis.store = store;
                    console.groupCollapsed("%credux bundler v" + version, colorBlue);
                    store.doLogDebugSummary();
                    console.groupEnd();
                }
            }
        }
    };
};
var appTimeBundle = appTime;
var asyncCountBundle = asyncCount;
var createCacheBundle = caching;
var createRouteBundle = createRoutingBundle;
var createReactorBundle = reactors;
var getIdleDispatcher$1 = getIdleDispatcher;
var createUrlBundle = url;
var createDebugBundle = createDebug;
var composeBundlesRaw = composeBundles;
var composeBundles$1 = function() {
    var userBundles = [], len = arguments.length;
    while(len--)userBundles[len] = arguments[len];
    userBundles || (userBundles = []);
    var bundles = [
        appTime,
        asyncCount,
        url(),
        reactors(),
        createDebug()
    ].concat(userBundles);
    return composeBundles.apply(void 0, bundles);
};

});

parcelRegister("2TQb1", function(module, exports) {
// tryit
// Simple, re-usuable try-catch, this is a performance optimization
// and provides a cleaner API.
module.exports = function(fn, cb) {
    var err;
    try {
        fn();
    } catch (e) {
        err = e;
    }
    if (cb) cb(err || null);
};

});

parcelRegister("5Skt9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4471dfa3a6e9a76a$export$2e2bcd8739ae039);

var $hjw1k = parcelRequire("hjw1k");

var $4LmDH = parcelRequire("4LmDH");
function $4471dfa3a6e9a76a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $hjw1k.default)(dirtyDate, Date.now());
}

});
parcelRegister("hjw1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ad0c9b51445ea3$export$2e2bcd8739ae039);

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfDay = (0, $cJfMa.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $cJfMa.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});
parcelRegister("cJfMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9445ecc5e7cfb647$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("gdr0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});





parcelRegister("dTc56", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");

var $9YtMX = parcelRequire("9YtMX");

var $a1c9c8830eaccf64$var$_classnames = $a1c9c8830eaccf64$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7EOve = parcelRequire("7EOve");

var $7Dcmj = parcelRequire("7Dcmj");
function $a1c9c8830eaccf64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $a1c9c8830eaccf64$var$_default extends $767w7.Component {
    constructor(props){
        super(props);
        this.toggleExpand = this.toggleExpand.bind(this);
        this.state = {
            expanded: true
        };
    }
    toggleExpand() {
        this.setState({
            expanded: !this.state.expanded
        });
    }
    render({ autoSuggestType: autoSuggestType, name: name, value: value, suggestions: suggestions, suggestionsDeleting: suggestionsDeleting, updateValue: updateValue, removeSuggestion: removeSuggestion }, { expanded: expanded }) {
        return (0, $767w7.h)("div", {
            className: "fw3 pa2 bg-near-white br2 shadow-inset",
            "data-e2e": "smartSuggestions:".concat(name)
        }, (0, $767w7.h)("div", {
            className: "f6"
        }, "SmartSuggestions\u2122"), (0, $767w7.h)("div", {
            className: (0, $a1c9c8830eaccf64$var$_classnames.default)("overflow-y-scroll", {
                dn: !expanded
            })
        }, suggestionsDeleting && (0, $767w7.h)("div", {
            className: "flex items-center pv2",
            "data-e2e": "smartSuggestionsUpdating"
        }, (0, $767w7.h)($7Dcmj.Icon, {
            icon: "autorenew",
            className: "spin-animation mr2",
            size: 16
        }), "Updating..."), !suggestionsDeleting && suggestions.map((suggestion)=>{
            const { pressed: pressed, phrase: phrase } = suggestion;
            return (0, $767w7.h)("label", {
                "data-e2e": "suggestionPhrase",
                key: phrase,
                className: (0, $a1c9c8830eaccf64$var$_classnames.default)("flex items-center ph1 pv2", {
                    fw6: pressed
                })
            }, (0, $767w7.h)("input", {
                onChange: (e)=>{
                    e.preventDefault();
                    if (autoSuggestType === "sentence") updateValue(pressed ? (0, $7EOve.withoutText)(value, phrase) : (0, $7EOve.textAppended)(value, phrase));
                    else if (autoSuggestType === "multiple") updateValue(pressed ? (0, $7EOve.removeCommaSeparatedItem)(value, phrase) : (0, $7EOve.addCommaSeparatedItem)(value, phrase));
                    else if (autoSuggestType === "single") updateValue(pressed ? "" : phrase);
                },
                type: "checkbox",
                checked: suggestion.pressed,
                className: "mr2 flex-shrink-0",
                style: {
                    width: "15px",
                    height: "15px"
                }
            }), (0, $767w7.h)("span", {
                className: "lh-solid"
            }, suggestion.phrase), (0, $767w7.h)($9YtMX.Button, {
                tiny: true,
                className: "flex ml2",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    removeSuggestion(name, suggestion.phrase);
                },
                type: "button"
            }, (0, $767w7.h)($7Dcmj.Icon, {
                icon: "close",
                size: 12
            })));
        })));
    }
}
module.exports.default = $a1c9c8830eaccf64$var$_default;

});
parcelRegister("9YtMX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TapIconButton = module.exports.IconButton = module.exports.Button = void 0;

var $767w7 = parcelRequire("767w7");

var $7430d30e03ecd182$var$_getStyledComponent = $7430d30e03ecd182$var$_interopRequireDefault((parcelRequire("45yGA")));

var $7Dcmj = parcelRequire("7Dcmj");

var $7430d30e03ecd182$var$_classnames = $7430d30e03ecd182$var$_interopRequireDefault((parcelRequire("8g1PZ")));
function $7430d30e03ecd182$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7430d30e03ecd182$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7430d30e03ecd182$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7430d30e03ecd182$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $7430d30e03ecd182$var$preventDefault = (e)=>{
    e.preventDefault();
};
const $7430d30e03ecd182$var$Button = (0, $7430d30e03ecd182$var$_getStyledComponent.default)({
    tagName: "button",
    baseClasses: "br2 ba",
    options: {
        size: [
            "tiny",
            "large"
        ],
        pressed: [
            "pressed"
        ],
        variant: [
            "primary",
            "stop",
            "disabled"
        ]
    },
    defaultProps: {
        onContextMenu: $7430d30e03ecd182$var$preventDefault
    },
    fn: ({ tiny: tiny, large: large, disabled: disabled, pressed: pressed, primary: primary, stop: stop })=>{
        let classes = [
            "bn"
        ]; // handle sizes
        if (tiny) classes.push("pa1");
        else if (large) classes.push("pa3 fw6");
        else classes.push("pa2");
         // if disabled stop here
        if (disabled) {
            classes.push("mid-gray bg-light-gray not-allowed");
            return classes.join(" ");
        } // pointer class
        classes.push("pointer");
        if (pressed) classes.push("shadow-3");
        else classes.push("shadow-2");
        if (stop) classes.push("white bg-red");
        if (primary) classes.push("dark-blue bg-light-blue");
        if (!stop && !primary) {
            classes.push("dark-blue");
            if (pressed) classes.push("bg-lightest-blue");
            else classes.push("bg-white");
        }
        return classes.join(" ");
    }
});
module.exports.Button = $7430d30e03ecd182$var$Button;
const $7430d30e03ecd182$var$getDefaultIconSize = (props)=>{
    if (props.large) return 32;
    if (props.tiny) return 14;
    return 16;
};
const $7430d30e03ecd182$var$IconButton = (_ref)=>{
    let { icon: icon, iconSize: iconSize, children: children } = _ref, rest = $7430d30e03ecd182$var$_objectWithoutProperties(_ref, [
        "icon",
        "iconSize",
        "children"
    ]);
    return (0, $767w7.h)($7430d30e03ecd182$var$Button, rest, (0, $767w7.h)("span", {
        className: "flex items-center"
    }, (0, $767w7.h)($7Dcmj.Icon, {
        icon: icon,
        className: (0, $7430d30e03ecd182$var$_classnames.default)({
            mr1: !rest.large,
            mr2: !!rest.large
        }),
        size: iconSize || $7430d30e03ecd182$var$getDefaultIconSize(rest)
    }), children));
};
module.exports.IconButton = $7430d30e03ecd182$var$IconButton;
const $7430d30e03ecd182$var$TapIconButton = (0, $7430d30e03ecd182$var$_getStyledComponent.default)({
    baseClasses: "button-reset pointer pa0 ma0 bn bg-transparent flex items-center justify-center",
    style: {
        width: "40px",
        height: "40px"
    },
    options: {
        icon: [
            "icon"
        ],
        color: [
            "color"
        ]
    },
    renderChildren: ({ icon: icon, color: color })=>[
            (0, $767w7.h)($7Dcmj.Icon, {
                key: icon,
                icon: icon,
                color: color,
                size: "28"
            })
        ]
});
module.exports.TapIconButton = $7430d30e03ecd182$var$TapIconButton;

});
parcelRegister("7Dcmj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CircledIcon = module.exports.Icon = void 0;

var $767w7 = parcelRequire("767w7");

var $58e5c32318fdcb5a$var$_classnames = $58e5c32318fdcb5a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $04wYO = parcelRequire("04wYO");

var $58e5c32318fdcb5a$var$_pillIcon = $58e5c32318fdcb5a$var$_interopRequireDefault((parcelRequire("c6sws")));

var $9I9Sw = parcelRequire("9I9Sw");

var $bpUB6 = parcelRequire("bpUB6");
function $58e5c32318fdcb5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $58e5c32318fdcb5a$var$_extends() {
    $58e5c32318fdcb5a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $58e5c32318fdcb5a$var$_extends.apply(this, arguments);
}
const $58e5c32318fdcb5a$var$customIcons = {
    pill: $58e5c32318fdcb5a$var$_pillIcon.default,
    loading_dots: $9I9Sw.LoadingDots,
    live_dot: $bpUB6.LiveDotIcon
};
/**
 * @typedef IconProps
 * @property {string} icon
 * @property {string | number} [size=24] Default is `24`
 * @property {string} [className]
 * @property {number} [speed] Where 0 is stopped 1 is normal speed.
 * @property {any} [style]
 */ /**
 * Icon
 *
 * @type {import('preact').FunctionComponent}
 * @param {IconProps} props
 */ const $58e5c32318fdcb5a$var$Icon = (props)=>{
    const { icon: icon, size: size, className: className, style: style, speed: speed } = props;
    const rest = (0, $04wYO.omit)(props, [
        "icon",
        "size",
        "className"
    ]);
    const px = "".concat(size || 24, "px");
    const styles = Object.assign({}, style, {
        fontSize: px,
        width: px,
        height: px
    });
    const Custom = $58e5c32318fdcb5a$var$customIcons[icon];
    return (0, $767w7.h)("i", $58e5c32318fdcb5a$var$_extends({}, rest, {
        style: styles,
        className: (0, $58e5c32318fdcb5a$var$_classnames.default)("dib flex-shrink-0", {
            "material-icons": !Custom
        }, className)
    }), Custom ? (0, $767w7.h)(Custom, {
        speed: speed,
        size: size
    }) : icon);
};
module.exports.Icon = $58e5c32318fdcb5a$var$Icon;
const $58e5c32318fdcb5a$var$colors = {
    blue: [
        "bg-lightest-blue",
        "blue"
    ],
    yellow: [
        "bg-light-yellow",
        "orange"
    ],
    green: [
        "bg-light-green",
        "dark-green"
    ],
    gray: [
        "bg-light-gray",
        "dark-gray"
    ],
    red: [
        "bg-light-red",
        "dark-red"
    ]
};
/**
 * @typedef CircleIconProps
 * @property {string} icon
 * @property {string | number} [size=24] Default is `24`
 * @property {'blue' | 'yellow' | 'green' | 'gray' | 'red'} color
 * @property {number} [speed] Where 0 is stopped 1 is normal speed.
 */ /**
 * CircledIcon
 *
 * @type {import('preact').FunctionComponent}
 * @param {CircleIconProps} props
 */ const $58e5c32318fdcb5a$var$CircledIcon = ({ icon: icon, size: size, color: color, speed: speed })=>{
    size = size ? Number(size) : 24;
    const circleSize = "".concat(Math.round(size * 1.5), "px");
    const matchedColor = $58e5c32318fdcb5a$var$colors[color];
    return (0, $767w7.h)("div", {
        style: {
            width: circleSize,
            height: circleSize
        },
        className: (0, $58e5c32318fdcb5a$var$_classnames.default)("inline-flex items-center justify-center br-100 flex-shrink-0", matchedColor && matchedColor[0])
    }, (0, $767w7.h)($58e5c32318fdcb5a$var$Icon, {
        icon: icon,
        size: size,
        speed: speed,
        className: (0, $58e5c32318fdcb5a$var$_classnames.default)(matchedColor && matchedColor[1])
    }));
};
module.exports.CircledIcon = $58e5c32318fdcb5a$var$CircledIcon;

});
parcelRegister("9I9Sw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoadingDots = void 0;

var $767w7 = parcelRequire("767w7");
function $711fe2c6122f1c98$var$_extends() {
    $711fe2c6122f1c98$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $711fe2c6122f1c98$var$_extends.apply(this, arguments);
}
function $711fe2c6122f1c98$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $711fe2c6122f1c98$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $711fe2c6122f1c98$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $711fe2c6122f1c98$var$LoadingDots = (_ref)=>{
    let { size: size = 24 } = _ref, rest = $711fe2c6122f1c98$var$_objectWithoutProperties(_ref, [
        "size"
    ]);
    const usableSize = size * 0.75;
    const padding = size * 0.125;
    const radius = usableSize / 8;
    return (0, $767w7.h)("svg", $711fe2c6122f1c98$var$_extends({
        className: "dot-animation",
        width: size,
        height: size
    }, rest), (0, $767w7.h)("circle", {
        cx: radius + padding,
        cy: radius * 3,
        r: radius
    }), (0, $767w7.h)("circle", {
        cx: radius * 4 + padding,
        cy: radius * 3,
        r: radius
    }), (0, $767w7.h)("circle", {
        cx: radius * 7 + padding,
        cy: radius * 3,
        r: radius
    }));
};
module.exports.LoadingDots = $711fe2c6122f1c98$var$LoadingDots;

});

parcelRegister("bpUB6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LiveDotIcon = void 0;

var $767w7 = parcelRequire("767w7");
function $84fdee91066fdb9b$var$_extends() {
    $84fdee91066fdb9b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84fdee91066fdb9b$var$_extends.apply(this, arguments);
}
function $84fdee91066fdb9b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $84fdee91066fdb9b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $84fdee91066fdb9b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $84fdee91066fdb9b$var$baseAnimation = [
    {
        opacity: 1,
        transform: "scale(0)"
    },
    {
        opacity: 0.2,
        offset: 0.7
    },
    {
        opacity: 0,
        transform: "scale(1)",
        color: "#000"
    }
];
class $84fdee91066fdb9b$var$LiveDotIcon extends $767w7.Component {
    constructor(props){
        super(props);
    }
    setSpeed(newSpeed) {
        const circles = this.getCircles();
        this.currentSpeed = newSpeed;
        if (circles) try {
            circles.forEach((circle)=>{
                const [animation] = circle.getAnimations();
                animation.updatePlaybackRate(newSpeed);
            });
        } catch (e) {}
    }
    updateSpeed(newSpeed) {
        if (newSpeed !== this.currentSpeed) this.setSpeed(newSpeed);
    }
    componentDidMount() {
        this.startAnimation();
        this.setSpeed(this.props.speed);
    }
    shouldComponentUpdate(props) {
        if (props.size !== this.props.size) return true;
        return false;
    }
    UNSAFE_componentWillReceiveProps(props) {
        this.updateSpeed(props.speed);
    }
    getCircles() {
        return this.base && Array.prototype.slice.call(this.base.children);
    }
    startAnimation() {
        const circles = this.getCircles();
        if (circles) try {
            circles.forEach((circle, i)=>{
                circle.animate($84fdee91066fdb9b$var$baseAnimation, {
                    duration: 3000,
                    delay: i * 1000,
                    iterations: Infinity,
                    easing: "ease-out"
                });
            });
        } catch (e) {}
    }
    render() {
        const style = {
            transformOrigin: "center"
        };
        const _this$props = this.props, { size: size = 24 } = _this$props, rest = $84fdee91066fdb9b$var$_objectWithoutProperties(_this$props, [
            "size"
        ]);
        const usableSize = size * 0.98;
        const halfSize = usableSize / 2;
        const middle = size / 2;
        return (0, $767w7.h)("svg", $84fdee91066fdb9b$var$_extends({
            width: size,
            height: size
        }, rest), (0, $767w7.h)("circle", {
            className: "o-0",
            style: style,
            cx: middle,
            cy: middle,
            r: halfSize
        }), (0, $767w7.h)("circle", {
            className: "o-0",
            style: style,
            cx: middle,
            cy: middle,
            r: halfSize
        }), (0, $767w7.h)("circle", {
            className: "o-0",
            style: style,
            cx: middle,
            cy: middle,
            r: halfSize
        }));
    }
}
module.exports.LiveDotIcon = $84fdee91066fdb9b$var$LiveDotIcon;

});



parcelRegister("7EOve", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuestionList = module.exports.buildSuggestionList = module.exports.getAutoPopulatedValue = module.exports.removeCommaSeparatedItem = module.exports.addCommaSeparatedItem = module.exports.withoutText = module.exports.textAppended = void 0;

var $bWREg = parcelRequire("bWREg");
const $5933719b9d8f09a3$var$textAppended = (existing, newPhrase)=>{
    if (!existing) return newPhrase;
    let cleaned = existing.trim();
    if (cleaned.slice(-1)[0] !== ".") cleaned = cleaned + ".";
    return "".concat(cleaned, " ").concat(newPhrase);
};
module.exports.textAppended = $5933719b9d8f09a3$var$textAppended;
const $5933719b9d8f09a3$var$withoutText = (existing = "", phraseToRemove)=>existing.replace(phraseToRemove, "").replace("  ", " ").trim();
module.exports.withoutText = $5933719b9d8f09a3$var$withoutText;
const $5933719b9d8f09a3$var$getAsArray = (existing = "")=>existing.split(",").map((item)=>item.trim()).filter(Boolean);
const $5933719b9d8f09a3$var$addCommaSeparatedItem = (existing, newItem)=>[
        ...$5933719b9d8f09a3$var$getAsArray(existing),
        newItem
    ].join(", ");
module.exports.addCommaSeparatedItem = $5933719b9d8f09a3$var$addCommaSeparatedItem;
const $5933719b9d8f09a3$var$removeCommaSeparatedItem = (existing, toRemove)=>$5933719b9d8f09a3$var$getAsArray(existing).filter((item)=>item !== toRemove).join(", ");
module.exports.removeCommaSeparatedItem = $5933719b9d8f09a3$var$removeCommaSeparatedItem;
const $5933719b9d8f09a3$var$getAutoPopulatedValue = (suggestions)=>{
    const totalSuggestions = suggestions.length;
    if (!totalSuggestions) return "";
    const firstSuggestionEntry = suggestions[0];
    const firstScore = firstSuggestionEntry.score;
    if (firstScore < 3) return "";
    const secondScore = suggestions[1] && suggestions[1].score || 0;
    const scoreDiff = firstScore - secondScore;
    const confidenceValue = scoreDiff / (firstScore + secondScore);
    return confidenceValue > 0.7 ? firstSuggestionEntry.phrase : "";
};
module.exports.getAutoPopulatedValue = $5933719b9d8f09a3$var$getAutoPopulatedValue;
const $5933719b9d8f09a3$var$buildSuggestionList = (matchingSuggestion, value, autoSuggestType)=>matchingSuggestion && autoSuggestType ? matchingSuggestion.slice(0, 5).map(({ phrase: phrase })=>{
        let pressed;
        if (autoSuggestType === "single") pressed = value && value.trim() === phrase;
        else pressed = value && value.includes(phrase);
        return {
            phrase: phrase,
            pressed: pressed
        };
    }) : null;
module.exports.buildSuggestionList = $5933719b9d8f09a3$var$buildSuggestionList;
const $5933719b9d8f09a3$var$buildQuestionList = (config, data, suggestionsByField)=>{
    const result = [];
    const addQuestion = (item)=>{
        const { suggestions: suggestions, deleting: deleting } = suggestionsByField[item.name] || {};
        let value = item.defaultValue;
        if (data.hasOwnProperty(item.name)) value = data[item.name];
        else if (item.autoSuggestType && suggestions) value = $5933719b9d8f09a3$var$getAutoPopulatedValue(suggestions);
        const question = Object.assign({}, (0, $bWREg.decorateFormItem)(item, value, data), {
            value: value,
            suggestions: $5933719b9d8f09a3$var$buildSuggestionList(suggestions, value, item.autoSuggestType),
            suggestionsDeleting: !!deleting
        });
        result.push(question);
        if (question.choices) question.choices.forEach(({ val: val, questions: questions })=>{
            if (question.value === val && questions) questions.forEach(addQuestion);
        });
    };
    config.forEach(addQuestion);
    return result;
};
module.exports.buildQuestionList = $5933719b9d8f09a3$var$buildQuestionList;

});
parcelRegister("bWREg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decorateFormItem = module.exports.choice = void 0;
function $8b2eb9f30ba2170d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8b2eb9f30ba2170d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8b2eb9f30ba2170d$var$ownKeys(Object(source), true).forEach(function(key) {
            $8b2eb9f30ba2170d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8b2eb9f30ba2170d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8b2eb9f30ba2170d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $8b2eb9f30ba2170d$var$choice = (name, val, qs)=>{
    if (Array.isArray(val) && !qs) {
        qs = val;
        val = name;
    }
    const result = {
        name: name,
        val: typeof val !== "undefined" ? val : name
    };
    if (qs) result.questions = qs;
    return result;
};
module.exports.choice = $8b2eb9f30ba2170d$var$choice;
const $8b2eb9f30ba2170d$var$testComplete = (value)=>typeof value === "string" ? !!value : value != null;
const $8b2eb9f30ba2170d$var$decorateFormItem = (item, value, allValues)=>{
    let itemToProcess = item.transformBasedOnValues ? item.transformBasedOnValues(item, allValues) : item;
    const { test: test, required: required, completenessTest: completenessTest, getFinalValue: getFinalValue } = itemToProcess;
    const isRequired = required !== false;
    const errorMessage = test && test(value);
    const isComplete = !isRequired && !value || !errorMessage && (completenessTest ? completenessTest(value) : $8b2eb9f30ba2170d$var$testComplete(value));
    const finalValue = getFinalValue ? getFinalValue(value) : value;
    return $8b2eb9f30ba2170d$var$_objectSpread($8b2eb9f30ba2170d$var$_objectSpread({}, itemToProcess), {}, {
        value: value,
        errorMessage: errorMessage,
        isComplete: isComplete,
        isRequired: isRequired,
        finalValue: finalValue
    });
};
module.exports.decorateFormItem = $8b2eb9f30ba2170d$var$decorateFormItem;

});



parcelRegister("RzImO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");

var $6nGUz = parcelRequire("6nGUz");
function $0a10a786d3bdbe37$var$_extends() {
    $0a10a786d3bdbe37$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a10a786d3bdbe37$var$_extends.apply(this, arguments);
}
function $0a10a786d3bdbe37$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0a10a786d3bdbe37$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0a10a786d3bdbe37$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0a10a786d3bdbe37$var$_default = (_ref)=>{
    let { bottom: bottom, fields: fields, onSubmit: onSubmit, updateValue: updateValue, removeSuggestion: removeSuggestion, otherFieldTypes: otherFieldTypes } = _ref, rest = $0a10a786d3bdbe37$var$_objectWithoutProperties(_ref, [
        "bottom",
        "fields",
        "onSubmit",
        "updateValue",
        "removeSuggestion",
        "otherFieldTypes"
    ]);
    return (0, $767w7.h)("form", $0a10a786d3bdbe37$var$_extends({
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit();
        }
    }, rest), (0, $767w7.h)("div", null, fields.map((item)=>(0, $767w7.h)($6nGUz.Question, {
            key: item.name,
            item: item,
            otherFieldTypes: otherFieldTypes,
            updateValue: (val)=>{
                let updateObj = {
                    [item.name]: val
                };
                if (item.getUpdates) updateObj = item.getUpdates(val);
                updateValue(updateObj);
            },
            removeSuggestion: removeSuggestion
        }))), bottom);
};
module.exports.default = $0a10a786d3bdbe37$var$_default;

});
parcelRegister("6nGUz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Question = void 0;

var $767w7 = parcelRequire("767w7");

var $aeAE3 = parcelRequire("aeAE3");

var $3GW7W = parcelRequire("3GW7W");

var $bvmaP = parcelRequire("bvmaP");
function $4a562d651dfe4864$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4a562d651dfe4864$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4a562d651dfe4864$var$ownKeys(Object(source), true).forEach(function(key) {
            $4a562d651dfe4864$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4a562d651dfe4864$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4a562d651dfe4864$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $4a562d651dfe4864$var$fieldMap = {
    multiButton: $aeAE3.SelectButtons,
    choices: $aeAE3.SelectButtons,
    longText: $aeAE3.TextareaField,
    checkbox: $aeAE3.CheckboxField,
    medications: $bvmaP.MultiMedicationEntryField,
    medication: $3GW7W.MedicationEntryField,
    signature: $aeAE3.SignatureField,
    incrementor: $aeAE3.IncrementButtonField,
    timeIncrementor: $aeAE3.TimeIncrementField,
    select: $aeAE3.SelectField,
    decimal: $aeAE3.DecimalInputField
};
const $4a562d651dfe4864$var$Question = ({ item: item, updateValue: updateValue, removeSuggestion: removeSuggestion, otherFieldTypes: otherFieldTypes })=>{
    if (item.hidden) return null;
     // if item has "choices" (very common in our app)
    // don't require specifying `type: 'choices'`
    const itemType = item.type || (item.choices ? "choices" : "text");
    const MatchedComponent = otherFieldTypes && otherFieldTypes[itemType] || $4a562d651dfe4864$var$fieldMap[itemType] || $aeAE3.InputField;
    const props = $4a562d651dfe4864$var$_objectSpread({
        item: item,
        updateValue: updateValue,
        removeSuggestion: removeSuggestion
    }, item.fieldSpecificProps || {});
    return (0, $767w7.h)(MatchedComponent, props);
};
module.exports.Question = $4a562d651dfe4864$var$Question;

});
parcelRegister("aeAE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckboxField = module.exports.InjectionTypeField = module.exports.InfusionBolusField = module.exports.InfusionUnitField = module.exports.InfusionTypeField = module.exports.LocalUnitField = module.exports.OralAdministrationField = module.exports.SelectField = module.exports.SignatureField = module.exports.TimeIncrementField = module.exports.IncrementButtonField = module.exports.TextareaField = module.exports.DecimalInputField = module.exports.InputField = module.exports.SelectButtons = module.exports.Label = void 0;

var $767w7 = parcelRequire("767w7");

var $7737a324d9c7092b$var$_classnames = $7737a324d9c7092b$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $jFHOZ = parcelRequire("jFHOZ");

var $23DLa = parcelRequire("23DLa");

var $3U6K7 = parcelRequire("3U6K7");

var $9YtMX = parcelRequire("9YtMX");

var $7Dcmj = parcelRequire("7Dcmj");

var $bug1B = parcelRequire("bug1B");

var $7737a324d9c7092b$var$_suggestionsBox = $7737a324d9c7092b$var$_interopRequireDefault((parcelRequire("dTc56")));

var $df4Ty = parcelRequire("df4Ty");

var $luEbf = parcelRequire("luEbf");

var $bWREg = parcelRequire("bWREg");
function $7737a324d9c7092b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7737a324d9c7092b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7737a324d9c7092b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7737a324d9c7092b$var$ownKeys(Object(source), true).forEach(function(key) {
            $7737a324d9c7092b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7737a324d9c7092b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7737a324d9c7092b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7737a324d9c7092b$var$_extends() {
    $7737a324d9c7092b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7737a324d9c7092b$var$_extends.apply(this, arguments);
}
function $7737a324d9c7092b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7737a324d9c7092b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7737a324d9c7092b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $7737a324d9c7092b$var$noOp = ()=>{};
const $7737a324d9c7092b$var$Label = ({ item: item, updateValue: updateValue, removeSuggestion: removeSuggestion })=>{
    const isRequired = item.required !== false;
    return (0, $767w7.h)("label", {
        className: "db fw6 lh-copy f5 mb1",
        htmlFor: item.name
    }, (0, $767w7.h)("div", {
        className: "flex-shrink-0"
    }, (0, $767w7.h)("div", {
        className: "flex items-center"
    }, item.label, isRequired && item.isComplete && (0, $767w7.h)($7Dcmj.Icon, {
        className: "ml2 light-blue",
        icon: "check",
        size: "18"
    }), isRequired && !item.isComplete && (0, $767w7.h)("span", {
        className: "fw3 red ml2"
    }, "(required)"), !isRequired && item.explicitOptional && (0, $767w7.h)("span", {
        className: "fw3 gray ml2"
    }, "(optional)")), item.subLabel && (0, $767w7.h)("div", {
        className: (0, $7737a324d9c7092b$var$_classnames.default)("fw3 f6", {
            orange: item.subLabelWarning,
            red: item.subLabelError
        })
    }, item.subLabel instanceof Function ? item.subLabel(item) : item.subLabel)), item.buttons && (0, $767w7.h)("div", null, item.buttons.map((option)=>{
        let label;
        let val;
        if (Array.isArray(option)) {
            label = option[0];
            val = option[1];
        } else {
            label = option;
            val = option;
        }
        return (0, $767w7.h)($9YtMX.Button, {
            key: val,
            type: "button",
            "data-e2e": "".concat(item.name, "InputButton:").concat(val),
            className: "mr2 ml0 mt2",
            pressed: item.value === val,
            onClick: (e)=>{
                e.preventDefault();
                updateValue(val);
            }
        }, label);
    })), item.suggestions && (0, $767w7.h)($7737a324d9c7092b$var$_suggestionsBox.default, {
        removeSuggestion: removeSuggestion,
        name: item.name,
        value: item.value,
        autoSuggestType: item.autoSuggestType,
        updateValue: updateValue,
        suggestions: item.suggestions,
        suggestionsDeleting: item.suggestionsDeleting
    }));
};
module.exports.Label = $7737a324d9c7092b$var$Label;
const $7737a324d9c7092b$var$separator = ", ";
const $7737a324d9c7092b$var$stringToArray = (str)=>str ? str.toString().split($7737a324d9c7092b$var$separator) : [];
const $7737a324d9c7092b$var$arrayToString = (arr)=>arr.filter(Boolean).join($7737a324d9c7092b$var$separator);
class $7737a324d9c7092b$var$SelectButtons extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = {
            open: false
        };
        this.handleButtonPress = this.handleButtonPress.bind(this);
        this.handleOtherPress = this.handleOtherPress.bind(this);
        this.open = ()=>{
            if (!this.state.open) this.setState({
                open: true
            });
            setTimeout(()=>{
                const input = this.base && this.base.querySelector("input");
                if (input) input.focus();
            }, 200);
        };
        this.close = ()=>this.setState({
                open: false
            });
        this.choiceValues = props.item.choices.reduce((res, choice)=>{
            res[choice.val] = true;
            return res;
        }, {});
    }
    handleButtonPress(val, isPressed) {
        const { item: item, updateValue: updateValue, allowDeselect: allowDeselect } = this.props;
        const preventDeselect = item.allowDeselect === false || allowDeselect === false;
        const isMultiButton = item.type === "multiButton";
        const { value: value } = item;
        if (!isMultiButton) {
            this.close();
            if (isPressed && preventDeselect) return;
            updateValue(isPressed ? null : val);
        } else {
            const values = $7737a324d9c7092b$var$stringToArray(value);
            const index = values.indexOf(val);
            if (index === -1) values.push(val);
            else values.splice(index, 1);
            updateValue($7737a324d9c7092b$var$arrayToString(values));
        }
    }
    handleOtherPress(isPressed) {
        const { updateValue: updateValue, item: item } = this.props;
        const isMultiButton = item.type === "multiButton";
        if (!isMultiButton) {
            if (isPressed) {
                this.close();
                updateValue(null);
            } else {
                this.open();
                updateValue("");
            }
        } else {
            const values = $7737a324d9c7092b$var$stringToArray(this.props.item.value);
            if (isPressed) {
                this.close();
                const unknownRemoved = values.reduce((res, val)=>{
                    if (this.choiceValues[val]) res.push(val);
                    return res;
                }, []);
                updateValue($7737a324d9c7092b$var$arrayToString(unknownRemoved));
            } else {
                values.push("");
                updateValue($7737a324d9c7092b$var$arrayToString(values));
                this.open();
            }
        }
    }
    getPressed(val) {
        const { value: value, type: type } = this.props.item;
        const isMultiButton = type === "multiButton"; // if there are no unusual circumstances, we just want an exact match
        if (!isMultiButton) return value === val;
        return value != null && value.toString().includes(val);
    }
    getOtherInputVisible() {
        return this.state.open || // or it contains something outside of known options
        // this is important for first load (since we may not have state yet)
        !$7737a324d9c7092b$var$stringToArray(this.props.item.value).every((val)=>this.choiceValues[val]);
    }
    render(_ref) {
        let { item: item, updateValue: updateValue } = _ref, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref, [
            "item",
            "updateValue"
        ]);
        const showOtherInput = this.getOtherInputVisible();
        const { value: value } = item;
        return (0, $767w7.h)("div", rest, item.label && (0, $767w7.h)($7737a324d9c7092b$var$Label, {
            item: item,
            updateValue: updateValue
        }), (0, $767w7.h)("div", {
            "data-e2e": "".concat(item.name, "InputButtons")
        }, item.choices.map((choice)=>{
            let { name: name, val: val, disabled: disabled } = choice;
            const pressed = this.getPressed(val);
            return (0, $767w7.h)($9YtMX.Button, {
                key: val,
                pressed: pressed,
                className: "mr2 mv1 items-base",
                "data-e2e": "".concat(item.name, "InputButton:").concat(val),
                "data-state": pressed ? "pressed" : "unpressed",
                type: "button",
                disabled: !!disabled,
                onClick: ()=>this.handleButtonPress(val, pressed)
            }, name);
        }), item.showOther && (0, $767w7.h)($9YtMX.Button, {
            key: "other",
            pressed: showOtherInput,
            "data-state": showOtherInput ? "pressed" : "unpressed",
            className: "mr2 mv1 items-base",
            type: "button",
            onClick: ()=>this.handleOtherPress(showOtherInput),
            "data-e2e": "".concat(item.name, "InputButton:other")
        }, "Other"), item.showOther && showOtherInput && (0, $767w7.h)($bug1B.Input, {
            className: "mv1 w-100 border-box",
            name: "".concat(item.name, "Other"),
            value: value,
            onInput: (e)=>updateValue(e.target.value)
        })));
    }
}
module.exports.SelectButtons = $7737a324d9c7092b$var$SelectButtons;
const $7737a324d9c7092b$var$identity = (res)=>res;
const $7737a324d9c7092b$var$autoCompleteFallback = $df4Ty.IS_CHROME ? "new-password" : "none";
const $7737a324d9c7092b$var$InputField = (_ref2)=>{
    let { item: item, updateValue: updateValue, autocomplete: autocomplete = $7737a324d9c7092b$var$autoCompleteFallback, autofocus: autofocus, className: className = "", inputClassName: inputClassName = "w-100", removeSuggestion: removeSuggestion } = _ref2, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref2, [
        "item",
        "updateValue",
        "autocomplete",
        "autofocus",
        "className",
        "inputClassName",
        "removeSuggestion"
    ]);
    const type = item.type || "text";
    let clean = item.clean;
    const { value: value, cleanRe: cleanRe } = item;
    if (!clean && cleanRe) clean = (val)=>val.replace(cleanRe, "");
    if (!clean) clean = $7737a324d9c7092b$var$identity;
    if (item.inputClassName) inputClassName = item.inputClassName;
    const update = (e)=>updateValue(clean(e.target.value));
    const hasError = !!item.errorMessage;
    return (0, $767w7.h)("div", $7737a324d9c7092b$var$_extends({
        className: "w-100 ".concat(className)
    }, rest), item.label && (0, $767w7.h)($7737a324d9c7092b$var$Label, {
        item: item,
        updateValue: updateValue,
        removeSuggestion: removeSuggestion
    }), (0, $767w7.h)($bug1B.Input, {
        className: (0, $7737a324d9c7092b$var$_classnames.default)("mv1", {
            "bg-washed-red": hasError
        }, inputClassName),
        name: item.name,
        onChange: item.onInput ? $7737a324d9c7092b$var$noOp : update,
        onInput: item.onInput ? update : $7737a324d9c7092b$var$noOp,
        id: item.name,
        placeholder: item.placeholder,
        type: type,
        value: value,
        autocomplete: autocomplete,
        autofocus: autofocus,
        disabled: item.disabled,
        inputmode: item.inputmode || null,
        "data-e2e": "".concat(item.name, "Input"),
        "data-has-error": hasError ? true : null,
        style: item.inputWidth ? {
            width: item.inputWidth
        } : null
    }));
};
module.exports.InputField = $7737a324d9c7092b$var$InputField;
const $7737a324d9c7092b$var$DecimalInputField = (_ref3)=>{
    let { item: item, updateValue: updateValue } = _ref3, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref3, [
        "item",
        "updateValue"
    ]);
    const args = {};
    if (item.hasOwnProperty("maxLenBefore")) args.min = item.min;
    if (item.hasOwnProperty("max")) args.max = item.max;
    const { maxLenBefore: maxLenBefore, maxLenAfter: maxLenAfter } = item, itemRest = $7737a324d9c7092b$var$_objectWithoutProperties(item, [
        "maxLenBefore",
        "maxLenAfter"
    ]);
    const modifiedItem = $7737a324d9c7092b$var$_objectSpread($7737a324d9c7092b$var$_objectSpread({
        onInput: true,
        inputmode: "decimal",
        clean: (0, $luEbf.getCleanDecimalWithLimits)({
            maxLenBefore: maxLenBefore,
            maxLenAfter: maxLenAfter
        }),
        required: false
    }, itemRest), {}, {
        type: "text"
    });
    return (0, $767w7.h)($7737a324d9c7092b$var$InputField, $7737a324d9c7092b$var$_extends({
        updateValue: updateValue,
        item: modifiedItem
    }, rest));
};
module.exports.DecimalInputField = $7737a324d9c7092b$var$DecimalInputField;
const $7737a324d9c7092b$var$TextareaField = ({ item: item, updateValue: updateValue, removeSuggestion: removeSuggestion })=>(0, $767w7.h)("div", {
        className: "mb2"
    }, (0, $767w7.h)($7737a324d9c7092b$var$Label, {
        item: item,
        updateValue: updateValue,
        removeSuggestion: removeSuggestion
    }), (0, $767w7.h)($bug1B.Textarea, {
        className: (0, $7737a324d9c7092b$var$_classnames.default)("w-100", item.size === "large" ? "h5" : "h4"),
        name: item.name,
        onChange: item.onInput ? $7737a324d9c7092b$var$noOp : (e)=>updateValue(e.target.value),
        onInput: item.onInput ? (e)=>updateValue(e.target.value) : $7737a324d9c7092b$var$noOp,
        value: item.value,
        id: item.name,
        "data-e2e": "".concat(item.name, "Input")
    }));
module.exports.TextareaField = $7737a324d9c7092b$var$TextareaField;
const $7737a324d9c7092b$var$IncrementButtonField = ({ item: item, displayValue: displayValue, updateValue: updateValue, step: step = 1, max: max = Infinity, min: min = 0, width: width, unit: unit = "", showStep: showStep = true, formatter: formatter, className: className })=>{
    const { name: name, value: value, fieldSpecificProps: fieldSpecificProps } = item;
    const passOn = $7737a324d9c7092b$var$_objectSpread({
        formatter: formatter,
        width: width,
        updateValue: updateValue,
        displayValue: displayValue,
        step: step,
        showStep: showStep,
        max: max,
        min: min,
        unit: unit,
        name: name,
        value: value != null ? value : fieldSpecificProps.startingValue
    }, fieldSpecificProps || {});
    return (0, $767w7.h)("div", {
        className: (0, $7737a324d9c7092b$var$_classnames.default)(className)
    }, (0, $767w7.h)($7737a324d9c7092b$var$Label, {
        item: item
    }), (0, $767w7.h)("div", null, (0, $767w7.h)($jFHOZ.IncrementorButtons, passOn)));
};
module.exports.IncrementButtonField = $7737a324d9c7092b$var$IncrementButtonField;
const $7737a324d9c7092b$var$TimeIncrementField = (_ref4)=>{
    let { item: item, displayValue: displayValue, updateValue: updateValue, max: max = Infinity, min: min = 0, className: className } = _ref4, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref4, [
        "item",
        "displayValue",
        "updateValue",
        "max",
        "min",
        "className"
    ]);
    const { name: name, value: value, fieldSpecificProps: fieldSpecificProps } = item;
    const passOn = $7737a324d9c7092b$var$_objectSpread({
        updateValue: updateValue,
        displayValue: displayValue,
        max: max,
        min: min,
        name: name,
        value: value != null ? value : fieldSpecificProps.startingValue
    }, fieldSpecificProps || {});
    return (0, $767w7.h)("div", $7737a324d9c7092b$var$_extends({
        className: (0, $7737a324d9c7092b$var$_classnames.default)(className)
    }, rest), (0, $767w7.h)($7737a324d9c7092b$var$Label, {
        item: item
    }), (0, $767w7.h)("div", null, (0, $767w7.h)($jFHOZ.TimeIncrementorButtons, passOn)));
};
module.exports.TimeIncrementField = $7737a324d9c7092b$var$TimeIncrementField;
class $7737a324d9c7092b$var$SignatureField extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = {
            editing: false
        };
    }
    render({ item: item, updateValue: updateValue }, { editing: editing }) {
        const { value: value } = item;
        return (0, $767w7.h)("div", null, item.label && (0, $767w7.h)($7737a324d9c7092b$var$Label, {
            item: item
        }), (0, $767w7.h)("div", null, !editing && value && (0, $767w7.h)($23DLa.Signature, {
            width: "200",
            path: value,
            className: $bug1B.inputOutlineClasses
        }), !editing && (0, $767w7.h)($9YtMX.Button, {
            type: "button",
            className: "db mv2",
            onClick: ()=>this.setState({
                    editing: true
                })
        }, value ? "Change" : "Add Signature"), editing && (0, $767w7.h)($3U6K7.SignatureInput, {
            name: item.signatureLineName,
            confirmButtonText: item.confirmButtonText,
            close: ()=>this.setState({
                    editing: false
                }),
            updateValue: (val)=>{
                updateValue(val);
                this.setState({
                    editing: false
                });
            }
        })));
    }
}
module.exports.SignatureField = $7737a324d9c7092b$var$SignatureField;
const $7737a324d9c7092b$var$Options = ({ options: options, value: value })=>(0, $767w7.h)($767w7.Fragment, null, options.map((option)=>{
        const val = option.hasOwnProperty("value") ? option.value : option;
        return (0, $767w7.h)("option", {
            key: val,
            value: val,
            selected: val === value,
            onClick: option.onClick
        }, option.label || option);
    }));
const $7737a324d9c7092b$var$SelectField = (_ref5)=>{
    let { item: item, updateValue: updateValue, autofocus: autofocus, className: className = "", inputClassName: inputClassName = "w-100" } = _ref5, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref5, [
        "item",
        "updateValue",
        "autofocus",
        "className",
        "inputClassName"
    ]);
    const type = item.type || "text";
    let clean = item.clean;
    const { value: value, cleanRe: cleanRe } = item;
    if (!clean && cleanRe) clean = (val)=>val.replace(cleanRe, "");
    if (!clean) clean = $7737a324d9c7092b$var$identity;
    if (item.inputClassName) inputClassName = item.inputClassName;
    const { optGroups: optGroups, options: options } = item;
    const update = (e)=>updateValue(clean(e.target.value));
    const hasError = !!item.errorMessage;
    return (0, $767w7.h)("div", $7737a324d9c7092b$var$_extends({
        className: "w-100 ".concat(className)
    }, rest), item.label && (0, $767w7.h)($7737a324d9c7092b$var$Label, {
        item: item,
        updateValue: updateValue
    }), (0, $767w7.h)($bug1B.Select, {
        className: (0, $7737a324d9c7092b$var$_classnames.default)("mv1", {
            "bg-washed-red": hasError
        }, inputClassName),
        name: item.name,
        onChange: update,
        id: item.name,
        placeholder: item.placeholder,
        type: type,
        value: value || "",
        autofocus: autofocus,
        "data-e2e": "".concat(item.name, "Select"),
        "data-has-error": hasError ? true : null,
        style: item.inputWidth ? {
            width: item.inputWidth
        } : null
    }, options && (0, $767w7.h)($7737a324d9c7092b$var$Options, {
        options: options
    }), optGroups && optGroups.map(({ label: label, options: options })=>(0, $767w7.h)("optgroup", {
            key: "label",
            label: label
        }, label, (0, $767w7.h)($7737a324d9c7092b$var$Options, {
            options: options
        })))));
};
module.exports.SelectField = $7737a324d9c7092b$var$SelectField;
const $7737a324d9c7092b$var$OralAdministrationField = (_ref6)=>{
    let { updateValue: updateValue, label: label, item: item } = _ref6, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref6, [
        "updateValue",
        "label",
        "item"
    ]);
    return (0, $767w7.h)($7737a324d9c7092b$var$SelectButtons, $7737a324d9c7092b$var$_extends({
        updateValue: updateValue,
        item: $7737a324d9c7092b$var$_objectSpread({
            name: "route",
            required: false,
            choices: [
                (0, $bWREg.choice)("PO"),
                (0, $bWREg.choice)("SL")
            ],
            label: label
        }, item)
    }, rest));
};
module.exports.OralAdministrationField = $7737a324d9c7092b$var$OralAdministrationField;
const $7737a324d9c7092b$var$LocalUnitField = (_ref7)=>{
    let { updateValue: updateValue, item: item } = _ref7, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref7, [
        "updateValue",
        "item"
    ]);
    return (0, $767w7.h)($7737a324d9c7092b$var$SelectButtons, $7737a324d9c7092b$var$_extends({
        item: $7737a324d9c7092b$var$_objectSpread({
            name: "unit",
            required: false,
            choices: [
                (0, $bWREg.choice)("cart.", "cartridges"),
                (0, $bWREg.choice)("ml"),
                (0, $bWREg.choice)("mg")
            ],
            label: "Unit"
        }, item),
        allowDeselect: false,
        updateValue: updateValue
    }, rest));
};
module.exports.LocalUnitField = $7737a324d9c7092b$var$LocalUnitField;
const $7737a324d9c7092b$var$InfusionTypeField = (_ref8)=>{
    let { updateValue: updateValue, label: label, item: item } = _ref8, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref8, [
        "updateValue",
        "label",
        "item"
    ]);
    return (0, $767w7.h)($7737a324d9c7092b$var$SelectButtons, $7737a324d9c7092b$var$_extends({
        updateValue: updateValue,
        item: $7737a324d9c7092b$var$_objectSpread({
            name: "infusionType",
            required: false,
            allowDeselect: false,
            choices: [
                (0, $bWREg.choice)("Flow rate", "infusion"),
                (0, $bWREg.choice)("Pump bolus", "infusionBolus")
            ],
            label: label
        }, item)
    }, rest));
};
module.exports.InfusionTypeField = $7737a324d9c7092b$var$InfusionTypeField;
const $7737a324d9c7092b$var$infusionChoices = [
    (0, $bWREg.choice)("mcg/kg/min"),
    (0, $bWREg.choice)("mcg/kg/hr"),
    (0, $bWREg.choice)("mcg/min"),
    (0, $bWREg.choice)("mg/hr")
];
const $7737a324d9c7092b$var$InfusionUnitField = (_ref9)=>{
    let { updateValue: updateValue, label: label, item: item } = _ref9, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref9, [
        "updateValue",
        "label",
        "item"
    ]);
    return (0, $767w7.h)($7737a324d9c7092b$var$SelectButtons, $7737a324d9c7092b$var$_extends({
        updateValue: updateValue,
        item: $7737a324d9c7092b$var$_objectSpread({
            name: "infusionUnit",
            required: false,
            choices: $7737a324d9c7092b$var$infusionChoices,
            label: label
        }, item)
    }, rest));
};
module.exports.InfusionUnitField = $7737a324d9c7092b$var$InfusionUnitField;
const $7737a324d9c7092b$var$infusionBolusChoices = [
    (0, $bWREg.choice)("mcg/kg"),
    (0, $bWREg.choice)("mcg"),
    (0, $bWREg.choice)("mg")
];
const $7737a324d9c7092b$var$InfusionBolusField = (_ref10)=>{
    let { updateValue: updateValue, label: label, item: item } = _ref10, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref10, [
        "updateValue",
        "label",
        "item"
    ]);
    return (0, $767w7.h)($7737a324d9c7092b$var$SelectButtons, $7737a324d9c7092b$var$_extends({
        updateValue: updateValue,
        item: $7737a324d9c7092b$var$_objectSpread({
            name: "bolusUnit",
            required: false,
            choices: $7737a324d9c7092b$var$infusionBolusChoices,
            label: label
        }, item)
    }, rest));
};
module.exports.InfusionBolusField = $7737a324d9c7092b$var$InfusionBolusField;
const $7737a324d9c7092b$var$InjectionTypeField = (_ref11)=>{
    let { updateValue: updateValue, label: label, item: item, usingIV: usingIV = true } = _ref11, rest = $7737a324d9c7092b$var$_objectWithoutProperties(_ref11, [
        "updateValue",
        "label",
        "item",
        "usingIV"
    ]);
    const choices = [
        (0, $bWREg.choice)("IM"),
        (0, $bWREg.choice)("IMAD")
    ];
    if (usingIV) choices.unshift((0, $bWREg.choice)("IV"));
    return (0, $767w7.h)($7737a324d9c7092b$var$SelectButtons, $7737a324d9c7092b$var$_extends({
        updateValue: updateValue,
        item: $7737a324d9c7092b$var$_objectSpread({
            name: "injectionType",
            required: false,
            allowDeselect: false,
            choices: choices,
            label: label
        }, item)
    }, rest));
};
module.exports.InjectionTypeField = $7737a324d9c7092b$var$InjectionTypeField;
const $7737a324d9c7092b$var$CheckboxField = ({ updateValue: updateValue, item: item })=>{
    const { value: value, name: name, fieldSpecificProps: fieldSpecificProps, label: label } = item;
    const isComplete = !!value;
    const { checkboxLabel: checkboxLabel, valueIfTrue: valueIfTrue } = fieldSpecificProps || {};
    const labelToUse = checkboxLabel || label;
    return (0, $767w7.h)("div", null, (0, $767w7.h)($7737a324d9c7092b$var$Label, {
        item: item
    }), (0, $767w7.h)("label", {
        htmlFor: name,
        className: (0, $7737a324d9c7092b$var$_classnames.default)("flex items-center mb2"),
        "data-e2e": "checkMark",
        "data-state": isComplete ? "checked" : "unchecked"
    }, (0, $767w7.h)("input", {
        onClick: ()=>updateValue(isComplete ? null : valueIfTrue != null ? valueIfTrue : true),
        className: "checkbox o-0 absolute",
        id: name,
        checked: isComplete,
        type: "checkbox",
        "data-e2e": "".concat(name, "Input")
    }), (0, $767w7.h)("div", {
        className: "flex items-center"
    }, (0, $767w7.h)("div", {
        className: "relative",
        style: {
            height: "24px",
            width: "24px"
        }
    }, (0, $767w7.h)("div", {
        style: {
            top: "4px",
            left: "4px",
            position: "relative",
            background: "white",
            width: "16px",
            height: "16px"
        }
    }), (0, $767w7.h)($7Dcmj.Icon, {
        size: 24,
        icon: isComplete ? "check_box" : "check_box_outline_blank",
        className: (0, $7737a324d9c7092b$var$_classnames.default)("absolute top-0", isComplete && "light-blue")
    }))), (0, $767w7.h)("span", {
        className: "ml1"
    }, labelToUse)));
};
module.exports.CheckboxField = $7737a324d9c7092b$var$CheckboxField;

});
parcelRegister("jFHOZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $KzcA1 = parcelRequire("KzcA1");
Object.keys($KzcA1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $KzcA1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $KzcA1[key];
        }
    });
});

var $bGdHR = parcelRequire("bGdHR");
Object.keys($bGdHR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bGdHR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bGdHR[key];
        }
    });
});

});
parcelRegister("KzcA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IncrementorButtons = void 0;

var $767w7 = parcelRequire("767w7");

var $08bf9a5b77bb87ac$var$_classnames = $08bf9a5b77bb87ac$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $luEbf = parcelRequire("luEbf");

var $bug1B = parcelRequire("bug1B");

var $5ldOi = parcelRequire("5ldOi");

var $diRk5 = parcelRequire("diRk5");
function $08bf9a5b77bb87ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $08bf9a5b77bb87ac$var$roundIfNeeded = (val, step)=>(0, $luEbf.roundToDecimal)(val, (0, $luEbf.getNumberOfDecimals)(step));
class $08bf9a5b77bb87ac$var$IncrementorButtons extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = this.getUpdatedStateForValue(this.getValueToShow());
    }
    getTargetNumberOfDecimals() {
        const { step: step = 1 } = this.props;
        return (0, $luEbf.getNumberOfDecimals)(step);
    }
    getValueAsNumber(value) {
        if (typeof value === "string") return Number(value);
        return value;
    }
    getUpdatedStateForValue(rawValue, isTrusted) {
        let { max: max } = this.props;
        if (max == null) max = Infinity;
        if (isTrusted) return {
            error: null,
            asNumber: rawValue,
            internalTextValue: rawValue.toString(),
            isValid: true
        };
        const maxLenBefore = max === Infinity ? 20 : max.toString().split(".")[0].length;
        const maxLenAfter = this.getTargetNumberOfDecimals();
        const cleaned = (0, $luEbf.getCleanDecimalWithLimits)({
            maxLenBefore: maxLenBefore,
            maxLenAfter: maxLenAfter
        })(rawValue);
        const asNumber = this.getValueAsNumber(cleaned);
        const hasValue = !!rawValue;
        const error = hasValue ? this.getError(asNumber) : null;
        const isValid = hasValue && !error;
        return {
            error: error,
            asNumber: asNumber,
            internalTextValue: cleaned,
            isValid: isValid
        };
    }
    getValueToShow() {
        const { displayValue: displayValue, value: value } = this.props;
        const targetNumberOfDecimals = this.getTargetNumberOfDecimals();
        let valueToShow = displayValue != null ? displayValue : value;
        if (!valueToShow) valueToShow = targetNumberOfDecimals === 0 ? value : (0, $luEbf.ensureDecimals)(value, targetNumberOfDecimals);
        return valueToShow && valueToShow.toString ? valueToShow.toString() : "";
    }
    getError(val) {
        const { max: max, min: min } = this.props;
        if (isNaN(val)) return "invalid value";
        if (val > max) return "max is ".concat(max);
        if (val < min) return "min is ".concat(min);
        return;
    }
    realUpdateValue(newValue, isTrusted) {
        const realValueError = this.getError(this.getValueToShow());
        const { updateValue: updateValue } = this.props;
        const changedState = this.getUpdatedStateForValue(newValue, isTrusted);
        this.setState(changedState); // if we're already in an error state, we can allow the update.
        // this is important if we are fixing a scenario where the real-underlying
        // value is already out of range and people want to use the + and - buttons
        // to get it *into* range.
        if (!changedState.error || realValueError) // we only want to report it if it's different
        {
            if (changedState.asNumber !== this.props.value) updateValue(changedState.asNumber);
        }
    }
    // reflected in the text
    componentDidUpdate(prevProps) {
        const valueChanged = prevProps.value !== this.props.value;
        if (valueChanged) {
            const newTextValue = this.getUpdatedStateForValue(this.props.value, true).internalTextValue;
            if (newTextValue !== this.state.internalTextValue) this.realUpdateValue(this.props.value);
        }
    }
    render() {
        const { step: step = 1, max: max = Infinity, min: min = 0, className: className = "", showStep: showStep = true, unit: unit = "", value: value, startingValue: startingValue, name: name } = this.props;
        const { internalTextValue: internalTextValue, error: error } = this.state;
        const effectiveValue = value != null ? value : startingValue;
        const stepDown = $08bf9a5b77bb87ac$var$roundIfNeeded(effectiveValue - step, step);
        const stepUp = $08bf9a5b77bb87ac$var$roundIfNeeded(effectiveValue + step, step);
        return (0, $767w7.h)("div", {
            className: (0, $08bf9a5b77bb87ac$var$_classnames.default)("dib", error && $diRk5.errorClasses, className)
        }, (0, $767w7.h)("div", {
            className: "flex items-center ".concat(className)
        }, (0, $767w7.h)($bug1B.Input, {
            type: "text",
            "data-e2e": "".concat(name, "Value"),
            style: {
                width: "60px"
            },
            className: "mr2 f5" + (error ? "bg-washed-red" : ""),
            value: internalTextValue,
            onInput: (e)=>{
                const value = e.target.value;
                this.realUpdateValue(value);
            }
        }), unit && (0, $767w7.h)("span", {
            className: "mr2 f5 fw6"
        }, unit), (0, $767w7.h)($5ldOi.MinusButton, {
            name: name,
            disabled: stepDown < min,
            onClick: ()=>this.realUpdateValue(stepDown, true)
        }, showStep ? step : null), (0, $767w7.h)($5ldOi.PlusButton, {
            name: name,
            disabled: stepUp > max,
            onClick: ()=>this.realUpdateValue(stepUp, true)
        }, showStep ? step : null)), error && (0, $767w7.h)($diRk5.IncrementorError, null, error));
    }
}
module.exports.IncrementorButtons = $08bf9a5b77bb87ac$var$IncrementorButtons;

});
parcelRegister("luEbf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCleanDecimalWithLimits = module.exports.cleanDecimalInput = module.exports.ensureDecimals = module.exports.roundToPrecision = module.exports.roundToDecimal = module.exports.getNumberOfDecimals = void 0;

var $hP87r = parcelRequire("hP87r");
const $fa5b914dd9cc9aee$var$getNumberOfDecimals = (num)=>{
    const postDecimalString = (num + "").split(".")[1];
    return postDecimalString ? postDecimalString.length : 0;
};
module.exports.getNumberOfDecimals = $fa5b914dd9cc9aee$var$getNumberOfDecimals;
const $fa5b914dd9cc9aee$var$roundToDecimal = (number, precision)=>{
    const factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
};
module.exports.roundToDecimal = $fa5b914dd9cc9aee$var$roundToDecimal;
const $fa5b914dd9cc9aee$var$roundToPrecision = (number, precision)=>{
    if (!number || isNaN(number)) return 0;
    const decimalString = $fa5b914dd9cc9aee$var$roundToDecimal(number, precision).toString();
    const numberOfDigitsBeforePeriod = decimalString.split(".")[0].length;
    const actualPrecision = Math.max(precision - numberOfDigitsBeforePeriod, 0);
    return $fa5b914dd9cc9aee$var$roundToDecimal(number, actualPrecision);
};
module.exports.roundToPrecision = $fa5b914dd9cc9aee$var$roundToPrecision;
const $fa5b914dd9cc9aee$var$ensureDecimals = (number, targetDecimals = 0)=>{
    const numberOfDecimals = $fa5b914dd9cc9aee$var$getNumberOfDecimals(number);
    let numberToAdd = targetDecimals - numberOfDecimals;
    if (!numberToAdd) return number;
    let result = number + (numberOfDecimals === 0 ? "." : "");
    while(numberToAdd--)result += "0";
    return result;
};
module.exports.ensureDecimals = $fa5b914dd9cc9aee$var$ensureDecimals;
const $fa5b914dd9cc9aee$var$floatInputRE = /[^0-9.]/g;
const $fa5b914dd9cc9aee$var$leadingZerosWithDecimalRE = /^0{2,}\./g;
const $fa5b914dd9cc9aee$var$leadingZerosNoDecimalRE = /^0{1,}[0-9]/g;
const $fa5b914dd9cc9aee$var$periodRE = /\./g;
const $fa5b914dd9cc9aee$var$cleanDecimalInput = (str)=>{
    let matches = 0;
    if ((0, $hP87r.isNumber)(str)) str = str.toString();
    return str // removes invalid characters anywhere
    .replace($fa5b914dd9cc9aee$var$floatInputRE, "") // removes leading zeros if there's more than one before a decimal '00.123'
    .replace($fa5b914dd9cc9aee$var$leadingZerosWithDecimalRE, "0.") // removes leading zeros if there's no decimal
    .replace($fa5b914dd9cc9aee$var$leadingZerosNoDecimalRE, (match)=>match.slice(-1)) // removes all but first decimal
    .replace($fa5b914dd9cc9aee$var$periodRE, ()=>matches++ > 0 ? "" : ".");
};
module.exports.cleanDecimalInput = $fa5b914dd9cc9aee$var$cleanDecimalInput;
const $fa5b914dd9cc9aee$var$getCleanDecimalWithLimits = ({ maxLenBefore: maxLenBefore, maxLenAfter: maxLenAfter })=>(str)=>{
        const cleaned = $fa5b914dd9cc9aee$var$cleanDecimalInput(str);
        let split = cleaned.split(".");
        let [before, after] = split;
        if (!before && !after) return cleaned;
        if ((0, $hP87r.isNumber)(maxLenBefore) && before) before = before.slice(0, maxLenBefore);
        if ((0, $hP87r.isNumber)(maxLenAfter) && after) after = after.slice(0, maxLenAfter);
        if (!before) return ".".concat(after);
        if (after === undefined) return before;
        return [
            before,
            after
        ].join(".");
    };
module.exports.getCleanDecimalWithLimits = $fa5b914dd9cc9aee$var$getCleanDecimalWithLimits;

});
parcelRegister("hP87r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidNumber = module.exports.isNumber = module.exports.isString = void 0;
const $cf9d7f5d9fd56141$var$isString = (val)=>typeof val === "string";
module.exports.isString = $cf9d7f5d9fd56141$var$isString;
const $cf9d7f5d9fd56141$var$isNumber = (val)=>typeof val === "number";
module.exports.isNumber = $cf9d7f5d9fd56141$var$isNumber;
const $cf9d7f5d9fd56141$var$isValidNumber = (val)=>$cf9d7f5d9fd56141$var$isNumber(val) && !isNaN(val);
module.exports.isValidNumber = $cf9d7f5d9fd56141$var$isValidNumber;

});


parcelRegister("bug1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Textarea = module.exports.Select = module.exports.Input = module.exports.inputClasses = module.exports.inputOutlineClasses = void 0;

var $767w7 = parcelRequire("767w7");

var $85ceed3f2a985b0f$var$_classnames = $85ceed3f2a985b0f$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7Dcmj = parcelRequire("7Dcmj");

var $85ceed3f2a985b0f$var$_getStyledComponent = $85ceed3f2a985b0f$var$_interopRequireDefault((parcelRequire("45yGA")));
function $85ceed3f2a985b0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85ceed3f2a985b0f$var$_extends() {
    $85ceed3f2a985b0f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $85ceed3f2a985b0f$var$_extends.apply(this, arguments);
}
function $85ceed3f2a985b0f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $85ceed3f2a985b0f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $85ceed3f2a985b0f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $85ceed3f2a985b0f$var$inputOutlineClasses = "ba b--gray";
module.exports.inputOutlineClasses = $85ceed3f2a985b0f$var$inputOutlineClasses;
const $85ceed3f2a985b0f$var$inputClasses = "pa2 input-reset " + $85ceed3f2a985b0f$var$inputOutlineClasses;
module.exports.inputClasses = $85ceed3f2a985b0f$var$inputClasses;
const $85ceed3f2a985b0f$var$Input = (0, $85ceed3f2a985b0f$var$_getStyledComponent.default)({
    baseClasses: $85ceed3f2a985b0f$var$inputClasses,
    tagName: "input",
    options: {
        disabled: [
            "disabled"
        ]
    },
    fn: ({ disabled: disabled })=>disabled ? "mid-gray bg-near-white not-allowed" : "bg-white"
});
module.exports.Input = $85ceed3f2a985b0f$var$Input;
const $85ceed3f2a985b0f$var$Select = (_ref)=>{
    let { className: className, children: children } = _ref, rest = $85ceed3f2a985b0f$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return (0, $767w7.h)("span", {
        className: "flex items-center"
    }, (0, $767w7.h)("select", $85ceed3f2a985b0f$var$_extends({}, rest, {
        className: (0, $85ceed3f2a985b0f$var$_classnames.default)($85ceed3f2a985b0f$var$inputClasses, "pr4", className)
    }), children), (0, $767w7.h)($7Dcmj.Icon, {
        style: {
            marginLeft: "-30px",
            pointerEvents: "none"
        },
        icon: "arrow_drop_down",
        size: "24"
    }));
};
module.exports.Select = $85ceed3f2a985b0f$var$Select;
const $85ceed3f2a985b0f$var$Textarea = (0, $85ceed3f2a985b0f$var$_getStyledComponent.default)({
    baseClasses: $85ceed3f2a985b0f$var$inputClasses,
    tagName: "textarea"
});
module.exports.Textarea = $85ceed3f2a985b0f$var$Textarea;

});

parcelRegister("5ldOi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MinusButton = module.exports.PlusButton = void 0;

var $767w7 = parcelRequire("767w7");

var $3e39a05bcb57ccf7$var$_classnames = $3e39a05bcb57ccf7$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7Dcmj = parcelRequire("7Dcmj");

var $9YtMX = parcelRequire("9YtMX");
function $3e39a05bcb57ccf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3e39a05bcb57ccf7$var$HOLD_DELAY = 180;
const $3e39a05bcb57ccf7$var$ITERATION_DELAY = 90;
const $3e39a05bcb57ccf7$var$getPlusMinusButton = (icon)=>class extends $767w7.Component {
        constructor(props){
            super(props);
            this.runIt = this.runIt.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onPress = this.onPress.bind(this);
            this.clear = this.clear.bind(this);
            this.holdStart = false;
        }
        runIt() {
            const { onClick: onClick, disabled: disabled } = this.props;
            if (onClick && !disabled) onClick();
        }
        componentDidMount() {
            if (this.base && this.base.addEventListener) {
                this.base.addEventListener("touchstart", this.onPress);
                this.base.addEventListener("touchend", this.clear);
                this.base.addEventListener("touchcancel", this.clear);
            }
        }
        componentWillUnmount() {
            if (this.base && this.base.removeEventListener) {
                this.base.removeEventListener("touchstart", this.onPress);
                this.base.removeEventListener("touchend", this.clear);
                this.base.removeEventListener("touchcancel", this.clear);
            }
        }
        onClick(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.clear();
            this.runIt();
        }
        onPress() {
            const iterate = ()=>{
                clearTimeout(this.iterationTimer);
                let delay = this.props.iterationDelay || $3e39a05bcb57ccf7$var$ITERATION_DELAY;
                const holdDuration = Date.now() - this.holdStart;
                if (holdDuration > 4000) delay = delay * 0.4;
                else if (holdDuration > 2000) delay = delay * 0.5;
                this.iterationTimer = setTimeout(()=>{
                    if (this.holdStart && !this.props.disabled) {
                        this.runIt();
                        iterate();
                    }
                }, delay);
            };
            this.holdTimer = setTimeout(()=>{
                this.holdStart = Date.now();
                iterate();
            }, this.props.holdDelay || $3e39a05bcb57ccf7$var$HOLD_DELAY);
        }
        clear() {
            clearTimeout(this.holdTimer);
            clearTimeout(this.iterationTimer);
            this.holdStart = false;
        }
        render() {
            const { className: className, disabled: disabled, name: name } = this.props;
            return (0, $767w7.h)($9YtMX.Button, {
                "data-e2e": "".concat(name || "").concat(icon.charAt(0).toUpperCase()).concat(icon.slice(1), "Button"),
                type: "button",
                onContextMenu: (e)=>{
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                },
                onClick: this.onClick,
                onMouseUp: this.clear,
                onMouseLeave: this.clear,
                onMouseDown: this.onPress,
                disabled: disabled,
                className: (0, $3e39a05bcb57ccf7$var$_classnames.default)("ba br2 pa2 mv1", {
                    mr2: icon === "remove"
                }, className)
            }, (0, $767w7.h)("div", {
                className: "flex items-center"
            }, (0, $767w7.h)($7Dcmj.Icon, {
                size: "18",
                icon: icon
            }), this.props.children));
        }
    };
const $3e39a05bcb57ccf7$var$PlusButton = $3e39a05bcb57ccf7$var$getPlusMinusButton("add");
module.exports.PlusButton = $3e39a05bcb57ccf7$var$PlusButton;
const $3e39a05bcb57ccf7$var$MinusButton = $3e39a05bcb57ccf7$var$getPlusMinusButton("remove");
module.exports.MinusButton = $3e39a05bcb57ccf7$var$MinusButton;

});

parcelRegister("diRk5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorClasses = module.exports.IncrementorError = void 0;

var $767w7 = parcelRequire("767w7");

var $7Dcmj = parcelRequire("7Dcmj");
const $9af6519ea24a0fa9$var$IncrementorError = ({ children: children })=>(0, $767w7.h)("div", {
        "data-e2e": "incrementorError",
        className: "flex items-center red mv1"
    }, (0, $767w7.h)($7Dcmj.Icon, {
        icon: "error",
        className: "mr1",
        size: "18"
    }), (0, $767w7.h)("div", null, children));
module.exports.IncrementorError = $9af6519ea24a0fa9$var$IncrementorError;
const $9af6519ea24a0fa9$var$errorClasses = "bg-washed-red br2 pa2";
module.exports.errorClasses = $9af6519ea24a0fa9$var$errorClasses;

});


parcelRegister("bGdHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeIncrementorButtons = void 0;

var $767w7 = parcelRequire("767w7");

var $880e3fc053b72cb0$var$_classnames = $880e3fc053b72cb0$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $bug1B = parcelRequire("bug1B");

var $8hAZN = parcelRequire("8hAZN");

var $5MXnj = parcelRequire("5MXnj");

var $5ldOi = parcelRequire("5ldOi");

var $c0jHA = parcelRequire("c0jHA");

var $880e3fc053b72cb0$var$_isToday = $880e3fc053b72cb0$var$_interopRequireDefault((parcelRequire("5Skt9")));

var $9YtMX = parcelRequire("9YtMX");

var $diRk5 = parcelRequire("diRk5");
function $880e3fc053b72cb0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $880e3fc053b72cb0$var$_extends() {
    $880e3fc053b72cb0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $880e3fc053b72cb0$var$_extends.apply(this, arguments);
}
function $880e3fc053b72cb0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $880e3fc053b72cb0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $880e3fc053b72cb0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $880e3fc053b72cb0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $880e3fc053b72cb0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $880e3fc053b72cb0$var$ownKeys(Object(source), true).forEach(function(key) {
            $880e3fc053b72cb0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $880e3fc053b72cb0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $880e3fc053b72cb0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $880e3fc053b72cb0$var$TimeIncrementorButtons extends $767w7.Component {
    constructor(props){
        super(props);
        this.handleTextInput = this.handleTextInput.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.getError = this.getError.bind(this);
        this.realUpdateValue = this.realUpdateValue.bind(this);
        this.startEditingDate = this.startEditingDate.bind(this);
        this.stopEditingDate = this.stopEditingDate.bind(this);
        this.handleDateInput = this.handleDateInput.bind(this);
        this.state = $880e3fc053b72cb0$var$_objectSpread({
            editingDate: false
        }, this.getUpdatedStateForValue(this.getValueToShow()));
    }
    getValueAsNumber(value) {
        if (typeof value === "string") return Number(value);
        return value;
    }
    getUpdatedStateForValue(rawValue, updatedText, updateDateText) {
        const error = this.getError(rawValue);
        return {
            error: error,
            asNumber: rawValue,
            internalTextValue: updatedText || (0, $c0jHA.msToTimeString)(rawValue),
            internalDateString: updateDateText || (0, $5MXnj.toSimpleISODateString)(rawValue),
            isValid: !error && rawValue
        };
    }
    handleTextInput(e) {
        const newText = e.target.value;
        const newValue = (0, $8hAZN.timeStringToMs)(newText, {
            timestampFromDay: this.props.value,
            strict: true
        });
        if (newValue) this.realUpdateValue(newValue, newText);
        else this.setState({
            error: "Invalid time input use HH:MM",
            internalTextValue: newText
        });
    }
    handleBlur() {
        this.resetFromValue();
    }
    getValueToShow() {
        const { displayValue: displayValue, value: value } = this.props;
        return displayValue != null ? displayValue : value;
    }
    startEditingDate() {
        this.setState({
            editingDate: true
        });
        setTimeout(()=>{
            const input = this.base && this.base.querySelector("input[type=date]");
            if (input) input.focus();
        }, 300);
    }
    getError(val) {
        const { max: max, min: min } = this.props;
        if (isNaN(val)) return "invalid value";
        if (val > max) return "max is ".concat((0, $5MXnj.toDateString)(max, true));
        if (val < min) return "min is ".concat((0, $5MXnj.toDateString)(min, true));
        return null;
    }
    realUpdateValue(newValue, updatedText) {
        const realValueError = this.getError(this.getValueToShow());
        const { updateValue: updateValue } = this.props;
        const changedState = this.getUpdatedStateForValue(newValue, updatedText);
        this.setState(changedState); // if we're already in an error state, we can allow the update
        // this is important if we are fixing a scenario where the real-underlying
        // value is already out of range and people want to use the + and - buttons
        // to get it *into* range.
        if (!changedState.error || realValueError) // we only want to report it if it's different
        {
            if (changedState.asNumber !== this.props.value) updateValue(changedState.asNumber);
        }
    }
    handleDateInput(e) {
        const value = e.target.value;
        if (value) {
            const wrongTZDate = new Date(value);
            const asDate = new Date(wrongTZDate.setMinutes(wrongTZDate.getMinutes() + wrongTZDate.getTimezoneOffset()));
            const updatedMs = (0, $8hAZN.timeStringToMs)(this.state.internalTextValue, {
                timestampFromDay: asDate,
                strict: true
            });
            this.realUpdateValue(updatedMs);
        }
    }
    stopEditingDate() {
        this.setState({
            editingDate: false
        });
    }
    resetFromValue() {
        const newTextValue = (0, $c0jHA.msToTimeString)(this.props.value);
        if (newTextValue !== this.state.internalTextValue) this.realUpdateValue(this.props.value, newTextValue);
    }
    // reflected in the text
    componentDidUpdate(prevProps) {
        const valueChanged = prevProps.value !== this.props.value;
        if (valueChanged) this.resetFromValue();
    }
    render(_ref) {
        let { step: step = 60000, max: max = Infinity, min: min = 0, className: className = "", value: value, startingValue: startingValue, name: name, style: style, wrap: wrap = true, showDate: showDate = "always" } = _ref, rest = $880e3fc053b72cb0$var$_objectWithoutProperties(_ref, [
            "step",
            "max",
            "min",
            "className",
            "value",
            "startingValue",
            "name",
            "style",
            "wrap",
            "showDate"
        ]);
        const shouldShowDate = showDate === "never" ? false : showDate === "always" || showDate === "notToday" && !(0, $880e3fc053b72cb0$var$_isToday.default)(value);
        const { internalTextValue: internalTextValue, internalDateString: internalDateString, editingDate: editingDate, error: error } = this.state;
        const effectiveValue = value != null ? value : startingValue;
        return (0, $767w7.h)("div", $880e3fc053b72cb0$var$_extends({
            className: (0, $880e3fc053b72cb0$var$_classnames.default)("dib", error && $diRk5.errorClasses, className),
            style: $880e3fc053b72cb0$var$_objectSpread({}, style)
        }, rest), (0, $767w7.h)("div", {
            className: (0, $880e3fc053b72cb0$var$_classnames.default)("flex items-center", wrap && "flex-wrap")
        }, shouldShowDate && (editingDate ? (0, $767w7.h)($bug1B.Input, {
            type: "date",
            "data-e2e": "incrementorDateInput",
            onBlur: this.stopEditingDate,
            value: internalDateString,
            onInput: this.handleDateInput,
            className: "mr2"
        }) : (0, $767w7.h)($9YtMX.IconButton, {
            type: "button",
            icon: "edit",
            "data-e2e": "incrementorEditDate",
            href: "#",
            className: "mid-gray mr2",
            onClick: this.startEditingDate
        }, (0, $5MXnj.toDateString)(effectiveValue))), (0, $767w7.h)($bug1B.Input, {
            type: "text",
            name: "time",
            style: {
                width: "60px"
            },
            "data-e2e": "".concat(name, "Value"),
            className: "mr2 f5" + (error ? "bg-washed-red" : ""),
            value: internalTextValue,
            onInput: this.handleTextInput,
            onBlur: this.handleBlur
        }), (0, $767w7.h)($5ldOi.MinusButton, {
            name: name,
            disabled: effectiveValue - step < min,
            onClick: ()=>this.realUpdateValue(effectiveValue - step)
        }), (0, $767w7.h)($5ldOi.PlusButton, {
            name: name,
            disabled: effectiveValue + step > max,
            onClick: ()=>this.realUpdateValue(effectiveValue + step)
        })), error && (0, $767w7.h)($diRk5.IncrementorError, null, error));
    }
}
module.exports.TimeIncrementorButtons = $880e3fc053b72cb0$var$TimeIncrementorButtons;

});
parcelRegister("8hAZN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeStringToMs = module.exports.cleanTimeStringInput = module.exports.parseTimeString = void 0;

var $607c9bd4b2006382$var$_milliseconds = $607c9bd4b2006382$var$_interopRequireDefault((parcelRequire("6zzev")));

var $5MXnj = parcelRequire("5MXnj");
function $607c9bd4b2006382$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $607c9bd4b2006382$var$_wrapRegExp(re, groups) {
    $607c9bd4b2006382$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, undefined, groups);
    };
    var _RegExp = $607c9bd4b2006382$var$_wrapNativeSuper(RegExp);
    var _super = RegExp.prototype;
    var _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);
        _groups.set(_this, groups || _groups.get(re));
        return _this;
    }
    $607c9bd4b2006382$var$_inherits(BabelRegExp, _RegExp);
    BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        if (result) result.groups = buildGroups(result, this);
        return result;
    };
    BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if (typeof substitution === "string") {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        } else if (typeof substitution === "function") {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = [];
                args.push.apply(args, arguments);
                if (typeof args[args.length - 1] !== "object") args.push(buildGroups(args, _this));
                return substitution.apply(this, args);
            });
        } else return _super[Symbol.replace].call(this, str, substitution);
    };
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            groups[name] = result[g[name]];
            return groups;
        }, Object.create(null));
    }
    return $607c9bd4b2006382$var$_wrapRegExp.apply(this, arguments);
}
function $607c9bd4b2006382$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $607c9bd4b2006382$var$_setPrototypeOf(subClass, superClass);
}
function $607c9bd4b2006382$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $607c9bd4b2006382$var$_assertThisInitialized(self);
}
function $607c9bd4b2006382$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $607c9bd4b2006382$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $607c9bd4b2006382$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$607c9bd4b2006382$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $607c9bd4b2006382$var$_construct(Class, arguments, $607c9bd4b2006382$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $607c9bd4b2006382$var$_setPrototypeOf(Wrapper, Class);
    };
    return $607c9bd4b2006382$var$_wrapNativeSuper(Class);
}
function $607c9bd4b2006382$var$_construct(Parent, args, Class) {
    if ($607c9bd4b2006382$var$_isNativeReflectConstruct()) $607c9bd4b2006382$var$_construct = Reflect.construct;
    else $607c9bd4b2006382$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $607c9bd4b2006382$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $607c9bd4b2006382$var$_construct.apply(null, arguments);
}
function $607c9bd4b2006382$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $607c9bd4b2006382$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $607c9bd4b2006382$var$_setPrototypeOf(o, p) {
    $607c9bd4b2006382$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $607c9bd4b2006382$var$_setPrototypeOf(o, p);
}
function $607c9bd4b2006382$var$_getPrototypeOf(o) {
    $607c9bd4b2006382$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $607c9bd4b2006382$var$_getPrototypeOf(o);
}
const $607c9bd4b2006382$var$toNumberInRange = (str, max)=>{
    const asNumber = Number(str);
    return asNumber >= 0 && asNumber <= max ? asNumber : null;
};
const $607c9bd4b2006382$var$validSeparatorRE = /[.: ]+/;
const $607c9bd4b2006382$var$separatorFormatRE = /^\d+([.: ]+\d|:)/;
const $607c9bd4b2006382$var$internalCleanRE = /[^0-9:. ap]/g;
const $607c9bd4b2006382$var$clean = (str)=>str && str.toLowerCase ? str.toLowerCase().replace($607c9bd4b2006382$var$internalCleanRE, "") // remove repeated characters
    .replace(/( +|p+|a+|:+)/gi, (match)=>match[0]).trim() : "";
/** @typedef {'a' | 'p' | ''} AorP */ /**
 * @param {string} str
 * @returns {AorP}
 */ const $607c9bd4b2006382$var$parseAmPm = (str)=>{
    const match = /*#__PURE__*/ $607c9bd4b2006382$var$_wrapRegExp(/[0-9](?:(?![ap])[\s\S])*(a|p)/i, {
        aorp: 1
    }).exec(str); // @ts-ignore
    return (match && match.groups && match.groups.aorp || "").toLowerCase();
};
/**
 * Turns a time string number of milliseconds
 *
 * @param {{ hoursStr: string; minutesStr: string; aOrP: AorP }} options
 * @returns {{ hours: number; minutes: number } | null}
 */ const $607c9bd4b2006382$var$validOrNull = ({ hoursStr: hoursStr, minutesStr: minutesStr, aOrP: aOrP })=>{
    const hoursAsNumber = $607c9bd4b2006382$var$toNumberInRange(hoursStr, aOrP ? 12 : 24);
    const result = {
        minutes: 0,
        hours: 0
    };
    if (hoursAsNumber === null) return null;
     // special handling for 12 am and 12 pm
    if (hoursAsNumber === 12 && aOrP) result.hours = aOrP === "a" ? 0 : 12;
    else if (hoursAsNumber === 24) result.hours = 0;
    else result.hours = hoursAsNumber + (aOrP === "p" ? 12 : 0);
    if (!minutesStr) return result;
    const minutesAsNumber = $607c9bd4b2006382$var$toNumberInRange(minutesStr, 59);
    if (minutesAsNumber === null) return null;
    result.minutes = minutesAsNumber;
    return result;
};
/**
 * Parse a possible time string into an object of hours and minutes. Handles
 * weird time quirks like 12am being 0 hours, etc.
 *
 * @param {string} str
 * @param {{ strict?: boolean }} opts
 * @returns {{ hours: number; minutes: number } | null}
 */ const $607c9bd4b2006382$var$parseTimeString = (str, { strict: strict = false } = {})=>{
    const cleaned = $607c9bd4b2006382$var$clean(str);
    const aOrP = $607c9bd4b2006382$var$parseAmPm(cleaned);
    const isSeparatorFormat = $607c9bd4b2006382$var$separatorFormatRE.test(cleaned);
    if (isSeparatorFormat) {
        const [hoursStr, minutesStr] = cleaned.split($607c9bd4b2006382$var$validSeparatorRE);
        const cleanedMinutes = minutesStr.replace(/[^\d]/g, "");
        const cleanedHours = hoursStr.replace(/[^\d]/g, "");
        if (strict) {
            if (!cleanedMinutes || !cleanedHours || cleanedHours.length !== 2) return null;
        }
        if (cleanedMinutes && cleanedMinutes.length !== 2) return null;
        return $607c9bd4b2006382$var$validOrNull({
            hoursStr: hoursStr,
            minutesStr: cleanedMinutes,
            aOrP: aOrP
        });
    } else {
        const match = /^(\d{1,4})/.exec(cleaned);
        const leadNumbers = match && match[0];
        if (!leadNumbers) return null;
        if (leadNumbers.length === 1) {
            if (!aOrP || strict) return null;
            return $607c9bd4b2006382$var$validOrNull({
                hoursStr: leadNumbers,
                minutesStr: "",
                aOrP: aOrP
            });
        } else if (leadNumbers.length === 2) {
            if (strict) return null;
            return $607c9bd4b2006382$var$validOrNull({
                hoursStr: leadNumbers,
                minutesStr: "",
                aOrP: aOrP
            });
        } else if (leadNumbers.length === 3) {
            if (strict) return null;
            return $607c9bd4b2006382$var$validOrNull({
                hoursStr: leadNumbers.slice(0, 1),
                minutesStr: leadNumbers.slice(1, 3),
                aOrP: aOrP
            });
        } else if (leadNumbers.length === 4) return $607c9bd4b2006382$var$validOrNull({
            hoursStr: leadNumbers.slice(0, 2),
            minutesStr: leadNumbers.slice(2, 4),
            aOrP: aOrP
        });
    }
    return null;
};
/**
 * Meant for real-time cleanup of user input meant to be parsed by
 * `parseTimeString` function above. Importantly it's meant to be typing
 * friendly, meaning it does not have to be parseable as valid at all times.
 * Just enough cleanup to avoid weird characters, and long bad clipboard pastes, etc.
 *
 * @param {string} input
 * @returns {string}
 */ module.exports.parseTimeString = $607c9bd4b2006382$var$parseTimeString;
const $607c9bd4b2006382$var$cleanTimeStringInput = (input)=>{
    if (!input) return "";
    return input.replace(/[^\d. :apm]/gi, "").replace(/(a+|p+| +|m+|\.+|:+)/gi, (match)=>match[0]).slice(0, 10);
};
/**
 * @param {string} str
 * @param {{
 *   timestampFromDay?: number | Date
 *   strict?: boolean
 * }} [opts]
 * @returns
 */ module.exports.cleanTimeStringInput = $607c9bd4b2006382$var$cleanTimeStringInput;
const $607c9bd4b2006382$var$timeStringToMs = (str, { timestampFromDay: timestampFromDay, strict: strict = false } = {})=>{
    const parsed = $607c9bd4b2006382$var$parseTimeString(str, {
        strict: strict
    });
    if (!parsed) return null;
    return (0, $5MXnj.getStartOfDate)(timestampFromDay || Date.now()).valueOf() + $607c9bd4b2006382$var$_milliseconds.default.hours(parsed.hours) + $607c9bd4b2006382$var$_milliseconds.default.minutes(parsed.minutes);
};
module.exports.timeStringToMs = $607c9bd4b2006382$var$timeStringToMs;

});
parcelRegister("5MXnj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msToTimeAgo = module.exports.toFriendlyDate = module.exports.toDateString = module.exports.toTimeString = module.exports.toSimpleISODateString = module.exports.getStartOfDate = module.exports.toDateCopy = void 0;
//@ts-check
/**
 * Turns a string into a Date if not already a Date object.
 *
 * @param {Date | string | number} date
 * @returns {Date}
 */ const $436f7e1b8affeabc$var$toDate = (date)=>date instanceof Date ? date : new Date(date);
/**
 * @param {number | string} num Number to zero-pad as two-digit string
 * @returns {string}
 */ const $436f7e1b8affeabc$var$pad = (num)=>(num + "").padStart(2, "0");
/**
 * @param {Date | number | null} [date] If falsy will just return today
 * @returns
 */ const $436f7e1b8affeabc$var$toDateCopy = (date)=>{
    if (typeof date === "number") return new Date(date);
    else if (date && date.valueOf) return new Date(date.valueOf());
    return new Date();
};
/**
 * @param {Date | number | null} date
 * @returns {Date}
 */ module.exports.toDateCopy = $436f7e1b8affeabc$var$toDateCopy;
const $436f7e1b8affeabc$var$getStartOfDate = (date)=>{
    let copy = $436f7e1b8affeabc$var$toDateCopy(date);
    copy.setMinutes(0);
    copy.setHours(0);
    copy.setSeconds(0);
    copy.setMilliseconds(0);
    return copy;
};
/**
 * @param {Date | number} date Date object or ms
 * @returns {string} As YYYY-MM-DD
 */ module.exports.getStartOfDate = $436f7e1b8affeabc$var$getStartOfDate;
const $436f7e1b8affeabc$var$toSimpleISODateString = (date)=>{
    date = $436f7e1b8affeabc$var$toDate(date);
    return "".concat(date.getFullYear(), "-").concat($436f7e1b8affeabc$var$pad(date.getMonth() + 1), "-").concat($436f7e1b8affeabc$var$pad(date.getDate()));
};
/**
 * @param {Date | number | string} date
 * @returns {string} Military time
 */ module.exports.toSimpleISODateString = $436f7e1b8affeabc$var$toSimpleISODateString;
const $436f7e1b8affeabc$var$toTimeString = (date)=>{
    const str = $436f7e1b8affeabc$var$toDate(date).toLocaleTimeString(undefined, {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit"
    }); // workaround for browser/node bug
    return str.replace("24:", "00:");
};
/**
 * @param {Date | number | string} date
 * @param {boolean} [includeTime=false] Default is `false`
 * @returns {string} Locale specific date
 */ module.exports.toTimeString = $436f7e1b8affeabc$var$toTimeString;
const $436f7e1b8affeabc$var$toDateString = (date, includeTime = false)=>{
    const asDate = $436f7e1b8affeabc$var$toDate(date);
    let res = asDate.toLocaleDateString(undefined);
    if (includeTime) res += " ".concat($436f7e1b8affeabc$var$toTimeString(asDate));
    return res;
};
/**
 * @param {Date | string} date
 * @param {{ now?: Date; includeTime?: boolean }} [options] Date to compare
 *   against (mainly for testing)
 * @returns {string}
 */ module.exports.toDateString = $436f7e1b8affeabc$var$toDateString;
const $436f7e1b8affeabc$var$toFriendlyDate = (date, { includeTime: includeTime = false, now: now = new Date() } = {})=>{
    date = $436f7e1b8affeabc$var$toDate(date); // we always want to compare calendar dates
    // not actual time passed this is so that it
    // will properly say "yesterday" if the day
    // was different even if it was only a few hours ago.
    const startOfDate = $436f7e1b8affeabc$var$getStartOfDate(date);
    now = $436f7e1b8affeabc$var$getStartOfDate(now);
    const withinSevenDays = Math.abs(startOfDate.valueOf() - now.valueOf()) < 6.048e8;
    const suffix = includeTime ? " @ ".concat($436f7e1b8affeabc$var$toTimeString(date)) : "";
    if (!withinSevenDays) {
        const isSameYear = date.getFullYear() === now.getFullYear();
        /** @type {Intl.DateTimeFormatOptions} */ const opts = {
            month: "long",
            day: "numeric"
        };
        if (!isSameYear) opts.year = "numeric";
        return date.toLocaleDateString(undefined, opts) + suffix;
    } // get a day diff
    const dayDiff = Math.floor((startOfDate.valueOf() - now.valueOf()) / 8.64e7);
    if (dayDiff === -1) return "Yesterday" + suffix;
    if (dayDiff === 0) return "Today" + suffix;
    if (dayDiff === 1) return "Tomorrow" + suffix;
    return "".concat(dayDiff < 0 ? "Last " : "").concat(date.toLocaleDateString(undefined, {
        weekday: "long"
    })) + suffix;
};
/**
 * Turns a number of milliseconds into a friendly "time ago" string.
 *
 * 5000 becomes '5s'
 *
 * @param {number} milliseconds Number of milliseconds that have passed
 * @param {boolean} [includeSeconds] Whether to include seconds in output
 * @returns {string}
 */ module.exports.toFriendlyDate = $436f7e1b8affeabc$var$toFriendlyDate;
const $436f7e1b8affeabc$var$msToTimeAgo = (milliseconds, includeSeconds = true)=>{
    const number = Math.max(milliseconds, 0);
    const seconds = Math.floor(number / 1000 % 60);
    const minutes = Math.floor(number / 60000 % 60);
    const hours = Math.floor(number / 3.6e6);
    let res = "";
    if (hours) res += "".concat(hours, "h ");
    if (minutes) res += "".concat(minutes, "m ");
    if (!includeSeconds && !minutes && !hours) return "0m";
    if (includeSeconds) res += "".concat(seconds, "s");
    return res.trim();
};
module.exports.msToTimeAgo = $436f7e1b8affeabc$var$msToTimeAgo;

});


parcelRegister("c0jHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msToTimeString = void 0;
const $8bd4c485c2467591$var$msToTimeString = (ms, includeSeconds = false)=>{
    if (!ms) return "";
    const d = new Date(ms);
    const hours = (d.getHours() + "").padStart(2, "0");
    const minutes = (d.getMinutes() + "").padStart(2, "0");
    const seconds = (d.getSeconds() + "").padStart(2, "0");
    return "".concat(hours, ":").concat(minutes) + (includeSeconds ? ":".concat(seconds) : "");
};
module.exports.msToTimeString = $8bd4c485c2467591$var$msToTimeString;

});



parcelRegister("23DLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signature = void 0;

var $767w7 = parcelRequire("767w7");

var $17fab404f99f8aa9$var$_tryit = $17fab404f99f8aa9$var$_interopRequireDefault((parcelRequire("2TQb1")));
function $17fab404f99f8aa9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $17fab404f99f8aa9$var$_extends() {
    $17fab404f99f8aa9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17fab404f99f8aa9$var$_extends.apply(this, arguments);
}
function $17fab404f99f8aa9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $17fab404f99f8aa9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $17fab404f99f8aa9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
class $17fab404f99f8aa9$var$AnimatedPath extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = {
            firstRender: true,
            length: 0
        };
    }
    componentDidMount() {
        setTimeout(()=>{
            let length = 0;
            (0, $17fab404f99f8aa9$var$_tryit.default)(()=>{
                // base could be null here because of delay
                length = Math.round(this.base.getTotalLength());
            });
            this.setState({
                length: length
            });
            setTimeout(()=>{
                this.setState({
                    firstRender: false
                });
            }, 100);
        }, 100);
    }
    render({ path: path, animate: animate }, { firstRender: firstRender, length: length }) {
        if (!animate) return (0, $767w7.h)("path", {
            d: path,
            fill: "none",
            stroke: "black",
            "stroke-width": "5"
        });
        return (0, $767w7.h)("path", {
            key: length ? "real" : "fake",
            d: path,
            fill: "none",
            stroke: length ? "black" : "none",
            "stroke-width": "5",
            style: {
                transitionDuration: "1s",
                transitionDelay: ".25s",
                transitionProperty: "stroke-dashoffset",
                strokeDashoffset: firstRender ? length : 0,
                strokeDasharray: length
            }
        });
    }
}
const $17fab404f99f8aa9$var$getCenteredViewbox = (path)=>{
    const targetWidth = 660;
    const cleaned = path.replace(/[^\d,. ]/g, "").trim();
    const parts = cleaned.split(" ");
    let maxX = 0;
    let minX = targetWidth;
    for (const part of parts){
        const [x, y] = part.split(",").map(Number);
        if (isNaN(x) || isNaN(y)) continue;
        maxX = Math.max(maxX, x);
        minX = Math.min(minX, x);
    }
    const width = maxX - minX;
    const centerX = minX + (width || 2) / 2;
    const realCenter = targetWidth / 2;
    const centerDiffX = -1 * (realCenter - centerX);
    return "".concat(centerDiffX || 0, " 0 ").concat(targetWidth, " 300");
};
const $17fab404f99f8aa9$var$Signature = (_ref)=>{
    let { path: path, width: width = "100", animate: animate } = _ref, rest = $17fab404f99f8aa9$var$_objectWithoutProperties(_ref, [
        "path",
        "width",
        "animate"
    ]);
    return (0, $767w7.h)("svg", $17fab404f99f8aa9$var$_extends({
        width: width,
        height: width / 2,
        viewBox: $17fab404f99f8aa9$var$getCenteredViewbox(path)
    }, rest), (0, $767w7.h)($17fab404f99f8aa9$var$AnimatedPath, {
        key: path.slice(0, 10),
        path: path,
        animate: animate
    }));
};
module.exports.Signature = $17fab404f99f8aa9$var$Signature;

});

parcelRegister("3U6K7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureInput = void 0;

var $767w7 = parcelRequire("767w7");

var $9YtMX = parcelRequire("9YtMX");

var $7Dcmj = parcelRequire("7Dcmj");
const $2d7bd506fc068805$var$height = 300;
class $2d7bd506fc068805$var$SignatureInput extends $767w7.Component {
    constructor(props){
        super(props);
        this.mouseMove = this.mouseMove.bind(this);
        this.mouseEnd = this.mouseEnd.bind(this);
        this.mouseDown = this.mouseDown.bind(this);
        this.mouseUp = this.mouseUp.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
        this.touchStart = this.touchStart.bind(this);
        this.touchMove = this.touchMove.bind(this);
        this.touchEnd = this.touchEnd.bind(this);
        this.calculateCanvasInfo = this.calculateCanvasInfo.bind(this);
        this.renderCanvas = this.renderCanvas.bind(this);
        this.state = {
            hasPath: false
        };
    }
    reset() {
        this.path = "";
        this.break = true;
        this.setState({
            hasPath: false
        });
    }
    componentDidMount() {
        this.reset();
        this.canvas = this.base.querySelector("canvas");
        this.ctx = this.canvas.getContext("2d");
        window.addEventListener("resize", this.calculateCanvasInfo, {
            passive: true
        });
        window.addEventListener("scroll", this.calculateCanvasInfo, {
            passive: true
        });
        document.addEventListener("mouseup", this.mouseUp);
        document.addEventListener("touchmove", this.touchMove);
        document.addEventListener("touchend", this.touchEnd);
        document.addEventListener("touchcancel", this.touchEnd);
        this.canvas.addEventListener("touchstart", this.touchStart);
        this.calculateCanvasInfo();
        this.renderCanvas();
    }
    calculateCanvasInfo() {
        const { top: top, left: left, width: width, height: height } = this.canvas.getBoundingClientRect();
        this.canvasInfo = {
            left: left,
            top: top,
            height: height,
            width: width
        };
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.calculateCanvasInfo, {
            passive: true
        });
        window.removeEventListener("scroll", this.calculateCanvasInfo, {
            passive: true
        });
        document.removeEventListener("mouseup", this.mouseUp);
        document.removeEventListener("touchmove", this.touchMove);
        document.removeEventListener("touchend", this.touchEnd);
        document.removeEventListener("touchcancel", this.touchEnd);
        this.canvas && this.canvas.removeEventListener("touchstart", this.touchStart);
    }
    adjustCoord(clientX, clientY) {
        const { left: left, top: top, height: height, width: width } = this.canvasInfo;
        const x = clientX - left;
        const y = clientY - top;
        if (x < 0 || x > width) return null;
        if (y < 0 || y > height) return null;
        return {
            x: x,
            y: y
        };
    }
    appendCoord(x, y) {
        if (!this.state.hasPath) this.setState({
            hasPath: true
        });
        this.path += " ".concat(x, ",").concat(y);
        requestAnimationFrame(this.renderCanvas);
    }
    mouseDown(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    mouseLeave(e) {
        if (e.buttons === 1) {
            this.appendCoord(e.layerX, e.layerY);
            this.break = true;
        }
    }
    mouseUp() {
        this.break = true;
    }
    mouseEnd(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.break = true;
    }
    appendM() {
        if (!this.path.endsWith(" M")) this.path += " M";
    }
    mouseMove(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (e.buttons === 1) {
            if (this.break) {
                this.break = false;
                this.appendM();
            }
            const adjusted = this.adjustCoord(e.clientX, e.clientY);
            if (adjusted) this.appendCoord(adjusted.x, adjusted.y);
            else this.break = true;
        }
    }
    touchStart(e) {
        this.drawing = true;
        this.appendM(); // this prevents to "M"s next to each other if
        // there's a touch start without a touch move
        this.touchMove(e);
        e.preventDefault();
    }
    touchMove(e) {
        if (this.drawing) {
            const touch = e.touches[0];
            const isStylus = touch.touchType === "stylus";
            const adjusted = this.adjustCoord(touch.clientX + (isStylus ? 0 : -20), touch.clientY + (isStylus ? 0 : -10));
            if (adjusted) this.appendCoord(adjusted.x, adjusted.y);
            else this.break = true;
        }
    }
    touchEnd() {
        this.break = true;
    }
    renderCanvas() {
        const { ctx: ctx } = this;
        const { width: width, height: height } = this.canvas;
        ctx.clearRect(0, 0, width, height);
        const marginFromEdge = width * 0.1;
        const marginFromBottom = 80; // signature line
        ctx.beginPath();
        ctx.moveTo(marginFromEdge, height - marginFromBottom);
        ctx.lineTo(width - marginFromEdge, height - marginFromBottom);
        ctx.strokeStyle = "#ddd";
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.strokeStyle = "#000";
        ctx.lineWidth = 1;
        ctx.fillStyle = "#000";
        if (this.path) ctx.stroke(new Path2D(this.path));
        if (this.props.name) {
            ctx.font = "18px sans-serif";
            ctx.fillText(this.props.name, marginFromEdge, height - (marginFromBottom - 25));
        }
    }
    shouldComponentUpdate(_, nextState) {
        // only update if haspath has changed
        return this.state.hasPath !== nextState.hasPath;
    }
    render({ updateValue: updateValue, close: close, showIncompleteWarning: showIncompleteWarning, confirmButtonText: confirmButtonText = "Sign" }) {
        return (0, $767w7.h)("div", {
            className: "top-0 left-0 fixed bg-gray w-100 h-100 z-9999 flex items-center justify-center"
        }, (0, $767w7.h)("div", {
            "data-e2e": "signatureBox",
            className: "relative"
        }, showIncompleteWarning && (0, $767w7.h)("div", {
            "data-e2e": "incompleteWarning",
            className: "absolute top-0 no-pointer-events bg-orange flex items-center gap2 w-100 pa2 bt bl br"
        }, (0, $767w7.h)($7Dcmj.Icon, {
            icon: "warning"
        }), "The report is incomplete, but as the primary provider you can still sign and finalize it."), (0, $767w7.h)("canvas", {
            "data-e2e": "signaturePad",
            className: "bg-white ba",
            width: Math.min(window.innerWidth - 10, 660),
            height: $2d7bd506fc068805$var$height,
            onMouseMove: this.mouseMove,
            onMouseDown: this.mouseDown,
            onMouseCancel: this.mouseCancel,
            onMouseLeave: this.mouseLeave
        }), (0, $767w7.h)("div", {
            className: "flex items-center justify-between mt2"
        }, (0, $767w7.h)($9YtMX.Button, {
            primary: true,
            large: true,
            disabled: !this.state.hasPath,
            "data-e2e": "signatureSaveButton",
            onClick: ()=>{
                updateValue(this.path.trim());
            },
            type: "button"
        }, confirmButtonText), (0, $767w7.h)("div", null, (0, $767w7.h)($9YtMX.Button, {
            large: true,
            onClick: ()=>{
                this.reset();
                this.renderCanvas();
            },
            className: "mr2",
            type: "button"
        }, "Clear"), (0, $767w7.h)($9YtMX.Button, {
            large: true,
            onClick: ()=>{
                this.reset();
                this.renderCanvas();
                close();
            },
            "data-e2e": "cancelSignatureButton",
            type: "button"
        }, "Cancel")))));
    }
}
module.exports.SignatureInput = $2d7bd506fc068805$var$SignatureInput;

});

parcelRegister("df4Ty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IS_CHROME = module.exports.IS_IOS = void 0;
if (typeof window === "undefined") // eslint-disable-next-line
$parcel$global.window = $parcel$global;
const $9a40791ab2fe4d26$var$navigator = window && window.navigator || {};
const $9a40791ab2fe4d26$var$ua = $9a40791ab2fe4d26$var$navigator && $9a40791ab2fe4d26$var$navigator.ua || "";
const $9a40791ab2fe4d26$var$IS_IOS = /iPad|iPhone|iPod/.test($9a40791ab2fe4d26$var$ua);
module.exports.IS_IOS = $9a40791ab2fe4d26$var$IS_IOS;
const $9a40791ab2fe4d26$var$IS_CHROME = /Chrome/.test($9a40791ab2fe4d26$var$ua) && /Google Inc/.test($9a40791ab2fe4d26$var$navigator.vendor);
module.exports.IS_CHROME = $9a40791ab2fe4d26$var$IS_CHROME;

});


parcelRegister("3GW7W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MedicationEntryField = void 0;

var $767w7 = parcelRequire("767w7");

var $aeAE3 = parcelRequire("aeAE3");

var $b1umg = parcelRequire("b1umg");

var $5ye2y = parcelRequire("5ye2y");
class $2b02622d059408ec$var$MedicationEntryField extends $767w7.Component {
    focusOnInput() {
        const input = this.base.querySelector("input");
        if (input) input.focus();
    }
    render({ item: item, updateValue: updateValue, className: className }) {
        const drugName = item.value && item.value.name;
        return (0, $767w7.h)("div", {
            className: className
        }, (0, $767w7.h)($aeAE3.Label, {
            item: item,
            updateValue: updateValue
        }), !drugName && (0, $767w7.h)($5ye2y.DrugAutoCompleteInput, {
            item: item,
            selectCallback: updateValue
        }), drugName && (0, $767w7.h)($b1umg.SelectedItem, {
            key: drugName,
            label: drugName,
            onClose: (e)=>{
                e.preventDefault();
                updateValue("");
                setTimeout(()=>this.focusOnInput(), 200);
            }
        }));
    }
}
module.exports.MedicationEntryField = $2b02622d059408ec$var$MedicationEntryField;

});
parcelRegister("b1umg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectedItem = void 0;

var $767w7 = parcelRequire("767w7");

var $7Dcmj = parcelRequire("7Dcmj");
const $8067562fbc2cc947$var$SelectedItem = ({ label: label, onClose: onClose })=>(0, $767w7.h)("div", {
        "data-e2e": "selectedItem",
        className: "bg-lightest-blue dark-blue inline-flex items-center br2"
    }, (0, $767w7.h)("span", {
        className: "pv2 pl2"
    }, label), (0, $767w7.h)("button", {
        className: "pa2 flex items-center bg-transparent bn pointer",
        type: "button",
        "data-e2e": "selectedRemoveButton",
        title: "remove",
        onClick: onClose
    }, (0, $767w7.h)($7Dcmj.Icon, {
        icon: "close",
        size: "20",
        className: "dark-blue"
    })));
module.exports.SelectedItem = $8067562fbc2cc947$var$SelectedItem;

});

parcelRegister("5ye2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DrugAutoCompleteInput = void 0;

var $767w7 = parcelRequire("767w7");

var $hgoFO = parcelRequire("hgoFO");

var $9UfIw = parcelRequire("9UfIw");
const $40ab04cc40d736f4$var$DrugAutoCompleteInput = ({ item: item, selectCallback: selectCallback })=>(0, $767w7.h)($hgoFO.AutoCompleteInput, {
        item: item,
        doSearch: $9UfIw.fetchDrugAutocomplete,
        renderEntry: (entry)=>entry.name + (entry.noMatch ? " (not matched to drug ID)" : ""),
        selectCallback: selectCallback
    });
module.exports.DrugAutoCompleteInput = $40ab04cc40d736f4$var$DrugAutoCompleteInput;

});
parcelRegister("hgoFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoCompleteInput = void 0;

var $767w7 = parcelRequire("767w7");

var $bug1B = parcelRequire("bug1B");
const $c91711e871f306a4$var$resultEntryClasses = "pa3";
const $c91711e871f306a4$var$ResultItem = ({ children: children, onClick: onClick, onFocus: onFocus })=>(0, $767w7.h)("div", null, (0, $767w7.h)("button", {
        "data-e2e": "resultButton",
        type: "button",
        onClick: onClick,
        onFocus: onFocus,
        className: "button-reset bg-transparent bn pa3 ma0 w-100 tl nowrap dark-blue"
    }, children));
class $c91711e871f306a4$var$AutoCompleteInput extends $767w7.Component {
    constructor(props){
        super(props);
        this.handleGlobalClick = this.handleGlobalClick.bind(this);
        this.clear = this.clear.bind(this);
        this.state = this.getStartingState();
        this.focusInput = this.focusInput.bind(this);
        this.handleInputFocus = ()=>this.setState({
                inputFocused: true
            });
        this.handleInputBlur = ()=>this.setState({
                inputFocused: false
            });
        this.keyDown = this.keyDown.bind(this);
        this.state.selectedId = props.item.value || "";
    }
    getInput() {
        return this.base && this.base.querySelector("input");
    }
    getStartingState() {
        const input = this.getInput();
        return {
            error: null,
            activeSearchTerm: "",
            matches: null,
            selectedId: "",
            focusedIndex: null,
            loading: false,
            searching: false,
            loadedObject: null,
            inputFocused: input && document.activeElement === input
        };
    }
    handleGlobalClick() {
        this.setState({
            activeSearchTerm: "",
            matches: null
        });
    }
    selectEntry(entry) {
        this.props.selectCallback(entry);
        this.setState(this.getStartingState());
    }
    selectNoMatch() {
        if (this.props.selectNoMatch) {
            this.props.selectNoMatch(this.state.activeSearchTerm);
            this.setState(this.getStartingState());
        }
    }
    componentDidMount() {
        window.addEventListener("click", this.handleGlobalClick);
        window.addEventListener("keydown", this.keyDown);
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.handleGlobalClick);
        window.removeEventListener("keydown", this.keyDown);
    }
    componentDidUpdate(_, prevState) {
        if (!this.props.updateValue) return;
        const { activeSearchTerm: activeSearchTerm, selectedId: selectedId } = this.state;
        if (activeSearchTerm !== prevState.activeSearchTerm || selectedId !== prevState.selectedId) {
            if (selectedId) this.props.updateValue(selectedId);
            else this.props.updateValue("");
        }
    }
    keyDown(e) {
        const { inputFocused: inputFocused, focusedIndex: focusedIndex, activeSearchTerm: activeSearchTerm, matches: matches } = this.state;
        if (!inputFocused && focusedIndex === null) return;
        const handler = {
            ArrowDown: (e)=>{
                e.preventDefault();
                const nextFocusedIndex = focusedIndex === null ? 0 : focusedIndex + 1;
                const found = this.base.querySelectorAll("[data-e2e=resultButton]")[nextFocusedIndex];
                if (found) {
                    found.focus();
                    this.setState({
                        focusedIndex: nextFocusedIndex
                    });
                } else this.setState({
                    focusedIndex: null
                });
            },
            ArrowUp: (e)=>{
                e.preventDefault();
                if (focusedIndex === null) return;
                const nextFocusedIndex = focusedIndex === 0 ? null : focusedIndex - 1;
                if (nextFocusedIndex === null) {
                    this.focusInput();
                    return;
                }
                const found = this.base.querySelectorAll("[data-e2e=resultButton]")[nextFocusedIndex];
                if (found) {
                    found.focus();
                    this.setState({
                        focusedIndex: nextFocusedIndex
                    });
                } else this.setState({
                    focusedIndex: null
                });
            },
            Enter: (e)=>{
                if (inputFocused && activeSearchTerm) {
                    e.preventDefault();
                    if (matches) {
                        if (matches.length) this.selectEntry(matches[0]);
                        else this.selectNoMatch();
                    }
                }
            }
        }[e.key];
        if (handler) handler(e);
    }
    focusInput() {
        const inputEl = this.base && this.base.querySelector("input");
        if (inputEl) inputEl.focus();
        this.setState({
            focusedIndex: null
        });
    }
    clear() {
        this.setState({
            loadedObject: null,
            selectedId: null
        }, this.focusInput);
    }
    render({ item: item, doSearch: doSearch, renderEntry: renderEntry, renderNoMatches: renderNoMatches }, { activeSearchTerm: activeSearchTerm, matches: matches, searching: searching, focusedIndex: focusedIndex }) {
        const noResults = matches && matches.length === 0;
        return (0, $767w7.h)("div", {
            className: "relative"
        }, (0, $767w7.h)($bug1B.Input, {
            className: item.inputClassName || "w-50",
            placeholder: item.placeholder,
            value: activeSearchTerm,
            "data-e2e": "".concat(item.name, "Input"),
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onInput: (e)=>{
                const searchString = e.target.value || "";
                const searching = !!searchString;
                this.setState({
                    activeSearchTerm: searchString,
                    matches: null,
                    searching: searching
                });
                if (!searching) return;
                doSearch(searchString).then((entry)=>{
                    if (searchString === this.state.activeSearchTerm) this.setState({
                        matches: entry,
                        searching: false,
                        error: null
                    });
                }).catch(()=>{
                    if (searchString === this.state.activeSearchTerm) this.setState({
                        entry: null,
                        error: true,
                        searching: false
                    });
                });
            }
        }), (0, $767w7.h)("div", null, (matches || searching) && (0, $767w7.h)("div", {
            className: "absolute bg-white br2 ba b--gray z-1"
        }, (0, $767w7.h)("div", {
            style: {
                maxHeight: "calc(100vh - 90px)"
            },
            className: "overflow-scroll"
        }, matches && matches.length > 0 && matches.map((entry, index)=>(0, $767w7.h)($c91711e871f306a4$var$ResultItem, {
                onClick: ()=>this.selectEntry(entry),
                onFocus: ()=>this.setState({
                        focusedIndex: index
                    }),
                key: entry.id
            }, renderEntry(entry), " ", (!focusedIndex && index === 0 || focusedIndex === index) && (0, $767w7.h)("span", {
                className: "gray i"
            }, 'push "enter" to select')))), noResults && renderNoMatches && (0, $767w7.h)($c91711e871f306a4$var$ResultItem, {
            onClick: ()=>this.selectNoMatch()
        }, renderNoMatches(activeSearchTerm)), noResults && !renderNoMatches && (0, $767w7.h)("div", {
            className: $c91711e871f306a4$var$resultEntryClasses
        }, "No matches"), searching && (0, $767w7.h)("div", {
            className: $c91711e871f306a4$var$resultEntryClasses
        }, "Searching..."))));
    }
}
module.exports.AutoCompleteInput = $c91711e871f306a4$var$AutoCompleteInput;

});

parcelRegister("9UfIw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchDrugAutocomplete = void 0;

var $inFKE = parcelRequire("inFKE");
const $7365891cc6ea34d2$var$fields = [
    "RXCUIS",
    "STRENGTHS_AND_FORMS"
];
const $7365891cc6ea34d2$var$fetchDrugAutocomplete = (term)=>{
    if (!term) return Promise.resolve([]);
    const unknownResult = {
        id: (0, $inFKE.createId)("unknown"),
        name: term,
        noMatch: true
    };
    return fetch("https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?ef=".concat($7365891cc6ea34d2$var$fields.join(","), "&terms=").concat(encodeURIComponent(term))).then((res)=>res.json()).then((parsed)=>{
        const nameList = parsed[1];
        const extraFields = parsed[2];
        const { RXCUIS: RXCUIS, STRENGTHS_AND_FORMS: STRENGTHS_AND_FORMS } = extraFields || {};
        return nameList.map((name, index)=>({
                name: name,
                id: RXCUIS[index] && RXCUIS[index][0],
                forms: STRENGTHS_AND_FORMS[index]
            }));
    }).then((result)=>{
        result.push(unknownResult);
        return result;
    }).catch(()=>[
            unknownResult
        ]);
};
module.exports.fetchDrugAutocomplete = $7365891cc6ea34d2$var$fetchDrugAutocomplete;

});
parcelRegister("inFKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createId = void 0;

var $e7EYC = parcelRequire("e7EYC");
const $d61ac2f2f4df5ffe$var$createId = (baseName)=>"".concat(baseName, "_").concat(Date.now(), "_").concat((0, $e7EYC.uuid)().slice(-5));
module.exports.createId = $d61ac2f2f4df5ffe$var$createId;

});
parcelRegister("e7EYC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uuid = void 0;
function $a481813c1ac3b2be$var$b(a) {
    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, $a481813c1ac3b2be$var$b);
}
const $a481813c1ac3b2be$var$uuid = $a481813c1ac3b2be$var$b;
module.exports.uuid = $a481813c1ac3b2be$var$uuid;

});





parcelRegister("bvmaP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultiMedicationEntryField = void 0;

var $767w7 = parcelRequire("767w7");

var $aeAE3 = parcelRequire("aeAE3");

var $b1umg = parcelRequire("b1umg");

var $5ye2y = parcelRequire("5ye2y");
function $8603ca2ca55b6bfe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8603ca2ca55b6bfe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8603ca2ca55b6bfe$var$ownKeys(Object(source), true).forEach(function(key) {
            $8603ca2ca55b6bfe$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8603ca2ca55b6bfe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8603ca2ca55b6bfe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $8603ca2ca55b6bfe$var$MultiMedicationEntryField extends $767w7.Component {
    constructor(props){
        super(props);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.focusOnInputDelayed = ()=>setTimeout(this.focusOnInput, 200);
        this.addDrug = this.addDrug.bind(this);
    }
    isEmptyArray(arr) {
        return Array.isArray(arr) && !arr.length;
    }
    focusOnInput() {
        const input = this.base && this.base.querySelector("input");
        if (input) input.focus();
    }
    addDrug(drug) {
        const { item: item, updateValue: updateValue } = this.props;
        const { value: value } = item;
        const valueIsNone = value === "none";
        const drugs = value && !valueIsNone ? value : [];
        const copy = drugs.slice();
        if (!copy.find((drugEntry)=>drugEntry.id === drug.id || drugEntry.name === drug.name)) copy.push(drug);
        updateValue(copy);
        this.focusOnInput();
    }
    render() {
        const { item: item, updateValue: updateValue } = this.props;
        const { value: value } = item;
        const valueIsNone = value === "none";
        const itemCopy = Object.assign({}, item);
        delete itemCopy.subLabel;
        const modifiedItemForLabel = !value ? $8603ca2ca55b6bfe$var$_objectSpread($8603ca2ca55b6bfe$var$_objectSpread({}, item), {}, {
            buttons: [
                "none"
            ]
        }) : item;
        return (0, $767w7.h)("div", null, (0, $767w7.h)($aeAE3.Label, {
            item: modifiedItemForLabel,
            updateValue: updateValue
        }), !valueIsNone && (0, $767w7.h)($5ye2y.DrugAutoCompleteInput, {
            item: modifiedItemForLabel,
            selectCallback: this.addDrug
        }), (0, $767w7.h)("div", {
            className: "mb2"
        }, valueIsNone && (0, $767w7.h)($b1umg.SelectedItem, {
            key: "none",
            label: "none",
            onClose: (e)=>{
                e.preventDefault();
                updateValue(null);
                this.focusOnInputDelayed();
            }
        }), value && !valueIsNone && value.length !== 0 && (0, $767w7.h)("div", null, (0, $767w7.h)("div", {
            className: "mb2 fw3 f6 pt2"
        }, "Chosen Medications:"), (0, $767w7.h)("div", {
            className: "flex flex-wrap gap2"
        }, value.map((drug)=>(0, $767w7.h)($b1umg.SelectedItem, {
                key: drug.name,
                label: drug.name,
                onClose: (e)=>{
                    e.preventDefault();
                    const newVal = value.filter((item)=>item.id !== drug.id);
                    updateValue(this.isEmptyArray(newVal) ? null : newVal);
                    this.focusOnInputDelayed();
                }
            }))))));
    }
}
module.exports.MultiMedicationEntryField = $8603ca2ca55b6bfe$var$MultiMedicationEntryField;

});



parcelRegister("4VWTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");

var $krJc1 = parcelRequire("krJc1");
var $397a2a6a43daae53$var$_default = (0, $krJc1.transitionIn)(({ firstRender: firstRender, percentage: percentage, barColor: barColor = "dark-green", backgroundColor: backgroundColor = "white" })=>(0, $767w7.h)("div", {
        className: "relative overflow-hidden br-pill ba b--gray shadow-3 bg-".concat(backgroundColor)
    }, (0, $767w7.h)("div", {
        className: "h1 w-100 absolute br-pill bg-".concat(barColor, " transition"),
        style: {
            transform: "translateX(-".concat(100 - Math.max(firstRender ? 0 : percentage * 100, 1), "%)"),
            boxShadow: "inset 0px 0px 3px rgba(0, 0, 0, 0.3)"
        }
    }), (0, $767w7.h)("div", {
        className: "h1"
    })));
module.exports.default = $397a2a6a43daae53$var$_default;

});
parcelRegister("krJc1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transitionIn = module.exports.onMount = void 0;

var $767w7 = parcelRequire("767w7");
function $ee29629f3ae1b3ac$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ee29629f3ae1b3ac$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ee29629f3ae1b3ac$var$ownKeys(Object(source), true).forEach(function(key) {
            $ee29629f3ae1b3ac$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ee29629f3ae1b3ac$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ee29629f3ae1b3ac$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * @param {{
 *   fn: (component) => void
 *   component: import('preact').Component
 *   startingState?: any
 * }} options
 * @returns {import('preact').Component}
 */ const $ee29629f3ae1b3ac$var$onMount = ({ fn: fn, startingState: startingState, component: ChildComponent })=>class extends $767w7.Component {
        constructor(props){
            super(props);
            if (startingState) this.state = startingState;
        }
        componentDidMount() {
            fn(this);
        }
        render() {
            // @ts-ignore
            return (0, $767w7.h)(ChildComponent, $ee29629f3ae1b3ac$var$_objectSpread($ee29629f3ae1b3ac$var$_objectSpread({}, this.props), this.state));
        }
    };
/**
 * @param {import('preact').Component} OriginalComponent
 * @returns {import('preact').Component}
 */ module.exports.onMount = $ee29629f3ae1b3ac$var$onMount;
const $ee29629f3ae1b3ac$var$transitionIn = (OriginalComponent)=>$ee29629f3ae1b3ac$var$onMount({
        fn: (component)=>{
            setTimeout(()=>{
                component.setState({
                    firstRender: false
                });
            }, 0);
        },
        startingState: {
            firstRender: true
        },
        component: OriginalComponent
    });
module.exports.transitionIn = $ee29629f3ae1b3ac$var$transitionIn;

});


parcelRegister("5T3EV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dRTL8 = parcelRequire("dRTL8");

var $bC6Tk = parcelRequire("bC6Tk");
//@ts-check
/** @typedef {'CreateResource' | 'UpdateResource' | 'DeleteResource'} FHIRActionType */ /**
 * @param {{
 *   apiUrl: string
 *   orgIdSelector: string
 *   eventFilter?: any
 *   logger?: any
 *   customHandlers?: any
 *   eventSourceConstructor?: any
 * }} Opts
 */ var $4494ed67d2ce3b32$var$_default = ({ apiUrl: apiUrl, eventFilter: eventFilter, customHandlers: customHandlers, orgIdSelector: orgIdSelector, logger: logger, eventSourceConstructor: eventSourceConstructor })=>(0, $bC6Tk.getEventSourceManagerBundle)({
        name: "orgEventSource",
        actionBaseName: "ORG_EVENT_SOURCE",
        eventSourceConstructor: eventSourceConstructor,
        dataActionCreatorName: "doReceiveOrgFhirEvents",
        activeIdsSelectorName: "selectOrgIdsToBeSubscribedTo",
        logger: logger,
        buildUrl: (orgId, store)=>{
            // we pass token explicitly for localhost to
            // enable hitting dev API without needing to have
            // valid token cookie.
            const addOn = store.selectHostname() === "localhost" ? "?token=".concat(store.selectAuthToken()) : "";
            return "".concat(apiUrl, "/fhir-sse/org/").concat(orgId).concat(addOn);
        },
        doReceiveOrgFhirEvents: ({ data: data })=>({ store: store })=>{
                const { action: action, orgId: orgId, resourceId: resourceId, resourceType: resourceType } = data;
                const resourceReference = "".concat(resourceType, "/").concat(resourceId);
                if (eventFilter && !eventFilter({
                    action: action,
                    resourceType: resourceType,
                    resourceReference: resourceReference,
                    store: store,
                    orgId: orgId
                })) return;
                const customHandler = customHandlers && customHandlers[resourceType] && customHandlers[resourceType][action];
                if (customHandler) {
                    customHandler(store, {
                        resourceId: resourceId,
                        orgId: orgId
                    });
                    return;
                } // we always fetch newly created resources
                // there's no way to know whether we need them
                if (action === "CreateResource") {
                    store.doFetchFhirResource(resourceReference, orgId);
                    return;
                } // For update and delete we don't know if we have it
                // we only do something if we do
                if (action === "UpdateResource") {
                    const found = store.utilFindFhirResourceById(resourceId);
                    if (found) store.doFetchFhirResource(resourceReference, orgId);
                    return;
                }
                if (action === "DeleteResource") {
                    const found = store.utilFindFhirResourceById(resourceId);
                    if (found) store.doRemoveFhirResource({
                        id: resourceId,
                        orgId: orgId,
                        resourceType: resourceType
                    });
                    return;
                }
            },
        selectOrgIdsToBeSubscribedTo: (0, $dRTL8.createSelector)("selectIsFullyAuthenticated", orgIdSelector, (fullyAuthed, orgIds)=>{
            if (!fullyAuthed || !orgIds) return [];
            return orgIds;
        })
    });
module.exports.default = $4494ed67d2ce3b32$var$_default;

});
parcelRegister("bC6Tk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEventSourceManagerBundle = void 0;

var $04wYO = parcelRequire("04wYO");

var $dRTL8 = parcelRequire("dRTL8");
function $874896cf3ab23eea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $874896cf3ab23eea$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $874896cf3ab23eea$var$ownKeys(Object(source), true).forEach(function(key) {
            $874896cf3ab23eea$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $874896cf3ab23eea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $874896cf3ab23eea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $874896cf3ab23eea$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $874896cf3ab23eea$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $874896cf3ab23eea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $874896cf3ab23eea$var$mappedState = {
    0: "connecting",
    1: "open",
    2: "closed"
};
/**
 * @param {  | {
 *       name: string
 *       actionBaseName: string
 *       activeIdsSelectorName: string
 *       dataActionCreatorName: string
 *       buildUrl: (id: string, store: any) => string
 *       eventSourceConstructor?: any
 *       logger?: any
 *       retryFailedTimeout: number
 *     }
 *   | any} Opts
 */ const $874896cf3ab23eea$var$getEventSourceManagerBundle = (_ref)=>{
    let { name: name, actionBaseName: actionBaseName, activeIdsSelectorName: activeIdsSelectorName, dataActionCreatorName: dataActionCreatorName, buildUrl: buildUrl, eventSourceConstructor: eventSourceConstructor, logger: logger = console, retryFailedTimeout: retryFailedTimeout = 60000 } = _ref, rest = $874896cf3ab23eea$var$_objectWithoutProperties(_ref, [
        "name",
        "actionBaseName",
        "activeIdsSelectorName",
        "dataActionCreatorName",
        "buildUrl",
        "eventSourceConstructor",
        "logger",
        "retryFailedTimeout"
    ]);
    const CREATED = "".concat(actionBaseName, "_CREATED");
    const OPENED = "".concat(actionBaseName, "_OPENED");
    const REMOVED = "".concat(actionBaseName, "_REMOVED");
    const FAILED = "".concat(actionBaseName, "_FAILED");
    const uCaseName = name.charAt(0).toUpperCase() + name.slice(1);
    const rawSelectorName = "select".concat(uCaseName, "Raw");
    const connectedSelectorName = "select".concat(uCaseName, "Connected");
    const doCreateName = "doCreate".concat(uCaseName, "ForId");
    const doRemoveName = "doRemove".concat(uCaseName, "ForId");
    return $874896cf3ab23eea$var$_objectSpread({
        name: name,
        getReducer: ()=>{
            const initial = {};
            return (state = initial, { type: type, payload: payload })=>{
                if (type === CREATED) return $874896cf3ab23eea$var$_objectSpread($874896cf3ab23eea$var$_objectSpread({}, state), {}, {
                    [payload.id]: {
                        es: payload.eventSource,
                        state: $874896cf3ab23eea$var$mappedState[payload.eventSource.readyState]
                    }
                });
                if (type === FAILED) {
                    const id = payload.id;
                    return $874896cf3ab23eea$var$_objectSpread($874896cf3ab23eea$var$_objectSpread({}, state), {}, {
                        [id]: $874896cf3ab23eea$var$_objectSpread($874896cf3ab23eea$var$_objectSpread({}, state[id]), {}, {
                            state: "failed",
                            failedAt: payload.time
                        })
                    });
                }
                if (type === OPENED) {
                    const { id: id } = payload;
                    const existing = state[id];
                    if (!existing) return state;
                    return $874896cf3ab23eea$var$_objectSpread($874896cf3ab23eea$var$_objectSpread({}, state), {}, {
                        [id]: $874896cf3ab23eea$var$_objectSpread($874896cf3ab23eea$var$_objectSpread({}, existing), {}, {
                            state: $874896cf3ab23eea$var$mappedState[existing.es.readyState]
                        })
                    });
                }
                if (type === REMOVED) return (0, $04wYO.omit)(state, [
                    payload
                ]);
                return state;
            };
        },
        [rawSelectorName]: (state)=>state[name],
        [doRemoveName]: (id)=>({ store: store, dispatch: dispatch })=>{
                const existing = store[rawSelectorName]()[id];
                if (existing) {
                    const { es: es } = existing;
                    if (es) try {
                        es.close();
                    } catch (e) {}
                    dispatch({
                        type: REMOVED,
                        payload: id
                    });
                }
            },
        [doCreateName]: (id)=>({ store: store, dispatch: dispatch })=>{
                const eventSource = new (eventSourceConstructor || EventSource)(buildUrl(id, store), {
                    withCredentials: true
                });
                dispatch({
                    type: CREATED,
                    payload: {
                        id: id,
                        eventSource: eventSource
                    }
                });
                eventSource.addEventListener("open", ()=>{
                    dispatch({
                        type: OPENED,
                        payload: {
                            id: id
                        }
                    });
                });
                eventSource.addEventListener("error", (errorEvent)=>{
                    logger && logger.debug({
                        errorEvent: errorEvent,
                        message: "eventSourceError ".concat(name),
                        readyState: eventSource.readyState
                    }); // closed
                    if (eventSource.readyState === 2) setTimeout(()=>{
                        // if it's still 2 we should retry
                        if (eventSource.readyState === 2) store[doCreateName](id);
                    }, 1000);
                     // error event status (if available)
                    const errorHttpStatus = errorEvent && errorEvent.status && typeof errorEvent.status === "number" ? errorEvent.status : 0;
                    if (errorHttpStatus >= 400 && errorHttpStatus <= 499) {
                        // we assume failure
                        eventSource.close();
                        dispatch({
                            type: FAILED,
                            payload: {
                                id: id,
                                time: Date.now()
                            }
                        });
                    }
                });
                eventSource.addEventListener("message", (message)=>{
                    try {
                        const data = JSON.parse(message.data);
                        store[dataActionCreatorName]({
                            id: id,
                            data: data
                        });
                        logger && logger.debug({
                            message: "eventSourceMessageReceived ".concat(name),
                            data: data
                        });
                    } catch (e) {
                        logger && logger.error({
                            error: e,
                            message: "eventSourceErrorReceivingMessage ".concat(name)
                        });
                    }
                });
            },
        [connectedSelectorName]: (0, $dRTL8.createSelector)(rawSelectorName, activeIdsSelectorName, (raw, idsToBeSubscribedTo)=>{
            if (!idsToBeSubscribedTo || !idsToBeSubscribedTo.length) return false;
            return idsToBeSubscribedTo.every((orgId)=>raw[orgId] && raw[orgId].state === "open");
        }),
        ["reactShouldCreateRemove".concat(uCaseName)]: (0, $dRTL8.createSelector)("selectAppTime", activeIdsSelectorName, rawSelectorName, (appTime, idResult, raw)=>{
            // always coerce to array of ids
            let ids = [];
            if (idResult) ids = Array.isArray(idResult) ? idResult : [
                idResult
            ];
            for (const id of ids){
                if (!raw[id]) return {
                    actionCreator: doCreateName,
                    args: [
                        id
                    ]
                };
            } // any to remove
            for(const id in raw){
                const idWasRemoved = !ids.includes(id);
                const failedAtTime = raw[id].failedAt;
                const isFailedAndOld = failedAtTime && appTime - failedAtTime > retryFailedTimeout;
                if (idWasRemoved || isFailedAndOld) return {
                    actionCreator: doRemoveName,
                    args: [
                        id
                    ]
                };
            }
        })
    }, rest);
};
module.exports.getEventSourceManagerBundle = $874896cf3ab23eea$var$getEventSourceManagerBundle;

});


parcelRegister("4AH5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @param {number} httpStatus
 * @param {{
 *   handleNotAuthorized: () => any
 *   handleNoAuthentication: () => any
 * }}
 * @returns {void}
 */ var $357bf1ace6ca7edc$var$_default = (httpStatus, { handleNoAuthentication: handleNoAuthentication, handleNotAuthorized: handleNotAuthorized })=>{
    if (httpStatus >= 400) {
        if (httpStatus === 404) throw Error("NOT_FOUND");
        else if (httpStatus === 401) {
            handleNoAuthentication();
            throw Error("NO_AUTHENTICATION");
        } else if (httpStatus === 403) {
            handleNotAuthorized();
            throw Error("NOT_AUTHORIZED");
        } else if (httpStatus === 409) throw Error("CONFLICT");
        else throw Error("REQUEST_ERROR_" + httpStatus);
    }
};
module.exports.default = $357bf1ace6ca7edc$var$_default;

});

parcelRegister("1reEh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $10c3acfa77911e1c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $10c3acfa77911e1c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $10c3acfa77911e1c$var$ownKeys(Object(source), true).forEach(function(key) {
            $10c3acfa77911e1c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $10c3acfa77911e1c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $10c3acfa77911e1c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// @ts-check
// these match pino on the server-side
const $10c3acfa77911e1c$var$levels = {
    trace: 10,
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60
};
const $10c3acfa77911e1c$var$levelToNumber = (levelName)=>$10c3acfa77911e1c$var$levels[levelName];
/** @typedef {'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal'} LogLevel */ /**
 * @typedef {{
 *   writeToConsole?: boolean
 *   writeAsObject?: boolean
 *   level?: LogLevel
 *   beaconLevel?: LogLevel
 *   sendLogs?: boolean
 * }} LoggerOptions
 */ /** @typedef {(data, message) => void} LogFn */ /**
 * @typedef {{
 *   trace: LogFn
 *   debug: LogFn
 *   info: LogFn
 *   warn: LogFn
 *   error: LogFn
 *   fatal: LogFn
 *   child: (any) => LoggerInstance
 * }} LoggerInstance
 */ /**
 * @param {LoggerOptions} spec
 * @param {any} bindings
 * @returns {LoggerInstance}
 */ const $10c3acfa77911e1c$var$getLogger = (spec, bindings)=>{
    /** @type {LoggerOptions} */ const options = $10c3acfa77911e1c$var$_objectSpread({
        writeToConsole: true,
        writeAsObject: false,
        level: "info",
        beaconLevel: "info",
        sendLogs: true
    }, spec);
    const { level: level, beaconLevel: beaconLevel, writeToConsole: writeToConsole, sendLogs: sendLogs, writeAsObject: writeAsObject } = options;
    let currentLevelAsNumber = $10c3acfa77911e1c$var$levelToNumber(level);
    let beaconLevelAsNumber = $10c3acfa77911e1c$var$levelToNumber(beaconLevel);
    const log = (level, metadata, message)=>{
        if (typeof metadata === "string") {
            message = metadata;
            metadata = {};
        }
        const asNumber = $10c3acfa77911e1c$var$levelToNumber(level);
        const processedBindings = {};
        for(const key in bindings){
            const value = bindings[key];
            try {
                processedBindings[key] = typeof value === "function" ? value() : value;
            } catch (e) {}
        }
        const asObject = $10c3acfa77911e1c$var$_objectSpread($10c3acfa77911e1c$var$_objectSpread({
            level: level,
            message: message,
            url: location.href,
            time: Date.now()
        }, metadata), processedBindings);
        if (writeToConsole && asNumber >= currentLevelAsNumber) {
            if (writeAsObject) // eslint-disable-next-line no-console
            console[level](asObject);
            else // eslint-disable-next-line no-console
            console[asObject.level](asObject.message, asObject);
        }
        if (sendLogs && asNumber >= beaconLevelAsNumber) try {
            // @ts-ignore
            window.__sendLog(asObject);
        } catch (e) {
            console.error("failed to send log");
        }
    };
    const child = (obj)=>$10c3acfa77911e1c$var$getLogger(options, $10c3acfa77911e1c$var$_objectSpread($10c3acfa77911e1c$var$_objectSpread({}, bindings), obj));
    const getLogFn = (level)=>(...args)=>log(level, ...args);
    return {
        trace: getLogFn("trace"),
        debug: getLogFn("debug"),
        info: getLogFn("info"),
        warn: getLogFn("warn"),
        error: getLogFn("error"),
        fatal: getLogFn("fatal"),
        child: child
    };
};
var $10c3acfa77911e1c$var$_default = $10c3acfa77911e1c$var$getLogger;
module.exports.default = $10c3acfa77911e1c$var$_default;

});

parcelRegister("g6HqF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bb9ee4fd23158f54$export$2e2bcd8739ae039);

var $iqaRf = parcelRequire("iqaRf");
var /**
 * This function turns a wide range of freeform input describing someone's birth
 * date into `YYYY-MM-DD` or `YYYY-MM` or `YYYY` using environment's locale to
 * get proper day / month order.
 *
 * @param {string} dateOfBirth In unknown format
 * @param {string} [locale] If you want to use a specific locale you can, but
 *   generally this won't be necessary it will default to environment's locale.
 * @returns {string | null} In format YYYY or YYYY-MM or YYYY-MM-DD
 */ $bb9ee4fd23158f54$export$2e2bcd8739ae039 = (dobString, locale)=>{
    if (!dobString) return null;
    const { knownOrder: knownOrder, parts: parts } = (0, $iqaRf.getParts)(dobString.trim());
    if (knownOrder) return (0, $iqaRf.finalOutput)(knownOrder);
    const combosToTry = (0, $iqaRf.getCombosToTry)(locale)[parts.length];
    if (!combosToTry) return null;
    for(let i = 0, l = combosToTry.length; i < l; i++){
        const res = (0, $iqaRf.testOrder)(combosToTry[i], parts);
        if (res) return (0, $iqaRf.finalOutput)(res);
    }
    return null;
};

});
parcelRegister("iqaRf", function(module, exports) {

$parcel$export(module.exports, "getCombosToTry", () => $d69313d93b5f0742$export$4b5721d0611e6b5b);
$parcel$export(module.exports, "finalOutput", () => $d69313d93b5f0742$export$25cf0247e1cdc251);
$parcel$export(module.exports, "testOrder", () => $d69313d93b5f0742$export$36f774e372ac8786);
$parcel$export(module.exports, "getParts", () => $d69313d93b5f0742$export$a3aee8a24a54661f);
const $d69313d93b5f0742$var$isNumber = (str)=>/^\d+$/.test(str);
const $d69313d93b5f0742$var$containsLetters = (str)=>/[a-z]/g.test(str);
const $d69313d93b5f0742$var$extractNumbers = (str)=>{
    const match = (str || "").match(/\d+/);
    return match && match[0] || null;
};
const $d69313d93b5f0742$var$months = {
    jan: "01",
    feb: "02",
    mar: "03",
    apr: "04",
    may: "05",
    jun: "06",
    jul: "07",
    aug: "08",
    sep: "09",
    oct: "10",
    nov: "11",
    dec: "12"
};
const $d69313d93b5f0742$var$clean = (str)=>str.replace(/[۰-۹]/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d)).replace(/[٠-٩]/g, (d)=>"\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d)).replace(/[^A-Za-z0-9]+/g, " ").trim().toLowerCase();
const $d69313d93b5f0742$var$isInFuture = ({ year: year, month: month, date: date })=>{
    const d = new Date();
    d.setHours(12);
    const currentYear = d.getFullYear();
    if (year !== currentYear) return year > currentYear;
    const currentMonth = d.getMonth() + 1;
    // year is the same
    if (month !== currentMonth) return month > currentMonth;
    // month is the same too
    const currentDate = d.getDate();
    return date > currentDate;
};
const $d69313d93b5f0742$var$parseFns = {
    month: (str)=>{
        if (!str) return null;
        // if they're numeric
        const numbers = $d69313d93b5f0742$var$extractNumbers(str);
        if (numbers) {
            const num = Number(numbers);
            if (num > 0 && num <= 12) return num;
        }
        const lower = str.toLowerCase();
        let match = $d69313d93b5f0742$var$months[lower.slice(0, 1)];
        if (match) return match;
        match = $d69313d93b5f0742$var$months[lower.slice(0, 2)];
        if (match) return match;
        match = $d69313d93b5f0742$var$months[lower.slice(0, 3)];
        if (match) return match;
        return null;
    },
    year: (str)=>{
        if (!$d69313d93b5f0742$var$isNumber(str)) return null;
        const maxYear = new Date().getFullYear();
        const minYear = 1000;
        const num = Number(str);
        if (num > minYear && num <= maxYear) return num;
        // guess year based on current date
        // assume < 100 years old
        if (str.length === 2) {
            const lastTwoDigitsOfMaxYear = Number((maxYear + "").slice(2, 4));
            const firstTwoDigitsOfMaxYear = Number((maxYear + "").slice(0, 2));
            if (lastTwoDigitsOfMaxYear > num) return firstTwoDigitsOfMaxYear * 100 + num;
            else return firstTwoDigitsOfMaxYear * 100 - 100 + num;
        }
        return null;
    },
    date: (str)=>{
        const numbers = $d69313d93b5f0742$var$extractNumbers(str);
        if (!numbers) return null;
        const num = Number(numbers);
        if (num > 0 && num <= 31) return num;
        return null;
    }
};
const $d69313d93b5f0742$var$memo = (fn)=>{
    let lastArg;
    let lastRes;
    let hasRan = false;
    return (arg)=>{
        if (arg === lastArg && hasRan) return lastRes;
        hasRan = true;
        lastRes = fn(arg);
        lastArg = arg;
        return lastRes;
    };
};
const $d69313d93b5f0742$var$arraysEqual = (a, b)=>a.every((item, index)=>b[index] === item);
const $d69313d93b5f0742$var$standardOrder = [
    "year",
    "month",
    "date"
];
const $d69313d93b5f0742$var$getLocaleOrder = (locale)=>{
    const dateString = $d69313d93b5f0742$var$clean(new Date(2021, 3, 5).toLocaleDateString(locale));
    const res = [
        {
            name: "month",
            index: dateString.indexOf("4")
        },
        {
            name: "year",
            index: dateString.indexOf("2021")
        },
        {
            name: "date",
            index: dateString.indexOf("5")
        }
    ];
    res.sort((a, b)=>a.index - b.index);
    const names = res.map((item)=>item.name);
    return $d69313d93b5f0742$var$arraysEqual(names, $d69313d93b5f0742$var$standardOrder) ? [
        names
    ] : [
        names,
        $d69313d93b5f0742$var$standardOrder
    ];
};
const $d69313d93b5f0742$export$4b5721d0611e6b5b = $d69313d93b5f0742$var$memo((locale)=>({
        1: [
            [
                "year"
            ]
        ],
        2: [
            [
                "year",
                "month"
            ],
            [
                "month",
                "year"
            ]
        ],
        3: $d69313d93b5f0742$var$getLocaleOrder(locale)
    }));
const $d69313d93b5f0742$export$b1bc68b38a4b1ea7 = ({ year: year, month: month, date: date })=>{
    if (!year) return null;
    let res = year + "";
    if (month) {
        res += "-" + (month + "").padStart(2, "0");
        if (date) res += "-" + (date + "").padStart(2, "0");
    }
    return res;
};
const $d69313d93b5f0742$export$25cf0247e1cdc251 = (values)=>$d69313d93b5f0742$var$isInFuture(values) ? null : $d69313d93b5f0742$export$b1bc68b38a4b1ea7(values);
const $d69313d93b5f0742$export$36f774e372ac8786 = (order, parts)=>{
    const result = {};
    for(let i = 0, l = order.length; i < l; i++){
        const part = parts[i];
        const partName = order[i];
        const value = $d69313d93b5f0742$var$parseFns[partName](part);
        if (!value) return null;
        result[partName] = value;
    }
    return result;
};
const $d69313d93b5f0742$export$a3aee8a24a54661f = (str)=>{
    const cleaned = $d69313d93b5f0742$var$clean(str);
    const split = cleaned.split(/\s+/).filter(Boolean);
    const result = {
        parts: [],
        knownOrder: null
    };
    if ($d69313d93b5f0742$var$containsLetters(cleaned)) {
        const monthIndex = split.findIndex($d69313d93b5f0742$var$containsLetters);
        const monthValue = $d69313d93b5f0742$var$parseFns.month(split[monthIndex]);
        const otherParts = [
            ...split.slice(0, monthIndex),
            ...split.slice(monthIndex + 1)
        ];
        if (split.length === 2) {
            result.knownOrder = {
                month: monthValue,
                year: $d69313d93b5f0742$var$parseFns.year(split[monthIndex === 0 ? 1 : 0])
            };
            return result;
        }
        if (split.length === 3) {
            const ordersToTry = monthIndex === 0 ? [
                [
                    "date",
                    "year"
                ]
            ] : [
                [
                    "year",
                    "date"
                ],
                [
                    "date",
                    "year"
                ]
            ];
            // console.l
            result.knownOrder = Object.assign({
                month: monthValue
            }, ordersToTry.reduce((res, order)=>{
                if (res) return res;
                return $d69313d93b5f0742$export$36f774e372ac8786(order, otherParts);
            }, null));
            return result;
        }
        return result;
    }
    for(let index = 0, l = split.length; index < l; index++){
        const value = split[index].trim();
        if (!value) continue;
        // handles arabian/persian strings: ie `2‏/1‏/2021`
        const { length: length } = value;
        if (index === 0 && $d69313d93b5f0742$var$isNumber(value) && (length === 6 || length === 5)) // last 4 are years
        result.parts.push(value.slice(0, length === 5 ? 1 : 2), value.slice(-4));
        else result.parts.push(value);
    }
    return result;
};

});


parcelRegister("8HZpF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6571fa3e50eaaeb9$export$2e2bcd8739ae039);
/**
 * @param {Date}
 * @returns {string} As YYYY-MM-DD
 */ const $6571fa3e50eaaeb9$var$dateToString = (date)=>[
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getDate().toString().padStart(2, "0")
    ].join("-");
var /**
 * @param {string} dateOfBirth In format YYYY or YYYY-MM or YYYY-MM-DD
 * @returns {number} Number of years old
 */ $6571fa3e50eaaeb9$export$2e2bcd8739ae039 = (dobString)=>{
    const now = new Date();
    const currentYear = now.getFullYear();
    // by creating both dates using the same mechanism
    // we can safely compare them without worrying about
    // timezones, etc.
    const todayDate = new Date($6571fa3e50eaaeb9$var$dateToString(now));
    const birthDate = new Date(dobString);
    // grabbing the number of years
    const yearsOld = currentYear - birthDate.getFullYear();
    // now we modify birthday to be same year as today
    // so we can do a simple comparison to see if the
    // day has occurred yet
    birthDate.setFullYear(currentYear);
    return Math.max(birthDate > todayDate ? yearsOld - 1 : yearsOld, 0);
};

});

parcelRegister("aH4SR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");

var $7Dcmj = parcelRequire("7Dcmj");
function $7c91b562d7ae30c6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7c91b562d7ae30c6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7c91b562d7ae30c6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * @typedef PillsProps
 * @property {{ icon: string; text: string }[]} items
 * @property {string} [pillBgColor]
 * @property {string} [pillTextColor]
 */ /**
 * Pills
 *
 * @typedef {import('preact').FunctionComponent} CardComponent
 * @param {PillsProps} Props
 */ var $7c91b562d7ae30c6$var$_default = (_ref)=>{
    let { items: items, pillBgColor: pillBgColor = "white", pillTextColor: pillTextColor = "dark-blue" } = _ref, rest = $7c91b562d7ae30c6$var$_objectWithoutProperties(_ref, [
        "items",
        "pillBgColor",
        "pillTextColor"
    ]);
    return (0, $767w7.h)("div", rest, items.map(({ icon: icon, text: text }, index)=>(0, $767w7.h)("span", {
            key: text,
            className: "inline-flex items-center pa1 f6 bg-".concat(pillBgColor, " ").concat(pillTextColor, " br-pill mr").concat(index === items.length - 1 ? "0" : "2")
        }, (0, $767w7.h)($7Dcmj.Icon, {
            icon: icon,
            size: "16",
            className: "mr2 ml1"
        }), (0, $767w7.h)("span", {
            className: "mr1"
        }, text))));
};
module.exports.default = $7c91b562d7ae30c6$var$_default;

});

parcelRegister("57nNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767w7 = parcelRequire("767w7");

var $3ba00fd5c7736dad$var$_classnames = $3ba00fd5c7736dad$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $dSxTB = parcelRequire("dSxTB");
function $3ba00fd5c7736dad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ba00fd5c7736dad$var$_extends() {
    $3ba00fd5c7736dad$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ba00fd5c7736dad$var$_extends.apply(this, arguments);
}
function $3ba00fd5c7736dad$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3ba00fd5c7736dad$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3ba00fd5c7736dad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3ba00fd5c7736dad$var$_default = (_ref)=>{
    let { visible: visible = true, message: message = "Loading..." } = _ref, rest = $3ba00fd5c7736dad$var$_objectWithoutProperties(_ref, [
        "visible",
        "message"
    ]);
    return (0, $767w7.h)("div", $3ba00fd5c7736dad$var$_extends({
        "data-e2e": "loadingScreen",
        className: (0, $3ba00fd5c7736dad$var$_classnames.default)("left-0 top-0 z-2 fixed vh-100 w-100 bg-dark-blue transition flex items-center justify-center", {
            "o-100": visible,
            "o-0": !visible
        })
    }, rest), (0, $767w7.h)("div", {
        className: "mb4"
    }, (0, $767w7.h)($dSxTB.XChart, {
        light: true,
        className: "pulse-animation h2 h3-m h4-l"
    })), (0, $767w7.h)("div", {
        className: "fixed bottom-0 right-0 pa3 f4 light-blue tc o-60"
    }, message));
};
module.exports.default = $3ba00fd5c7736dad$var$_default;

});
parcelRegister("dSxTB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XChart = module.exports.XMark = module.exports.LoadingMark = module.exports.UpChevron = module.exports.DownChevron = void 0;

var $767w7 = parcelRequire("767w7");
function $a1aa9c7de4f0e7f6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a1aa9c7de4f0e7f6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a1aa9c7de4f0e7f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a1aa9c7de4f0e7f6$var$_extends() {
    $a1aa9c7de4f0e7f6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a1aa9c7de4f0e7f6$var$_extends.apply(this, arguments);
}
const $a1aa9c7de4f0e7f6$var$DownChevron = (props)=>(0, $767w7.h)("path", $a1aa9c7de4f0e7f6$var$_extends({
        className: "downchev"
    }, props, {
        d: "M87 4.2L65 35a6.2 6.2 0 01-10 0L33 4.2A10 10 0 0021 .8 100 100 0 000 13l42.7 60.8c9.5 13.6 25.1 13.6 34.6 0L120 13A100 100 0 0099 .8a10 10 0 00-12 3.4z"
    }));
module.exports.DownChevron = $a1aa9c7de4f0e7f6$var$DownChevron;
const $a1aa9c7de4f0e7f6$var$UpChevron = (props)=>(0, $767w7.h)("path", $a1aa9c7de4f0e7f6$var$_extends({
        fill: "#73D2E1",
        className: "upchev"
    }, props, {
        d: "M87 139.8L65 109a6.2 6.2 0 00-10 0l-22 30.7a10 10 0 01-12 3.4C13.5 140 6.5 135.9 0 131l42.7-60.8c9.5-13.6 25.1-13.6 34.6 0L120 131a100 100 0 01-21 12.2 10 10 0 01-12-3.4z"
    }));
module.exports.UpChevron = $a1aa9c7de4f0e7f6$var$UpChevron;
const $a1aa9c7de4f0e7f6$var$LoadingMark = (_ref)=>{
    let { light: light } = _ref, props = $a1aa9c7de4f0e7f6$var$_objectWithoutProperties(_ref, [
        "light"
    ]);
    const textColor = light ? "#FFF" : "#193750";
    return (0, $767w7.h)("svg", $a1aa9c7de4f0e7f6$var$_extends({
        viewBox: "-60 -72 240 288",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $767w7.h)($a1aa9c7de4f0e7f6$var$DownChevron, {
        fill: textColor
    }), (0, $767w7.h)($a1aa9c7de4f0e7f6$var$UpChevron, null));
};
module.exports.LoadingMark = $a1aa9c7de4f0e7f6$var$LoadingMark;
const $a1aa9c7de4f0e7f6$var$XMark = (_ref2)=>{
    let { light: light } = _ref2, props = $a1aa9c7de4f0e7f6$var$_objectWithoutProperties(_ref2, [
        "light"
    ]);
    const textColor = light ? "#FFF" : "#193750";
    return (0, $767w7.h)("svg", $a1aa9c7de4f0e7f6$var$_extends({
        viewBox: "0 0 120 144",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $767w7.h)($a1aa9c7de4f0e7f6$var$DownChevron, {
        fill: textColor
    }), (0, $767w7.h)($a1aa9c7de4f0e7f6$var$UpChevron, null));
};
module.exports.XMark = $a1aa9c7de4f0e7f6$var$XMark;
const $a1aa9c7de4f0e7f6$var$XChart = (_ref3)=>{
    let { light: light, includeDomain: includeDomain = true } = _ref3, props = $a1aa9c7de4f0e7f6$var$_objectWithoutProperties(_ref3, [
        "light",
        "includeDomain"
    ]);
    const textColor = light ? "#FFF" : "#193750";
    return (0, $767w7.h)("svg", $a1aa9c7de4f0e7f6$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 ".concat(includeDomain ? "744" : "552", " 144")
    }, props), (0, $767w7.h)($a1aa9c7de4f0e7f6$var$DownChevron, {
        fill: textColor
    }), (0, $767w7.h)($a1aa9c7de4f0e7f6$var$UpChevron, null), (0, $767w7.h)("path", {
        fill: textColor,
        d: "M173.4 37c6.9 0 15.7 1 26.4 3.2l5.3 1.3-.8 21.4c-10.4-1-18.1-1.6-23.1-1.6-9.2 0-15.2 2-18.3 6-2.9 4-4.3 11.4-4.3 22.5 0 11 1.4 18.7 4.3 22.9 3 4 9.2 6 18.5 6l23-1.6.7 21.6c-14.1 2.9-24.9 4.3-32.3 4.3-14.6 0-25.2-4.2-31.7-12.6-6.3-8.4-9.5-22-9.5-40.6s3.3-32 10-40.2C148 41.2 158.7 37 173.3 37zM246.4 141.6H220V0h26.5v45.3A53.4 53.4 0 01271 38c13.2 0 22.3 4 27.4 12 5 8 7.5 20.2 7.5 36.8v54.8h-26.6V87.4c0-8.5-1-14.8-3-18.8-2-4.2-5.9-6.3-11.8-6.3-5.2 0-10.3.8-15.5 2.4l-2.6.8v76zM400.4 72v42c.3 3.3.8 5.6 1.6 7 .8 1.2 2.4 2 5 2.6L406 144a75 75 0 01-16.2-1.4c-4-1-8-2.8-12.1-5.7a65 65 0 01-29.1 7.1c-20.5 0-30.8-11-30.8-33.2 0-10.8 2.9-18.4 8.6-22.8a46.6 46.6 0 0126.1-8.1l21.2-1.6V72c0-4.2-.9-7-2.7-8.5-1.9-1.6-4.9-2.4-9-2.4L325 62.7l-.8-18.8c14.1-4 27.5-5.9 40.2-5.9 12.8 0 22 2.7 27.6 8.1 5.7 5.4 8.5 14 8.5 25.9zm-44.6 26.7c-7.4.7-11.1 4.7-11.1 12.1 0 7.4 3.2 11.2 9.7 11.2 5 0 10.5-.9 16.5-2.5l3-.8V97.1l-18.1 1.6zM419.8 141.6V40.4H446v10.8A99.7 99.7 0 01477.8 38v27.3a302.4 302.4 0 00-27.5 7.1l-4 1.4v67.8h-26.5zM551.4 63.5H527V105c0 4 0 7 .2 8.7.3 1.6 1 3 2.2 4.2 1.3 1.2 3.3 1.8 6 1.8l15-.4 1.2 21.7a99 99 0 01-20.2 3c-12 0-20-2.7-24.4-8-4.4-5.6-6.5-15.7-6.5-30.4v-42h-11.7V40.3h11.7v-28H527v28h24.4v23.1z"
    }), includeDomain && (0, $767w7.h)("path", {
        fill: textColor,
        d: "M564 142.9v-15.2h13.3v15.2H564zM605.5 96c3.2 0 7.3.5 12.3 1.5l2.5.5-.4 9.7c-4.8-.5-8.4-.7-10.8-.7-4.2 0-7 1-8.5 2.7-1.3 1.8-2 5.2-2 10.2 0 5 .7 8.5 2 10.4 1.4 1.8 4.3 2.7 8.6 2.7l10.7-.7.4 9.8c-6.6 1.3-11.6 1.9-15 1.9-7 0-11.8-1.9-14.9-5.7-3-3.8-4.4-10-4.4-18.4 0-8.4 1.5-14.5 4.6-18.2 3.1-3.8 8-5.7 15-5.7zM631.6 102.3c3.3-4.2 8.7-6.3 16.4-6.3 7.6 0 13 2.1 16.4 6.3 3.2 4.2 4.9 10 4.9 17.6 0 16-7.1 24.1-21.3 24.1-14.2 0-21.3-8-21.3-24 0-7.7 1.7-13.5 5-17.7zm9.5 28c1.3 2.2 3.6 3.3 6.9 3.3 3.3 0 5.5-1.1 6.7-3.3 1.3-2.2 2-5.7 2-10.4s-.7-8.1-2-10.3c-1.2-2-3.4-3.2-6.7-3.2-3.3 0-5.6 1.1-6.9 3.2a21.4 21.4 0 00-1.8 10.3c0 4.7.6 8.2 1.8 10.4zM689.8 142.9h-12.4V97.1h12.3v2.6a23 23 0 0111-3.7c5 0 8.8 1.4 11.5 4.3a34.9 34.9 0 0115.5-4.3c6.1 0 10.4 1.8 12.7 5.3 2.4 3.5 3.6 9 3.6 16.8v24.8h-12.4v-24.5c0-3.9-.4-6.7-1.3-8.6-.8-1.9-2.6-2.8-5.2-2.8-2 0-4.3.4-7.2 1.3l-1.4.4c.3 4.6.4 8 .4 10.5v23.7h-12.4v-23.5c0-4.6-.4-7.7-1.2-9.6-.8-1.9-2.5-2.8-5.3-2.8-2.4 0-4.7.4-7 1.3l-1.2.3V143z"
    }));
};
module.exports.XChart = $a1aa9c7de4f0e7f6$var$XChart;

});


parcelRegister("aAVks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @param {{
 *   recentActionsToTrack?: number
 *   maxByteSize?: number
 * }} [options]
 * @returns
 */ const $7b69bc82f8b43a4c$var$getRecentActionsBundle = ({ recentActionsToTrack: recentActionsToTrack = 20, maxByteSize: maxByteSize = 10000 } = {})=>({
        name: "recentActions",
        init: (store)=>{
            store.getRecentActions = ()=>{
                try {
                    const getLen = (items)=>JSON.stringify(items).length;
                    const isTooBig = (items)=>getLen(items) > maxByteSize;
                    const copy = [
                        ...store.meta.recentActions
                    ];
                    const allowedPerEntry = Math.round((maxByteSize - 5) / copy.length);
                    if (isTooBig(copy)) // this is important so we can trim down really large action payloads
                    for(let i = 0, len = copy.length; i < len; i++){
                        const entry = copy[i];
                        if (getLen(entry) > allowedPerEntry) copy[i] = {
                            type: entry.type,
                            payload: "_LONG_"
                        };
                    }
                     // trim until we fit (this shouldn't be necessary)
                    while(isTooBig(copy))copy.shift();
                    return copy;
                } catch (e) {
                    return "error serializing recent actions";
                }
            };
        },
        getMiddleware: ()=>(store)=>(next)=>(action)=>{
                        // only log non-idle actions
                        if (action.type !== "APP_IDLE") {
                            const recentActions = store.meta.recentActions || (store.meta.recentActions = []);
                            recentActions.push(action);
                            if (recentActions.length > recentActionsToTrack) recentActions.shift();
                        }
                        return next(action);
                    }
    });
var $7b69bc82f8b43a4c$var$_default = $7b69bc82f8b43a4c$var$getRecentActionsBundle;
module.exports.default = $7b69bc82f8b43a4c$var$_default;

});

parcelRegister("hZ5C6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8q4hu = parcelRequire("8q4hu");
// writes a beta cookie lazily
// for opting into beta
var $d17c7ce264c9a295$var$_default = ({ domain: domain, redirect: redirect, maxAge: maxAge })=>({
        name: "betaBundle",
        init: (store)=>{
            setTimeout(store.doEnsureBetaCookie, 2000);
        },
        doEnsureBetaCookie: ()=>()=>{
                (0, $8q4hu.writeCookie)("beta", 1, {
                    maxAge: maxAge,
                    domain: domain
                });
            },
        doLeaveBeta: ()=>()=>{
                (0, $8q4hu.deleteCookie)("beta", domain);
                location = redirect;
            }
    });
module.exports.default = $d17c7ce264c9a295$var$_default;

});
parcelRegister("8q4hu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteCookie = module.exports.readCookie = module.exports.writeCookie = void 0;
/**
 * @param {string} name
 * @param {string} value
 * @param {{
 *   maxAge?: number
 *   expires?: Date
 *   secure?: boolean
 *   domain?: string
 * }} opts
 */ const $621412948ebeb6f0$var$writeCookie = (name, value, { maxAge: maxAge, expires: expires, secure: secure = false, domain: domain } = {})=>{
    const hostname = globalThis.location && globalThis.location.hostname;
    const cookieData = {
        [name]: value,
        domain: domain || hostname,
        path: "/",
        secure: secure
    };
    if (hostname === "localhost") cookieData.secure = false;
    if (maxAge) cookieData["max-age"] = Math.floor(maxAge / 1000); // convert to seconds
    else if (expires) cookieData.expires = expires.toGMTString();
    const cookieString = Object.keys(cookieData).reduce((result, key)=>{
        const value = cookieData[key];
        if (typeof value === "boolean") {
            if (value === true) result.push(key);
        } else result.push("".concat(key, "=").concat(value));
        return result;
    }, []).join(";");
    document.cookie = cookieString;
};
module.exports.writeCookie = $621412948ebeb6f0$var$writeCookie;
const $621412948ebeb6f0$var$readCookie = (name)=>{
    let value = null;
    document.cookie.split(";").find((item)=>{
        const parts = item.split("=");
        const key = parts[0].trim();
        if (key === name) {
            value = parts[1].trim();
            return true;
        }
    });
    return value;
};
module.exports.readCookie = $621412948ebeb6f0$var$readCookie;
const $621412948ebeb6f0$var$deleteCookie = (item, domain)=>$621412948ebeb6f0$var$writeCookie(item, "", {
        expires: new Date(0),
        domain: domain
    });
module.exports.deleteCookie = $621412948ebeb6f0$var$deleteCookie;

});


parcelRegister("il5gP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $brUQh = parcelRequire("brUQh");

var $ezNDq = parcelRequire("ezNDq");

var $5RiU8 = parcelRequire("5RiU8");
function $d59e46c75220fc22$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d59e46c75220fc22$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d59e46c75220fc22$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d59e46c75220fc22$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d59e46c75220fc22$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d59e46c75220fc22$var$ownKeys(Object(source), true).forEach(function(key) {
            $d59e46c75220fc22$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d59e46c75220fc22$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d59e46c75220fc22$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $d59e46c75220fc22$var$encode = (obj)=>{
    const str = JSON.stringify(obj);
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode("0x" + p1)));
}; // does the fetch, but swallows errors, and
// resolves promise after a max of 250 ms not matter what
const $d59e46c75220fc22$var$doFetch = (url, obj, debug = false)=>{
    let builtUrl = url + "?data=" + $d59e46c75220fc22$var$encode(obj);
    if (debug) {
        console.info("sending", obj);
        builtUrl += "&verbose=1";
    }
    const promise = fetch(builtUrl).then((res)=>debug ? res.json() : res.text()).then((res)=>{
        if (!debug && res !== "1") console.error("mixpanel request failed");
        if (debug) console.info(res);
    }).catch(()=>{
        console.error("mixpanel request failed");
    });
    return (0, $ezNDq.promiseTimeout)({
        promise: promise,
        timeout: 250,
        shouldReject: false
    });
};
var $d59e46c75220fc22$var$_default = (token, debug)=>{
    const envProps = (0, $brUQh.getEnvironmentData)();
    const anonId = (0, $5RiU8.getOrCreateUid)();
    const engage = (obj)=>$d59e46c75220fc22$var$doFetch("https://api.mixpanel.com/engage/", obj, debug);
    const track = (event, props)=>$d59e46c75220fc22$var$doFetch("https://api.mixpanel.com/track/", {
            event: event,
            properties: $d59e46c75220fc22$var$_objectSpread({
                token: token,
                distinct_id: realId || anonId
            }, props)
        }, debug);
    let realId;
    return {
        identify: (_ref)=>{
            let { id: id, name: name, email: email } = _ref, rest = $d59e46c75220fc22$var$_objectWithoutProperties(_ref, [
                "id",
                "name",
                "email"
            ]);
            if (!realId) {
                realId = id;
                track("$identify", {
                    $anon_distinct_id: anonId,
                    $identified_id: id
                });
            }
            return engage({
                $token: token,
                $distinct_id: realId,
                $set: $d59e46c75220fc22$var$_objectSpread({
                    $name: name,
                    $email: email
                }, rest)
            });
        },
        track: (event, props)=>track(event, $d59e46c75220fc22$var$_objectSpread({
                $current_url: window.location.href,
                $screen_height: window.innerHeight,
                $screen_width: window.innerWidth,
                $browser: envProps.browser,
                $browser_version: envProps.browserVersion,
                $os: envProps.os,
                $device: envProps.device,
                nativeAppVersion: envProps.nativeAppVersion,
                app_version: window.version || 0
            }, props))
    };
};
module.exports.default = $d59e46c75220fc22$var$_default;

});
parcelRegister("brUQh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentData = module.exports.getBrowserVersion = module.exports.getDevice = module.exports.getOs = module.exports.getBrowser = void 0;

var $kRHng = parcelRequire("kRHng");
const $855e4f0205317465$var$getBrowser = (ua, vendor = "")=>{
    if (ua.includes(" OPR/")) {
        if (ua.includes("Mini")) return "Opera Mini";
        return "Opera";
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(ua)) return "BlackBerry";
    else if (ua.includes("IEMobile") || ua.includes("WPDesktop")) return "Internet Explorer Mobile";
    else if (ua.includes("Edge")) return "Microsoft Edge";
    else if (ua.includes("FBIOS")) return "Facebook Mobile";
    else if (ua.includes("Chrome")) return "Chrome";
    else if (ua.includes("CriOS")) return "Chrome iOS";
    else if (ua.includes("UCWEB") || ua.includes("UCBrowser")) return "UC Browser";
    else if (ua.includes("FxiOS")) return "Firefox iOS";
    else if (vendor.includes("Apple")) {
        if (ua.includes("Mobile")) return "Mobile Safari";
        return "Safari";
    } else if (ua.includes("Android")) return "Android Mobile";
    else if (ua.includes("Konqueror")) return "Konqueror";
    else if (ua.includes("Firefox")) return "Firefox";
    else if (ua.includes("MSIE") || ua.includes("Trident/")) return "Internet Explorer";
    else if (ua.includes("Gecko")) return "Mozilla";
    return "";
};
module.exports.getBrowser = $855e4f0205317465$var$getBrowser;
const $855e4f0205317465$var$getOs = (ua)=>{
    if (/Windows/i.test(ua)) {
        if (/Phone/.test(ua) || /WPDesktop/.test(ua)) return "Windows Phone";
        return "Windows";
    } else if (/(iPhone|iPad|iPod)/.test(ua)) return "iOS";
    else if (/Android/.test(ua)) return "Android";
    else if (/(BlackBerry|PlayBook|BB10)/i.test(ua)) return "BlackBerry";
    else if (/Mac/i.test(ua)) return "Mac OS X";
    else if (/Linux/.test(ua)) return "Linux";
    else if (/CrOS/.test(ua)) return "Chrome OS";
    return "";
};
module.exports.getOs = $855e4f0205317465$var$getOs;
const $855e4f0205317465$var$getDevice = (ua)=>{
    if (/Windows Phone/i.test(ua) || /WPDesktop/.test(ua)) return "Windows Phone";
    else if (/iPad/.test(ua)) return "iPad";
    else if (/iPod/.test(ua)) return "iPod Touch";
    else if (/iPhone/.test(ua)) return "iPhone";
    else if (/(BlackBerry|PlayBook|BB10)/i.test(ua)) return "BlackBerry";
    else if (/Android/.test(ua)) return "Android";
    return "";
};
module.exports.getDevice = $855e4f0205317465$var$getDevice;
const $855e4f0205317465$var$versionRegexs = {
    "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
    "Microsoft Edge": /Edge\/(\d+(\.\d+)?)/,
    Chrome: /Chrome\/(\d+(\.\d+)?)/,
    "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
    "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
    Safari: /Version\/(\d+(\.\d+)?)/,
    "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
    Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
    Firefox: /Firefox\/(\d+(\.\d+)?)/,
    "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
    Konqueror: /Konqueror:(\d+(\.\d+)?)/,
    BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
    "Android Mobile": /android\s(\d+(\.\d+)?)/,
    "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
    Mozilla: /rv:(\d+(\.\d+)?)/
};
const $855e4f0205317465$var$getBrowserVersion = function(userAgent, vendor) {
    const browser = $855e4f0205317465$var$getBrowser(userAgent, vendor);
    const regex = $855e4f0205317465$var$versionRegexs[browser];
    if (regex === undefined) return null;
    const matches = userAgent.match(regex);
    if (!matches) return null;
    return parseFloat(matches[matches.length - 2]);
};
module.exports.getBrowserVersion = $855e4f0205317465$var$getBrowserVersion;
const $855e4f0205317465$var$IS_BROWSER = !!globalThis.navigator;
/**
 * @returns {{
 *   browser: string
 *   browserVersion: number
 *   os: string
 *   device: string
 *   nativeAppVersion: string || null
 * }}
 */ const $855e4f0205317465$var$getEnvironmentData = (0, $kRHng.once)(()=>{
    if (!$855e4f0205317465$var$IS_BROWSER) return {};
    const { vendor: vendor, userAgent: userAgent } = navigator;
    let electron = false;
    if (window.acElectron) electron = window.acElectron.version || "unknown";
    return {
        browser: electron ? "Electron App" : $855e4f0205317465$var$getBrowser(userAgent, vendor),
        browserVersion: $855e4f0205317465$var$getBrowserVersion(userAgent, vendor),
        os: $855e4f0205317465$var$getOs(userAgent),
        device: $855e4f0205317465$var$getDevice(userAgent) || "unknown",
        nativeAppVersion: electron || null
    };
});
module.exports.getEnvironmentData = $855e4f0205317465$var$getEnvironmentData;

});
parcelRegister("kRHng", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.once = module.exports.limitCalls = module.exports.arrayOfKeysMemoize = module.exports.singleArgMemoize = void 0;

var $04wYO = parcelRequire("04wYO");
// dead simple memoization. Only skips
// compute if first arg is same only
// stores one answer
const $f30a671bea6cefe3$var$singleArgMemoize = (fn)=>{
    let answer;
    let lastArg;
    let hasRun = false;
    return (arg1)=>{
        if (arg1 === lastArg && hasRun) return answer;
        hasRun = true;
        answer = fn(arg1);
        lastArg = arg1;
        return answer;
    };
};
module.exports.singleArgMemoize = $f30a671bea6cefe3$var$singleArgMemoize;
const $f30a671bea6cefe3$var$serialize = (obj, keys)=>{
    let buff = "";
    for(let i = 0, l = keys.length; i < l; i++){
        const key = keys[i];
        buff += "".concat(key, ":").concat(obj[key]);
    }
    return buff;
};
const $f30a671bea6cefe3$var$arrayOfKeysMemoize = (keys)=>{
    let answer;
    let lastArg;
    let hasRun = false;
    return (obj)=>{
        const serialized = $f30a671bea6cefe3$var$serialize(obj, keys);
        if (serialized === lastArg && hasRun) return answer;
        hasRun = true;
        answer = (0, $04wYO.pluck)(obj, keys);
        lastArg = serialized;
        return answer;
    };
};
module.exports.arrayOfKeysMemoize = $f30a671bea6cefe3$var$arrayOfKeysMemoize;
const $f30a671bea6cefe3$var$limitCalls = (fn, times)=>{
    let memo;
    return function() {
        if (times-- > 0) memo = fn.apply(this, arguments);
        else fn = null;
        return memo;
    };
};
module.exports.limitCalls = $f30a671bea6cefe3$var$limitCalls;
const $f30a671bea6cefe3$var$once = (fn)=>$f30a671bea6cefe3$var$limitCalls(fn, 1);
module.exports.once = $f30a671bea6cefe3$var$once;

});


parcelRegister("ezNDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promiseTimeout = void 0;
/**
 * @param {{
 *   timeout: number
 *   promise: Promise<any>
 *   shouldReject: boolean
 * }} opts
 * @returns
 */ const $a9cad60306daeb1a$var$promiseTimeout = ({ timeout: timeout, promise: promise, shouldReject: shouldReject = true })=>Promise.race([
        promise,
        new Promise((resolve, reject)=>{
            const id = setTimeout(()=>{
                clearTimeout(id);
                shouldReject ? reject() : resolve();
            }, timeout);
        })
    ]);
module.exports.promiseTimeout = $a9cad60306daeb1a$var$promiseTimeout;

});

parcelRegister("5RiU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOrCreateUid = module.exports.createUid = module.exports.deleteUid = module.exports.getUid = void 0;

var $444090fea4c73ad5$var$_milliseconds = $444090fea4c73ad5$var$_interopRequireDefault((parcelRequire("6zzev")));

var $8q4hu = parcelRequire("8q4hu");

var $e7EYC = parcelRequire("e7EYC");
function $444090fea4c73ad5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// @ts-check
const $444090fea4c73ad5$var$domain = globalThis.location && globalThis.location.hostname.split(".").slice(-2).join(".") || "xchart.com";
const $444090fea4c73ad5$var$getUid = ()=>(0, $8q4hu.readCookie)("uid");
module.exports.getUid = $444090fea4c73ad5$var$getUid;
const $444090fea4c73ad5$var$deleteUid = ()=>(0, $8q4hu.deleteCookie)("uid", $444090fea4c73ad5$var$domain);
module.exports.deleteUid = $444090fea4c73ad5$var$deleteUid;
const $444090fea4c73ad5$var$createUid = ()=>{
    const uid = (0, $e7EYC.uuid)();
    try {
        (0, $8q4hu.writeCookie)("uid", uid, {
            maxAge: $444090fea4c73ad5$var$_milliseconds.default.years(10),
            domain: $444090fea4c73ad5$var$domain
        });
    } catch (e) {}
    return uid;
};
module.exports.createUid = $444090fea4c73ad5$var$createUid;
const $444090fea4c73ad5$var$getOrCreateUid = ()=>$444090fea4c73ad5$var$getUid() || $444090fea4c73ad5$var$createUid();
module.exports.getOrCreateUid = $444090fea4c73ad5$var$getOrCreateUid;

});


parcelRegister("74SEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $brUQh = parcelRequire("brUQh");

var $5RiU8 = parcelRequire("5RiU8");
function $52734c5cbd6d66d7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $52734c5cbd6d66d7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $52734c5cbd6d66d7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $52734c5cbd6d66d7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $52734c5cbd6d66d7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $52734c5cbd6d66d7$var$ownKeys(Object(source), true).forEach(function(key) {
            $52734c5cbd6d66d7$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $52734c5cbd6d66d7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $52734c5cbd6d66d7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $52734c5cbd6d66d7$var$encode = (obj)=>{
    const str = JSON.stringify(obj);
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode("0x" + p1)));
};
const $52734c5cbd6d66d7$var$send = (baseUrl, url, obj, debug = false)=>{
    if (debug) console.info("sending", obj);
    let builtUrl = "".concat(baseUrl).concat(url, "?data=").concat($52734c5cbd6d66d7$var$encode(obj));
    if (globalThis.navigator && globalThis.navigator.sendBeacon) navigator.sendBeacon(builtUrl);
};
/**
 * @param {string} baseUrl
 * @param {boolean} [debug=false] Default is `false`
 */ var $52734c5cbd6d66d7$var$_default = (baseUrl, debug = false)=>{
    const envProps = (0, $brUQh.getEnvironmentData)();
    const anonId = (0, $5RiU8.getOrCreateUid)();
    const engage = (obj)=>$52734c5cbd6d66d7$var$send(baseUrl, "/engage/", obj, debug);
    const track = (event, props)=>$52734c5cbd6d66d7$var$send(baseUrl, "/track/", {
            event: event,
            properties: $52734c5cbd6d66d7$var$_objectSpread({
                distinct_id: realId || anonId
            }, props)
        }, debug);
    let realId;
    return {
        identify: (_ref)=>{
            let { id: id, name: name, email: email } = _ref, rest = $52734c5cbd6d66d7$var$_objectWithoutProperties(_ref, [
                "id",
                "name",
                "email"
            ]);
            if (!realId) {
                realId = id;
                track("$identify", {
                    $anon_distinct_id: anonId,
                    $identified_id: id
                });
            }
            engage({
                $distinct_id: realId,
                $set: $52734c5cbd6d66d7$var$_objectSpread({
                    $name: name,
                    $email: email
                }, rest)
            });
        },
        track: (event, props)=>track(event, $52734c5cbd6d66d7$var$_objectSpread({
                $current_url: window.location.href,
                $screen_height: window.innerHeight,
                $screen_width: window.innerWidth,
                $browser: envProps.browser,
                $browser_version: envProps.browserVersion,
                $os: envProps.os,
                $device: envProps.device,
                nativeAppVersion: envProps.nativeAppVersion,
                app_version: window.version || 0
            }, props))
    };
};
module.exports.default = $52734c5cbd6d66d7$var$_default;

});

parcelRegister("34ucQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $23c92d264a41f5c8$export$2e2bcd8739ae039);

var $2MTnF = parcelRequire("2MTnF");

var $7yBDJ = parcelRequire("7yBDJ");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $23c92d264a41f5c8$export$2e2bcd8739ae039(dirtyInterval, options) {
    (0, $4LmDH.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $gdr0J.default)(interval.start);
    var endDate = (0, $gdr0J.default)(interval.end);
    var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var startDateWeek = (0, $7yBDJ.default)(startDate, options);
    var endDateWeek = (0, $7yBDJ.default)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    endTime = endDateWeek.getTime();
    var weeks = [];
    var currentWeek = startDateWeek;
    while(currentWeek.getTime() <= endTime){
        currentWeek.setHours(0);
        weeks.push((0, $gdr0J.default)(currentWeek));
        currentWeek = (0, $2MTnF.default)(currentWeek, 1);
        currentWeek.setHours(15);
    }
    return weeks;
}

});
parcelRegister("2MTnF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $207b05f27970aaba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");
function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $6OX6Q.default)(dirtyDate, days);
}

});
parcelRegister("esGEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874c42e2166676d$export$2e2bcd8739ae039);
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("6OX6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f754377033842c6$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});


parcelRegister("7yBDJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5808e7e2a5fbbc4c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("5E40x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $41c3cc0836893904$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6uyHy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ba07667a7282b10$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("eqWMS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a8211859f65764ad$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("l2vHo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f5125f9e9edab43e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("75XN4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $52a761315a8e3e9c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $esGEx.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $esGEx.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("lmLBg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f8e0936f0e85f082$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f8e0936f0e85f082$export$2e2bcd8739ae039(dirtyInterval, options) {
    (0, $4LmDH.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $gdr0J.default)(interval.start);
    var endDate = (0, $gdr0J.default)(interval.end);
    var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = options && "step" in options ? Number(options.step) : 1;
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, $gdr0J.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$t, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e = {}, $13c40c34b78c8ee2$var$c = [], $13c40c34b78c8ee2$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $13c40c34b78c8ee2$var$a(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$h(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$y(l, f, t, r, null);
}
function $13c40c34b78c8ee2$var$y(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$u : o
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$k(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$k(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$k(n) : null;
}
function $13c40c34b78c8ee2$var$b(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$b(n);
    }
}
function $13c40c34b78c8ee2$var$m(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$t.push(n) && !$13c40c34b78c8ee2$var$g.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$g);
}
function $13c40c34b78c8ee2$var$g() {
    for(var n; $13c40c34b78c8ee2$var$g.__r = $13c40c34b78c8ee2$var$t.length;)n = $13c40c34b78c8ee2$var$t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $13c40c34b78c8ee2$var$t = [], n.some(function(n) {
        var l, u, i, t, r, o;
        n.__d && (r = (t = (l = n).__v).__e, (o = l.__P) && (u = [], (i = $13c40c34b78c8ee2$var$a({}, t)).__v = t.__v + 1, $13c40c34b78c8ee2$var$j(o, t, i, l.__n, void 0 !== o.ownerSVGElement, null != t.__h ? [
            r
        ] : null, u, null == r ? $13c40c34b78c8ee2$var$k(t) : r, t.__h), $13c40c34b78c8ee2$var$z(u, t), t.__e != r && $13c40c34b78c8ee2$var$b(t)));
    });
}
function $13c40c34b78c8ee2$var$w(n, l, u, i, t, r, o, f, s, a) {
    var h, v, p, _, b, m, g, w = i && i.__k || $13c40c34b78c8ee2$var$c, A = w.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? $13c40c34b78c8ee2$var$y(null, _, null, null, _) : Array.isArray(_) ? $13c40c34b78c8ee2$var$y($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: _
    }, null, null, null) : _.__b > 0 ? $13c40c34b78c8ee2$var$y(_.type, _.props, _.key, null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;
        else for(v = 0; v < A; v++){
            if ((p = w[v]) && _.key == p.key && _.type === p.type) {
                w[v] = void 0;
                break;
            }
            p = null;
        }
        $13c40c34b78c8ee2$var$j(n, _, p = p || $13c40c34b78c8ee2$var$e, t, r, o, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && _.__k === p.__k ? _.__d = s = $13c40c34b78c8ee2$var$x(_, s, n) : s = $13c40c34b78c8ee2$var$P(n, _, p, w, b, s), "function" == typeof u.type && (u.__d = s)) : s && p.__e == s && s.parentNode != n && (s = $13c40c34b78c8ee2$var$k(p));
    }
    for(u.__e = m, h = A; h--;)null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = $13c40c34b78c8ee2$var$k(i, h + 1)), $13c40c34b78c8ee2$var$N(w[h], w[h]));
    if (g) for(h = 0; h < g.length; h++)$13c40c34b78c8ee2$var$M(g[h], g[++h], g[++h]);
}
function $13c40c34b78c8ee2$var$x(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $13c40c34b78c8ee2$var$x(i, l, u) : $13c40c34b78c8ee2$var$P(u, i, i, t, i.__e, l));
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$P(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $13c40c34b78c8ee2$var$C(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $13c40c34b78c8ee2$var$H(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $13c40c34b78c8ee2$var$H(n, r, l[r], u[r], i);
}
function $13c40c34b78c8ee2$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$s.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$H(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $13c40c34b78c8ee2$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $13c40c34b78c8ee2$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $13c40c34b78c8ee2$var$T : $13c40c34b78c8ee2$var$I, r) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$T : $13c40c34b78c8ee2$var$I, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $13c40c34b78c8ee2$var$I(n) {
    this.l[n.type + !1]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$T(n) {
    this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$j(n, u, i, t, r, o, f, e, c) {
    var s, h, v, y, p, k, b, m, g, x, A, P = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof P) {
            if (m = u.props, g = (s = P.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in P && P.prototype.render ? u.__c = h = new P(m, x) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(m, x), h.constructor = P, h.render = $13c40c34b78c8ee2$var$O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != P.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$a({}, h.__s)), $13c40c34b78c8ee2$var$a(h.__s, P.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == P.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == P.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
                    h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, p, k);
                });
            }
            h.context = x, h.props = m, h.state = h.__s, (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r) && s(u), h.__d = !1, h.__v = u, h.__P = n, s = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (t = $13c40c34b78c8ee2$var$a($13c40c34b78c8ee2$var$a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), A = null != s && s.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $13c40c34b78c8ee2$var$w(n, Array.isArray(A) ? A : [
                A
            ], u, i, t, r, o, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $13c40c34b78c8ee2$var$L(i.__e, u, i, t, r, o, f, c);
        (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $13c40c34b78c8ee2$var$z(n, u) {
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$L(l, u, i, t, r, o, f, c) {
    var s, a, v, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (o = o && $13c40c34b78c8ee2$var$n.call(l.childNodes), a = (y = i.props || $13c40c34b78c8ee2$var$e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($13c40c34b78c8ee2$var$C(l, p, y, r, c), v) u.__k = [];
        else if (_ = u.props.children, $13c40c34b78c8ee2$var$w(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $13c40c34b78c8ee2$var$k(i, 0), c), null != o) for(_ = o.length; _--;)null != o[_] && $13c40c34b78c8ee2$var$h(o[_]);
        c || ("value" in p && void 0 !== (_ = p.value) && (_ !== y.value || _ !== l.value || "progress" === d && !_) && $13c40c34b78c8ee2$var$H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $13c40c34b78c8ee2$var$H(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $13c40c34b78c8ee2$var$N(n, u, i) {
    var t, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $13c40c34b78c8ee2$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $13c40c34b78c8ee2$var$N(t[r], u, "function" != typeof n.type);
    i || null == n.__e || $13c40c34b78c8ee2$var$h(n.__e), n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $13c40c34b78c8ee2$var$j(i, u = (!r && t || i).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$e, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $13c40c34b78c8ee2$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $13c40c34b78c8ee2$var$z(f, u);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $13c40c34b78c8ee2$var$a({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), $13c40c34b78c8ee2$var$y(l.type, f, t || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$f++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($13c40c34b78c8ee2$var$m);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$c.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l) {
        for(var u, i, t; l = l.__;)if ((u = l.__c) && !u.__) try {
            if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$a({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$a({}, u), this.props)), n && $13c40c34b78c8ee2$var$a(u, n), null != n && this.__v && (l && this.__h.push(l), $13c40c34b78c8ee2$var$m(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$m(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$t = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$g.__r = 0, $13c40c34b78c8ee2$var$f = 0;



var $1dcfb6b13a3657f8$exports = {};
"use strict";
Object.defineProperty($1dcfb6b13a3657f8$exports, "__esModule", {
    value: true
});
var $1dcfb6b13a3657f8$var$_exportNames = {
    getStyledComponent: true,
    Form: true,
    ProgressBar: true,
    getOrgEventSourceBundle: true,
    getLogger: true,
    Pills: true,
    LoadingScreen: true,
    getRecentActionsBundle: true,
    getBetaBundle: true,
    getMixpanelTracker: true,
    getMixpanelBeaconTracker: true
};
Object.defineProperty($1dcfb6b13a3657f8$exports, "getStyledComponent", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_getStyledComponent.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "Form", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_form.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "ProgressBar", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_progress.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "getOrgEventSourceBundle", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_getOrgEventSourceBundle.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "getLogger", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_logger.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "Pills", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_pills.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "LoadingScreen", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_loadingScreen.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "getRecentActionsBundle", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_getRecentActionsBundle.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "getBetaBundle", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_getBetaBundle.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "getMixpanelTracker", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_getMixpanelTracker.default;
    }
});
Object.defineProperty($1dcfb6b13a3657f8$exports, "getMixpanelBeaconTracker", {
    enumerable: true,
    get: function() {
        return $1dcfb6b13a3657f8$var$_getMixpanelBeaconTracker.default;
    }
});

var $9YtMX = parcelRequire("9YtMX");
Object.keys($9YtMX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $9YtMX[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $9YtMX[key];
        }
    });
});

var $dSxTB = parcelRequire("dSxTB");
Object.keys($dSxTB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $dSxTB[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $dSxTB[key];
        }
    });
});
var $c366123f80b1b4d8$exports = {};
"use strict";
Object.defineProperty($c366123f80b1b4d8$exports, "__esModule", {
    value: true
});
$c366123f80b1b4d8$exports.MessagePageCrate = $c366123f80b1b4d8$exports.PageCrate = $c366123f80b1b4d8$exports.PageCrateHeading = $c366123f80b1b4d8$exports.Page = $c366123f80b1b4d8$exports.LogoCrate = void 0;

var $767w7 = parcelRequire("767w7");

var $c366123f80b1b4d8$var$_classnames = $c366123f80b1b4d8$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $c366123f80b1b4d8$var$_getStyledComponent = $c366123f80b1b4d8$var$_interopRequireDefault((parcelRequire("45yGA")));

var $krJc1 = parcelRequire("krJc1");

var $04wYO = parcelRequire("04wYO");

var $7Dcmj = parcelRequire("7Dcmj");

var $dSxTB = parcelRequire("dSxTB");
function $c366123f80b1b4d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c366123f80b1b4d8$var$_extends() {
    $c366123f80b1b4d8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c366123f80b1b4d8$var$_extends.apply(this, arguments);
}
const $c366123f80b1b4d8$var$LogoCrate = ({ wide: wide = false })=>(0, $767w7.h)("div", {
        className: (0, $c366123f80b1b4d8$var$_classnames.default)({
            mw6: !wide,
            mw7: wide
        }, "mv3 ph3 center br2")
    }, (0, $767w7.h)("a", {
        href: "/"
    }, (0, $767w7.h)($dSxTB.XChart, {
        className: "h2"
    })));
/** @type {import('preact').FunctionComponent} */ $c366123f80b1b4d8$exports.LogoCrate = $c366123f80b1b4d8$var$LogoCrate;
const $c366123f80b1b4d8$var$Page = (0, $krJc1.transitionIn)((0, $c366123f80b1b4d8$var$_getStyledComponent.default)({
    baseClasses: "transition",
    options: {
        transitions: [
            "firstRender"
        ]
    },
    fn: ({ firstRender: firstRender })=>firstRender ? "o-0 translate-y" : "o-100"
}));
$c366123f80b1b4d8$exports.Page = $c366123f80b1b4d8$var$Page;
const $c366123f80b1b4d8$var$PageCrateHeading = (0, $c366123f80b1b4d8$var$_getStyledComponent.default)({
    baseClasses: "mt1 mb3",
    tagName: "h3"
});
$c366123f80b1b4d8$exports.PageCrateHeading = $c366123f80b1b4d8$var$PageCrateHeading;
const $c366123f80b1b4d8$var$PageCrate = (0, $c366123f80b1b4d8$var$_getStyledComponent.default)({
    baseClasses: "no-print-padding pa3 center br2",
    options: {
        title: "",
        backgroundColor: "white",
        width: [
            "wide",
            "noMaxWidth"
        ],
        shadowExists: [
            "noShadow"
        ],
        margins: [
            "noMargin"
        ]
    },
    fn: ({ wide: wide, noMaxWidth: noMaxWidth, backgroundColor: backgroundColor, noShadow: noShadow, noMargin: noMargin })=>(0, $c366123f80b1b4d8$var$_classnames.default)("bg-".concat(backgroundColor), {
            "shadow-1": !noShadow,
            mv3: !noMargin,
            mw7: wide,
            mw6: !wide && !noMaxWidth
        }),
    renderChildren: ({ title: title, children: children })=>{
        const res = [
            children
        ];
        if (title) res.unshift((0, $767w7.h)($c366123f80b1b4d8$var$PageCrateHeading, null, title));
        return res;
    }
});
/**
 * @typedef MessagePageCrateProps
 * @property {boolean} [loading]
 * @property {boolean} [error]
 * @property {boolean} [success]
 * @property {boolean} [warning]
 * @property {boolean} [info]
 * @property {boolean} [noShadow]
 * @property {any} children
 */ /**
 * @type {import('preact').FunctionComponent}
 * @param {MessagePageCrateProps} props
 */ $c366123f80b1b4d8$exports.PageCrate = $c366123f80b1b4d8$var$PageCrate;
const $c366123f80b1b4d8$var$MessagePageCrate = (props)=>{
    const { loading: loading, error: error, warning: warning, success: success, info: info, children: children, noShadow: noShadow, noMargin: noMargin } = props;
    const rest = (0, $04wYO.omit)(props, [
        "loading",
        "error",
        "warning",
        "success",
        "children"
    ]);
    let icon = null;
    let iconClasses = null;
    let backgroundColor = "white";
    let colorClasses = null;
    if (loading) {
        icon = "autorenew";
        iconClasses = "load";
    }
    if (error) {
        icon = "error";
        backgroundColor = "red";
        colorClasses = "black";
    }
    if (warning) {
        icon = "warning";
        backgroundColor = "orange";
        colorClasses = "black";
    }
    if (success) {
        icon = "check";
        backgroundColor = "light-blue";
        colorClasses = "black";
    }
    if (info) {
        icon = "info";
        backgroundColor = "lightest-blue";
        colorClasses = "black";
    }
    let iconComp;
    if (loading) iconComp = (0, $767w7.h)($dSxTB.LoadingMark, {
        className: (0, $c366123f80b1b4d8$var$_classnames.default)("f3 mr3 top-animation", iconClasses),
        style: {
            width: "50px"
        }
    });
    else if (loading || error || warning || success || info) iconComp = (0, $767w7.h)($7Dcmj.Icon, {
        className: (0, $c366123f80b1b4d8$var$_classnames.default)("f3 mr3", iconClasses),
        size: "40",
        icon: icon
    });
    return (0, $767w7.h)($c366123f80b1b4d8$var$PageCrate, $c366123f80b1b4d8$var$_extends({
        backgroundColor: backgroundColor,
        noShadow: !!noShadow,
        noMargin: !!noMargin
    }, rest), (0, $767w7.h)("div", {
        className: (0, $c366123f80b1b4d8$var$_classnames.default)("flex items-center min-h3 f4", colorClasses)
    }, iconComp, children));
};
$c366123f80b1b4d8$exports.MessagePageCrate = $c366123f80b1b4d8$var$MessagePageCrate;


Object.keys($c366123f80b1b4d8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $c366123f80b1b4d8$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $c366123f80b1b4d8$exports[key];
        }
    });
});
var $3c010a2b9974f9d2$exports = {};
"use strict";
Object.defineProperty($3c010a2b9974f9d2$exports, "__esModule", {
    value: true
});
$3c010a2b9974f9d2$exports.FullScreenOverlay = $3c010a2b9974f9d2$exports.FullScreenOverlayWrapper = void 0;

var $767w7 = parcelRequire("767w7");

var $3c010a2b9974f9d2$var$_getStyledComponent = $3c010a2b9974f9d2$var$_interopRequireDefault((parcelRequire("45yGA")));

var $04wYO = parcelRequire("04wYO");
function $3c010a2b9974f9d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3c010a2b9974f9d2$var$FullScreenOverlayWrapper = (0, $3c010a2b9974f9d2$var$_getStyledComponent.default)({
    baseClasses: "fixed top-0 left-0 z-999 w-100 h-100 bg-gray flex items-center dark-blue"
});
$3c010a2b9974f9d2$exports.FullScreenOverlayWrapper = $3c010a2b9974f9d2$var$FullScreenOverlayWrapper;
const $3c010a2b9974f9d2$var$FullScreenOverlay = (props)=>(0, $767w7.h)($3c010a2b9974f9d2$var$FullScreenOverlayWrapper, (0, $04wYO.omit)(props, [
        "children"
    ]), (0, $767w7.h)("div", {
        className: "center ph2 ph4-m"
    }, props.children));
$3c010a2b9974f9d2$exports.FullScreenOverlay = $3c010a2b9974f9d2$var$FullScreenOverlay;


Object.keys($3c010a2b9974f9d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $3c010a2b9974f9d2$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $3c010a2b9974f9d2$exports[key];
        }
    });
});

var $bug1B = parcelRequire("bug1B");
Object.keys($bug1B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $bug1B[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $bug1B[key];
        }
    });
});

var $7Dcmj = parcelRequire("7Dcmj");
Object.keys($7Dcmj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $7Dcmj[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $7Dcmj[key];
        }
    });
});
var $4f37274b875b6e4d$exports = {};
"use strict";
Object.defineProperty($4f37274b875b6e4d$exports, "__esModule", {
    value: true
});
$4f37274b875b6e4d$exports.DrugBox = void 0;

var $4f37274b875b6e4d$var$_getStyledComponent = $4f37274b875b6e4d$var$_interopRequireDefault((parcelRequire("45yGA")));
function $4f37274b875b6e4d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4f37274b875b6e4d$var$DrugBox = (0, $4f37274b875b6e4d$var$_getStyledComponent.default)({
    baseClasses: "pv2 ph2 br2 ba b--light-gray bg-near-white",
    options: {
        highlight: [
            "highlighted"
        ]
    },
    fn: ({ highlighted: highlighted })=>highlighted ? "bg-lightest-blue" : "bg-near-white"
});
$4f37274b875b6e4d$exports.DrugBox = $4f37274b875b6e4d$var$DrugBox;


Object.keys($4f37274b875b6e4d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $4f37274b875b6e4d$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $4f37274b875b6e4d$exports[key];
        }
    });
});
var $8efee2f7154a9507$exports = {};
"use strict";
Object.defineProperty($8efee2f7154a9507$exports, "__esModule", {
    value: true
});
$8efee2f7154a9507$exports.SupportLink = $8efee2f7154a9507$exports.Link = void 0;

var $767w7 = parcelRequire("767w7");

var $8efee2f7154a9507$var$_classnames = $8efee2f7154a9507$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $8efee2f7154a9507$var$_getStyledComponent = $8efee2f7154a9507$var$_interopRequireDefault((parcelRequire("45yGA")));
function $8efee2f7154a9507$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8efee2f7154a9507$var$_extends() {
    $8efee2f7154a9507$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8efee2f7154a9507$var$_extends.apply(this, arguments);
}
const $8efee2f7154a9507$var$supportEmail = "support@xchart.com";
const $8efee2f7154a9507$var$Link = (0, $8efee2f7154a9507$var$_getStyledComponent.default)({
    baseClasses: "link",
    tagName: "a",
    options: {
        white: false,
        underline: true
    },
    fn: ({ underline: underline, white: white })=>(0, $8efee2f7154a9507$var$_classnames.default)(underline ? "underline" : "no-underline", white ? "white hover-lightest-blue" : "dark-blue hover-blue")
});
$8efee2f7154a9507$exports.Link = $8efee2f7154a9507$var$Link;
const $8efee2f7154a9507$var$SupportLink = (props)=>(0, $767w7.h)($8efee2f7154a9507$var$Link, $8efee2f7154a9507$var$_extends({
        href: "mailto:".concat($8efee2f7154a9507$var$supportEmail)
    }, props), $8efee2f7154a9507$var$supportEmail);
$8efee2f7154a9507$exports.SupportLink = $8efee2f7154a9507$var$SupportLink;


Object.keys($8efee2f7154a9507$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $8efee2f7154a9507$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $8efee2f7154a9507$exports[key];
        }
    });
});
var $32f1f9c188e4aae9$exports = {};
"use strict";
Object.defineProperty($32f1f9c188e4aae9$exports, "__esModule", {
    value: true
});
$32f1f9c188e4aae9$exports.CheckMark = void 0;

var $767w7 = parcelRequire("767w7");

var $7Dcmj = parcelRequire("7Dcmj");

var $32f1f9c188e4aae9$var$_classnames = $32f1f9c188e4aae9$var$_interopRequireDefault((parcelRequire("8g1PZ")));
function $32f1f9c188e4aae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $32f1f9c188e4aae9$var$_extends() {
    $32f1f9c188e4aae9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $32f1f9c188e4aae9$var$_extends.apply(this, arguments);
}
function $32f1f9c188e4aae9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $32f1f9c188e4aae9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $32f1f9c188e4aae9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $32f1f9c188e4aae9$var$CheckMark = (_ref)=>{
    let { className: className, name: name, label: label, isComplete: isComplete, isAuto: isAuto, onClick: onClick } = _ref, rest = $32f1f9c188e4aae9$var$_objectWithoutProperties(_ref, [
        "className",
        "name",
        "label",
        "isComplete",
        "isAuto",
        "onClick"
    ]);
    return (0, $767w7.h)("label", $32f1f9c188e4aae9$var$_extends({
        htmlFor: name,
        className: (0, $32f1f9c188e4aae9$var$_classnames.default)("flex items-center mb2", className),
        "data-e2e": "checkMark",
        "data-state": isComplete ? "checked" : "unchecked"
    }, rest), (0, $767w7.h)("input", {
        onClick: ()=>onClick(name),
        className: "checkbox o-0",
        id: name,
        checked: isComplete,
        type: "checkbox"
    }), !isAuto && isComplete && (0, $767w7.h)($7Dcmj.Icon, {
        className: "light-blue",
        size: "40",
        icon: "check_box"
    }), !isAuto && !isComplete && (0, $767w7.h)($7Dcmj.Icon, {
        size: "40",
        icon: "check_box_outline_blank"
    }), isAuto && (0, $767w7.h)("div", {
        className: "relative bg-light-blue br2",
        style: {
            margin: "5px",
            width: "30px",
            height: "30px"
        }
    }, (0, $767w7.h)($7Dcmj.Icon, {
        size: "18",
        className: "absolute white",
        icon: "auto_awesome",
        style: {
            left: "6px",
            top: "2px"
        }
    }), (0, $767w7.h)("span", {
        className: "helvetica absolute tc bottom-0 smallcaps white ttu fw6",
        style: {
            fontSize: "8px",
            width: "30px"
        }
    }, "auto")), (0, $767w7.h)("span", {
        className: "ml2"
    }, label || name));
};
$32f1f9c188e4aae9$exports.CheckMark = $32f1f9c188e4aae9$var$CheckMark;


Object.keys($32f1f9c188e4aae9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $32f1f9c188e4aae9$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $32f1f9c188e4aae9$exports[key];
        }
    });
});

var $krJc1 = parcelRequire("krJc1");
Object.keys($krJc1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $krJc1[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $krJc1[key];
        }
    });
});
var $c7be9607bdbcd598$exports = {};
"use strict";
Object.defineProperty($c7be9607bdbcd598$exports, "__esModule", {
    value: true
});
$c7be9607bdbcd598$exports.Drawer = $c7be9607bdbcd598$exports.DrawerLinkContainer = $c7be9607bdbcd598$exports.DrawerLink = $c7be9607bdbcd598$exports.FlipIcon = $c7be9607bdbcd598$exports.FlipContainer = void 0;

var $c7be9607bdbcd598$var$_getStyledComponent = $c7be9607bdbcd598$var$_interopRequireDefault((parcelRequire("45yGA")));

var $767w7 = parcelRequire("767w7");

var $7Dcmj = parcelRequire("7Dcmj");

var $c7be9607bdbcd598$var$_classnames = $c7be9607bdbcd598$var$_interopRequireDefault((parcelRequire("8g1PZ")));
function $c7be9607bdbcd598$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c7be9607bdbcd598$var$_extends() {
    $c7be9607bdbcd598$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7be9607bdbcd598$var$_extends.apply(this, arguments);
}
function $c7be9607bdbcd598$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c7be9607bdbcd598$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c7be9607bdbcd598$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c7be9607bdbcd598$var$cardStyles = {
    backfaceVisibility: "hidden",
    webkitBackfaceVisibility: "hidden",
    top: "0",
    left: "0"
};
const $c7be9607bdbcd598$var$FlipContainer = (_ref)=>{
    let { front: front, back: back, flipped: flipped, height: height, width: width, className: className, style: style, direction: direction = "vertical", perspective: perspective = "100px" } = _ref, rest = $c7be9607bdbcd598$var$_objectWithoutProperties(_ref, [
        "front",
        "back",
        "flipped",
        "height",
        "width",
        "className",
        "style",
        "direction",
        "perspective"
    ]);
    const axis = direction === "vertical" ? "X" : "Y";
    const rotateZero = "rotate".concat(axis, "(0deg)");
    const rotateFlipped = "rotate".concat(axis, "(180deg)");
    return (0, $767w7.h)("div", $c7be9607bdbcd598$var$_extends({}, rest, {
        className: className,
        style: Object.assign({
            position: "relative",
            perspective: perspective,
            width: width,
            height: height
        }, style)
    }), (0, $767w7.h)("div", {
        style: {
            transition: "0.6s",
            transformStyle: "preserve-3d",
            webkitTransformStyle: "preserve-3d",
            position: "relative",
            transformOrigin: "center",
            webkitTransformOrigin: "center",
            width: "100%",
            height: "100%",
            transform: !flipped ? rotateFlipped : "",
            webkitTransform: !flipped ? rotateFlipped : ""
        }
    }, (0, $767w7.h)("div", {
        style: Object.assign({}, $c7be9607bdbcd598$var$cardStyles, {
            transform: rotateFlipped,
            webkitTransform: rotateFlipped,
            width: "100%",
            height: "100%",
            position: "relative"
        })
    }, front), (0, $767w7.h)("div", {
        style: Object.assign({}, $c7be9607bdbcd598$var$cardStyles, {
            zIndex: 2,
            transform: rotateZero,
            webkitTransform: rotateZero,
            width: "100%",
            height: "100%",
            position: "absolute"
        })
    }, back)));
};
$c7be9607bdbcd598$exports.FlipContainer = $c7be9607bdbcd598$var$FlipContainer;
const $c7be9607bdbcd598$var$FlipIcon = (0, $c7be9607bdbcd598$var$_getStyledComponent.default)({
    options: {
        complete: [
            "complete"
        ],
        icon: [
            "icon"
        ]
    },
    renderChildren: ({ icon: icon, complete: complete })=>{
        return [
            (0, $767w7.h)($c7be9607bdbcd598$var$FlipContainer, {
                key: "flipContainer",
                width: "20px",
                height: "20px",
                flipped: complete,
                front: (0, $767w7.h)($7Dcmj.Icon, {
                    size: "20",
                    icon: icon
                }),
                back: (0, $767w7.h)($7Dcmj.Icon, {
                    className: "light-blue",
                    size: "20",
                    icon: "check_circle"
                })
            })
        ];
    }
});
$c7be9607bdbcd598$exports.FlipIcon = $c7be9607bdbcd598$var$FlipIcon;
const $c7be9607bdbcd598$var$DrawerLink = (0, $c7be9607bdbcd598$var$_getStyledComponent.default)({
    tagName: "a",
    baseClasses: "link pv1 mt1 f5 fw3 flex items-center",
    options: {
        active: [
            "active"
        ],
        disabled: [
            "disabled"
        ],
        completeness: [
            "complete"
        ]
    },
    fn: ({ active: active, disabled: disabled })=>(0, $c7be9607bdbcd598$var$_classnames.default)({
            "light-blue": active,
            "mid-gray not-allowed": disabled,
            "white hover-moon-gray": !active && !disabled
        }),
    renderChildren: ({ icon: icon, title: title, complete: complete })=>[
            (0, $767w7.h)($c7be9607bdbcd598$var$FlipIcon, {
                key: "flipIcon",
                icon: icon,
                complete: complete
            }),
            (0, $767w7.h)("span", {
                key: "span",
                "data-state": complete ? "complete" : "incomplete",
                "data-e2e": "".concat(title, "Nav"),
                className: icon ? "pl2" : null
            }, title)
        ]
});
$c7be9607bdbcd598$exports.DrawerLink = $c7be9607bdbcd598$var$DrawerLink;
const $c7be9607bdbcd598$var$DrawerLinkContainer = (0, $c7be9607bdbcd598$var$_getStyledComponent.default)({
    baseClasses: "link db pt2 pl3 f4",
    options: {
        completeness: [
            "complete"
        ],
        title: [
            "title"
        ]
    },
    renderChildren: ({ complete: complete, title: title, children: children })=>[
            (0, $767w7.h)("div", {
                key: title,
                className: "flex items-center"
            }, (0, $767w7.h)($7Dcmj.Icon, {
                className: (0, $c7be9607bdbcd598$var$_classnames.default)("light-blue pr2", {
                    hidden: !complete
                }),
                size: "20",
                icon: "check_circle"
            }), (0, $767w7.h)("h3", {
                className: "fw3 f6 ma0 ttu mid-gray bb b--mid-gray pb2 pt1 relative flex-grow-1"
            }, title)),
            (0, $767w7.h)("div", {
                key: title + "children"
            }, children)
        ]
});
$c7be9607bdbcd598$exports.DrawerLinkContainer = $c7be9607bdbcd598$var$DrawerLinkContainer;
const $c7be9607bdbcd598$var$Drawer = (0, $c7be9607bdbcd598$var$_getStyledComponent.default)({
    baseClasses: "bg-dark-blue white fixed top-0 vh-100 overflow-x-hidden"
});
$c7be9607bdbcd598$exports.Drawer = $c7be9607bdbcd598$var$Drawer;


Object.keys($c7be9607bdbcd598$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $c7be9607bdbcd598$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $c7be9607bdbcd598$exports[key];
        }
    });
});
var $f112c84953e7c35b$exports = {};
"use strict";
Object.defineProperty($f112c84953e7c35b$exports, "__esModule", {
    value: true
});
$f112c84953e7c35b$exports.Dialog = void 0;

var $767w7 = parcelRequire("767w7");

var $f112c84953e7c35b$var$_classnames = $f112c84953e7c35b$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7Dcmj = parcelRequire("7Dcmj");

var $04wYO = parcelRequire("04wYO");
var $ef7d658c4ec714e8$exports = {};
"use strict";
Object.defineProperty($ef7d658c4ec714e8$exports, "__esModule", {
    value: true
});
$ef7d658c4ec714e8$exports.Portal = void 0;

var $767w7 = parcelRequire("767w7");
var $6e8a58651e634e47$var$t, $6e8a58651e634e47$var$u, $6e8a58651e634e47$var$r, $6e8a58651e634e47$var$o = 0, $6e8a58651e634e47$var$i = [], $6e8a58651e634e47$var$c = (0, $767w7.options).__b, $6e8a58651e634e47$var$f = (0, $767w7.options).__r, $6e8a58651e634e47$var$e = (0, $767w7.options).diffed, $6e8a58651e634e47$var$a = (0, $767w7.options).__c, $6e8a58651e634e47$var$v = (0, $767w7.options).unmount;
function $6e8a58651e634e47$var$m(t, r) {
    (0, $767w7.options).__h && (0, $767w7.options).__h($6e8a58651e634e47$var$u, t, $6e8a58651e634e47$var$o || r), $6e8a58651e634e47$var$o = 0;
    var i = $6e8a58651e634e47$var$u.__H || ($6e8a58651e634e47$var$u.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({}), i.__[t];
}
function $6e8a58651e634e47$export$60241385465d0a34(n) {
    return $6e8a58651e634e47$var$o = 1, $6e8a58651e634e47$export$13e3392192263954($6e8a58651e634e47$var$w, n);
}
function $6e8a58651e634e47$export$13e3392192263954(n, r, o) {
    var i = $6e8a58651e634e47$var$m($6e8a58651e634e47$var$t++, 2);
    return i.t = n, i.__c || (i.__ = [
        o ? o(r) : $6e8a58651e634e47$var$w(void 0, r),
        function(n) {
            var t = i.t(i.__[0], n);
            i.__[0] !== t && (i.__ = [
                t,
                i.__[1]
            ], i.__c.setState({}));
        }
    ], i.__c = $6e8a58651e634e47$var$u), i.__;
}
function $6e8a58651e634e47$export$6d9c69b0de29b591(r, o) {
    var i = $6e8a58651e634e47$var$m($6e8a58651e634e47$var$t++, 3);
    !(0, $767w7.options).__s && $6e8a58651e634e47$var$k(i.__H, o) && (i.__ = r, i.__H = o, $6e8a58651e634e47$var$u.__H.__h.push(i));
}
function $6e8a58651e634e47$export$e5c5a5f917a5871c(r, o) {
    var i = $6e8a58651e634e47$var$m($6e8a58651e634e47$var$t++, 4);
    !(0, $767w7.options).__s && $6e8a58651e634e47$var$k(i.__H, o) && (i.__ = r, i.__H = o, $6e8a58651e634e47$var$u.__h.push(i));
}
function $6e8a58651e634e47$export$b8f5890fc79d6aca(n) {
    return $6e8a58651e634e47$var$o = 5, $6e8a58651e634e47$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $6e8a58651e634e47$export$d5a552a76deda3c2(n, t, u) {
    $6e8a58651e634e47$var$o = 6, $6e8a58651e634e47$export$e5c5a5f917a5871c(function() {
        "function" == typeof n ? n(t()) : n && (n.current = t());
    }, null == u ? u : u.concat(n));
}
function $6e8a58651e634e47$export$1538c33de8887b59(n, u) {
    var r = $6e8a58651e634e47$var$m($6e8a58651e634e47$var$t++, 7);
    return $6e8a58651e634e47$var$k(r.__H, u) && (r.__ = n(), r.__H = u, r.__h = n), r.__;
}
function $6e8a58651e634e47$export$35808ee640e87ca7(n, t) {
    return $6e8a58651e634e47$var$o = 8, $6e8a58651e634e47$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $6e8a58651e634e47$export$fae74005e78b1a27(n) {
    var r = $6e8a58651e634e47$var$u.context[n.__c], o = $6e8a58651e634e47$var$m($6e8a58651e634e47$var$t++, 9);
    return o.__c = n, r ? (null == o.__ && (o.__ = !0, r.sub($6e8a58651e634e47$var$u)), r.props.value) : n.__;
}
function $6e8a58651e634e47$export$dc8fbce3eb94dc1e(t, u) {
    (0, $767w7.options).useDebugValue && (0, $767w7.options).useDebugValue(u ? u(t) : t);
}
function $6e8a58651e634e47$export$c052f6604b7d51fe(n) {
    var r = $6e8a58651e634e47$var$m($6e8a58651e634e47$var$t++, 10), o = $6e8a58651e634e47$export$60241385465d0a34();
    return r.__ = n, $6e8a58651e634e47$var$u.componentDidCatch || ($6e8a58651e634e47$var$u.componentDidCatch = function(n) {
        r.__ && r.__(n), o[1](n);
    }), [
        o[0],
        function() {
            o[1](void 0);
        }
    ];
}
function $6e8a58651e634e47$var$x() {
    $6e8a58651e634e47$var$i.forEach(function(t) {
        if (t.__P) try {
            t.__H.__h.forEach($6e8a58651e634e47$var$g), t.__H.__h.forEach($6e8a58651e634e47$var$j), t.__H.__h = [];
        } catch (u) {
            t.__H.__h = [], (0, $767w7.options).__e(u, t.__v);
        }
    }), $6e8a58651e634e47$var$i = [];
}
(0, $767w7.options).__b = function(n) {
    $6e8a58651e634e47$var$u = null, $6e8a58651e634e47$var$c && $6e8a58651e634e47$var$c(n);
}, (0, $767w7.options).__r = function(n) {
    $6e8a58651e634e47$var$f && $6e8a58651e634e47$var$f(n), $6e8a58651e634e47$var$t = 0;
    var r = ($6e8a58651e634e47$var$u = n.__c).__H;
    r && (r.__h.forEach($6e8a58651e634e47$var$g), r.__h.forEach($6e8a58651e634e47$var$j), r.__h = []);
}, (0, $767w7.options).diffed = function(t) {
    $6e8a58651e634e47$var$e && $6e8a58651e634e47$var$e(t);
    var o = t.__c;
    o && o.__H && o.__H.__h.length && (1 !== $6e8a58651e634e47$var$i.push(o) && $6e8a58651e634e47$var$r === (0, $767w7.options).requestAnimationFrame || (($6e8a58651e634e47$var$r = (0, $767w7.options).requestAnimationFrame) || function(n) {
        var t, u = function() {
            clearTimeout(r), $6e8a58651e634e47$var$b && cancelAnimationFrame(t), setTimeout(n);
        }, r = setTimeout(u, 100);
        $6e8a58651e634e47$var$b && (t = requestAnimationFrame(u));
    })($6e8a58651e634e47$var$x)), $6e8a58651e634e47$var$u = void 0;
}, (0, $767w7.options).__c = function(t, u) {
    u.some(function(t) {
        try {
            t.__h.forEach($6e8a58651e634e47$var$g), t.__h = t.__h.filter(function(n) {
                return !n.__ || $6e8a58651e634e47$var$j(n);
            });
        } catch (r) {
            u.some(function(n) {
                n.__h && (n.__h = []);
            }), u = [], (0, $767w7.options).__e(r, t.__v);
        }
    }), $6e8a58651e634e47$var$a && $6e8a58651e634e47$var$a(t, u);
}, (0, $767w7.options).unmount = function(t) {
    $6e8a58651e634e47$var$v && $6e8a58651e634e47$var$v(t);
    var u = t.__c;
    if (u && u.__H) try {
        u.__H.__.forEach($6e8a58651e634e47$var$g);
    } catch (t) {
        (0, $767w7.options).__e(t, u.__v);
    }
};
var $6e8a58651e634e47$var$b = "function" == typeof requestAnimationFrame;
function $6e8a58651e634e47$var$g(n) {
    var t = $6e8a58651e634e47$var$u;
    "function" == typeof n.__c && n.__c(), $6e8a58651e634e47$var$u = t;
}
function $6e8a58651e634e47$var$j(n) {
    var t = $6e8a58651e634e47$var$u;
    n.__c = n.__(), $6e8a58651e634e47$var$u = t;
}
function $6e8a58651e634e47$var$k(n, t) {
    return !n || n.length !== t.length || t.some(function(t, u) {
        return t !== n[u];
    });
}
function $6e8a58651e634e47$var$w(n, t) {
    return "function" == typeof t ? t(n) : t;
}



var $767w7 = parcelRequire("767w7");
function $80bff275086f04c8$var$C(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $80bff275086f04c8$var$S(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $80bff275086f04c8$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $80bff275086f04c8$export$7c73462e0d25e514(n, t) {
    function e(n) {
        var e = this.props.ref, r = e == n.ref;
        return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : $80bff275086f04c8$var$S(this.props, n);
    }
    function r(t) {
        return this.shouldComponentUpdate = e, (0, $767w7.createElement)(n, t);
    }
    return r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}
($80bff275086f04c8$export$221d75b3f55bb0bd.prototype = new (0, $767w7.Component)).isPureReactComponent = !0, $80bff275086f04c8$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $80bff275086f04c8$var$S(this.props, n) || $80bff275086f04c8$var$S(this.state, t);
};
var $80bff275086f04c8$var$w = (0, $767w7.options).__b;
(0, $767w7.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $80bff275086f04c8$var$w && $80bff275086f04c8$var$w(n);
};
var $80bff275086f04c8$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $80bff275086f04c8$export$257a8862b851cb5b(n) {
    function t(t, e) {
        var r = $80bff275086f04c8$var$C({}, t);
        return delete r.ref, n(r, (e = t.ref || e) && ("object" != typeof e || "current" in e) ? e : null);
    }
    return t.$$typeof = $80bff275086f04c8$var$R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $80bff275086f04c8$var$N = function(n, t) {
    return null == n ? null : (0, $767w7.toChildArray)((0, $767w7.toChildArray)(n).map(t));
}, $80bff275086f04c8$export$dca3b0875bd9a954 = {
    map: $80bff275086f04c8$var$N,
    forEach: $80bff275086f04c8$var$N,
    count: function(n) {
        return n ? (0, $767w7.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $767w7.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $767w7.toChildArray)
}, $80bff275086f04c8$var$A = (0, $767w7.options).__e;
(0, $767w7.options).__e = function(n, t, e) {
    if (n.then) {
        for(var r, u = t; u = u.__;)if ((r = u.__c) && r.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), r.__c(n, t);
    }
    $80bff275086f04c8$var$A(n, t, e);
};
var $80bff275086f04c8$var$O = (0, $767w7.options).unmount;
function $80bff275086f04c8$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $80bff275086f04c8$var$U(n) {
    var t = n.__.__c;
    return t && t.__e && t.__e(n);
}
function $80bff275086f04c8$export$488013bae63b21da(n) {
    var t, e, r;
    function u(u) {
        if (t || (t = n()).then(function(n) {
            e = n.default || n;
        }, function(n) {
            r = n;
        }), r) throw r;
        if (!e) throw t;
        return (0, $767w7.createElement)(e, u);
    }
    return u.displayName = "Lazy", u.__f = !0, u;
}
function $80bff275086f04c8$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $767w7.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $80bff275086f04c8$var$O && $80bff275086f04c8$var$O(n);
}, ($80bff275086f04c8$export$74bf444e3cd11ea5.prototype = new (0, $767w7.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $80bff275086f04c8$var$U(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__e) {
                var n = r.state.__e;
                r.__v.__k[0] = function n(t, e, r) {
                    return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(t) {
                        return n(t, e, r);
                    }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
                }(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __e: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, f = !0 === t.__h;
    r.__u++ || f || r.setState({
        __e: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $80bff275086f04c8$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $80bff275086f04c8$export$74bf444e3cd11ea5.prototype.render = function(n, t) {
    if (this.__b) {
        if (this.__v.__k) {
            var e = document.createElement("div"), r = this.__v.__k[0].__c;
            this.__v.__k[0] = function n(t, e, r) {
                return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(n) {
                    "function" == typeof n.__c && n.__c();
                }), t.__c.__H = null), null != (t = $80bff275086f04c8$var$C({}, t)).__c && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(t) {
                    return n(t, e, r);
                })), t;
            }(this.__b, e, r.__O = r.__P);
        }
        this.__b = null;
    }
    var u = t.__e && (0, $767w7.createElement)((0, $767w7.Fragment), null, n.fallback);
    return u && (u.__h = null), [
        (0, $767w7.createElement)((0, $767w7.Fragment), null, t.__e ? null : n.children),
        u
    ];
};
var $80bff275086f04c8$var$M = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $80bff275086f04c8$var$T(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $80bff275086f04c8$var$j(n) {
    var t = this, e = n.i;
    t.componentWillUnmount = function() {
        (0, $767w7.render)(null, t.l), t.l = null, t.i = null;
    }, t.i && t.i !== e && t.componentWillUnmount(), n.__v ? (t.l || (t.i = e, t.l = {
        nodeType: 1,
        parentNode: e,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        insertBefore: function(n, e) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), t.i.removeChild(n);
        }
    }), (0, $767w7.render)((0, $767w7.createElement)($80bff275086f04c8$var$T, {
        context: t.context
    }, n.__v), t.l)) : t.l && t.componentWillUnmount();
}
function $80bff275086f04c8$export$d39a5bbd09211389(n, t) {
    return (0, $767w7.createElement)($80bff275086f04c8$var$j, {
        __v: n,
        i: t
    });
}
($80bff275086f04c8$export$998bcd577473dd93.prototype = new (0, $767w7.Component)).__e = function(n) {
    var t = this, e = $80bff275086f04c8$var$U(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $80bff275086f04c8$var$M(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $80bff275086f04c8$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $767w7.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $80bff275086f04c8$export$998bcd577473dd93.prototype.componentDidUpdate = $80bff275086f04c8$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $80bff275086f04c8$var$M(n, e, t);
    });
};
var $80bff275086f04c8$var$W = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $80bff275086f04c8$var$P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $80bff275086f04c8$var$V = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $80bff275086f04c8$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $767w7.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $80bff275086f04c8$export$fa8d919ba61d84db(n, t, e) {
    return (0, $767w7.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $767w7.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n) {
    Object.defineProperty((0, $767w7.Component).prototype, n, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n];
        },
        set: function(t) {
            Object.defineProperty(this, n, {
                configurable: !0,
                writable: !0,
                value: t
            });
        }
    });
});
var $80bff275086f04c8$var$H = (0, $767w7.options).event;
function $80bff275086f04c8$var$Z() {}
function $80bff275086f04c8$var$Y() {
    return this.cancelBubble;
}
function $80bff275086f04c8$var$$() {
    return this.defaultPrevented;
}
(0, $767w7.options).event = function(n) {
    return $80bff275086f04c8$var$H && (n = $80bff275086f04c8$var$H(n)), n.persist = $80bff275086f04c8$var$Z, n.isPropagationStopped = $80bff275086f04c8$var$Y, n.isDefaultPrevented = $80bff275086f04c8$var$$, n.nativeEvent = n;
};
var $80bff275086f04c8$var$q, $80bff275086f04c8$var$G = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $80bff275086f04c8$var$J = (0, $767w7.options).vnode;
(0, $767w7.options).vnode = function(n) {
    var t = n.type, e = n.props, r = e;
    if ("string" == typeof t) {
        for(var u in r = {}, e){
            var o = e[u];
            "value" === u && "defaultValue" in e && null == o || ("defaultValue" === u && "value" in e && null == e.value ? u = "value" : "download" === u && !0 === o ? o = "" : /ondoubleclick/i.test(u) ? u = "ondblclick" : /^onchange(textarea|input)/i.test(u + t) && !$80bff275086f04c8$var$V(e.type) ? u = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(u) ? u = u.toLowerCase() : $80bff275086f04c8$var$P.test(u) ? u = u.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === o && (o = void 0), r[u] = o);
        }
        "select" == t && r.multiple && Array.isArray(r.value) && (r.value = (0, $767w7.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != r.value.indexOf(n.props.value);
        })), "select" == t && null != r.defaultValue && (r.value = (0, $767w7.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(n.props.value) : r.defaultValue == n.props.value;
        })), n.props = r;
    }
    t && e.class != e.className && ($80bff275086f04c8$var$G.enumerable = "className" in e, null != e.className && (r.class = e.className), Object.defineProperty(r, "className", $80bff275086f04c8$var$G)), n.$$typeof = $80bff275086f04c8$var$W, $80bff275086f04c8$var$J && $80bff275086f04c8$var$J(n);
};
var $80bff275086f04c8$var$K = (0, $767w7.options).__r;
(0, $767w7.options).__r = function(n) {
    $80bff275086f04c8$var$K && $80bff275086f04c8$var$K(n), $80bff275086f04c8$var$q = n.__c;
};
var $80bff275086f04c8$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $80bff275086f04c8$var$q.__n[n.__c].props.value;
            }
        }
    }
}, $80bff275086f04c8$export$e26fe2ed2fa76875 = 1, $80bff275086f04c8$export$33ee1acdc04fd2a2 = 2, $80bff275086f04c8$export$6e3807111c4874c4 = 3, $80bff275086f04c8$export$502329bbf4b505b1 = 4, $80bff275086f04c8$export$3e506c1ccc9cc1a7 = 5;
function $80bff275086f04c8$export$61bcfe829111a1d0(n, t) {
    return t();
}
var $80bff275086f04c8$export$c4744153514ff05d = "object" == typeof performance && "function" == typeof performance.now ? performance.now.bind(performance) : function() {
    return Date.now();
}, $80bff275086f04c8$export$83d89fbfd8236492 = "16.8.0";
function $80bff275086f04c8$export$d38cd72104c1f0e9(n) {
    return (0, $767w7.createElement).bind(null, n);
}
function $80bff275086f04c8$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $80bff275086f04c8$var$W;
}
function $80bff275086f04c8$export$e530037191fcd5d7(n) {
    return $80bff275086f04c8$export$a8257692ac88316c(n) ? (0, $767w7.cloneElement).apply(null, arguments) : n;
}
function $80bff275086f04c8$export$502457920280e6be(n) {
    return !!n.__k && ((0, $767w7.render)(null, n), !0);
}
function $80bff275086f04c8$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $80bff275086f04c8$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $80bff275086f04c8$export$5f8d39834fd61797 = (0, $767w7.Fragment);
var $80bff275086f04c8$export$2e2bcd8739ae039 = {
    useState: (0, $6e8a58651e634e47$export$60241385465d0a34),
    useReducer: (0, $6e8a58651e634e47$export$13e3392192263954),
    useEffect: (0, $6e8a58651e634e47$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $6e8a58651e634e47$export$e5c5a5f917a5871c),
    useRef: (0, $6e8a58651e634e47$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $6e8a58651e634e47$export$d5a552a76deda3c2),
    useMemo: (0, $6e8a58651e634e47$export$1538c33de8887b59),
    useCallback: (0, $6e8a58651e634e47$export$35808ee640e87ca7),
    useContext: (0, $6e8a58651e634e47$export$fae74005e78b1a27),
    useDebugValue: (0, $6e8a58651e634e47$export$dc8fbce3eb94dc1e),
    version: "16.8.0",
    Children: $80bff275086f04c8$export$dca3b0875bd9a954,
    render: $80bff275086f04c8$export$b3890eb0ae9dca99,
    hydrate: $80bff275086f04c8$export$fa8d919ba61d84db,
    unmountComponentAtNode: $80bff275086f04c8$export$502457920280e6be,
    createPortal: $80bff275086f04c8$export$d39a5bbd09211389,
    createElement: (0, $767w7.createElement),
    createContext: (0, $767w7.createContext),
    createFactory: $80bff275086f04c8$export$d38cd72104c1f0e9,
    cloneElement: $80bff275086f04c8$export$e530037191fcd5d7,
    createRef: (0, $767w7.createRef),
    Fragment: (0, $767w7.Fragment),
    isValidElement: $80bff275086f04c8$export$a8257692ac88316c,
    findDOMNode: $80bff275086f04c8$export$466bfc07425424d5,
    Component: (0, $767w7.Component),
    PureComponent: $80bff275086f04c8$export$221d75b3f55bb0bd,
    memo: $80bff275086f04c8$export$7c73462e0d25e514,
    forwardRef: $80bff275086f04c8$export$257a8862b851cb5b,
    unstable_batchedUpdates: $80bff275086f04c8$export$c78a37762a8d58e1,
    StrictMode: (0, $767w7.Fragment),
    Suspense: $80bff275086f04c8$export$74bf444e3cd11ea5,
    SuspenseList: $80bff275086f04c8$export$998bcd577473dd93,
    lazy: $80bff275086f04c8$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $80bff275086f04c8$export$ae55be85d98224ed
};


const $ef7d658c4ec714e8$var$Portal = ({ into: into, children: children })=>{
    const container = document.querySelector(into);
    return (0, $80bff275086f04c8$export$d39a5bbd09211389)(children, container);
};
$ef7d658c4ec714e8$exports.Portal = $ef7d658c4ec714e8$var$Portal;


var $c3fbb3693cd604d2$exports = {};
"use strict";
Object.defineProperty($c3fbb3693cd604d2$exports, "__esModule", {
    value: true
});
$c3fbb3693cd604d2$exports.Shield = void 0;

var $c3fbb3693cd604d2$var$_getStyledComponent = $c3fbb3693cd604d2$var$_interopRequireDefault((parcelRequire("45yGA")));

var $krJc1 = parcelRequire("krJc1");
function $c3fbb3693cd604d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3fbb3693cd604d2$var$Shield = (0, $krJc1.transitionIn)((0, $c3fbb3693cd604d2$var$_getStyledComponent.default)({
    baseClasses: "fixed transition w-100 h-100 top-0 left-0 bg-blue-50",
    options: {
        transitions: [
            "firstRender"
        ]
    },
    fn: ({ firstRender: firstRender })=>firstRender ? "o-0" : ""
}));
$c3fbb3693cd604d2$exports.Shield = $c3fbb3693cd604d2$var$Shield;


function $f112c84953e7c35b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f112c84953e7c35b$var$_extends() {
    $f112c84953e7c35b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f112c84953e7c35b$var$_extends.apply(this, arguments);
}
const $f112c84953e7c35b$var$Dialog = (incomingProps)=>{
    const { className: className, title: title, doClose: doClose, forceChoice: forceChoice, style: style, bottom: bottom, children: children } = incomingProps;
    const props = (0, $04wYO.omit)(incomingProps, [
        "className",
        "title",
        "doClose",
        "forceChoice",
        "style",
        "children",
        "bottom"
    ]);
    return (0, $767w7.h)($ef7d658c4ec714e8$exports.Portal, {
        into: "body"
    }, (0, $767w7.h)("div", {
        className: "fixed z-999 vh-100 w-100 top-0 left-0 flex items-center justify-center"
    }, (0, $767w7.h)($c3fbb3693cd604d2$exports.Shield, {
        onClick: forceChoice ? null : doClose
    }), (0, $767w7.h)("dialog", $f112c84953e7c35b$var$_extends({
        open: true,
        style: Object.assign({
            minHeight: "150px",
            minWidth: "300px",
            width: "600px",
            // this is important for iOS
            maxHeight: "calc(100vh - 120px)"
        }, style),
        className: (0, $f112c84953e7c35b$var$_classnames.default)("ph2 pt2 pb1 bg-white bn br3 shadow-2 z-999 relative flex flex-column", className)
    }, props), (0, $767w7.h)("div", {
        className: "w-100 pt1 ph1"
    }, !forceChoice && // this is just a spacer
    (0, $767w7.h)("div", {
        className: "fr",
        style: {
            width: "44px",
            height: "10px"
        }
    }, (0, $767w7.h)("button", {
        onClick: doClose,
        style: {
            top: "-16px",
            right: "-4px"
        },
        className: "button-reset bn bg-transparent relative pa3"
    }, (0, $767w7.h)($7Dcmj.Icon, {
        icon: "close"
    }))), title && (0, $767w7.h)("h3", {
        className: "mt0 mb2"
    }, title)), (0, $767w7.h)("div", {
        className: "pa1 prevent-overscroll overflow-y-scroll w-100 overflow-x-hidden"
    }, children), (0, $767w7.h)("div", {
        className: "ph1 pv2"
    }, bottom))));
};
$f112c84953e7c35b$exports.Dialog = $f112c84953e7c35b$var$Dialog;


Object.keys($f112c84953e7c35b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $f112c84953e7c35b$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $f112c84953e7c35b$exports[key];
        }
    });
});
var $f6afbeee1a2c4c61$exports = {};
"use strict";
Object.defineProperty($f6afbeee1a2c4c61$exports, "__esModule", {
    value: true
});
$f6afbeee1a2c4c61$exports.AppLayout = void 0;

var $f6afbeee1a2c4c61$var$_classnames = $f6afbeee1a2c4c61$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $767w7 = parcelRequire("767w7");

var $dSxTB = parcelRequire("dSxTB");


var $b66e621e1478540c$exports = {};
"use strict";
Object.defineProperty($b66e621e1478540c$exports, "__esModule", {
    value: true
});
$b66e621e1478540c$exports.Footer = void 0;

var $767w7 = parcelRequire("767w7");

var $b66e621e1478540c$var$_milliseconds = $b66e621e1478540c$var$_interopRequireDefault((parcelRequire("6zzev")));
function $b66e621e1478540c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b66e621e1478540c$var$currentYear = new Date().getFullYear();
const $b66e621e1478540c$var$getUpdatedText = (updatedDate)=>{
    if (Date.now() - updatedDate < $b66e621e1478540c$var$_milliseconds.default.weeks(2)) {
        const date = new Date(updatedDate);
        return "".concat(date.getMonth() + 1, "/").concat(date.getDate(), "/").concat((date.getFullYear() + "").slice(2));
    }
};
const $b66e621e1478540c$var$linkClasses = "link f6 gray no-underline underline-hover";
const $b66e621e1478540c$var$Footer = ({ privacyUrl: privacyUrl = "https://legal.xchart.com/privacy", termsUrl: termsUrl = "https://legal.xchart.com/terms", hipaaUrl: hipaaUrl = "https://legal.xchart.com/hipaa", version: version, privacyUpdatedDate: privacyUpdatedDate, hideLinks: hideLinks, extra: extra })=>{
    const updateText = privacyUpdatedDate && $b66e621e1478540c$var$getUpdatedText(privacyUpdatedDate);
    return (0, $767w7.h)("footer", {
        className: "pt2 pb3 tc f6 gray mb7"
    }, "\xa9 ", $b66e621e1478540c$var$currentYear, " I.V. Enterprises LLC ", version && "v".concat(version), " ", !hideLinks && (0, $767w7.h)("div", {
        className: "mt1 no-print"
    }, (0, $767w7.h)("a", {
        className: $b66e621e1478540c$var$linkClasses,
        href: termsUrl,
        rel: "noopener"
    }, "terms"), " | ", (0, $767w7.h)("a", {
        className: $b66e621e1478540c$var$linkClasses,
        href: privacyUrl,
        rel: "noopener"
    }, "privacy"), " | ", (0, $767w7.h)("a", {
        className: $b66e621e1478540c$var$linkClasses,
        href: hipaaUrl,
        rel: "noopener"
    }, "hipaa"), updateText && " (updated ".concat(updateText, ")")), extra);
};
$b66e621e1478540c$exports.Footer = $b66e621e1478540c$var$Footer;



var $9YtMX = parcelRequire("9YtMX");

var $04wYO = parcelRequire("04wYO");
var $17791e7335b36e48$exports = {};
"use strict";
Object.defineProperty($17791e7335b36e48$exports, "__esModule", {
    value: true
});
$17791e7335b36e48$exports.throttle = void 0;
const $17791e7335b36e48$var$throttle = (callback, wait, leading = false)=>{
    let timeout = null;
    let hasRun = false;
    const fn = (...args)=>{
        if (!hasRun && leading) {
            callback(...args);
            hasRun = true;
            return;
        }
        if (!timeout) timeout = setTimeout(()=>{
            callback(...args);
            clearTimeout(timeout);
            timeout = null;
        }, wait);
    };
    return fn;
};
$17791e7335b36e48$exports.throttle = $17791e7335b36e48$var$throttle;


var $23ca660b3341d0b2$exports = {};
"use strict";
Object.defineProperty($23ca660b3341d0b2$exports, "__esModule", {
    value: true
});
$23ca660b3341d0b2$exports.EnvTag = void 0;

var $767w7 = parcelRequire("767w7");

var $23ca660b3341d0b2$var$_classnames = $23ca660b3341d0b2$var$_interopRequireDefault((parcelRequire("8g1PZ")));
function $23ca660b3341d0b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23ca660b3341d0b2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $23ca660b3341d0b2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $23ca660b3341d0b2$var$ownKeys(Object(source), true).forEach(function(key) {
            $23ca660b3341d0b2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $23ca660b3341d0b2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $23ca660b3341d0b2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $23ca660b3341d0b2$var$classMap = {
    dev: "bg-yellow black",
    stage: "bg-green black"
};
const $23ca660b3341d0b2$var$fallback = "bg-red white";
const $23ca660b3341d0b2$var$guessEnv = ()=>{
    let host = "server";
    try {
        host = window.location.host;
    } catch (err) {}
    if (host.includes("dev")) return "dev";
    if (host.includes("stage")) return "stage";
    if (host.includes("localhost")) return "local";
    return "prod";
};
const $23ca660b3341d0b2$var$EnvTag = ({ env: env, style: style })=>{
    env = env || $23ca660b3341d0b2$var$guessEnv();
    if (!env || env === "prod" || env === "production") return null;
    if (env === "development") env = "dev";
    return (0, $767w7.h)("div", {
        style: $23ca660b3341d0b2$var$_objectSpread({
            right: "0px",
            top: "0px",
            padding: "4px",
            fontSize: "10px",
            borderBottomLeftRadius: "4px"
        }, style),
        className: (0, $23ca660b3341d0b2$var$_classnames.default)("absolute z-999 br--bottom-left fw6", $23ca660b3341d0b2$var$classMap[env] || $23ca660b3341d0b2$var$fallback)
    }, env.toUpperCase());
};
$23ca660b3341d0b2$exports.EnvTag = $23ca660b3341d0b2$var$EnvTag;


function $f6afbeee1a2c4c61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6afbeee1a2c4c61$var$_extends() {
    $f6afbeee1a2c4c61$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f6afbeee1a2c4c61$var$_extends.apply(this, arguments);
}
class $f6afbeee1a2c4c61$var$DrawerContentWrapper extends $767w7.Component {
    constructor(props){
        super(props);
        this.handleScroll = (0, $17791e7335b36e48$exports.throttle)(this.handleScroll.bind(this), 200);
    }
    handleScroll() {
        if (!this.base) return;
        const { updateScrolledDown: updateScrolledDown, scrolledDown: scrolledDown } = this.props;
        const { scrollTop: scrollTop } = this.base;
        if (scrollTop === 0 && scrolledDown) updateScrolledDown(false);
        if (!scrolledDown && scrollTop > 0) updateScrolledDown(true);
    }
    componentDidMount() {
        this.base.addEventListener("scroll", this.handleScroll, {
            passive: true
        });
    }
    componentWillUnMount() {
        this.base.removeEventListener("scroll", this.handleScroll, {
            passive: true
        });
    }
    render({ style: style, children: children }) {
        return (0, $767w7.h)("div", {
            className: "v-scroll h-100 w-100",
            style: style
        }, children);
    }
}
class $f6afbeee1a2c4c61$var$AppLayout extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = {
            drawerScrolledDown: false
        };
        this.updateScrolledDown = this.updateScrolledDown.bind(this);
    }
    updateScrolledDown(scrolledDown) {
        this.setState({
            drawerScrolledDown: scrolledDown
        });
    }
    render(props, { drawerScrolledDown: drawerScrolledDown }) {
        const { drawerOpen: drawerOpen, screenIsWide: screenIsWide, drawerEnabled: drawerEnabled, drawerContent: drawerContent, statusBarContent: statusBarContent, extraContent: extraContent, extraFooterContent: extraFooterContent, drawerWidth: drawerWidth = 256, mainContent: mainContent, doCloseDrawer: doCloseDrawer, hideFooter: hideFooter, version: version, logoHref: logoHref, logoOnClick: logoOnClick, preventScroll: preventScroll, subHeader: subHeader, env: env } = props;
        const rest = (0, $04wYO.omit)(props, [
            "drawerOpen",
            "screenIsWide",
            "drawerEnabled",
            "drawerContent",
            "statusBarContent",
            "extraContent",
            "drawerWidth",
            "mainContent",
            "doCloseDrawer",
            "hideFooter",
            "version",
            "logoHref",
            "logoOnClick",
            "preventScroll",
            "extraFooterContent",
            "subHeader"
        ]);
        const drawerAlwaysVisible = drawerEnabled && screenIsWide;
        const useFloatingDrawer = drawerEnabled && !screenIsWide;
        const showShield = useFloatingDrawer && drawerOpen;
        const floatingDrawerHidden = useFloatingDrawer && !drawerOpen;
        const leftMarginStyles = drawerAlwaysVisible ? {
            width: "calc(100% - ".concat(drawerWidth, "px)"),
            marginLeft: "".concat(drawerWidth, "px")
        } : {
            width: "100%"
        };
        if (showShield || preventScroll) document.body.classList.add("overflow-hidden");
        else document.body.classList.remove("overflow-hidden");
        const drawerHeaderHeightPx = "80px";
        const logoClasses = (0, $f6afbeee1a2c4c61$var$_classnames.default)({
            pointer: logoHref || logoOnClick
        });
        return (0, $767w7.h)("div", $f6afbeee1a2c4c61$var$_extends({
            className: "bg-near-white dark-blue sans-serif min-vh-100"
        }, rest), statusBarContent && (0, $767w7.h)("div", {
            className: "sticky no-print top-0 bg-light-gray z-1 shadow-1",
            style: leftMarginStyles
        }, statusBarContent), drawerEnabled && (0, $767w7.h)($c7be9607bdbcd598$exports.Drawer, {
            "aria-hidden": floatingDrawerHidden,
            className: useFloatingDrawer ? "z-4 transition" : "",
            style: {
                width: "".concat(drawerWidth, "px"),
                transform: floatingDrawerHidden ? "translateX(".concat(-drawerWidth, "px)") : null
            }
        }, (0, $767w7.h)("div", {
            className: (0, $f6afbeee1a2c4c61$var$_classnames.default)("absolute left-0 bg-dark-blue z-1 top-0 pa2 pa3-l", {
                "shadow-1": drawerScrolledDown
            }),
            style: {
                width: "".concat(drawerWidth, "px"),
                height: drawerHeaderHeightPx
            }
        }, (0, $767w7.h)($23ca660b3341d0b2$exports.EnvTag, {
            env: env
        }), (0, $767w7.h)("div", null, !screenIsWide && (0, $767w7.h)($9YtMX.TapIconButton, {
            icon: "close",
            color: "white",
            className: "absolute",
            style: {
                top: "14px",
                left: "14px"
            },
            onClick: (e)=>{
                e.preventDefault();
                doCloseDrawer();
            }
        }), (0, $767w7.h)("a", {
            className: (0, $f6afbeee1a2c4c61$var$_classnames.default)("db link white absolute", logoClasses),
            style: {
                left: "44px",
                top: "20px"
            },
            href: logoHref,
            onClick: logoOnClick || doCloseDrawer,
            "data-e2e": "logoLink"
        }, (0, $767w7.h)($dSxTB.XChart, {
            light: true,
            className: "h2"
        }), (0, $767w7.h)("span", {
            className: "absolute ttu fw3 f6 gray",
            style: {
                top: "36px",
                left: "0px",
                width: "168px"
            }
        }, subHeader)))), (0, $767w7.h)($f6afbeee1a2c4c61$var$DrawerContentWrapper, {
            scrolledDown: drawerScrolledDown,
            updateScrolledDown: this.updateScrolledDown,
            style: {
                paddingTop: drawerHeaderHeightPx,
                paddingBottom: "120px"
            }
        }, drawerContent)), showShield && (0, $767w7.h)($c3fbb3693cd604d2$exports.Shield, {
            className: "z-3 dn-l",
            onClick: ()=>doCloseDrawer && doCloseDrawer()
        }), (0, $767w7.h)("main", {
            style: leftMarginStyles,
            className: "bg-nearly-white overflow-x-hidden"
        }, mainContent, hideFooter !== true && (0, $767w7.h)($b66e621e1478540c$exports.Footer, {
            version: version,
            extra: extraFooterContent
        })), extraContent);
    }
}
$f6afbeee1a2c4c61$exports.AppLayout = $f6afbeee1a2c4c61$var$AppLayout;


Object.keys($f6afbeee1a2c4c61$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $f6afbeee1a2c4c61$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $f6afbeee1a2c4c61$exports[key];
        }
    });
});

Object.keys($c3fbb3693cd604d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $c3fbb3693cd604d2$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $c3fbb3693cd604d2$exports[key];
        }
    });
});

Object.keys($ef7d658c4ec714e8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $ef7d658c4ec714e8$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $ef7d658c4ec714e8$exports[key];
        }
    });
});

Object.keys($23ca660b3341d0b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $23ca660b3341d0b2$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $23ca660b3341d0b2$exports[key];
        }
    });
});
var $46f7b3fcafd29752$exports = {};
"use strict";
Object.defineProperty($46f7b3fcafd29752$exports, "__esModule", {
    value: true
});
$46f7b3fcafd29752$exports.DefinitionTable = void 0;

var $767w7 = parcelRequire("767w7");
function $46f7b3fcafd29752$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $46f7b3fcafd29752$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $46f7b3fcafd29752$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * @typedef DefinitionTableProps
 * @property {{
 *   [key: string]: () => import('preact').VNode | string
 * }} data
 */ /**
 * DefinitionTable Generates a table of name / value cells, given a data prop
 *
 * @type {import('preact').FunctionComponent}
 * @param {DefinitionTableProps} Props
 */ const $46f7b3fcafd29752$var$DefinitionTable = (_ref)=>{
    let { data: data } = _ref, rest = $46f7b3fcafd29752$var$_objectWithoutProperties(_ref, [
        "data"
    ]);
    return (0, $767w7.h)("table", rest, Object.keys(data).map((key)=>(0, $767w7.h)("tr", {
            key: key
        }, (0, $767w7.h)("td", {
            className: "fw6 no-wrap v-top"
        }, key, ":"), (0, $767w7.h)("td", {
            className: "v-top"
        }, data[key] == null ? (0, $767w7.h)("span", {
            className: "black-40"
        }, "(none)") : data[key]))));
};
$46f7b3fcafd29752$exports.DefinitionTable = $46f7b3fcafd29752$var$DefinitionTable;


Object.keys($46f7b3fcafd29752$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $46f7b3fcafd29752$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $46f7b3fcafd29752$exports[key];
        }
    });
});
var $a406c38524ee1eae$exports = {};
"use strict";
Object.defineProperty($a406c38524ee1eae$exports, "__esModule", {
    value: true
});
$a406c38524ee1eae$exports.fhirResourceBundle = $a406c38524ee1eae$exports.extractOrgId = void 0;

var $04wYO = parcelRequire("04wYO");

var $dRTL8 = parcelRequire("dRTL8");
function $a406c38524ee1eae$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a406c38524ee1eae$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a406c38524ee1eae$var$ownKeys(Object(source), true).forEach(function(key) {
            $a406c38524ee1eae$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a406c38524ee1eae$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a406c38524ee1eae$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $a406c38524ee1eae$var$RECEIVED = "FHIR_RESOURCE_RECEIVED";
const $a406c38524ee1eae$var$LOADING = "FHIR_RESOURCE_LOADING";
const $a406c38524ee1eae$var$DELETING = "FHIR_RESOURCE_DELETING";
const $a406c38524ee1eae$var$DELETED = "FHIR_RESOURCE_DELETED";
const $a406c38524ee1eae$var$UPDATING = "FHIR_RESOURCE_UPDATING";
const $a406c38524ee1eae$var$CLEARED = "FHIR_RESOURCES_CLEARED";
const $a406c38524ee1eae$var$CLEARED_NOT_IN_ORG = "FHIR_RESOURCES_CLEARED_EXCEPT";
/**
 * @param {string} fullUrl Full google resource URL for resource
 * @returns {string} Extracted OrgId
 */ const $a406c38524ee1eae$var$extractOrgId = (fullUrl)=>{
    const result = /\/fhirStores\/([a-zA-Z0-9._-]+)\/fhir/i.exec(fullUrl);
    return result && result[1] || "";
};
$a406c38524ee1eae$exports.extractOrgId = $a406c38524ee1eae$var$extractOrgId;
const $a406c38524ee1eae$var$emptyObj = {};
const $a406c38524ee1eae$var$createFhirResourceSelector = (resourceName)=>{
    let lastResult;
    let lastResourceCollection;
    return (state)=>{
        const resourceCollection = state.fhirResourceCache[resourceName] || $a406c38524ee1eae$var$emptyObj;
        if (resourceCollection === lastResourceCollection) return lastResult;
        const result = {};
        for(const key in resourceCollection){
            /** @type {ResourceEntry} */ const entry = resourceCollection[key];
            const { resource: resource, activeOperation: activeOperation, orgId: orgId } = entry;
            if (activeOperation) result[resource.id] = $a406c38524ee1eae$var$_objectSpread($a406c38524ee1eae$var$_objectSpread({}, resource), {}, {
                activeOperation: activeOperation,
                orgId: orgId
            });
            else result[resource.id] = $a406c38524ee1eae$var$_objectSpread($a406c38524ee1eae$var$_objectSpread({}, resource), {}, {
                orgId: orgId
            });
        }
        lastResourceCollection = resourceCollection;
        lastResult = result;
        return result;
    };
};
/** @typedef {'delete' | 'update' | 'load' | 'deleted'} OperationStatus */ /**
 * @typedef ResourceEntry
 * @property {any} resource
 * @property {OperationStatus} activeOperation
 * @property {string} orgId
 */ /**
 * @param {any} state
 * @param {{
 *   id: string
 *   resourceType: string
 *   orgId: string
 * }} payload
 * @param {OperationStatus} status
 */ const $a406c38524ee1eae$var$updateState = (state, payload, status)=>{
    const { id: id, resourceType: resourceType, orgId: orgId } = payload;
    const resourceCollection = state[resourceType] || {};
    if (status === "deleted") return $a406c38524ee1eae$var$_objectSpread($a406c38524ee1eae$var$_objectSpread({}, state), {}, {
        [resourceType]: (0, $04wYO.omit)(resourceCollection, [
            id
        ])
    });
    const existingResource = resourceCollection[id] && resourceCollection[id].resource;
    return $a406c38524ee1eae$var$_objectSpread($a406c38524ee1eae$var$_objectSpread({}, state), {}, {
        [resourceType]: $a406c38524ee1eae$var$_objectSpread($a406c38524ee1eae$var$_objectSpread({}, resourceCollection), {}, {
            [id]: {
                resource: existingResource || {
                    resourceType: resourceType,
                    id: id
                },
                activeOperation: status,
                orgId: orgId
            }
        })
    });
};
const $a406c38524ee1eae$var$fhirResourceBundle = {
    name: "fhirResourceCache",
    getReducer: ()=>{
        const initial = {
        };
        return (state = initial, { type: type, payload: payload })=>{
            if (type === $a406c38524ee1eae$var$CLEARED) return initial;
            if (type === $a406c38524ee1eae$var$RECEIVED) {
                const { resources: resources, orgId: orgId } = payload;
                const updatedState = $a406c38524ee1eae$var$_objectSpread({}, state);
                for(const id in resources){
                    const resource = resources[id];
                    const { resourceType: resourceType } = resource;
                    updatedState[resourceType] = $a406c38524ee1eae$var$_objectSpread($a406c38524ee1eae$var$_objectSpread({}, updatedState[resourceType]), {}, {
                        [id]: {
                            resource: resource,
                            orgId: orgId
                        }
                    });
                }
                return updatedState;
            }
            if (type === $a406c38524ee1eae$var$LOADING) return $a406c38524ee1eae$var$updateState(state, payload, "load");
            if (type === $a406c38524ee1eae$var$DELETING) return $a406c38524ee1eae$var$updateState(state, payload, "delete");
            if (type === $a406c38524ee1eae$var$DELETED) return $a406c38524ee1eae$var$updateState(state, payload, "deleted");
            if (type === $a406c38524ee1eae$var$UPDATING) return $a406c38524ee1eae$var$updateState(state, payload, "update");
            if (type === $a406c38524ee1eae$var$CLEARED_NOT_IN_ORG) {
                const newState = {};
                for(const resourceType in state){
                    newState[resourceType] = {};
                    const resources = state[resourceType];
                    for(const resourceId in resources){
                        const resourceEntry = resources[resourceId];
                        if (resourceEntry.orgId === payload) newState[resourceType][resourceId] = resourceEntry;
                    }
                }
                return newState;
            }
            return state;
        };
    },
    init: (store)=>{
        store.utilFindFhirResourceById = (id)=>{
            const collections = store.selectFhirResourceCacheRaw();
            for(const key in collections){
                const items = collections[key];
                const found = items[id];
                if (found) return found.resource;
            }
            return null;
        };
    },
    selectFhirResourceCacheRaw: (state)=>state.fhirResourceCache,
    selectPatientsRaw: $a406c38524ee1eae$var$createFhirResourceSelector("Patient"),
    selectLocationsRaw: $a406c38524ee1eae$var$createFhirResourceSelector("Location"),
    selectPractitionersRaw: $a406c38524ee1eae$var$createFhirResourceSelector("Practitioner"),
    selectAppointmentsRaw: $a406c38524ee1eae$var$createFhirResourceSelector("Appointment"),
    selectCompositionsRaw: $a406c38524ee1eae$var$createFhirResourceSelector("Composition"),
    selectFhirHasResources: (0, $dRTL8.createSelector)("selectFhirResourceCacheRaw", (cache)=>{
        for(const key in cache){
            const collection = cache[key];
            for(const id in collection)// if there's anything... it's true
            return true;
        }
        return false;
    }),
    doClearFhirCache: ()=>({
            type: $a406c38524ee1eae$var$CLEARED
        }),
    doClearFhirModelsNotInOrg: (orgId)=>({
            type: $a406c38524ee1eae$var$CLEARED_NOT_IN_ORG,
            payload: orgId
        }),
    doRemoveFhirResource: ({ orgId: orgId, id: id, resourceType: resourceType })=>({
            type: $a406c38524ee1eae$var$DELETED,
            payload: {
                orgId: orgId,
                id: id,
                resourceType: resourceType
            }
        }),
    doReceiveSingleFhirResource: (resource, orgId)=>({
            type: $a406c38524ee1eae$var$RECEIVED,
            payload: {
                orgId: orgId,
                resources: {
                    [resource.id]: resource
                }
            }
        }),
    doReceiveFhirResponse: (...fhirResponses)=>({ dispatch: dispatch })=>{
            fhirResponses.forEach((response)=>{
                const { entry: entry, total: total } = response;
                const isEmpty = total === 0;
                if (!isEmpty && entry && Array.isArray(entry)) {
                    const firstEntry = entry[0];
                    const orgId = firstEntry && $a406c38524ee1eae$var$extractOrgId(firstEntry.fullUrl) || null;
                    const resources = entry.map((item)=>item.resource);
                    dispatch({
                        type: $a406c38524ee1eae$var$RECEIVED,
                        payload: {
                            orgId: orgId,
                            resources: (0, $04wYO.arrayToObject)(resources)
                        }
                    });
                }
            });
        },
    doFhirFetch: (...args)=>({ fhirFetch: fhirFetch })=>fhirFetch(...args),
    doFetchFhirResource: (fhirUrl, orgId)=>({ dispatch: dispatch, fhirFetch: fhirFetch, store: store })=>{
            const [resourceType, maybeId] = fhirUrl.split("/");
            const [id, extraQueryParams] = maybeId.split("?");
            dispatch({
                type: $a406c38524ee1eae$var$LOADING,
                payload: {
                    resourceType: resourceType,
                    id: id,
                    orgId: orgId
                }
            }); // we have to do this as a search in order to include related resources
            return fhirFetch("/".concat(resourceType, "?_id=").concat(id, "&_include=*").concat(extraQueryParams ? "&" + extraQueryParams : ""), {
                orgId: orgId
            }).then(store.doReceiveFhirResponse);
        },
    doFetchPdfShareInfo: (pdfId, orgId)=>({ gqlFetch: gqlFetch })=>gqlFetch('{pdfUrl(orgId:"'.concat(orgId, '",pdfId:"').concat(pdfId, '"){url text title}}')).then((res)=>res.data.pdfUrl),
    doCreateChartForAppointment: (appointmentId, orgId)=>({ gqlFetch: gqlFetch })=>gqlFetch("mutation createCompositionForAppointment($orgId:String!,$appointmentId:String!) {\n      createCompositionForAppointment(orgId:$orgId,appointmentId:$appointmentId) \n    }", {
                orgId: orgId,
                appointmentId: appointmentId
            }).then((res)=>res.data.createCompositionForAppointment),
    doFetchUpcomingAndIncompleteAppointments: ({ orgId: orgId, practitionerId: practitionerId })=>({ store: store })=>Promise.all([
                store.doFetchAppointments({
                    orgId: orgId,
                    gt: store.selectAppDayDate(),
                    sort: "date",
                    practitionerId: practitionerId,
                    count: 50
                }),
                store.doFetchAppointments({
                    orgId: orgId,
                    missingDate: true
                }),
                // should include everything with"
                // status other than "fullfilled"
                // OR the statuses that mean the
                // appointment did not happen.
                store.doFetchAppointments({
                    orgId: orgId,
                    lt: store.selectAppDayDate(),
                    sort: "date",
                    status: [
                        "proposed",
                        "pending",
                        "booked",
                        "arrived",
                        "checked-in",
                        "waitlist" // the other possible statuses
                    ].join(",")
                })
            ]),
    doFetchAppointments: ({ sort: sort, orgId: orgId, includeActors: includeActors = true, includeComposition: includeComposition = true, compositionIncomplete: compositionIncomplete, practitionerId: practitionerId, gt: gt, lt: lt, missingDate: missingDate = false, count: count, status: status, incomingResponseArrayHandler: incomingResponseArrayHandler, waitForAll: waitForAll = false, fetchAll: fetchAll = true })=>({ fhirFetch: fhirFetch, store: store })=>{
            let params = [];
            if (includeComposition) params.push("_include=Appointment:supporting-info:Composition");
            if (includeActors) params.push("_include=Appointment:actor");
            if (missingDate) params.push("date:missing=true");
            if (count) params.push("_count=".concat(count));
            if (sort) params.push("_sort=".concat(sort));
            if (gt) params.push("date=gt".concat(gt.toISOString()));
            if (lt) params.push("date=lt".concat(lt.toISOString()));
            if (practitionerId) params.push("practitioner=".concat(practitionerId));
            if (status) params.push("status=".concat(status));
            if (compositionIncomplete) params.push("supporting-info:Composition.status=preliminary");
            return fhirFetch("/Appointment?" + params.join("&"), {
                waitForAll: waitForAll,
                fetchAll: fetchAll,
                incomingResponseArrayHandler: incomingResponseArrayHandler || ((res)=>store.doReceiveFhirResponse(...res)),
                orgId: orgId
            });
        }
};
$a406c38524ee1eae$exports.fhirResourceBundle = $a406c38524ee1eae$var$fhirResourceBundle;


Object.keys($a406c38524ee1eae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $a406c38524ee1eae$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $a406c38524ee1eae$exports[key];
        }
    });
});
var $7e3facfcefa8cde1$exports = {};
"use strict";
Object.defineProperty($7e3facfcefa8cde1$exports, "__esModule", {
    value: true
});
$7e3facfcefa8cde1$exports.getUserInactiveBundle = void 0;

var $dRTL8 = parcelRequire("dRTL8");
/**
 * @typedef UserInactiveBundleOptions
 * @property {number} [inactiveThreshold=30000] Time in milliseconds after which
 *   to consider the user inactive. Default is `30000`
 * @property {string} [updateActionType='USER_INACTIVE_UPDATED'] Action `type`
 *   to use when updating this. Default is `'USER_INACTIVE_UPDATED'`
 * @property {string} [name='userInactive'] Name of bundle. Default is `'userInactive'`
 * @property {string[]} [events=['mousemove', 'click', 'keydown']] The window
 *   events to listen to. Default is `['mousemove', 'click', 'keydown']`
 */ /**
 * @param {UserInactiveBundleOptions} [opts]
 * @returns {ReduxBundlerBundle}
 */ const $7e3facfcefa8cde1$var$getUserInactiveBundle = ({ inactiveThreshold: inactiveThreshold, updateActionType: updateActionType = "USER_INACTIVE_UPDATED", name: name = "userInactive", events: events = [
    "mousemove",
    "click",
    "keydown"
] } = {})=>({
        name: name,
        reducer: (state = null, { type: type, payload: payload })=>type === updateActionType ? payload || null : state,
        selectUserIsActive: (state)=>!state[name],
        selectUserInactiveTime: (state)=>state[name],
        init: (store)=>{
            let lastActiveTime;
            const resetInactivityTimer = (0, $dRTL8.debounce)(()=>{
                store.dispatch({
                    type: updateActionType,
                    payload: lastActiveTime
                });
            }, inactiveThreshold || 30000);
            const listener = ()=>{
                lastActiveTime = Date.now();
                resetInactivityTimer();
                if (!store.selectUserIsActive()) store.dispatch({
                    type: updateActionType
                });
            };
            events.forEach((eventName)=>{
                window.addEventListener(eventName, listener, {
                    passive: true
                });
            });
            resetInactivityTimer();
        }
    });
$7e3facfcefa8cde1$exports.getUserInactiveBundle = $7e3facfcefa8cde1$var$getUserInactiveBundle;


Object.keys($7e3facfcefa8cde1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $7e3facfcefa8cde1$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $7e3facfcefa8cde1$exports[key];
        }
    });
});
var $b7af012631134a8e$exports = {};
"use strict";
Object.defineProperty($b7af012631134a8e$exports, "__esModule", {
    value: true
});
$b7af012631134a8e$exports.getSessionBundle = $b7af012631134a8e$exports.sessionResponseSnippet = void 0;

var $dRTL8 = parcelRequire("dRTL8");
var $561fbfb5381cff1a$exports = {};
"use strict";
Object.defineProperty($561fbfb5381cff1a$exports, "__esModule", {
    value: true
});
$561fbfb5381cff1a$exports.toGqlQuery = void 0;
const $561fbfb5381cff1a$var$toGqlQuery = (arr)=>"{".concat(arr.reduce((result, item, index)=>result + (index === 0 ? "" : " ") + (Array.isArray(item) ? "".concat(item[0], " ").concat($561fbfb5381cff1a$var$toGqlQuery(item.slice(1))) : item), ""), "}");
$561fbfb5381cff1a$exports.toGqlQuery = $561fbfb5381cff1a$var$toGqlQuery;


var $8846264bcad4f7cd$exports = {};
"use strict";
Object.defineProperty($8846264bcad4f7cd$exports, "__esModule", {
    value: true
});
$8846264bcad4f7cd$exports.generateBundle = void 0;
function $8846264bcad4f7cd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8846264bcad4f7cd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8846264bcad4f7cd$var$ownKeys(Object(source), true).forEach(function(key) {
            $8846264bcad4f7cd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8846264bcad4f7cd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8846264bcad4f7cd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8846264bcad4f7cd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8846264bcad4f7cd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8846264bcad4f7cd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8846264bcad4f7cd$var$generateBundle = (definition)=>{
    const { actionTypes: actionTypes, initialState: initialState, persistActions: persistActions = [] } = definition, rest = $8846264bcad4f7cd$var$_objectWithoutProperties(definition, [
        "actionTypes",
        "initialState",
        "persistActions"
    ]);
    const handledActions = {};
    for(const key in actionTypes){
        const { handler: handler, persist: persist } = actionTypes[key];
        if (handler) handledActions[key] = handler;
        if (persist) persistActions.push(key);
    }
    return $8846264bcad4f7cd$var$_objectSpread($8846264bcad4f7cd$var$_objectSpread({}, rest), {}, {
        persistActions: persistActions,
        reducer: (state = initialState, { type: type, payload: payload })=>handledActions[type] ? handledActions[type](state, payload) : state
    });
};
$8846264bcad4f7cd$exports.generateBundle = $8846264bcad4f7cd$var$generateBundle;


function $b7af012631134a8e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b7af012631134a8e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b7af012631134a8e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b7af012631134a8e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b7af012631134a8e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b7af012631134a8e$var$ownKeys(Object(source), true).forEach(function(key) {
            $b7af012631134a8e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b7af012631134a8e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b7af012631134a8e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $b7af012631134a8e$var$IS_CYPRESS = !!(typeof window !== "undefined" && window.Cypress);
const $b7af012631134a8e$var$STARTED = "SESSION_FETCH_STARTED";
const $b7af012631134a8e$var$FAILED = "SESSION_FETCH_FAILED";
const $b7af012631134a8e$var$SESSION_RECEIVED = "SESSION_RECEIVED";
const $b7af012631134a8e$var$sessionResponseSnippet = (0, $561fbfb5381cff1a$exports.toGqlQuery)([
    "multiFactorLast",
    "multiFactorAuthExp",
    "sessionRenewedAt",
    "sessionExpiresAt",
    "token",
    "orgs{id roles status type memberId}"
]);
/**
 * @typedef GetSessionBundleOptions
 * @property {number} [renewSessionWhenOlderThan=180000] Time in milliseconds
 *   after which to renew the token. Defaults to three minutes. Default is `180000`
 * @property {number} [retryFailedFetchAfter=30000] Time in milliseconds after
 *   which to try again if we failed to fetchDefault is 30 seconds `30000`.
 *   Default is `30000`
 * @property {string[]} selectorsThatDetermineActivity If any of these return a
 *   truthy value, they will keep the session renewing.
 * @property {string} activeOrgIdSelectorName
 * @property {boolean} [persist=false] Default is `false`
 */ /**
 * @param {GetSessionBundleOptions} [opts]
 * @returns {ReduxBundlerBundle}
 */ $b7af012631134a8e$exports.sessionResponseSnippet = $b7af012631134a8e$var$sessionResponseSnippet;
const $b7af012631134a8e$var$getSessionBundle = (opts)=>{
    /** @type {GetSessionBundleOptions} */ const options = $b7af012631134a8e$var$_objectSpread({
        renewSessionWhenOlderThan: 180000,
        retryFailedFetchAfter: 30000
    }, opts);
    const getRoleSelector = (role)=>(0, $dRTL8.createSelector)("selectActiveOrgRoles", (roles)=>roles.includes(role));
    return (0, $8846264bcad4f7cd$exports.generateBundle)({
        name: "session",
        initialState: {
            token: "",
            loading: false,
            data: null,
            lastExtendError: null
        },
        actionTypes: {
            [$b7af012631134a8e$var$STARTED]: {
                handler: (state)=>$b7af012631134a8e$var$_objectSpread($b7af012631134a8e$var$_objectSpread({}, state), {}, {
                        loading: true
                    })
            },
            [$b7af012631134a8e$var$FAILED]: {
                handler: (state, payload)=>{
                    const { time: time } = payload;
                    return $b7af012631134a8e$var$_objectSpread($b7af012631134a8e$var$_objectSpread({}, state), {}, {
                        loading: false,
                        lastExtendError: time
                    });
                }
            },
            [$b7af012631134a8e$var$SESSION_RECEIVED]: {
                handler: (state, payload)=>{
                    const { token: token, data: data } = payload;
                    return $b7af012631134a8e$var$_objectSpread($b7af012631134a8e$var$_objectSpread({}, state), {}, {
                        loading: false,
                        data: data,
                        token: token,
                        lastExtendError: null
                    });
                },
                persist: !!options.persist
            }
        },
        selectSessionRaw: (state)=>state.session,
        selectSessionData: (state)=>state.session.data,
        selectSessionDataIsLoading: (state)=>state.session.loading,
        selectSessionLastExtendError: (state)=>state.session.lastExtendError,
        selectSessionTimes: (0, $dRTL8.createSelector)("selectSessionData", (sessionData)=>{
            const keys = [
                "multiFactorAuthExp",
                "multiFactorLast",
                "sessionExpiresAt",
                "sessionRenewedAt"
            ];
            const data = sessionData || {};
            const result = {};
            for (const key of keys){
                const asNumber = Number(data[key]);
                result[key] = isNaN(asNumber) ? null : asNumber;
            }
            return result;
        }),
        selectSessionHasValidMFA: (0, $dRTL8.createSelector)("selectSessionTimes", "selectAppTime", ({ multiFactorAuthExp: multiFactorAuthExp, multiFactorLast: multiFactorLast }, appTime)=>!!multiFactorLast && multiFactorAuthExp > appTime),
        selectHasValidSession: (0, $dRTL8.createSelector)("selectSessionTimes", "selectAppTime", ({ sessionExpiresAt: sessionExpiresAt, sessionRenewedAt: sessionRenewedAt }, appTime)=>!!sessionRenewedAt && sessionExpiresAt > appTime),
        selectIsSignedIn: (0, $dRTL8.createSelector)("selectHasAuthToken", "selectHasValidSession", (authToken, hasValidSession)=>!!(authToken && hasValidSession)),
        selectSessionOrgs: (0, $dRTL8.createSelector)("selectSessionData", (data)=>data && data.orgs || null),
        selectSessionRegularOrgIds: (0, $dRTL8.createSelector)("selectSessionOrgs", (orgs)=>(orgs || []).filter((org)=>!org.type).map((org)=>org.id)),
        selectSessionOrgIds: (0, $dRTL8.createSelector)("selectSessionOrgs", (orgs)=>orgs && orgs.map((item)=>item.id) || []),
        selectActiveOrgMembership: (0, $dRTL8.createSelector)("selectSessionOrgs", opts.activeOrgIdSelectorName, (orgs, activeOrgId)=>orgs && orgs.find((org)=>org.id === activeOrgId) || null),
        selectActiveOrgMemberId: (0, $dRTL8.createSelector)("selectActiveOrgMembership", (membership)=>membership && membership.memberId),
        selectActiveOrgType: (0, $dRTL8.createSelector)("selectActiveOrgMembership", (membership)=>membership ? membership.type || "regular" : null),
        selectActiveOrgIsXchart: (0, $dRTL8.createSelector)("selectActiveOrgType", (type)=>type === "xchart"),
        selectActiveOrgIsParent: (0, $dRTL8.createSelector)("selectActiveOrgType", (type)=>type === "parent"),
        selectActiveOrgIsRegular: (0, $dRTL8.createSelector)("selectActiveOrgType", (type)=>type === "regular"),
        selectActiveOrgRoles: (0, $dRTL8.createSelector)("selectActiveOrgMembership", (membership)=>membership && membership.roles || []),
        selectIsOrgUber: getRoleSelector("uber"),
        selectIsOrgAdmin: getRoleSelector("admin"),
        selectIsOrgProvider: getRoleSelector("provider"),
        selectIsXchartUberUser: (0, $dRTL8.createSelector)("selectSessionOrgs", (orgs)=>{
            const xchartOrg = orgs && orgs.find((org)=>org.id === "xchart" && org.type === "xchart");
            return !!(xchartOrg && xchartOrg.roles.includes("uber"));
        }),
        selectAuthStatus: (0, $dRTL8.createSelector)("selectHasAuthToken", "selectSessionData", "selectSessionHasValidMFA", "selectHasValidSession", (hasToken, sessionData, hasMFA, hasValidSession)=>{
            // this means we're still figuring it out
            if (hasToken && !sessionData) return null;
            if (!hasToken) return "none";
            if (hasMFA && hasValidSession) return "full";
            if (hasValidSession) return "partial";
            return "expired";
        }),
        selectIsDeterminingAuthStatus: (0, $dRTL8.createSelector)("selectAuthStatus", (status)=>!status),
        selectIsFullyAuthenticated: (0, $dRTL8.createSelector)("selectAuthStatus", (status)=>status === "full"),
        selectNotFullyAuthenticated: (0, $dRTL8.createSelector)("selectIsDeterminingAuthStatus", "selectIsFullyAuthenticated", (isDetermining, fullyAuthenticated)=>!isDetermining && !fullyAuthenticated),
        doFetchSession: (update = false)=>({ gqlFetch: gqlFetch, dispatch: dispatch, store: store })=>{
                dispatch({
                    type: $b7af012631134a8e$var$STARTED
                });
                let fetchPromise;
                if (update) fetchPromise = gqlFetch("mutation extendSession($testOnly_overrideTime:String){" + "extendSession(testOnly_overrideTime:$testOnly_overrideTime)".concat($b7af012631134a8e$var$sessionResponseSnippet, "}"), {
                    testOnly_overrideTime: $b7af012631134a8e$var$IS_CYPRESS ? Date.now().toString() : null
                }).then((res)=>res.data.extendSession);
                else fetchPromise = gqlFetch("{session".concat($b7af012631134a8e$var$sessionResponseSnippet, "}")).then((res)=>res.data.session);
                return fetchPromise.then((res)=>{
                    store.doReceiveSession(res);
                }).catch(()=>{
                    dispatch({
                        type: $b7af012631134a8e$var$FAILED,
                        payload: {
                            time: Date.now()
                        }
                    });
                });
            },
        doReceiveSession: (updatedSession)=>({ store: store, dispatch: dispatch })=>{
                const { token: token } = updatedSession, rest = $b7af012631134a8e$var$_objectWithoutProperties(updatedSession, [
                    "token"
                ]);
                if (token !== store.selectAuthToken()) store.doReceiveToken(token);
                 // this keeps the in alphabetical order then we don't have
                // to sort it on reads.
                if (rest.orgs && rest.orgs.length) rest.orgs.sort((a, b)=>a.id.localeCompare(b.id));
                dispatch({
                    type: $b7af012631134a8e$var$SESSION_RECEIVED,
                    payload: {
                        token: token,
                        data: rest
                    }
                });
            },
        selectSessionShouldRetryFailed: (0, $dRTL8.createSelector)("selectSessionLastExtendError", "selectAppTime", (lastExtendError, appTime)=>lastExtendError && appTime - lastExtendError > options.retryFailedFetchAfter),
        reactShouldExtendSession: (0, $dRTL8.createSelector)("selectIsSignedIn", "selectSessionData", "selectSessionRaw", "selectSessionShouldRetryFailed", "selectAppTime", ...options.selectorsThatDetermineActivity, (signedIn, data, raw, shouldRetryFailed, appTime, ...otherValues)=>{
            const { sessionRenewedAt: sessionRenewedAt } = data || {};
            const { loading: loading } = raw;
            const active = otherValues.some(Boolean);
            if (!signedIn || !active || !sessionRenewedAt || loading) return false;
            const sessionAge = appTime - Number(sessionRenewedAt);
            if (shouldRetryFailed || sessionAge > options.renewSessionWhenOlderThan) return {
                actionCreator: "doFetchSession",
                args: [
                    true
                ]
            };
        }),
        reactShouldFetchSession: (0, $dRTL8.createSelector)("selectShowUserLoading", "selectSessionRaw", "selectAuthToken", (userLoading, raw, authToken)=>{
            if (userLoading || raw.loading || !authToken) return;
            if (raw.token !== authToken) return {
                actionCreator: "doFetchSession"
            };
        })
    });
};
$b7af012631134a8e$exports.getSessionBundle = $b7af012631134a8e$var$getSessionBundle;


Object.keys($b7af012631134a8e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $b7af012631134a8e$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $b7af012631134a8e$exports[key];
        }
    });
});
var $b724e0b41c737c25$exports = {};
"use strict";
Object.defineProperty($b724e0b41c737c25$exports, "__esModule", {
    value: true
});
$b724e0b41c737c25$exports.appDayBundle = void 0;

var $dRTL8 = parcelRequire("dRTL8");

var $5MXnj = parcelRequire("5MXnj");
const $b724e0b41c737c25$var$appDayBundle = {
    name: "appDay",
    selectAppDateString: (0, $dRTL8.createSelector)("selectAppTime", $5MXnj.toSimpleISODateString),
    selectAppDayDate: (0, $dRTL8.createSelector)("selectAppDateString", (string)=>{
        const arr = string.split("-").map(Number);
        arr[1] = arr[1] - 1;
        return new Date(...arr);
    })
};
$b724e0b41c737c25$exports.appDayBundle = $b724e0b41c737c25$var$appDayBundle;


Object.keys($b724e0b41c737c25$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $b724e0b41c737c25$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $b724e0b41c737c25$exports[key];
        }
    });
});
var $a7a9a22faa9f98db$exports = {};
"use strict";
Object.defineProperty($a7a9a22faa9f98db$exports, "__esModule", {
    value: true
});
$a7a9a22faa9f98db$exports.presetsBaseBundle = $a7a9a22faa9f98db$exports.presetsSnippet = void 0;

const $a7a9a22faa9f98db$var$oralSedativesSnippet = "oralSedatives{id name unit dose route}";
const $a7a9a22faa9f98db$var$parenDrugsSnippet = "parenDrugs{id name unit draw dose route}";
const $a7a9a22faa9f98db$var$infusionDrugsSnippet = "infusionDrugs{id name dose unit bolusUnit}";
const $a7a9a22faa9f98db$var$base = [
    "enabled",
    $a7a9a22faa9f98db$var$oralSedativesSnippet
];
const $a7a9a22faa9f98db$var$presetsSnippet = (0, $561fbfb5381cff1a$exports.toGqlQuery)([
    "dischargeScoreType",
    "calculateDrugWaste",
    [
        "local",
        "enabled",
        "localDrugs{id dose epi name unit percent}"
    ],
    [
        "minimal",
        ...$a7a9a22faa9f98db$var$base
    ],
    [
        "moderate",
        ...$a7a9a22faa9f98db$var$base,
        $a7a9a22faa9f98db$var$parenDrugsSnippet,
        $a7a9a22faa9f98db$var$infusionDrugsSnippet
    ],
    [
        "deep",
        ...$a7a9a22faa9f98db$var$base,
        $a7a9a22faa9f98db$var$parenDrugsSnippet,
        $a7a9a22faa9f98db$var$infusionDrugsSnippet
    ],
    [
        "ga",
        ...$a7a9a22faa9f98db$var$base,
        $a7a9a22faa9f98db$var$parenDrugsSnippet,
        $a7a9a22faa9f98db$var$infusionDrugsSnippet
    ]
]);
$a7a9a22faa9f98db$exports.presetsSnippet = $a7a9a22faa9f98db$var$presetsSnippet;
const $a7a9a22faa9f98db$var$presetsBaseBundle = {
    name: "presets",
    doFetchPresetsForMemberRaw: (orgId, memberId)=>({ gqlFetch: gqlFetch })=>gqlFetch('{providerPresets(orgId:"'.concat(orgId, '",memberId:"').concat(memberId, '")').concat($a7a9a22faa9f98db$var$presetsSnippet, "}")).then((res)=>res.data.providerPresets),
    // deprecated, can delete once price tiers are shipped
    doFetchPresetsForCompositionRaw: (orgId, compositionId)=>({ gqlFetch: gqlFetch })=>gqlFetch('{providerPresetsForComposition(orgId:"'.concat(orgId, '",compositionId:"').concat(compositionId, '")').concat($a7a9a22faa9f98db$var$presetsSnippet, "}")).then((res)=>res.data.providerPresetsForComposition),
    doFetchPresetsAndLimitForComposition: (orgId, compositionId)=>({ gqlFetch: gqlFetch })=>gqlFetch("{" + 'providerPresetsForComposition(orgId:"'.concat(orgId, '",compositionId:"').concat(compositionId, '")').concat($a7a9a22faa9f98db$var$presetsSnippet) + 'org(orgId: "'.concat(orgId, '") {subscription {sedationLevelLimit}}') + "}").then((res)=>({
                    presets: res.data.providerPresetsForComposition,
                    sedationLevelLimit: res.data.org.subscription.sedationLevelLimit
                }))
};
$a7a9a22faa9f98db$exports.presetsBaseBundle = $a7a9a22faa9f98db$var$presetsBaseBundle;


Object.keys($a7a9a22faa9f98db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $a7a9a22faa9f98db$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $a7a9a22faa9f98db$exports[key];
        }
    });
});
var $cafd3bc11a100524$exports = {};
"use strict";
Object.defineProperty($cafd3bc11a100524$exports, "__esModule", {
    value: true
});
$cafd3bc11a100524$exports.referredByBundle = void 0;

var $dRTL8 = parcelRequire("dRTL8");

var $04wYO = parcelRequire("04wYO");
var $cb0b433b3296a8ca$exports = {};
"use strict";
Object.defineProperty($cb0b433b3296a8ca$exports, "__esModule", {
    value: true
});
$cb0b433b3296a8ca$exports.writeReferredBy = $cb0b433b3296a8ca$exports.deleteReferredBy = $cb0b433b3296a8ca$exports.getReferredBy = $cb0b433b3296a8ca$exports.REFERRAL_ID_NAME = void 0;

var $cb0b433b3296a8ca$var$_milliseconds = $cb0b433b3296a8ca$var$_interopRequireDefault((parcelRequire("6zzev")));

var $8q4hu = parcelRequire("8q4hu");
function $cb0b433b3296a8ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// @ts-check
const $cb0b433b3296a8ca$var$domain = globalThis.location && globalThis.location.hostname.split(".").slice(-2).join(".") || "xchart.com";
const $cb0b433b3296a8ca$var$REFERRAL_ID_NAME = "ref_id";
$cb0b433b3296a8ca$exports.REFERRAL_ID_NAME = $cb0b433b3296a8ca$var$REFERRAL_ID_NAME;
const $cb0b433b3296a8ca$var$getReferredBy = ()=>(0, $8q4hu.readCookie)($cb0b433b3296a8ca$var$REFERRAL_ID_NAME);
$cb0b433b3296a8ca$exports.getReferredBy = $cb0b433b3296a8ca$var$getReferredBy;
const $cb0b433b3296a8ca$var$deleteReferredBy = ()=>(0, $8q4hu.deleteCookie)($cb0b433b3296a8ca$var$REFERRAL_ID_NAME, $cb0b433b3296a8ca$var$domain);
$cb0b433b3296a8ca$exports.deleteReferredBy = $cb0b433b3296a8ca$var$deleteReferredBy;
const $cb0b433b3296a8ca$var$writeReferredBy = (str)=>{
    try {
        (0, $8q4hu.writeCookie)($cb0b433b3296a8ca$var$REFERRAL_ID_NAME, str, {
            maxAge: $cb0b433b3296a8ca$var$_milliseconds.default.years(10),
            domain: $cb0b433b3296a8ca$var$domain
        });
    } catch (e) {}
};
$cb0b433b3296a8ca$exports.writeReferredBy = $cb0b433b3296a8ca$var$writeReferredBy;


const $cafd3bc11a100524$var$referredByBundle = {
    name: "referredBy",
    selectReferredBy: $cb0b433b3296a8ca$exports.getReferredBy,
    reactStoreReferredBy: (0, $dRTL8.createSelector)("selectQueryObject", (queryObj)=>{
        if (queryObj && queryObj[$cb0b433b3296a8ca$exports.REFERRAL_ID_NAME]) {
            (0, $cb0b433b3296a8ca$exports.writeReferredBy)(queryObj[$cb0b433b3296a8ca$exports.REFERRAL_ID_NAME]);
            return {
                actionCreator: "doUpdateQuery",
                args: [
                    (0, $04wYO.omit)(queryObj, [
                        $cb0b433b3296a8ca$exports.REFERRAL_ID_NAME
                    ]),
                    {
                        maintainScrollPosition: true,
                        replace: true
                    }
                ]
            };
        }
    })
};
$cafd3bc11a100524$exports.referredByBundle = $cafd3bc11a100524$var$referredByBundle;


Object.keys($cafd3bc11a100524$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $cafd3bc11a100524$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $cafd3bc11a100524$exports[key];
        }
    });
});

var $bC6Tk = parcelRequire("bC6Tk");
Object.keys($bC6Tk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $bC6Tk[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $bC6Tk[key];
        }
    });
});

var $1dcfb6b13a3657f8$var$_getStyledComponent = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("45yGA")));
var $7b7cda9bab2078f3$exports = {};
"use strict";
Object.defineProperty($7b7cda9bab2078f3$exports, "__esModule", {
    value: true
});
$7b7cda9bab2078f3$exports.clearLocalStorage = $7b7cda9bab2078f3$exports.deleteLocalStorageItem = $7b7cda9bab2078f3$exports.getLocalStorageItem = $7b7cda9bab2078f3$exports.setLocalStorageItem = void 0;

var $7b7cda9bab2078f3$var$_tryit = $7b7cda9bab2078f3$var$_interopRequireDefault((parcelRequire("2TQb1")));
function $7b7cda9bab2078f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7b7cda9bab2078f3$var$setLocalStorageItem = (item, value)=>(0, $7b7cda9bab2078f3$var$_tryit.default)(()=>localStorage.setItem(item, value));
$7b7cda9bab2078f3$exports.setLocalStorageItem = $7b7cda9bab2078f3$var$setLocalStorageItem;
const $7b7cda9bab2078f3$var$getLocalStorageItem = (item)=>{
    let result;
    (0, $7b7cda9bab2078f3$var$_tryit.default)(()=>{
        result = localStorage.getItem(item);
    });
    return result;
};
$7b7cda9bab2078f3$exports.getLocalStorageItem = $7b7cda9bab2078f3$var$getLocalStorageItem;
const $7b7cda9bab2078f3$var$deleteLocalStorageItem = (item)=>(0, $7b7cda9bab2078f3$var$_tryit.default)(()=>delete localStorage[item]);
$7b7cda9bab2078f3$exports.deleteLocalStorageItem = $7b7cda9bab2078f3$var$deleteLocalStorageItem;
const $7b7cda9bab2078f3$var$clearLocalStorage = ()=>(0, $7b7cda9bab2078f3$var$_tryit.default)(()=>{
        const debug = localStorage.debug;
        localStorage.clear();
        if (debug) localStorage.debug = debug;
    });
$7b7cda9bab2078f3$exports.clearLocalStorage = $7b7cda9bab2078f3$var$clearLocalStorage;


Object.keys($7b7cda9bab2078f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $7b7cda9bab2078f3$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $7b7cda9bab2078f3$exports[key];
        }
    });
});

var $hP87r = parcelRequire("hP87r");
Object.keys($hP87r).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $hP87r[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $hP87r[key];
        }
    });
});

var $8q4hu = parcelRequire("8q4hu");
Object.keys($8q4hu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $8q4hu[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $8q4hu[key];
        }
    });
});
var $3b5bb7380472bd18$exports = {};
"use strict";
Object.defineProperty($3b5bb7380472bd18$exports, "__esModule", {
    value: true
});
$3b5bb7380472bd18$exports.createTokenWriter = void 0;

var $3b5bb7380472bd18$var$_milliseconds = $3b5bb7380472bd18$var$_interopRequireDefault((parcelRequire("6zzev")));

var $8q4hu = parcelRequire("8q4hu");
function $3b5bb7380472bd18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3b5bb7380472bd18$var$createTokenWriter = ({ name: name = "token", domain: domain })=>{
    const writeToken = (token)=>{
        (0, $8q4hu.writeCookie)(name, token, {
            maxAge: $3b5bb7380472bd18$var$_milliseconds.default.days(180),
            secure: true,
            domain: domain
        });
    };
    const readToken = ()=>(0, $8q4hu.readCookie)(name);
    const clearToken = ()=>(0, $8q4hu.deleteCookie)(name, domain);
    return {
        writeToken: writeToken,
        readToken: readToken,
        clearToken: clearToken
    };
};
$3b5bb7380472bd18$exports.createTokenWriter = $3b5bb7380472bd18$var$createTokenWriter;


Object.keys($3b5bb7380472bd18$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $3b5bb7380472bd18$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $3b5bb7380472bd18$exports[key];
        }
    });
});

Object.keys($17791e7335b36e48$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $17791e7335b36e48$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $17791e7335b36e48$exports[key];
        }
    });
});
var $1f22af9689e4c10e$exports = {};
"use strict";
Object.defineProperty($1f22af9689e4c10e$exports, "__esModule", {
    value: true
});
$1f22af9689e4c10e$exports.waitFor = void 0;
/**
 * @param {any} store
 * @param {string} selectorName
 * @param {{ timeout: number }} [opts]
 * @returns {Promise<void>}
 */ const $1f22af9689e4c10e$var$waitFor = (store, selectorName, { timeout: timeout } = {})=>new Promise((resolve, reject)=>{
        const conditionMatched = ()=>store[selectorName]();
        if (conditionMatched()) return resolve();
        let timerId;
        const unsubscribe = store.subscribeToSelectors([
            selectorName
        ], ()=>{
            if (conditionMatched()) {
                clearTimeout(timerId);
                unsubscribe();
                return resolve();
            }
        });
        if (timeout) timerId = setTimeout(()=>{
            // cleanup
            unsubscribe();
            reject(Error("TIMED_OUT"));
        }, timeout);
    });
$1f22af9689e4c10e$exports.waitFor = $1f22af9689e4c10e$var$waitFor;


Object.keys($1f22af9689e4c10e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $1f22af9689e4c10e$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $1f22af9689e4c10e$exports[key];
        }
    });
});

var $c0jHA = parcelRequire("c0jHA");
Object.keys($c0jHA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $c0jHA[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $c0jHA[key];
        }
    });
});
var $3b558c53aab14c60$exports = {};
"use strict";
Object.defineProperty($3b558c53aab14c60$exports, "__esModule", {
    value: true
});
$3b558c53aab14c60$exports.createTokenBundle = void 0;

var $dRTL8 = parcelRequire("dRTL8");

const $3b558c53aab14c60$var$UPDATED = "TOKEN_UPDATED";
const $3b558c53aab14c60$var$CLEARED = "TOKEN_CLEARED";
const $3b558c53aab14c60$var$cookieReadInterval = 10000;
const $3b558c53aab14c60$var$getTokenFromHash = ()=>location.hash.split("token=")[1] || null;
const $3b558c53aab14c60$var$createTokenBundle = (opts)=>{
    const { readToken: readToken, writeToken: writeToken, clearToken: clearToken } = (0, $3b5bb7380472bd18$exports.createTokenWriter)(opts);
    return {
        name: "token",
        getReducer: ()=>{
            let token = readToken();
            if (token === "null") token = null;
            if (!token) {
                const fromHash = $3b558c53aab14c60$var$getTokenFromHash();
                if (fromHash) {
                    token = fromHash;
                    writeToken(token);
                }
            }
            const initial = {
                token: token
            };
            return (state = initial, { type: type, payload: payload })=>{
                if (type === $3b558c53aab14c60$var$UPDATED) return Object.assign({}, state, {
                    token: payload
                });
                if (type === $3b558c53aab14c60$var$CLEARED) return Object.assign({}, state, {
                    token: null
                });
                return state;
            };
        },
        init: (store)=>{
            if ($dRTL8.IS_BROWSER) {
                const read = ()=>{
                    store.doUpdateTokenFromCookie();
                    setTimeout(()=>(0, $dRTL8.ric)(read), $3b558c53aab14c60$var$cookieReadInterval);
                };
                setTimeout(read, $3b558c53aab14c60$var$cookieReadInterval);
            }
        },
        selectAuthToken: (state)=>state.token.token,
        selectHasAuthToken: (state)=>!!state.token.token,
        doReceiveToken: (token)=>({ dispatch: dispatch, store: store })=>{
                if (token === "null" || !token) return store.doClearToken();
                else {
                    writeToken(token);
                    dispatch({
                        type: $3b558c53aab14c60$var$UPDATED,
                        payload: token
                    });
                }
            },
        doClearToken: ()=>({ dispatch: dispatch })=>{
                clearToken();
                dispatch({
                    type: $3b558c53aab14c60$var$CLEARED
                });
            },
        doUpdateTokenFromCookie: ()=>({ store: store })=>{
                const token = readToken();
                if (token !== store.selectAuthToken()) store.doReceiveToken(token);
            }
    };
};
$3b558c53aab14c60$exports.createTokenBundle = $3b558c53aab14c60$var$createTokenBundle;


Object.keys($3b558c53aab14c60$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $3b558c53aab14c60$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $3b558c53aab14c60$exports[key];
        }
    });
});
var $fcdede7fab8e6356$exports = {};
"use strict";
Object.defineProperty($fcdede7fab8e6356$exports, "__esModule", {
    value: true
});
$fcdede7fab8e6356$exports.CopyButton = void 0;

var $767w7 = parcelRequire("767w7");

var $9YtMX = parcelRequire("9YtMX");
function $fcdede7fab8e6356$var$_extends() {
    $fcdede7fab8e6356$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fcdede7fab8e6356$var$_extends.apply(this, arguments);
}
function $fcdede7fab8e6356$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fcdede7fab8e6356$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fcdede7fab8e6356$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
class $fcdede7fab8e6356$var$CopyButton extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = {
            copying: false,
            copied: false,
            error: false
        };
    }
    render(_ref, { copying: copying, copied: copied, error: error }) {
        let { text: text, buttonText: buttonText = "Copy to clipboard" } = _ref, rest = $fcdede7fab8e6356$var$_objectWithoutProperties(_ref, [
            "text",
            "buttonText"
        ]);
        if (!navigator.clipboard || !navigator.clipboard.writeText) return null;
        return (0, $767w7.h)($9YtMX.Button, $fcdede7fab8e6356$var$_extends({
            disabled: copying || copied || rest.disabled,
            onClick: ()=>{
                this.setState({
                    copying: true
                });
                navigator.clipboard.writeText(text).then(()=>{
                    this.setState({
                        copying: false,
                        copied: true
                    });
                    setTimeout(()=>{
                        this.setState({
                            copied: false,
                            copying: false
                        });
                    }, 1000);
                }).catch(()=>{
                    this.setState({
                        copying: false,
                        copied: false,
                        error: "failed to copy"
                    });
                });
            }
        }, rest), error && "Failed to copy, try again", !copying && !copied && buttonText, copied && "Copied!", copying && "Copying...");
    }
}
$fcdede7fab8e6356$exports.CopyButton = $fcdede7fab8e6356$var$CopyButton;


Object.keys($fcdede7fab8e6356$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $fcdede7fab8e6356$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $fcdede7fab8e6356$exports[key];
        }
    });
});
var $6dd1c893f22e506e$exports = {};
"use strict";
Object.defineProperty($6dd1c893f22e506e$exports, "__esModule", {
    value: true
});
$6dd1c893f22e506e$exports.CopyInput = void 0;

var $767w7 = parcelRequire("767w7");
function $6dd1c893f22e506e$var$_extends() {
    $6dd1c893f22e506e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6dd1c893f22e506e$var$_extends.apply(this, arguments);
}
function $6dd1c893f22e506e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6dd1c893f22e506e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6dd1c893f22e506e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
class $6dd1c893f22e506e$var$CopyInput extends $767w7.Component {
    constructor(props){
        super(props);
        this.onFocus = this.onFocus.bind(this);
    }
    onFocus() {
        this.base && this.base.select();
    }
    render(_ref) {
        let { value: value } = _ref, rest = $6dd1c893f22e506e$var$_objectWithoutProperties(_ref, [
            "value"
        ]);
        return (0, $767w7.h)("input", $6dd1c893f22e506e$var$_extends({
            value: value
        }, rest, {
            onFocus: this.onFocus
        }));
    }
}
$6dd1c893f22e506e$exports.CopyInput = $6dd1c893f22e506e$var$CopyInput;


Object.keys($6dd1c893f22e506e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $6dd1c893f22e506e$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $6dd1c893f22e506e$exports[key];
        }
    });
});

Object.keys($b66e621e1478540c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $b66e621e1478540c$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $b66e621e1478540c$exports[key];
        }
    });
});
var $6ddebd7a9eb4070d$exports = {};
"use strict";
Object.defineProperty($6ddebd7a9eb4070d$exports, "__esModule", {
    value: true
});
$6ddebd7a9eb4070d$exports.layoutUiBundle = void 0;
const $6ddebd7a9eb4070d$var$DRAWER_OPENED = "DRAWER_OPENED";
const $6ddebd7a9eb4070d$var$DRAWER_CLOSED = "DRAWER_CLOSED";
const $6ddebd7a9eb4070d$var$layoutUiBundle = {
    name: "layoutUi",
    reducer: (state = {
        drawerOpen: false,
        beeping: null
    }, { type: type })=>{
        if (type === $6ddebd7a9eb4070d$var$DRAWER_OPENED) return Object.assign({}, state, {
            drawerOpen: true
        });
        if (type === $6ddebd7a9eb4070d$var$DRAWER_CLOSED) return Object.assign({}, state, {
            drawerOpen: false
        });
        return state;
    },
    selectDrawerIsOpen: (state)=>state.layoutUi.drawerOpen,
    doOpenDrawer: ()=>({
            type: $6ddebd7a9eb4070d$var$DRAWER_OPENED
        }),
    doCloseDrawer: ()=>({
            type: $6ddebd7a9eb4070d$var$DRAWER_CLOSED
        })
};
$6ddebd7a9eb4070d$exports.layoutUiBundle = $6ddebd7a9eb4070d$var$layoutUiBundle;


Object.keys($6ddebd7a9eb4070d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $6ddebd7a9eb4070d$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $6ddebd7a9eb4070d$exports[key];
        }
    });
});
var $a4da0a4cc0b66e44$exports = {};
"use strict";
Object.defineProperty($a4da0a4cc0b66e44$exports, "__esModule", {
    value: true
});
$a4da0a4cc0b66e44$exports.tabIdBundle = void 0;

var $e7EYC = parcelRequire("e7EYC");
// used to track subscriptions
const $a4da0a4cc0b66e44$var$tabId = (0, $e7EYC.uuid)();
const $a4da0a4cc0b66e44$var$tabIdBundle = {
    name: "tabId",
    selectTabId: ()=>$a4da0a4cc0b66e44$var$tabId
};
$a4da0a4cc0b66e44$exports.tabIdBundle = $a4da0a4cc0b66e44$var$tabIdBundle;


Object.keys($a4da0a4cc0b66e44$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $a4da0a4cc0b66e44$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $a4da0a4cc0b66e44$exports[key];
        }
    });
});

var $6nGUz = parcelRequire("6nGUz");
Object.keys($6nGUz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $6nGUz[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $6nGUz[key];
        }
    });
});

var $jFHOZ = parcelRequire("jFHOZ");
Object.keys($jFHOZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $jFHOZ[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $jFHOZ[key];
        }
    });
});
var $1b38ddf0550accb5$exports = {};
"use strict";
Object.defineProperty($1b38ddf0550accb5$exports, "__esModule", {
    value: true
});
$1b38ddf0550accb5$exports.TriggerWaitingComponent = void 0;

var $767w7 = parcelRequire("767w7");
function $1b38ddf0550accb5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b38ddf0550accb5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1b38ddf0550accb5$var$ownKeys(Object(source), true).forEach(function(key) {
            $1b38ddf0550accb5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1b38ddf0550accb5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1b38ddf0550accb5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b38ddf0550accb5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1b38ddf0550accb5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1b38ddf0550accb5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $1b38ddf0550accb5$var$TriggerWaitingComponent = class extends $767w7.Component {
    constructor(props){
        super(props);
        this.trigger = ()=>{
            this.setState({
                waiting: true
            });
            setTimeout(()=>{
                this.setState({
                    waiting: false
                });
            }, this.props.waitTime || 1000);
        };
    }
    render() {
        // eslint-disable-next-line no-unused-vars
        const _this$props = this.props, { onClick: onClick, render: render, pause: pause } = _this$props, rest = $1b38ddf0550accb5$var$_objectWithoutProperties(_this$props, [
            "onClick",
            "render",
            "pause"
        ]);
        return render($1b38ddf0550accb5$var$_objectSpread($1b38ddf0550accb5$var$_objectSpread($1b38ddf0550accb5$var$_objectSpread({}, rest), this.state), {}, {
            trigger: this.trigger
        }));
    }
};
$1b38ddf0550accb5$exports.TriggerWaitingComponent = $1b38ddf0550accb5$var$TriggerWaitingComponent;


Object.keys($1b38ddf0550accb5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $1b38ddf0550accb5$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $1b38ddf0550accb5$exports[key];
        }
    });
});

var $1dcfb6b13a3657f8$var$_form = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("RzImO")));
var $fdcdd8b59f8f6297$exports = {};
"use strict";
Object.defineProperty($fdcdd8b59f8f6297$exports, "__esModule", {
    value: true
});
$fdcdd8b59f8f6297$exports.Tabs = void 0;

var $767w7 = parcelRequire("767w7");

var $fdcdd8b59f8f6297$var$_classnames = $fdcdd8b59f8f6297$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7Dcmj = parcelRequire("7Dcmj");
function $fdcdd8b59f8f6297$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $fdcdd8b59f8f6297$var$Tabs extends $767w7.Component {
    constructor(props){
        super(props);
        this.handleResize = ()=>this.measureActive();
    }
    measureActive() {
        const { vertical: vertical, padding: padding = 4 } = this.props;
        const activeEl = this.base ? this.base.querySelector("[data-active]") : null;
        if (activeEl) {
            const bg = this.base.querySelector(".bg");
            const left = activeEl.offsetLeft;
            const height = activeEl.offsetHeight;
            const width = activeEl.offsetWidth;
            const top = activeEl.offsetTop;
            bg.style = "transform: translateX(".concat((vertical ? 0 : left) + padding, "px) translateY(").concat(top + padding, "px); width: ").concat((vertical ? this.base.offsetWidth : width) - padding * 2, "px; height: ").concat(height - padding * 2, "px"); // debugger
        }
    }
    componentDidUpdate() {
        this.measureActive();
    }
    componentDidMount() {
        this.measureActive();
        window.addEventListener("resize", this.handleResize, {
            passive: true
        });
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize, {
            passive: true
        });
    }
    render() {
        const { tabs: tabs, updateSelectedTab: updateSelectedTab, className: className, vertical: vertical, activeClasses: activeClasses = "bg-lightest-blue", tabTextCenter: tabTextCenter, style: style } = this.props;
        return (0, $767w7.h)("nav", {
            className: (0, $fdcdd8b59f8f6297$var$_classnames.default)("br2 relative", {
                "flex items-center flex-wrap": !vertical
            }, className),
            style: style
        }, (0, $767w7.h)("div", {
            key: "same",
            className: (0, $fdcdd8b59f8f6297$var$_classnames.default)("bg absolute top-0 left-0 transition-all br2 bg w-auto", activeClasses)
        }), tabs.map(({ label: label, name: name, active: active, icon: icon, iconColor: iconColor = "black", textColor: textColor = "black" })=>(0, $767w7.h)("div", {
                className: "relative",
                "data-active": active,
                key: name
            }, (0, $767w7.h)("a", {
                "data-e2e": "tab".concat(name),
                className: (0, $fdcdd8b59f8f6297$var$_classnames.default)("flex no-underline items-center pa3 hover-blue", textColor, {
                    underline: !active,
                    "no-underline": active,
                    "w-100 db": vertical,
                    "justify-center": tabTextCenter
                }),
                href: "#",
                onClick: (e)=>{
                    e.preventDefault();
                    updateSelectedTab(name);
                }
            }, icon && (0, $767w7.h)($7Dcmj.Icon, {
                size: "20",
                className: (0, $fdcdd8b59f8f6297$var$_classnames.default)("mr2", iconColor),
                icon: icon
            }), (0, $767w7.h)("span", {
                className: (0, $fdcdd8b59f8f6297$var$_classnames.default)(!active && "underline")
            }, label)))));
    }
}
$fdcdd8b59f8f6297$exports.Tabs = $fdcdd8b59f8f6297$var$Tabs;


Object.keys($fdcdd8b59f8f6297$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $fdcdd8b59f8f6297$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $fdcdd8b59f8f6297$exports[key];
        }
    });
});

var $1dcfb6b13a3657f8$var$_progress = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("4VWTb")));

var $1dcfb6b13a3657f8$var$_getOrgEventSourceBundle = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("5T3EV")));

var $aeAE3 = parcelRequire("aeAE3");
Object.keys($aeAE3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $aeAE3[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $aeAE3[key];
        }
    });
});

Object.keys($8846264bcad4f7cd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $8846264bcad4f7cd$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $8846264bcad4f7cd$exports[key];
        }
    });
});

var $7EOve = parcelRequire("7EOve");
Object.keys($7EOve).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $7EOve[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $7EOve[key];
        }
    });
});

var $fiq2I = parcelRequire("fiq2I");
Object.keys($fiq2I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $fiq2I[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $fiq2I[key];
        }
    });
});

var $04wYO = parcelRequire("04wYO");
Object.keys($04wYO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $04wYO[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $04wYO[key];
        }
    });
});

var $bWREg = parcelRequire("bWREg");
Object.keys($bWREg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $bWREg[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $bWREg[key];
        }
    });
});
var $f6b193d7b7356773$exports = {};
"use strict";
Object.defineProperty($f6b193d7b7356773$exports, "__esModule", {
    value: true
});
$f6b193d7b7356773$exports.getApiFetch = void 0;

var $f6b193d7b7356773$var$_handleHttpResponse = $f6b193d7b7356773$var$_interopRequireDefault((parcelRequire("4AH5e")));
function $f6b193d7b7356773$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6b193d7b7356773$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f6b193d7b7356773$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f6b193d7b7356773$var$ownKeys(Object(source), true).forEach(function(key) {
            $f6b193d7b7356773$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f6b193d7b7356773$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f6b193d7b7356773$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Get a configured fetcher for API requests
 *
 * @param {{
 *   apiUrl: string
 *   getToken: () => string
 *   handleNotAuthorized: () => any
 *   handleNoAuthentication: () => any
 * }} spec
 * @returns {(pathname: string, opts?: RequestInit) => Promise}
 */ const $f6b193d7b7356773$var$getApiFetch = (spec)=>(url, options = {})=>{
        const { apiUrl: apiUrl, getToken: getToken, handleNoAuthentication: handleNoAuthentication, handleNotAuthorized: handleNotAuthorized } = spec;
        const [path, passedQs] = url.split("?");
        const searchParams = new URLSearchParams(passedQs || "");
        searchParams.append("token", getToken());
        return fetch(apiUrl + path + "?" + searchParams.toString(), {
            method: options.method || "get",
            headers: $f6b193d7b7356773$var$_objectSpread({
                "content-type": "application/json"
            }, options.headers),
            body: options.body
        }).then((res)=>{
            (0, $f6b193d7b7356773$var$_handleHttpResponse.default)(res.status, {
                handleNoAuthentication: handleNoAuthentication,
                handleNotAuthorized: handleNotAuthorized
            });
            return res.json();
        });
    };
$f6b193d7b7356773$exports.getApiFetch = $f6b193d7b7356773$var$getApiFetch;


Object.keys($f6b193d7b7356773$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $f6b193d7b7356773$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $f6b193d7b7356773$exports[key];
        }
    });
});
var $85a96f2795db49dc$exports = {};
"use strict";
Object.defineProperty($85a96f2795db49dc$exports, "__esModule", {
    value: true
});
$85a96f2795db49dc$exports.getFhirFetch = void 0;

var $85a96f2795db49dc$var$_handleHttpResponse = $85a96f2795db49dc$var$_interopRequireDefault((parcelRequire("4AH5e")));

var $04wYO = parcelRequire("04wYO");
function $85a96f2795db49dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// @ts-check
/** @typedef {'NO_AUTH' | 'NO_USER'} BadAuthStatus */ /**
 * Get a configured fetcher for FHIR requests
 *
 * @param {{
 *   apiUrl: string
 *   getToken: () => string
 *   getOrgId: () => string
 *   handleNotAuthorized: () => any
 *   handleNoAuthentication: () => any
 * }} options
 * @returns {(
 *   pathname: string,
 *   opts?: {
 *     orgId?: string
 *     fetchAll?: boolean
 *     waitForAll?: boolean
 *     incomingResponseArrayHandler?: (res) => Promise<any>
 *   }
 * ) => Promise<any>}
 *   Opts
 */ const $85a96f2795db49dc$var$getFhirFetch = (options)=>{
    const { getToken: getToken, getOrgId: getOrgId, apiUrl: apiUrl, handleNoAuthentication: handleNoAuthentication, handleNotAuthorized: handleNotAuthorized } = options;
    const buildUrlWithToken = (url, orgId)=>{
        const [pathname, query] = url.split("?");
        const tokenAddon = "token=".concat(getToken());
        const modifiedQueryString = query ? "".concat(query, "&").concat(tokenAddon) : tokenAddon;
        const base = "".concat(apiUrl, "/fhir/").concat(orgId);
        return "".concat(base).concat(pathname, "?").concat(modifiedQueryString);
    };
    const parseResponse = (res)=>{
        (0, $85a96f2795db49dc$var$_handleHttpResponse.default)(res.status, {
            handleNoAuthentication: handleNoAuthentication,
            handleNotAuthorized: handleNotAuthorized
        });
        return res.json();
    };
    const getNextUrl = (response)=>{
        const nextLink = response.link && response.link.find((link)=>link.relation === "next");
        if (nextLink) return "/" + nextLink.url.split("/").slice(13).join("/");
    };
    return (relative, opts = {})=>{
        const orgId = opts.orgId || getOrgId();
        const fetchAll = !!opts.fetchAll;
        const waitForAll = !!opts.waitForAll;
        const incomingResponseArrayHandler = opts.incomingResponseArrayHandler;
        if (!orgId) throw Error("NO_ORG_ID");
        const fetchOptions = (0, $04wYO.omit)(opts, [
            "orgId",
            "fetchAll"
        ]);
        const responseArray = [];
        const fetchNext = (startingUrl)=>fetch(buildUrlWithToken(startingUrl, orgId), fetchOptions).then(parseResponse).then((response)=>{
                const nextUrl = fetchAll ? getNextUrl(response) : null;
                if (!waitForAll && incomingResponseArrayHandler) incomingResponseArrayHandler([
                    response
                ]);
                if (waitForAll) responseArray.push(response);
                if (nextUrl) {
                    if (!waitForAll) // if we got  we don't wait to resolve, we
                    // just let it keep going and keep fetching
                    fetchNext(nextUrl);
                    else return fetchNext(nextUrl);
                }
                if (waitForAll) return incomingResponseArrayHandler ? incomingResponseArrayHandler(responseArray) : responseArray;
                else return incomingResponseArrayHandler ? incomingResponseArrayHandler([
                    response
                ]) : response;
            });
        return fetchNext(relative);
    };
};
$85a96f2795db49dc$exports.getFhirFetch = $85a96f2795db49dc$var$getFhirFetch;


Object.keys($85a96f2795db49dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $85a96f2795db49dc$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $85a96f2795db49dc$exports[key];
        }
    });
});
var $f200382e68afad9a$exports = {};
"use strict";
Object.defineProperty($f200382e68afad9a$exports, "__esModule", {
    value: true
});
$f200382e68afad9a$exports.getGqlFetch = void 0;
// @ts-check
const $f200382e68afad9a$var$defaults = {
    getToken: ()=>null
};
/**
 * @param {{
 *   apiUrl: string
 *   getToken: () => string
 *   handleNotAuthorized: () => any
 *   handleNoAuthentication: () => any
 * }} options
 * @returns {(query: string, variables?: any) => Promise}
 */ const $f200382e68afad9a$var$getGqlFetch = (options)=>(query, variables = null)=>{
        const opts = Object.assign({}, $f200382e68afad9a$var$defaults, options);
        const token = opts.getToken();
        const encodedQuery = encodeURIComponent(query.trim());
        const tokenQuery = token ? "&token=".concat(token) : "";
        return fetch("".concat(opts.apiUrl, "/graphql?query=").concat(encodedQuery).concat(tokenQuery), {
            method: "post",
            body: variables ? JSON.stringify({
                variables: variables
            }) : null,
            headers: variables ? {
                "content-type": "application/json"
            } : {}
        }).then((response)=>response.json()).then((parsed)=>{
            if (parsed.errors) {
                parsed.errors.forEach((error)=>{
                    if (error.message === "NO_AUTHENTICATION") opts.handleNoAuthentication();
                    if (error.message === "NOT_AUTHORIZED") opts.handleNotAuthorized();
                });
                throw parsed.errors;
            }
            return parsed;
        });
    };
$f200382e68afad9a$exports.getGqlFetch = $f200382e68afad9a$var$getGqlFetch;


Object.keys($f200382e68afad9a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $f200382e68afad9a$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $f200382e68afad9a$exports[key];
        }
    });
});

Object.keys($561fbfb5381cff1a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $561fbfb5381cff1a$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $561fbfb5381cff1a$exports[key];
        }
    });
});

var $kRHng = parcelRequire("kRHng");
Object.keys($kRHng).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $kRHng[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $kRHng[key];
        }
    });
});
var $d51bda8984983eec$exports = {};
"use strict";
Object.defineProperty($d51bda8984983eec$exports, "__esModule", {
    value: true
});
$d51bda8984983eec$exports.formatSedationLevel = void 0;
const $d51bda8984983eec$var$nameMap = {
    minimal: "Minimal",
    moderate: "Moderate",
    deep: "Deep",
    ga: "GA"
};
const $d51bda8984983eec$var$formatSedationLevel = (sedationLevel)=>$d51bda8984983eec$var$nameMap[sedationLevel] || "(not set)";
$d51bda8984983eec$exports.formatSedationLevel = $d51bda8984983eec$var$formatSedationLevel;


Object.keys($d51bda8984983eec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $d51bda8984983eec$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $d51bda8984983eec$exports[key];
        }
    });
});
var $1c32162f116f7fc2$exports = {};
"use strict";
Object.defineProperty($1c32162f116f7fc2$exports, "__esModule", {
    value: true
});
$1c32162f116f7fc2$exports.localAnestheticVariantsList = $1c32162f116f7fc2$exports.getLocalVariantLabel = $1c32162f116f7fc2$exports.getLocalVariantSubName = void 0;

var $1c32162f116f7fc2$var$_milliseconds = $1c32162f116f7fc2$var$_interopRequireDefault((parcelRequire("6zzev")));

var $04wYO = parcelRequire("04wYO");
var $ef7319b3136ffa92$exports = {};
"use strict";
Object.defineProperty($ef7319b3136ffa92$exports, "__esModule", {
    value: true
});
$ef7319b3136ffa92$exports.formatEpi = void 0;
var $c5f2a3adb5018c21$exports = {};
"use strict";
Object.defineProperty($c5f2a3adb5018c21$exports, "__esModule", {
    value: true
});
$c5f2a3adb5018c21$exports.addCommas = void 0;

var $fiq2I = parcelRequire("fiq2I");
const $c5f2a3adb5018c21$var$addCommas = (input)=>{
    const string = (0, $fiq2I.toNumber)(input).toString() || "";
    const [beforeDecimal, afterDecimal] = string.split(".");
    if (beforeDecimal.length <= 3) return string + (afterDecimal ? ".".concat(afterDecimal) : "");
    const reversed = beforeDecimal.split("").reverse();
    let result = "";
    reversed.forEach((number, index)=>{
        const mod = index % 3;
        if (index && !mod) result = number + "," + result;
        else result = number + result;
    });
    return result + (afterDecimal ? ".".concat(afterDecimal) : "");
};
$c5f2a3adb5018c21$exports.addCommas = $c5f2a3adb5018c21$var$addCommas;


const $ef7319b3136ffa92$var$formatEpi = (number)=>number == 0 ? "(no epi)" : "1:".concat((0, $c5f2a3adb5018c21$exports.addCommas)(Math.round(number * 1000)), " epi");
$ef7319b3136ffa92$exports.formatEpi = $ef7319b3136ffa92$var$formatEpi;


var $6b7f7002be78f39d$exports = {};
"use strict";
Object.defineProperty($6b7f7002be78f39d$exports, "__esModule", {
    value: true
});
$6b7f7002be78f39d$exports.formatPercent = void 0;

var $luEbf = parcelRequire("luEbf");
const $6b7f7002be78f39d$var$formatPercent = (number, precision)=>"".concat((0, $luEbf.roundToDecimal)(number * 100, typeof precision === "number" ? precision : 2), "%");
$6b7f7002be78f39d$exports.formatPercent = $6b7f7002be78f39d$var$formatPercent;


function $1c32162f116f7fc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c32162f116f7fc2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c32162f116f7fc2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c32162f116f7fc2$var$ownKeys(Object(source), true).forEach(function(key) {
            $1c32162f116f7fc2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c32162f116f7fc2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c32162f116f7fc2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $1c32162f116f7fc2$var$localAnestheticListAsArray = [
    {
        id: "142440",
        name: "Lidocaine",
        brandName: "Xylocaine",
        percent: 0.02,
        halfLife: $1c32162f116f7fc2$var$_milliseconds.default.minutes(120),
        input: "cartridges",
        variants: [
            {
                id: "142440|0",
                epi: 0,
                color: "#5A77AC",
                manAbsoluteMax: 300,
                manRatioMax: 4.5
            },
            {
                id: "142440|1",
                epi: 50,
                color: "#007D59",
                manAbsoluteMax: 500,
                manRatioMax: 7,
                aapdAbsoluteMax: 300,
                aapdRatioMax: 4.4
            },
            {
                id: "142440|2",
                epi: 100,
                color: "#FB0019",
                manAbsoluteMax: 500,
                manRatioMax: 7,
                aapdAbsoluteMax: 300,
                aapdRatioMax: 4.4
            }
        ]
    },
    {
        id: "2117",
        name: "Articaine",
        brandName: "Septocaine",
        percent: 0.04,
        halfLife: $1c32162f116f7fc2$var$_milliseconds.default.minutes(44.4),
        input: "cartridges",
        variants: [
            {
                id: "2117|0",
                epi: 100,
                color: "#B28768",
                manAbsoluteMax: null,
                manRatioMax: 7,
                aapdAbsoluteMax: 500,
                aapdRatioMax: 7,
                minAge: 5,
                enableDilute: true,
                ageWarning: "Manufacturer recommends not using on patients 4 and under."
            },
            {
                id: "2117|1",
                epi: 200,
                color: "#807772",
                manAbsoluteMax: null,
                manRatioMax: 7,
                aapdAbsoluteMax: 500,
                aapdRatioMax: 7,
                minAge: 5,
                enableDilute: true,
                ageWarning: "Manufacturer recommends not using on patients 4 and under."
            }
        ]
    },
    {
        id: "267396",
        name: "Bupivacaine",
        brandName: "Marcaine",
        percent: 0.005,
        halfLife: $1c32162f116f7fc2$var$_milliseconds.default.hours(3.5),
        nameForChart: "0.5% Bupiv.",
        input: "cartridges",
        variants: [
            {
                id: "267396|0",
                epi: 200,
                color: "#2063A1",
                manAbsoluteMax: 90,
                manRatioMax: 7,
                minAge: 13,
                enableDilute: true,
                ageWarning: "Extra caution advised for pediatric patients."
            }
        ]
    },
    {
        id: "2557",
        name: "Prilocaine",
        brandName: "Citanest",
        percent: 0.04,
        halfLife: $1c32162f116f7fc2$var$_milliseconds.default.hours(1.6),
        input: "cartridges",
        variants: [
            {
                id: "2557|0",
                epi: 200,
                color: "#FFE95E",
                manAbsoluteMax: 600,
                manRatioMax: 8,
                aapdAbsoluteMax: 400,
                aapdRatioMax: 6
            },
            {
                id: "2557|1",
                epi: 0,
                color: "#2B251F",
                manAbsoluteMax: 600,
                manRatioMax: 8,
                aapdAbsoluteMax: 300,
                aapdRatioMax: 6
            }
        ]
    },
    {
        id: "203185",
        name: "Mepivacaine",
        brandName: "Carbocaine",
        percent: 0.03,
        halfLife: $1c32162f116f7fc2$var$_milliseconds.default.hours(1.9),
        input: "cartridges",
        variants: [
            {
                id: "203185|0",
                color: "#EFC09B",
                manAbsoluteMax: 400,
                manRatioMax: 6.6,
                aapdAbsoluteMax: 300,
                aapdRatioMax: 4.4
            },
            {
                id: "700826|0",
                drugIdOverride: "700826",
                subName: "1:20,000 Levonordefrin",
                nameForChart: "Mepivacaine",
                unitForChart: "Levonordefrin",
                percent: 0.02,
                color: "#874C41",
                manAbsoluteMax: 400,
                manRatioMax: 6.6,
                aapdAbsoluteMax: 300,
                aapdRatioMax: 4.4
            }
        ]
    },
    {
        id: "1726513",
        name: "Exparel\u2122",
        altName: "Bupivacaine liposome susp.",
        reminder: "Never to be injected within 20 minutes of any other kind of non-Bupivacaine local anesthetic, nor is any other local anesthetic to be given 96 hours after Exparel.",
        percent: 0.0133,
        halfLife: $1c32162f116f7fc2$var$_milliseconds.default.hours(24),
        input: "mg",
        variants: [
            {
                id: "1726513|0",
                color: "#044F56",
                minAge: 18,
                ageWarning: "FDA approved for 18+ only."
            }
        ]
    },
    {
        id: "1856568",
        name: "OraVerse\u2122",
        altName: "Phentolamine Mesylate",
        reminder: "Should only follow local anesthetics that contain a vasoconstrictor.",
        percent: 0.4 / 1.7 / 1000,
        input: "cartridges",
        variants: [
            {
                id: "1856568|0",
                subName: "0.4 mg/1.7 mL",
                color: "#B2EB87",
                minAge: 3,
                noEpiWarning: "No doses with epinepherine have been recorded. Should only be given after locals with a vasoconstrictor.",
                ageWarning: "The safety and efficacy of Phentolamine Mesylate has not been established in patients younger than 3 years.",
                // very important!
                skipForToxicity: true
            }
        ]
    }
];
const $1c32162f116f7fc2$var$getLocalVariantSubName = (variant)=>{
    if (variant.subName) return variant.subName;
    if (variant.epi != null) {
        if (typeof variant.epi === "number") return (0, $ef7319b3136ffa92$exports.formatEpi)(variant.epi);
        return "(no epi)";
    }
};
$1c32162f116f7fc2$exports.getLocalVariantSubName = $1c32162f116f7fc2$var$getLocalVariantSubName;
const $1c32162f116f7fc2$var$getLocalVariantLabel = (variant)=>{
    let fullVariantName = "".concat(variant.name).concat(variant.subName ? " " + variant.subName : "");
    if (variant.percent) fullVariantName = "".concat((0, $6b7f7002be78f39d$exports.formatPercent)(variant.percent), " ").concat(fullVariantName);
    return fullVariantName;
};
$1c32162f116f7fc2$exports.getLocalVariantLabel = $1c32162f116f7fc2$var$getLocalVariantLabel;
const $1c32162f116f7fc2$var$variantDefaults = {
    epi: 0
};
const $1c32162f116f7fc2$var$localAnestheticVariantsList = $1c32162f116f7fc2$var$localAnestheticListAsArray.reduce((result, drug)=>{
    drug.variants.forEach((variant)=>{
        result.push($1c32162f116f7fc2$var$_objectSpread($1c32162f116f7fc2$var$_objectSpread($1c32162f116f7fc2$var$_objectSpread($1c32162f116f7fc2$var$_objectSpread({}, (0, $04wYO.omit)(drug, [
            "variants"
        ])), {}, {
            rxcui: drug.id
        }, $1c32162f116f7fc2$var$variantDefaults), variant), {}, {
            subName: $1c32162f116f7fc2$var$getLocalVariantSubName(variant)
        }));
    });
    return result;
}, []);
$1c32162f116f7fc2$exports.localAnestheticVariantsList = $1c32162f116f7fc2$var$localAnestheticVariantsList;


Object.keys($1c32162f116f7fc2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $1c32162f116f7fc2$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $1c32162f116f7fc2$exports[key];
        }
    });
});

var $9UfIw = parcelRequire("9UfIw");
Object.keys($9UfIw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $9UfIw[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $9UfIw[key];
        }
    });
});

Object.keys($c5f2a3adb5018c21$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $c5f2a3adb5018c21$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $c5f2a3adb5018c21$exports[key];
        }
    });
});

Object.keys($ef7319b3136ffa92$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $ef7319b3136ffa92$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $ef7319b3136ffa92$exports[key];
        }
    });
});

Object.keys($6b7f7002be78f39d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $6b7f7002be78f39d$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $6b7f7002be78f39d$exports[key];
        }
    });
});

var $luEbf = parcelRequire("luEbf");
Object.keys($luEbf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $luEbf[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $luEbf[key];
        }
    });
});

var $5MXnj = parcelRequire("5MXnj");
Object.keys($5MXnj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $5MXnj[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $5MXnj[key];
        }
    });
});

var $e7EYC = parcelRequire("e7EYC");
Object.keys($e7EYC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $e7EYC[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $e7EYC[key];
        }
    });
});

var $inFKE = parcelRequire("inFKE");
Object.keys($inFKE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $inFKE[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $inFKE[key];
        }
    });
});
var $5a7057912cdd9ed0$exports = {};
"use strict";
Object.defineProperty($5a7057912cdd9ed0$exports, "__esModule", {
    value: true
});
$5a7057912cdd9ed0$exports.bpmToPlaybackSpeed = void 0;

var $luEbf = parcelRequire("luEbf");
const $5a7057912cdd9ed0$var$baselineBPM = 60; // baseline bpm
const $5a7057912cdd9ed0$var$bpmToPlaybackSpeed = (bpm)=>{
    const res = (0, $luEbf.roundToDecimal)((bpm === null ? 60 : bpm) / $5a7057912cdd9ed0$var$baselineBPM, 3);
    return isNaN(res) ? 1 : res;
};
$5a7057912cdd9ed0$exports.bpmToPlaybackSpeed = $5a7057912cdd9ed0$var$bpmToPlaybackSpeed;


Object.keys($5a7057912cdd9ed0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $5a7057912cdd9ed0$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $5a7057912cdd9ed0$exports[key];
        }
    });
});
var $206450580007e137$exports = {};
"use strict";
Object.defineProperty($206450580007e137$exports, "__esModule", {
    value: true
});
$206450580007e137$exports.getColorForIndex = void 0;
const $206450580007e137$var$colors = [
    "light-blue",
    "green",
    "yellow",
    "light-red",
    "light-pink",
    "navy",
    "dark-green"
];
const $206450580007e137$var$getColorForIndex = (index)=>$206450580007e137$var$colors[index % $206450580007e137$var$colors.length];
$206450580007e137$exports.getColorForIndex = $206450580007e137$var$getColorForIndex;


Object.keys($206450580007e137$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $206450580007e137$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $206450580007e137$exports[key];
        }
    });
});

var $8hAZN = parcelRequire("8hAZN");
Object.keys($8hAZN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $8hAZN[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $8hAZN[key];
        }
    });
});

var $1dcfb6b13a3657f8$var$_logger = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("1reEh")));
var $ef89ab3652a3c333$exports = {};
"use strict";
Object.defineProperty($ef89ab3652a3c333$exports, "__esModule", {
    value: true
});
$ef89ab3652a3c333$exports.birthDateField = $ef89ab3652a3c333$exports.formatBirthDate = void 0;

var $ef89ab3652a3c333$var$_parseDob = $ef89ab3652a3c333$var$_interopRequireDefault((parcelRequire("g6HqF")));

var $ef89ab3652a3c333$var$_dobToAge = $ef89ab3652a3c333$var$_interopRequireDefault((parcelRequire("8HZpF")));

var $kRHng = parcelRequire("kRHng");
function $ef89ab3652a3c333$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ef89ab3652a3c333$var$parseDobMemoized = (0, $kRHng.singleArgMemoize)($ef89ab3652a3c333$var$_parseDob.default);
const $ef89ab3652a3c333$var$formatBirthDate = (0, $kRHng.singleArgMemoize)((str)=>{
    const [year, month, date] = str.split("-");
    const d = new Date();
    const opts = {
        year: "numeric"
    };
    d.setFullYear(Number(year));
    d.setHours(12);
    if (month) {
        d.setMonth(Number(month) - 1);
        opts.month = "long";
    }
    if (date) {
        d.setDate(Number(date));
        opts.day = "numeric";
    }
    return d.toLocaleDateString(undefined, opts);
});
$ef89ab3652a3c333$exports.formatBirthDate = $ef89ab3652a3c333$var$formatBirthDate;
const $ef89ab3652a3c333$var$birthDateField = {
    label: "Birth Date",
    name: "birthDate",
    onInput: true,
    subLabel: (item)=>{
        const parsed = $ef89ab3652a3c333$var$parseDobMemoized(item.value || "");
        if (!parsed) return "Enter it however you'd like, interpreted result will appear here. ";
        return "Interpreted as: ".concat($ef89ab3652a3c333$var$formatBirthDate(parsed), " (").concat((0, $ef89ab3652a3c333$var$_dobToAge.default)(parsed), " years old).");
    },
    completenessTest: $ef89ab3652a3c333$var$parseDobMemoized,
    test: (val)=>{
        const parsed = $ef89ab3652a3c333$var$parseDobMemoized(val);
        if (val && !parsed) return "Could not interpret birth date yet. ";
    },
    tourVal: "12/01/1984",
    inputWidth: "180px",
    getFinalValue: (val)=>$ef89ab3652a3c333$var$parseDobMemoized(val)
};
$ef89ab3652a3c333$exports.birthDateField = $ef89ab3652a3c333$var$birthDateField;


Object.keys($ef89ab3652a3c333$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $ef89ab3652a3c333$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $ef89ab3652a3c333$exports[key];
        }
    });
});

var $brUQh = parcelRequire("brUQh");
Object.keys($brUQh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $brUQh[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $brUQh[key];
        }
    });
});

var $1dcfb6b13a3657f8$var$_pills = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("aH4SR")));

var $1dcfb6b13a3657f8$var$_loadingScreen = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("57nNb")));

var $1dcfb6b13a3657f8$var$_getRecentActionsBundle = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("aAVks")));

var $1dcfb6b13a3657f8$var$_getBetaBundle = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("hZ5C6")));

var $1dcfb6b13a3657f8$var$_getMixpanelTracker = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("il5gP")));

var $1dcfb6b13a3657f8$var$_getMixpanelBeaconTracker = $1dcfb6b13a3657f8$var$_interopRequireDefault((parcelRequire("74SEk")));

var $5RiU8 = parcelRequire("5RiU8");
Object.keys($5RiU8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $5RiU8[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $5RiU8[key];
        }
    });
});

var $ezNDq = parcelRequire("ezNDq");
Object.keys($ezNDq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $ezNDq[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $ezNDq[key];
        }
    });
});
var $af42ecebe7ca4cf4$exports = {};
"use strict";
Object.defineProperty($af42ecebe7ca4cf4$exports, "__esModule", {
    value: true
});
$af42ecebe7ca4cf4$exports.deSlug = $af42ecebe7ca4cf4$exports.capitalize = void 0;
const $af42ecebe7ca4cf4$var$capitalize = (str)=>!str ? "" : str.slice(0, 1).toUpperCase() + str.slice(1);
$af42ecebe7ca4cf4$exports.capitalize = $af42ecebe7ca4cf4$var$capitalize;
const $af42ecebe7ca4cf4$var$deSlug = (str)=>!str ? "" : str.replace(/-/g, " ");
$af42ecebe7ca4cf4$exports.deSlug = $af42ecebe7ca4cf4$var$deSlug;


Object.keys($af42ecebe7ca4cf4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $af42ecebe7ca4cf4$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $af42ecebe7ca4cf4$exports[key];
        }
    });
});
var $c7081ae0446c3c41$exports = {};
"use strict";
Object.defineProperty($c7081ae0446c3c41$exports, "__esModule", {
    value: true
});
$c7081ae0446c3c41$exports.serializeError = void 0;
const $c7081ae0446c3c41$var$serializeError = (obj)=>obj && (obj.message || obj.stack) ? {
        message: obj.message,
        stack: obj.stack
    } : obj;
$c7081ae0446c3c41$exports.serializeError = $c7081ae0446c3c41$var$serializeError;


Object.keys($c7081ae0446c3c41$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $c7081ae0446c3c41$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $c7081ae0446c3c41$exports[key];
        }
    });
});
var $3c52478ffd11c959$exports = {};
"use strict";
Object.defineProperty($3c52478ffd11c959$exports, "__esModule", {
    value: true
});
$3c52478ffd11c959$exports.clientRenderToString = void 0;

var $767w7 = parcelRequire("767w7");
const $3c52478ffd11c959$var$clientRenderToString = (contents)=>{
    const el = document.createElement("div");
    (0, $767w7.render)(contents, el);
    return el.innerHTML;
};
$3c52478ffd11c959$exports.clientRenderToString = $3c52478ffd11c959$var$clientRenderToString;


Object.keys($3c52478ffd11c959$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $3c52478ffd11c959$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $3c52478ffd11c959$exports[key];
        }
    });
});
var $a058fc80931eca9a$exports = {};
"use strict";
Object.defineProperty($a058fc80931eca9a$exports, "__esModule", {
    value: true
});
$a058fc80931eca9a$exports.AppointmentStatus = void 0;

var $767w7 = parcelRequire("767w7");

var $a058fc80931eca9a$var$_classnames = $a058fc80931eca9a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

function $a058fc80931eca9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a058fc80931eca9a$var$_extends() {
    $a058fc80931eca9a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a058fc80931eca9a$var$_extends.apply(this, arguments);
}
function $a058fc80931eca9a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a058fc80931eca9a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a058fc80931eca9a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * @typedef {  | 'proposed'
 *   | 'pending'
 *   | 'booked'
 *   | 'arrived'
 *   | 'fulfilled'
 *   | 'cancelled'
 *   | 'noshow'
 *   | 'entered-in-error'
 *   | 'checked-in'
 *   | 'waitlist'} AppointmentStatus
 */ /**
 * @param {AppointmentStatus} status
 * @returns {string}
 */ const $a058fc80931eca9a$var$getClasses = (status)=>{
    if (status === "booked") return "bg-lightest-blue";
    if (status === "arrived") return "bg-orange white";
    if (status === "fulfilled") return "bg-green";
    if (status === "checked-in" || status === "pending" || status === "proposed") return "bg-yellow";
    if (status === "entered-in-error" || status === "noshow" || status === "cancelled") return "bg-red white";
    return "bg-orange white";
};
/**
 * Small wrapped component for showing a color-coded FHIR appointment status.
 *
 * @typedef {import('preact').FunctionComponent} Appointment
 * @param {{
 *   status: AppointmentStatus
 *   className?: string
 *   children?: any
 * }} Props
 */ const $a058fc80931eca9a$var$AppointmentStatus = (_ref)=>{
    let { status: status, className: className, children: children } = _ref, rest = $a058fc80931eca9a$var$_objectWithoutProperties(_ref, [
        "status",
        "className",
        "children"
    ]);
    return (0, $767w7.h)("span", $a058fc80931eca9a$var$_extends({
        className: (0, $a058fc80931eca9a$var$_classnames.default)("pa1 br2 fw4 f5", $a058fc80931eca9a$var$getClasses(status), className)
    }, rest), children || (0, $af42ecebe7ca4cf4$exports.deSlug)(status));
};
$a058fc80931eca9a$exports.AppointmentStatus = $a058fc80931eca9a$var$AppointmentStatus;


Object.keys($a058fc80931eca9a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $a058fc80931eca9a$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $a058fc80931eca9a$exports[key];
        }
    });
});
var $b1d7f9f3c2f8c3fb$exports = {};
"use strict";
Object.defineProperty($b1d7f9f3c2f8c3fb$exports, "__esModule", {
    value: true
});
$b1d7f9f3c2f8c3fb$exports.ConnectedMonitorStatus = void 0;

var $767w7 = parcelRequire("767w7");

var $b1d7f9f3c2f8c3fb$var$_classnames = $b1d7f9f3c2f8c3fb$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b1d7f9f3c2f8c3fb$var$_milliseconds = $b1d7f9f3c2f8c3fb$var$_interopRequireDefault((parcelRequire("6zzev")));

var $7Dcmj = parcelRequire("7Dcmj");

var $5MXnj = parcelRequire("5MXnj");

function $b1d7f9f3c2f8c3fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b1d7f9f3c2f8c3fb$var$maxAge = $b1d7f9f3c2f8c3fb$var$_milliseconds.default.seconds(60);
const $b1d7f9f3c2f8c3fb$var$delayedAge = $b1d7f9f3c2f8c3fb$var$_milliseconds.default.seconds(20);
const $b1d7f9f3c2f8c3fb$var$veryDelayedAge = $b1d7f9f3c2f8c3fb$var$_milliseconds.default.seconds(30);
const $b1d7f9f3c2f8c3fb$var$VitalEntry = ({ name: name, value: value, unit: unit, loading: loading, error: error })=>{
    let content;
    if (value == null && !error) error = true;
    if (loading) content = (0, $767w7.h)($7Dcmj.Icon, {
        className: "spin-animation",
        size: "16",
        icon: "autorenew"
    });
    else if (error) content = (0, $767w7.h)("div", {
        "data-e2e": "error",
        className: "flex items-center"
    }, (0, $767w7.h)($7Dcmj.Icon, {
        size: "16",
        icon: "error"
    }), error !== true ? (0, $767w7.h)("span", {
        className: "ml1"
    }, error) : null);
    else content = (0, $767w7.h)("strong", {
        "data-e2e": "value"
    }, value);
    return (0, $767w7.h)("div", {
        "data-e2e": "vital|".concat(name),
        className: (0, $b1d7f9f3c2f8c3fb$var$_classnames.default)("f6 fw4 flex items-center mr1", {
            "bg-red white br1 pa1": error
        })
    }, (0, $767w7.h)("span", {
        className: "mr1"
    }, name, ":"), content, unit);
};
class $b1d7f9f3c2f8c3fb$var$ConnectedMonitorStatus extends $767w7.Component {
    constructor(props){
        super(props);
        this.state = {
            now: Date.now()
        };
        this.refreshTimer = null;
    }
    startTimer() {
        if (!this.refreshTimer) this.refreshTimer = setInterval(()=>this.setState({
                now: Date.now()
            }), 1000);
    }
    render() {
        const { latestMetadata: latestMetadata, isLocal: isLocal, extraContent: extraContent, className: className, hideLeadingIcon: hideLeadingIcon = false } = this.props;
        const { now: now } = this.state;
        if (!latestMetadata || !latestMetadata.connectionId) {
            clearTimeout(this.refreshTimer);
            this.refreshTimer = null;
            return null;
        }
        const { time: time, bpTime: bpTime, vitals: vitals, hasValues: hasValues, simulated: simulated, monitorLabel: monitorLabel, autoVitalsStatus: autoVitalsStatus } = latestMetadata;
        const age = now - time;
        if (age > $b1d7f9f3c2f8c3fb$var$maxAge && !isLocal) return null;
        this.startTimer();
        let isVeryDelayed = !isLocal ? age > $b1d7f9f3c2f8c3fb$var$veryDelayedAge : false;
        let isSomewhatDelayed = !isLocal && !isVeryDelayed ? age > $b1d7f9f3c2f8c3fb$var$delayedAge : false;
        const isConnected = autoVitalsStatus === "connected";
        const isWaiting = autoVitalsStatus === "waiting";
        const hr = vitals.find((item)=>item.id === "hr");
        return (0, $767w7.h)("div", {
            "data-e2e": "connectedMonitorVitals",
            className: (0, $b1d7f9f3c2f8c3fb$var$_classnames.default)("flex items-center flex-wrap justify-between", className)
        }, (0, $767w7.h)("div", {
            className: "flex items-center"
        }, !hideLeadingIcon && (0, $767w7.h)("div", null, isConnected && (0, $767w7.h)($7Dcmj.Icon, {
            className: "nl1 ".concat(isLocal ? "dark-blue" : "light-blue"),
            size: "48",
            icon: "live_dot",
            speed: (0, $5a7057912cdd9ed0$exports.bpmToPlaybackSpeed)(hr && hr.value),
            "data-e2e": "connectedMonitorConnected"
        }), isWaiting && (0, $767w7.h)($7Dcmj.Icon, {
            "data-e2e": "connectedMonitorConnecting",
            size: "24",
            icon: "autorenew",
            className: "spin-animation"
        })), (0, $767w7.h)("div", {
            className: "pa1"
        }, (0, $767w7.h)("div", {
            className: "flex items-center flex-wrap"
        }, (0, $767w7.h)("div", null, (0, $767w7.h)("div", {
            className: "flex items-center fw6 nowrap"
        }, (0, $767w7.h)("span", {
            className: "mr1"
        }, monitorLabel, " Data"), simulated && (0, $767w7.h)("span", {
            className: "mr1"
        }, "(simulated)"), !isLocal && (0, $767w7.h)("span", {
            className: "mr1"
        }, "(via other computer)"))), !isWaiting && (0, $767w7.h)("div", {
            className: (0, $b1d7f9f3c2f8c3fb$var$_classnames.default)("nowrap mr1", {
                orange: isSomewhatDelayed,
                red: isVeryDelayed
            })
        }, "Received: ", time ? "".concat((0, $5MXnj.msToTimeAgo)(now - time), " ago") : "(none)", ","), !isWaiting && (0, $767w7.h)("div", {
            className: "nowrap mr1"
        }, "Last BP received:", " ", typeof bpTime === "number" ? "".concat((0, $5MXnj.msToTimeAgo)(now - bpTime), " ago") : "(none)")), !isWaiting && (0, $767w7.h)("div", null, (0, $767w7.h)("div", {
            className: "flex flex-wrap mt1"
        }, vitals.map((vital)=>(0, $767w7.h)($b1d7f9f3c2f8c3fb$var$VitalEntry, {
                key: vital.id,
                name: vital.chartName,
                value: vital.value,
                error: vital.error,
                loading: vital.status === "measuring"
            })))), !hasValues && isConnected && (0, $767w7.h)("div", {
            className: "inline-flex items-center mt1"
        }, (0, $767w7.h)($7Dcmj.Icon, {
            icon: "warning",
            size: "16",
            className: "mr1"
        }), (0, $767w7.h)("span", null, "The monitor is connected but sending blank vitals values.")))), extraContent, !isLocal && (isVeryDelayed || isSomewhatDelayed) && (0, $767w7.h)("div", {
            className: (0, $b1d7f9f3c2f8c3fb$var$_classnames.default)("br2 pa2 flex items-center", {
                "bg-red white": isVeryDelayed,
                "bg-orange": isSomewhatDelayed
            })
        }, (0, $767w7.h)($7Dcmj.Icon, {
            icon: "warning",
            className: "mr2"
        }), "Data is delayed"));
    }
}
$b1d7f9f3c2f8c3fb$exports.ConnectedMonitorStatus = $b1d7f9f3c2f8c3fb$var$ConnectedMonitorStatus;


Object.keys($b1d7f9f3c2f8c3fb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $b1d7f9f3c2f8c3fb$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $b1d7f9f3c2f8c3fb$exports[key];
        }
    });
});
var $58c33ebca9062a90$exports = {};
"use strict";
Object.defineProperty($58c33ebca9062a90$exports, "__esModule", {
    value: true
});
$58c33ebca9062a90$exports.EmptyMessage = void 0;

var $58c33ebca9062a90$var$_getStyledComponent = $58c33ebca9062a90$var$_interopRequireDefault((parcelRequire("45yGA")));
function $58c33ebca9062a90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// @ts-check
/**
 * Small component for showing empty text
 *
 * @typedef {import('preact').FunctionComponent} PatientSummary
 * @param {{
 *   message: any
 *   className?: string
 * }} Props
 */ const $58c33ebca9062a90$var$EmptyMessage = (0, $58c33ebca9062a90$var$_getStyledComponent.default)({
    baseClasses: "mid-gray",
    tagName: "p",
    options: {
        message: ""
    },
    renderChildren: ({ message: message })=>"(" + message + ")"
});
$58c33ebca9062a90$exports.EmptyMessage = $58c33ebca9062a90$var$EmptyMessage;


Object.keys($58c33ebca9062a90$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $58c33ebca9062a90$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $58c33ebca9062a90$exports[key];
        }
    });
});
var $cbc3f3803444810a$exports = {};
"use strict";
Object.defineProperty($cbc3f3803444810a$exports, "__esModule", {
    value: true
});
$cbc3f3803444810a$exports.TitleCard = $cbc3f3803444810a$exports.Card = void 0;

var $767w7 = parcelRequire("767w7");

var $cbc3f3803444810a$var$_classnames = $cbc3f3803444810a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $7Dcmj = parcelRequire("7Dcmj");
function $cbc3f3803444810a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbc3f3803444810a$var$_extends() {
    $cbc3f3803444810a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cbc3f3803444810a$var$_extends.apply(this, arguments);
}
function $cbc3f3803444810a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cbc3f3803444810a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cbc3f3803444810a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * @typedef CardProps
 * @property {boolean} [white]
 * @property {boolean} [nearWhite]
 * @property {string} [className]
 * @property {string} [href]
 */ /**
 * Card
 *
 * @type {import('preact').FunctionComponent}
 * @param {CardProps} props
 */ const $cbc3f3803444810a$var$Card = (_ref)=>{
    let { white: white = false, nearWhite: nearWhite = false, className: className, href: href } = _ref, props = $cbc3f3803444810a$var$_objectWithoutProperties(_ref, [
        "white",
        "nearWhite",
        "className",
        "href"
    ]);
    const classes = (0, $cbc3f3803444810a$var$_classnames.default)({
        "bg-white": white,
        "bg-near-white": nearWhite
    }, "pa3 br2 shadow-1", href && "no-underline color-inherit", className);
    if (href) return (0, $767w7.h)("a", $cbc3f3803444810a$var$_extends({
        className: classes,
        href: href
    }, props));
    return (0, $767w7.h)("div", $cbc3f3803444810a$var$_extends({
        className: classes
    }, props));
};
/**
 * Card
 *
 * @type {import('preact').FunctionComponent}
 * @param {CardProps & {
 *   icon: string
 *   iconColor: import('./icon').CircleIconProps['color']
 * }} props
 */ $cbc3f3803444810a$exports.Card = $cbc3f3803444810a$var$Card;
const $cbc3f3803444810a$var$TitleCard = (_ref2)=>{
    let { children: children, icon: icon, iconColor: iconColor = "blue", title: title } = _ref2, props = $cbc3f3803444810a$var$_objectWithoutProperties(_ref2, [
        "children",
        "icon",
        "iconColor",
        "title"
    ]);
    return (0, $767w7.h)($cbc3f3803444810a$var$Card, props, (0, $767w7.h)("div", {
        className: (0, $cbc3f3803444810a$var$_classnames.default)("flex items-center", children && "mb2")
    }, (0, $767w7.h)($7Dcmj.CircledIcon, {
        icon: icon,
        color: iconColor
    }), (0, $767w7.h)("h4", {
        className: "ml2 mv0 f5 fw4"
    }, title)), children);
};
$cbc3f3803444810a$exports.TitleCard = $cbc3f3803444810a$var$TitleCard;


Object.keys($cbc3f3803444810a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $cbc3f3803444810a$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $cbc3f3803444810a$exports[key];
        }
    });
});
var $94135915bf2521ed$exports = {};
"use strict";
Object.defineProperty($94135915bf2521ed$exports, "__esModule", {
    value: true
});
$94135915bf2521ed$exports.BarGraph = void 0;

var $767w7 = parcelRequire("767w7");

var $94135915bf2521ed$var$_classnames = $94135915bf2521ed$var$_interopRequireDefault((parcelRequire("8g1PZ")));


function $94135915bf2521ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @typedef BarGraphData
 * @property {number} value
 * @property {string} label
 * @property {string} [href]
 * @property {string} [color] Color will be assigned if not passed
 */ /**
 * @typedef BarGraphProps
 * @property {BarGraphData[]} data
 * @property {boolean} [showTotal=true] Default is `true`
 * @property {boolean} [sort=true] Default is `true`
 */ /**
 * Card
 *
 * @type {import('preact').FunctionComponent}
 * @param {BarGraphProps} props
 */ const $94135915bf2521ed$var$BarGraph = ({ data: data, showTotal: showTotal = true, sort: sort = true })=>{
    const sorted = sort ? data.slice().sort((a, b)=>b.value - a.value) : data;
    const max = sorted.reduce((max, item)=>Math.max(item.value, max), 0);
    const total = sorted.reduce((sum, item)=>sum + item.value, 0);
    return (0, $767w7.h)("div", null, sorted.length === 0 && (0, $767w7.h)($58c33ebca9062a90$exports.EmptyMessage, {
        message: "no data"
    }), sorted.map((item, index)=>{
        const isLast = index === sorted.length - 1;
        const contents = (0, $767w7.h)($767w7.Fragment, null, (0, $767w7.h)("div", {
            className: "w4 truncate flex-shrink-0 pr2"
        }, item.label), (0, $767w7.h)("div", {
            className: "w-100 flex items-center"
        }, (0, $767w7.h)("div", {
            className: "relative w-100"
        }, (0, $767w7.h)("div", {
            key: item.label,
            className: (0, $94135915bf2521ed$var$_classnames.default)("br1 flex-shrink-0 flex-grow-0", "bg-".concat(item.color || (0, $206450580007e137$exports.getColorForIndex)(index))),
            style: {
                height: "16px",
                width: "".concat(item.value / max * 100, "%")
            }
        })), (0, $767w7.h)("div", {
            className: "ml2"
        }, item.value)));
        const baseClasses = "flex items-center" + (isLast ? "" : " mb2");
        if (item.href) return (0, $767w7.h)("a", {
            href: item.href,
            className: baseClasses + " no-underline color-inherit"
        }, contents);
        return (0, $767w7.h)("div", {
            key: item.label,
            className: baseClasses
        }, contents);
    }), sorted.length > 0 && showTotal && (0, $767w7.h)("div", {
        className: "tr mt2"
    }, "Total: ", total));
};
$94135915bf2521ed$exports.BarGraph = $94135915bf2521ed$var$BarGraph;


Object.keys($94135915bf2521ed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $94135915bf2521ed$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $94135915bf2521ed$exports[key];
        }
    });
});
var $65a9c47c210c1451$exports = {};
"use strict";
Object.defineProperty($65a9c47c210c1451$exports, "__esModule", {
    value: true
});
$65a9c47c210c1451$exports.Calendar = void 0;

var $767w7 = parcelRequire("767w7");

var $65a9c47c210c1451$var$_classnames = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $9YtMX = parcelRequire("9YtMX");

var $7Dcmj = parcelRequire("7Dcmj");

var $5MXnj = parcelRequire("5MXnj");

var $65a9c47c210c1451$var$_eachWeekOfInterval = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("34ucQ")));

var $65a9c47c210c1451$var$_startOfMonth = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("5E40x")));

var $65a9c47c210c1451$var$_endOfDay = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("6uyHy")));

var $65a9c47c210c1451$var$_addMonths = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("eqWMS")));

var $65a9c47c210c1451$var$_endOfMonth = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("l2vHo")));

var $65a9c47c210c1451$var$_endOfWeek = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("75XN4")));

var $65a9c47c210c1451$var$_eachDayOfInterval = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("lmLBg")));

var $65a9c47c210c1451$var$_addWeeks = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("2MTnF")));

var $65a9c47c210c1451$var$_startOfWeek = $65a9c47c210c1451$var$_interopRequireDefault((parcelRequire("7yBDJ")));
function $65a9c47c210c1451$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65a9c47c210c1451$var$_extends() {
    $65a9c47c210c1451$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $65a9c47c210c1451$var$_extends.apply(this, arguments);
}
function $65a9c47c210c1451$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $65a9c47c210c1451$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $65a9c47c210c1451$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $65a9c47c210c1451$var$Day = ({ start: start, end: end, events: events, isToday: isToday, isFuture: isFuture, isPast: isPast, isCurrentMonth: isCurrentMonth, isBottomRow: isBottomRow, isTopRow: isTopRow, isFirstColumn: isFirstColumn, isLastColumn: isLastColumn, onDayClick: onDayClick, dateNumber: dateNumber, dayContentComponent: DayContentComponent })=>{
    const monthName = dateNumber === 1 ? start.toLocaleDateString(undefined, {
        month: "short"
    }) : null;
    return (0, $767w7.h)("div", {
        "data-e2e": "day",
        "data-state": (0, $5MXnj.toSimpleISODateString)(start),
        "data-current-month": isCurrentMonth ? "current" : null,
        className: (0, $65a9c47c210c1451$var$_classnames.default)("db shadow-1 br2 ba b--light-gray", !isCurrentMonth && "bg-near-white"),
        style: {
            minHeight: "64px"
        },
        onClick: ()=>{
            if (onDayClick) onDayClick(start);
        }
    }, (0, $767w7.h)("div", {
        className: "relative fw2 f5 tc"
    }, isToday && (0, $767w7.h)("div", {
        style: {
            top: "1px",
            left: "50%",
            marginLeft: "-12px",
            width: "24px",
            height: "24px"
        },
        className: "bg-light-blue br-100 dib dark-blue absolute"
    }), (0, $767w7.h)("div", {
        className: (0, $65a9c47c210c1451$var$_classnames.default)("pa1 mv1 relative", !isToday && !isCurrentMonth && "mid-gray", !isToday && isCurrentMonth && "dark-blue")
    }, monthName && (0, $767w7.h)("div", {
        className: "absolute top-0 left-0 ml2 mt1 fw2 dn db-l"
    }, monthName), dateNumber)), (0, $767w7.h)(DayContentComponent, {
        start: start,
        end: end,
        events: events,
        isToday: isToday,
        isFuture: isFuture,
        isPast: isPast,
        isCurrentMonth: isCurrentMonth,
        isBottomRow: isBottomRow,
        isTopRow: isTopRow,
        isFirstColumn: isFirstColumn,
        isLastColumn: isLastColumn,
        onDayClick: onDayClick,
        dateNumber: dateNumber
    }));
};
class $65a9c47c210c1451$var$Calendar extends $767w7.Component {
    constructor(props){
        super(props);
        const currentDayDate = props.currentDayDate;
        this.setDate = this.setDate.bind(this);
        this.nextMonth = this.nextMonth.bind(this);
        this.prevMonth = this.prevMonth.bind(this);
        this.thisMonth = this.thisMonth.bind(this);
        this.setDate(props.dateInMonth || currentDayDate);
    }
    getStartAndEnd(date) {
        const currentMonthStart = (0, $65a9c47c210c1451$var$_startOfMonth.default)(date);
        const currentMonthEnd = (0, $65a9c47c210c1451$var$_endOfMonth.default)(date);
        return {
            currentMonthStart: currentMonthStart,
            currentMonthEnd: currentMonthEnd,
            start: (0, $65a9c47c210c1451$var$_startOfWeek.default)((0, $65a9c47c210c1451$var$_addWeeks.default)(currentMonthStart, -1)),
            end: (0, $65a9c47c210c1451$var$_endOfWeek.default)((0, $65a9c47c210c1451$var$_addWeeks.default)(currentMonthEnd, 2))
        };
    }
    setDate(date) {
        this.setState({
            selectedDate: date
        });
        if (this.props.onMonthChange) this.props.onMonthChange(this.getStartAndEnd(date));
    }
    nextMonth() {
        this.setDate((0, $65a9c47c210c1451$var$_addMonths.default)(this.state.selectedDate, 1));
    }
    prevMonth() {
        this.setDate((0, $65a9c47c210c1451$var$_addMonths.default)(this.state.selectedDate, -1));
    }
    thisMonth() {
        this.setDate(this.props.currentDayDate);
    }
    render() {
        const _this$props = this.props, { currentDayDate: currentDayDate, entries: entries, dayContentComponent: dayContentComponent, dayComponent: dayComponent, onDayClick: onDayClick, dateInMonth: dateInMonth } = _this$props, rest = $65a9c47c210c1451$var$_objectWithoutProperties(_this$props, [
            "currentDayDate",
            "entries",
            "dayContentComponent",
            "dayComponent",
            "onDayClick",
            "dateInMonth"
        ]);
        const endOfToday = (0, $65a9c47c210c1451$var$_endOfDay.default)(currentDayDate);
        const date = dateInMonth || this.state.selectedDate;
        const { currentMonthStart: currentMonthStart, currentMonthEnd: currentMonthEnd, start: start, end: end } = this.getStartAndEnd(date);
        const dayNames = [];
        const weeks = (0, $65a9c47c210c1451$var$_eachWeekOfInterval.default)({
            start: start,
            end: end
        });
        const weeksOfDays = weeks.map((startOfWeek, weekIndex)=>{
            const intervals = (0, $65a9c47c210c1451$var$_eachDayOfInterval.default)({
                start: startOfWeek,
                end: (0, $65a9c47c210c1451$var$_endOfWeek.default)(startOfWeek)
            });
            const isBottomRow = weekIndex === weeks.length - 1;
            return intervals.map((start, dayIndex)=>{
                const isTopRow = weekIndex === 0;
                if (isTopRow) dayNames.push(start.toLocaleDateString(undefined, {
                    weekday: "short"
                }));
                const end = (0, $65a9c47c210c1451$var$_endOfDay.default)(start);
                return {
                    events: entries.filter((entry)=>entry.startAsDate >= start && entry.startAsDate <= end || // started before but ends today
                        entry.startAsDate <= start && entry.endAsDate >= start),
                    start: start,
                    end: end,
                    dateNumber: start.getDate(),
                    isToday: currentDayDate.valueOf() === start.valueOf(),
                    isPast: start < currentDayDate,
                    isFuture: start > endOfToday,
                    isCurrentMonth: start < currentMonthEnd && start >= currentMonthStart,
                    isTopRow: isTopRow,
                    isBottomRow: isBottomRow,
                    isFirstColumn: dayIndex === 0,
                    isLastColumn: dayIndex === intervals.length - 1,
                    onDayClick: onDayClick,
                    dayContentComponent: dayContentComponent
                };
            });
        });
        const DayComponent = dayComponent || $65a9c47c210c1451$var$Day;
        return (0, $767w7.h)("div", rest, (0, $767w7.h)("div", {
            className: "flex items-center justify-between mb2"
        }, (0, $767w7.h)($9YtMX.Button, {
            "data-e2e": "prevMonthButton",
            onClick: this.prevMonth,
            className: "flex items-center"
        }, (0, $767w7.h)($7Dcmj.Icon, {
            size: "18",
            icon: "keyboard_arrow_left"
        }), (0, $767w7.h)("span", {
            className: "dn db-ns ml1"
        }, "Previous")), (0, $767w7.h)("div", {
            "data-e2e": "monthName",
            className: "f3 f1-ns fw1"
        }, currentMonthStart.toLocaleDateString(undefined, {
            month: "long",
            year: "numeric"
        })), (0, $767w7.h)($9YtMX.Button, {
            "data-e2e": "nextMonthButton",
            onClick: this.nextMonth,
            className: "flex items-center"
        }, (0, $767w7.h)("span", {
            className: "dn db-ns mr1"
        }, "Next"), (0, $767w7.h)($7Dcmj.Icon, {
            size: "18",
            icon: "keyboard_arrow_right"
        }))), (0, $767w7.h)("div", {
            style: {
                display: "grid",
                gridTemplateColumns: "repeat(7, minmax(40px, 1fr))"
            },
            "data-e2e": "calendarDayContainer"
        }, dayNames.map((name)=>(0, $767w7.h)("div", {
                key: name,
                className: "tc fw2 ttu"
            }, name)), weeksOfDays.map((days)=>days.map((day)=>(0, $767w7.h)(DayComponent, $65a9c47c210c1451$var$_extends({
                    key: start.toISOString()
                }, day))))));
    }
}
$65a9c47c210c1451$exports.Calendar = $65a9c47c210c1451$var$Calendar;


Object.keys($65a9c47c210c1451$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $65a9c47c210c1451$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $65a9c47c210c1451$exports[key];
        }
    });
});

var $3GW7W = parcelRequire("3GW7W");
Object.keys($3GW7W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $3GW7W[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $3GW7W[key];
        }
    });
});

var $bvmaP = parcelRequire("bvmaP");
Object.keys($bvmaP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $bvmaP[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $bvmaP[key];
        }
    });
});

var $hgoFO = parcelRequire("hgoFO");
Object.keys($hgoFO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $hgoFO[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $hgoFO[key];
        }
    });
});

var $23DLa = parcelRequire("23DLa");
Object.keys($23DLa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $23DLa[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $23DLa[key];
        }
    });
});

var $3U6K7 = parcelRequire("3U6K7");
Object.keys($3U6K7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $3U6K7[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $3U6K7[key];
        }
    });
});

var $b1umg = parcelRequire("b1umg");
Object.keys($b1umg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $b1umg[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $b1umg[key];
        }
    });
});

var $5ldOi = parcelRequire("5ldOi");
Object.keys($5ldOi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $5ldOi[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $5ldOi[key];
        }
    });
});

var $5ye2y = parcelRequire("5ye2y");
Object.keys($5ye2y).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $5ye2y[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $5ye2y[key];
        }
    });
});
var $f2f7c7bb05cf95db$exports = {};
"use strict";
Object.defineProperty($f2f7c7bb05cf95db$exports, "__esModule", {
    value: true
});
$f2f7c7bb05cf95db$exports.findCustomDrugByName = void 0;
var $7c0da91f0e8532dd$exports = {};
"use strict";
Object.defineProperty($7c0da91f0e8532dd$exports, "__esModule", {
    value: true
});
$7c0da91f0e8532dd$exports.getDrugName = void 0;
var $8502c993a8bbbd78$var$Store = function Store(dbName, storeName) {
    if (dbName === void 0) dbName = "keyval-store";
    if (storeName === void 0) storeName = "keyval";
    this.storeName = storeName;
    this._dbp = new Promise(function(resolve, reject) {
        var openreq = indexedDB.open(dbName, 1);
        openreq.onerror = function() {
            return reject(openreq.error);
        };
        openreq.onsuccess = function() {
            return resolve(openreq.result);
        };
        openreq.onupgradeneeded = function() {
            openreq.result.createObjectStore(storeName);
        };
    });
};
$8502c993a8bbbd78$var$Store.prototype._withIDBStore = function _withIDBStore(type, callback) {
    var this$1 = this;
    return this._dbp.then(function(db) {
        return new Promise(function(resolve, reject) {
            var transaction = db.transaction(this$1.storeName, type);
            transaction.oncomplete = function() {
                return resolve();
            };
            transaction.onabort = transaction.onerror = function() {
                return reject(transaction.error);
            };
            callback(transaction.objectStore(this$1.storeName));
        });
    });
};
var $8502c993a8bbbd78$var$store;
function $8502c993a8bbbd78$var$getDefaultStore() {
    if (!$8502c993a8bbbd78$var$store) $8502c993a8bbbd78$var$store = new $8502c993a8bbbd78$var$Store();
    return $8502c993a8bbbd78$var$store;
}
function $8502c993a8bbbd78$var$get(key, store) {
    if (store === void 0) store = $8502c993a8bbbd78$var$getDefaultStore();
    var req;
    return store._withIDBStore("readonly", function(store) {
        req = store.get(key);
    }).then(function() {
        return req.result;
    });
}
function $8502c993a8bbbd78$var$set(key, value, store) {
    if (store === void 0) store = $8502c993a8bbbd78$var$getDefaultStore();
    return store._withIDBStore("readwrite", function(store) {
        store.put(value, key);
    });
}
function $8502c993a8bbbd78$var$del(key, store) {
    if (store === void 0) store = $8502c993a8bbbd78$var$getDefaultStore();
    return store._withIDBStore("readwrite", function(store) {
        store.delete(key);
    });
}
function $8502c993a8bbbd78$var$clear(store) {
    if (store === void 0) store = $8502c993a8bbbd78$var$getDefaultStore();
    return store._withIDBStore("readwrite", function(store) {
        store.clear();
    });
}
function $8502c993a8bbbd78$var$keys(store) {
    if (store === void 0) store = $8502c993a8bbbd78$var$getDefaultStore();
    var keys = [];
    return store._withIDBStore("readonly", function(store) {
        (store.openKeyCursor || store.openCursor).call(store).onsuccess = function() {
            if (!this.result) return;
            keys.push(this.result.key);
            this.result.continue();
        };
    }).then(function() {
        return keys;
    });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var $8502c993a8bbbd78$var$idbKeyVal = {
    Store: $8502c993a8bbbd78$var$Store,
    get: $8502c993a8bbbd78$var$get,
    set: $8502c993a8bbbd78$var$set,
    del: $8502c993a8bbbd78$var$del,
    clear: $8502c993a8bbbd78$var$clear,
    keys: $8502c993a8bbbd78$var$keys
};
var $8502c993a8bbbd78$var$defaultOpts = {
    maxAge: Infinity,
    version: 0,
    lib: $8502c993a8bbbd78$var$idbKeyVal
};
var $8502c993a8bbbd78$var$getOpts = function(passedOptions) {
    return Object.assign({}, $8502c993a8bbbd78$var$defaultOpts, passedOptions);
};
var $8502c993a8bbbd78$export$8b96767477a52e09 = $8502c993a8bbbd78$var$idbKeyVal;
var $8502c993a8bbbd78$export$3988ae62b71be9a3 = function(key, opts, store) {
    var ref = $8502c993a8bbbd78$var$getOpts(opts);
    var maxAge = ref.maxAge;
    var version = ref.version;
    var lib = ref.lib;
    return lib.get(key, store).then(JSON.parse).then(function(parsed) {
        var age = Date.now() - parsed.time;
        if (age > maxAge || version !== parsed.version) {
            lib.del(key, store);
            return null;
        }
        return parsed.data;
    }).catch(function() {
        return null;
    });
};
var $8502c993a8bbbd78$export$adaa4cf7ef1b65be = function(key, data, spec, store) {
    var ref = $8502c993a8bbbd78$var$getOpts(spec);
    var lib = ref.lib;
    var version = ref.version;
    return lib.set(key, JSON.stringify({
        version: version,
        time: Date.now(),
        data: data
    }), store).catch(function() {
        return null;
    });
};
var $8502c993a8bbbd78$export$2774c37398bee8b2 = function(spec, store) {
    var opts = $8502c993a8bbbd78$var$getOpts(spec);
    var keys$$1;
    return opts.lib.keys(store).then(function(retrievedKeys) {
        keys$$1 = retrievedKeys;
        return Promise.all(keys$$1.map(function(key) {
            return $8502c993a8bbbd78$export$3988ae62b71be9a3(key, opts, store);
        }));
    }).then(function(data) {
        return data.reduce(function(acc, bundleData, index) {
            if (bundleData) acc[keys$$1[index]] = bundleData;
            return acc;
        }, {});
    }).catch(function() {});
};
var $8502c993a8bbbd78$export$ac0743d3155e7396 = function(spec) {
    var opts = $8502c993a8bbbd78$var$getOpts(spec);
    var store;
    if (opts.name) store = new $8502c993a8bbbd78$var$Store(opts.name, opts.name);
    return {
        get: function(key) {
            return $8502c993a8bbbd78$export$3988ae62b71be9a3(key, opts, store);
        },
        set: function(key, val) {
            return $8502c993a8bbbd78$export$adaa4cf7ef1b65be(key, val, opts, store);
        },
        getAll: function() {
            return $8502c993a8bbbd78$export$2774c37398bee8b2(opts, store);
        },
        del: function(key) {
            return opts.lib.del(key, store);
        },
        clear: function() {
            return opts.lib.clear(store);
        },
        keys: function() {
            return opts.lib.keys(store);
        }
    };
};


const { set: $7c0da91f0e8532dd$var$set, get: $7c0da91f0e8532dd$var$get, getAll: $7c0da91f0e8532dd$var$getAll } = (0, $8502c993a8bbbd78$export$ac0743d3155e7396)({
    maxAge: Infinity,
    version: 1,
    name: "drug-name-cache"
});
const $7c0da91f0e8532dd$var$drugData = {};
$7c0da91f0e8532dd$var$getAll().then((dbValues)=>{
    Object.assign($7c0da91f0e8532dd$var$drugData, dbValues);
});
const $7c0da91f0e8532dd$var$fetchDrug = (id)=>fetch("https://rxnav.nlm.nih.gov/REST/rxcui/".concat(id, ".json")).then((res)=>res.json()).then((drugData)=>drugData.idGroup.name);
const $7c0da91f0e8532dd$var$getDrugName = (id)=>{
    let found = $7c0da91f0e8532dd$var$drugData[id];
    if (found) return Promise.resolve(found);
    return $7c0da91f0e8532dd$var$get(id).then((res)=>{
        if (res) {
            $7c0da91f0e8532dd$var$drugData[id] = res;
            return res;
        }
        return $7c0da91f0e8532dd$var$fetchDrug(id).then((res)=>{
            if (res) {
                $7c0da91f0e8532dd$var$drugData[id] = res;
                $7c0da91f0e8532dd$var$set(id, res);
                return res;
            }
        });
    });
};
$7c0da91f0e8532dd$exports.getDrugName = $7c0da91f0e8532dd$var$getDrugName;


const $f2f7c7bb05cf95db$var$findCustomDrugByName = (term)=>{
    if (!term) return Promise.resolve([]);
    return fetch("https://rxnav.nlm.nih.gov/REST/approximateTerm.json?maxEntries=4&term=".concat(encodeURIComponent(term))).then((res)=>res.json()).then((parsed)=>{
        const resultsById = (parsed.approximateGroup.candidate || []).reduce((result, item)=>{
            const id = item.rxcui;
            if (!result[id]) result[id] = {
                id: id,
                score: item.score
            };
            return result;
        }, {});
        return Object.keys(resultsById);
    }).then((ids)=>Promise.all(ids.map($7c0da91f0e8532dd$exports.getDrugName)).then((names)=>names.map((name, index)=>({
                    id: ids[index],
                    name: name
                }))).then((matches)=>matches.filter((item)=>!!item.name)));
};
$f2f7c7bb05cf95db$exports.findCustomDrugByName = $f2f7c7bb05cf95db$var$findCustomDrugByName;


Object.keys($f2f7c7bb05cf95db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $f2f7c7bb05cf95db$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $f2f7c7bb05cf95db$exports[key];
        }
    });
});
var $89646e1c64a58cfc$exports = {};
"use strict";
Object.defineProperty($89646e1c64a58cfc$exports, "__esModule", {
    value: true
});
$89646e1c64a58cfc$exports.getDocumentBaseStyles = void 0;
const $89646e1c64a58cfc$var$fontFam = "-apple-system,BlinkMacSystemFont,'avenir next',avenir,helvetica,'helvetica neue',arial,sans-serif";
const $89646e1c64a58cfc$var$table = ".ld th,.ld td{padding:8px;line-height:1.5;vertical-align:top;text-align:left;border-top: 1px solid #ddd;}\n.ld table{border-spacing:0}\n.ld tr:nth-child(odd) > td{background:#f9f9f9}";
const $89646e1c64a58cfc$var$headings = ".ld h1,.ld h2,.ld h3,.ld h4,.ld h5,.ld h6{margin:0 0 2rem 0}";
const $89646e1c64a58cfc$var$bq = ".ld blockquote{border-left:3px solid #ddd; margin-left:1px; padding-left: 16px}";
const $89646e1c64a58cfc$var$getDocumentBaseStyles = ({ noPadding: noPadding = false } = {})=>{
    const padding = noPadding ? "" : "padding:20px;";
    const base = ".ld{all:initial;display:block;sizing:border-box;".concat(padding, "margin:0px;background:white;font-family:").concat($89646e1c64a58cfc$var$fontFam, ";}");
    return base + $89646e1c64a58cfc$var$headings + $89646e1c64a58cfc$var$table + $89646e1c64a58cfc$var$bq;
};
$89646e1c64a58cfc$exports.getDocumentBaseStyles = $89646e1c64a58cfc$var$getDocumentBaseStyles;


Object.keys($89646e1c64a58cfc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $89646e1c64a58cfc$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $89646e1c64a58cfc$exports[key];
        }
    });
});
var $4c5aceb032601174$exports = {};
"use strict";
Object.defineProperty($4c5aceb032601174$exports, "__esModule", {
    value: true
});
$4c5aceb032601174$exports.LegalDocument = void 0;

var $767w7 = parcelRequire("767w7");

var $23DLa = parcelRequire("23DLa");

var $5MXnj = parcelRequire("5MXnj");

function $4c5aceb032601174$var$_extends() {
    $4c5aceb032601174$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c5aceb032601174$var$_extends.apply(this, arguments);
}
function $4c5aceb032601174$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4c5aceb032601174$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4c5aceb032601174$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $4c5aceb032601174$var$Empty = (_ref)=>{
    let { children: children } = _ref, rest = $4c5aceb032601174$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return (0, $767w7.h)("div", $4c5aceb032601174$var$_extends({
        style: {
            color: "lightgray"
        }
    }, rest), children);
}; // very important that these are all inline styles
const $4c5aceb032601174$var$LegalDocument = ({ html: html, data: data, noPadding: noPadding, appendSignature: appendSignature, date: date })=>{
    const signature = data && data.signature;
    const signerName = data && data.signerName;
    return (0, $767w7.h)("div", {
        className: "ld"
    }, (0, $767w7.h)("style", null, (0, $89646e1c64a58cfc$exports.getDocumentBaseStyles)({
        noPadding: noPadding
    })), (0, $767w7.h)("div", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    }), appendSignature && (0, $767w7.h)("div", null, signature && (0, $767w7.h)($23DLa.Signature, {
        style: {
            marginBottom: "-26px"
        },
        path: signature
    }), !signature && (0, $767w7.h)($4c5aceb032601174$var$Empty, null, "signature will be inserted here"), (0, $767w7.h)("div", null, (0, $767w7.h)("hr", {
        style: {
            width: "8rem",
            marginLeft: "0",
            color: "lightgray"
        }
    })), (0, $767w7.h)("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, (0, $767w7.h)("span", {
        style: {
            marginRight: "2rem"
        }
    }, signerName, !signerName && (0, $767w7.h)($4c5aceb032601174$var$Empty, null, "name will be inserted here")), (0, $767w7.h)("span", null, (0, $5MXnj.toDateString)(date || Date.now())))));
};
$4c5aceb032601174$exports.LegalDocument = $4c5aceb032601174$var$LegalDocument;


Object.keys($4c5aceb032601174$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1dcfb6b13a3657f8$var$_exportNames, key)) return;
    if (key in $1dcfb6b13a3657f8$exports && $1dcfb6b13a3657f8$exports[key] === $4c5aceb032601174$exports[key]) return;
    Object.defineProperty($1dcfb6b13a3657f8$exports, key, {
        enumerable: true,
        get: function() {
            return $4c5aceb032601174$exports[key];
        }
    });
});
function $1dcfb6b13a3657f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $606ec13e2ec5f3fe$exports = {};
$606ec13e2ec5f3fe$exports = new URL("xchart.com-for-light.4d4e654b.svg", import.meta.url).toString();


const $14b0e53c727d0f3f$var$fullLightUrl = new URL($606ec13e2ec5f3fe$exports);
var $a7121ee973380a35$exports = {};
$a7121ee973380a35$exports = new URL("xchart.com-for-dark.70c9e41d.svg", import.meta.url).toString();


const $14b0e53c727d0f3f$var$fullDarkUrl = new URL($a7121ee973380a35$exports);
var $005b9bb11dedbf4b$exports = {};
$005b9bb11dedbf4b$exports = new URL("xchart-for-light.cb145956.svg", import.meta.url).toString();


const $14b0e53c727d0f3f$var$shortLightUrl = new URL($005b9bb11dedbf4b$exports);
var $d86a0094578dd38d$exports = {};
$d86a0094578dd38d$exports = new URL("xchart-for-dark.39c65c0b.svg", import.meta.url).toString();


const $14b0e53c727d0f3f$var$shortDarkUrl = new URL($d86a0094578dd38d$exports);
var $f9833e4d0dc4049c$exports = {};
$f9833e4d0dc4049c$exports = new URL("x-for-light.aa181aef.svg", import.meta.url).toString();


const $14b0e53c727d0f3f$var$xLightUrl = new URL($f9833e4d0dc4049c$exports);
var $ac59eb22c035219d$exports = {};
$ac59eb22c035219d$exports = new URL("x-for-dark.b6190bca.svg", import.meta.url).toString();


const $14b0e53c727d0f3f$var$xDarkUrl = new URL($ac59eb22c035219d$exports);
const $14b0e53c727d0f3f$var$BACKGROUND_OPTIONS_BY_MODE = {
    light: [
        {
            value: "transparent",
            label: "Transparent"
        },
        {
            value: "white",
            label: "White"
        }
    ],
    dark: [
        {
            value: "transparent",
            label: "Transparent"
        },
        {
            value: "dark-blue",
            label: "Dark blue"
        }
    ]
};
const $14b0e53c727d0f3f$var$BACKGROUND_FILL = {
    "dark-blue": "#133651",
    white: "#FFFFFF"
};
const $14b0e53c727d0f3f$var$LOGO_OPTIONS = [
    {
        value: "full",
        label: "Xchart.com"
    },
    {
        value: "short",
        label: "Xchart"
    },
    {
        value: "x",
        label: "X"
    }
];
const $14b0e53c727d0f3f$var$MODE_OPTIONS = [
    {
        value: "light",
        label: "For light backgrounds"
    },
    {
        value: "dark",
        label: "For dark backgrounds"
    }
];
const $14b0e53c727d0f3f$var$FORMAT_OPTIONS = [
    {
        value: "png",
        label: "PNG"
    },
    {
        value: "jpg",
        label: "JPG"
    },
    {
        value: "svg",
        label: "SVG"
    }
];
const $14b0e53c727d0f3f$var$LOGO_SOURCES = {
    full: {
        light: $14b0e53c727d0f3f$var$fullLightUrl,
        dark: $14b0e53c727d0f3f$var$fullDarkUrl
    },
    short: {
        light: $14b0e53c727d0f3f$var$shortLightUrl,
        dark: $14b0e53c727d0f3f$var$shortDarkUrl
    },
    x: {
        light: $14b0e53c727d0f3f$var$xLightUrl,
        dark: $14b0e53c727d0f3f$var$xDarkUrl
    }
};
const $14b0e53c727d0f3f$var$DEFAULT_WIDTH = 512;
const $14b0e53c727d0f3f$var$checkerboardBackground = {
    backgroundColor: "#ffffff",
    backgroundImage: "linear-gradient(45deg, #e5edf2 25%, transparent 25%), linear-gradient(-45deg, #e5edf2 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e5edf2 75%), linear-gradient(-45deg, transparent 75%, #e5edf2 75%)",
    backgroundPosition: "0 0, 0 12px, 12px -12px, -12px 0",
    backgroundSize: "24px 24px"
};
const $14b0e53c727d0f3f$var$formLayoutStyle = {
    gap: "1.5rem"
};
const $14b0e53c727d0f3f$var$columnStyle = {
    minWidth: "280px",
    flexBasis: "320px"
};
const $14b0e53c727d0f3f$var$fieldRowStyle = {
    margin: "0 -0.5rem"
};
const $14b0e53c727d0f3f$var$halfFieldStyle = {
    flex: "1 1 170px"
};
const $14b0e53c727d0f3f$var$previewImageStyle = {
    display: "block"
};
const $14b0e53c727d0f3f$var$previewViewportStyle = {
    maxWidth: "100%",
    overflow: "auto"
};
const $14b0e53c727d0f3f$var$parsePositiveInteger = (value)=>{
    if (value === "" || value === null || typeof value === "undefined") return null;
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    return parsed;
};
const $14b0e53c727d0f3f$var$parseNonNegativeInteger = (value)=>{
    if (value === "" || value === null || typeof value === "undefined") return 0;
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 0) return 0;
    return parsed;
};
const $14b0e53c727d0f3f$var$parseViewBox = (svgElement)=>{
    const viewBox = svgElement.getAttribute("viewBox");
    if (viewBox) {
        const parts = viewBox.split(/[\s,]+/).map(Number).filter((part)=>Number.isFinite(part));
        if (parts.length === 4) return {
            minX: parts[0],
            minY: parts[1],
            width: parts[2],
            height: parts[3]
        };
    }
    return {
        minX: 0,
        minY: 0,
        width: Number(svgElement.getAttribute("width")) || 1,
        height: Number(svgElement.getAttribute("height")) || 1
    };
};
const $14b0e53c727d0f3f$var$parseSvgDefinition = (svgText)=>{
    const parser = new window.DOMParser();
    const document1 = parser.parseFromString(svgText, "image/svg+xml");
    const svgElement = document1.documentElement;
    const { minX: minX, minY: minY, width: width, height: height } = $14b0e53c727d0f3f$var$parseViewBox(svgElement);
    return {
        minX: minX,
        minY: minY,
        width: width,
        height: height,
        content: svgElement.innerHTML
    };
};
const $14b0e53c727d0f3f$var$computeOutputDimensions = ({ width: width, height: height, margin: margin, baseWidth: baseWidth, baseHeight: baseHeight })=>{
    const safeMargin = Math.max(0, margin);
    const aspectRatio = baseWidth / baseHeight;
    if (width && height) return {
        width: width,
        height: height,
        margin: safeMargin
    };
    if (width) {
        const derivedHeight = Math.max(1, Math.ceil((width - safeMargin * 2) / aspectRatio + safeMargin * 2));
        return {
            width: width,
            height: derivedHeight,
            margin: safeMargin
        };
    }
    if (height) {
        const derivedWidth = Math.max(1, Math.ceil((height - safeMargin * 2) * aspectRatio + safeMargin * 2));
        return {
            width: derivedWidth,
            height: height,
            margin: safeMargin
        };
    }
    const fallbackWidth = $14b0e53c727d0f3f$var$DEFAULT_WIDTH;
    const fallbackHeight = Math.max(1, Math.ceil((fallbackWidth - safeMargin * 2) / aspectRatio + safeMargin * 2));
    return {
        width: fallbackWidth,
        height: fallbackHeight,
        margin: safeMargin
    };
};
const $14b0e53c727d0f3f$var$buildComposedSvg = ({ definition: definition, width: width, height: height, margin: margin, background: background })=>{
    const availableWidth = Math.max(width - margin * 2, 1);
    const availableHeight = Math.max(height - margin * 2, 1);
    const scale = Math.min(availableWidth / definition.width, availableHeight / definition.height);
    const renderedWidth = definition.width * scale;
    const renderedHeight = definition.height * scale;
    const offsetX = (width - renderedWidth) / 2 - definition.minX * scale;
    const offsetY = (height - renderedHeight) / 2 - definition.minY * scale;
    const backgroundMarkup = background === "transparent" ? "" : `<rect width="${width}" height="${height}" fill="${$14b0e53c727d0f3f$var$BACKGROUND_FILL[background]}" />`;
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" fill="none">${backgroundMarkup}<g transform="translate(${offsetX} ${offsetY}) scale(${scale})">${definition.content}</g></svg>`;
};
const $14b0e53c727d0f3f$var$svgToDataUrl = (svgMarkup)=>`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgMarkup)}`;
const $14b0e53c727d0f3f$var$canvasToBlob = (canvas, mimeType)=>new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) {
                resolve(blob);
                return;
            }
            reject(new Error("Could not create the image file."));
        }, mimeType);
    });
const $14b0e53c727d0f3f$var$loadImage = (src)=>new Promise((resolve, reject)=>{
        const image = new window.Image();
        image.onload = ()=>resolve(image);
        image.onerror = ()=>reject(new Error("Could not render the selected logo for download."));
        image.src = src;
    });
const $14b0e53c727d0f3f$var$downloadBlob = (blob, filename)=>{
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = filename;
    link.click();
    window.setTimeout(()=>window.URL.revokeObjectURL(href), 1000);
};
const $14b0e53c727d0f3f$var$buildFilenamePart = (value)=>value.replace(/[^a-z0-9]+/gi, "_");
const $14b0e53c727d0f3f$var$getBackgroundOptions = ({ mode: mode, format: format })=>$14b0e53c727d0f3f$var$BACKGROUND_OPTIONS_BY_MODE[mode].filter((option)=>format !== "jpg" || option.value !== "transparent");
const $14b0e53c727d0f3f$var$buildFilename = ({ logo: logo, mode: mode, background: background, margin: margin, width: width, height: height, format: format })=>`${$14b0e53c727d0f3f$var$buildFilenamePart(logo)}_${$14b0e53c727d0f3f$var$buildFilenamePart(mode)}_${$14b0e53c727d0f3f$var$buildFilenamePart(background)}_${margin}margin_${width}x${height}.${format}`;
class $14b0e53c727d0f3f$export$b17936400621def7 extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.state = {
            background: "transparent",
            definitions: {},
            error: "",
            format: "png",
            height: "",
            isDownloading: false,
            isLoading: true,
            logo: "full",
            margin: "0",
            mode: "light",
            previewUrl: "",
            width: "512"
        };
        this.previewRequestId = 0;
    }
    componentDidMount() {
        this.loadDefinitions();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.background !== this.state.background || prevState.definitions !== this.state.definitions || prevState.format !== this.state.format || prevState.height !== this.state.height || prevState.isLoading !== this.state.isLoading || prevState.logo !== this.state.logo || prevState.margin !== this.state.margin || prevState.mode !== this.state.mode || prevState.width !== this.state.width) this.updatePreview();
    }
    async loadDefinitions() {
        try {
            const definitions = {};
            await Promise.all(Object.entries($14b0e53c727d0f3f$var$LOGO_SOURCES).flatMap(([logoKey, modes])=>Object.entries(modes).map(async ([modeKey, path])=>{
                    const response = await fetch(path);
                    const svgText = await response.text();
                    if (!response.ok) throw new Error(`Unable to load ${path}`);
                    if (!definitions[logoKey]) definitions[logoKey] = {};
                    definitions[logoKey][modeKey] = $14b0e53c727d0f3f$var$parseSvgDefinition(svgText);
                })));
            this.setState({
                definitions: definitions,
                isLoading: false
            });
        } catch (error) {
            this.setState({
                error: error.message || "Unable to load the logo files.",
                isLoading: false
            });
        }
    }
    updateField(name, value) {
        const nextMode = name === "mode" ? value : this.state.mode;
        const nextFormat = name === "format" ? value : this.state.format;
        const backgroundOptions = $14b0e53c727d0f3f$var$getBackgroundOptions({
            mode: nextMode,
            format: nextFormat
        });
        const requestedBackground = name === "background" ? value : this.state.background;
        const nextBackground = backgroundOptions.some((option)=>option.value === requestedBackground) ? requestedBackground : backgroundOptions[0].value;
        const nextState = {
            [name]: value,
            background: nextBackground,
            error: ""
        };
        this.setState(nextState);
    }
    getCurrentDefinition() {
        const { definitions: definitions, logo: logo, mode: mode } = this.state;
        return definitions[logo] && definitions[logo][mode];
    }
    getRenderState() {
        const definition = this.getCurrentDefinition();
        if (!definition) return null;
        const width = $14b0e53c727d0f3f$var$parsePositiveInteger(this.state.width);
        const height = $14b0e53c727d0f3f$var$parsePositiveInteger(this.state.height);
        const margin = $14b0e53c727d0f3f$var$parseNonNegativeInteger(this.state.margin);
        const output = $14b0e53c727d0f3f$var$computeOutputDimensions({
            width: width,
            height: height,
            margin: margin,
            baseWidth: definition.width,
            baseHeight: definition.height
        });
        const svgMarkup = $14b0e53c727d0f3f$var$buildComposedSvg({
            definition: definition,
            width: output.width,
            height: output.height,
            margin: output.margin,
            background: this.state.background
        });
        return {
            ...output,
            definition: definition,
            filename: $14b0e53c727d0f3f$var$buildFilename({
                logo: this.state.logo,
                mode: this.state.mode,
                background: this.state.background,
                margin: output.margin,
                width: output.width,
                height: output.height,
                format: this.state.format
            }),
            svgMarkup: svgMarkup
        };
    }
    async updatePreview() {
        const renderState = this.getRenderState();
        if (!renderState) {
            if (this.state.previewUrl) this.setState({
                previewUrl: ""
            });
            return;
        }
        const requestId = ++this.previewRequestId;
        const svgUrl = $14b0e53c727d0f3f$var$svgToDataUrl(renderState.svgMarkup);
        try {
            if (this.state.format === "svg") {
                if (requestId === this.previewRequestId && this.state.previewUrl !== svgUrl) this.setState({
                    previewUrl: svgUrl
                });
                return;
            }
            const image = await $14b0e53c727d0f3f$var$loadImage(svgUrl);
            const canvas = document.createElement("canvas");
            const pixelRatio = Math.max(1, window.devicePixelRatio || 1);
            canvas.width = Math.round(renderState.width * pixelRatio);
            canvas.height = Math.round(renderState.height * pixelRatio);
            const context = canvas.getContext("2d");
            if (!context) throw new Error("Could not start the preview renderer.");
            context.scale(pixelRatio, pixelRatio);
            context.drawImage(image, 0, 0, renderState.width, renderState.height);
            const mimeType = this.state.format === "jpg" ? "image/jpeg" : "image/png";
            const previewUrl = canvas.toDataURL(mimeType);
            if (requestId === this.previewRequestId && this.state.previewUrl !== previewUrl) this.setState({
                previewUrl: previewUrl
            });
        } catch (error) {
            if (requestId === this.previewRequestId) this.setState({
                error: error.message || "Could not render the preview."
            });
        }
    }
    async handleDownload() {
        const renderState = this.getRenderState();
        if (!renderState || this.state.isDownloading) return;
        this.setState({
            error: "",
            isDownloading: true
        });
        try {
            if (this.state.format === "svg") {
                $14b0e53c727d0f3f$var$downloadBlob(new window.Blob([
                    renderState.svgMarkup
                ], {
                    type: "image/svg+xml"
                }), renderState.filename);
                return;
            }
            const image = await $14b0e53c727d0f3f$var$loadImage($14b0e53c727d0f3f$var$svgToDataUrl(renderState.svgMarkup));
            const canvas = document.createElement("canvas");
            canvas.width = renderState.width;
            canvas.height = renderState.height;
            const context = canvas.getContext("2d");
            if (!context) throw new Error("Could not start the image renderer.");
            if (this.state.format === "jpg" && this.state.background === "transparent") {
                context.fillStyle = "#FFFFFF";
                context.fillRect(0, 0, canvas.width, canvas.height);
            }
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            const mimeType = this.state.format === "jpg" ? "image/jpeg" : "image/png";
            const blob = await $14b0e53c727d0f3f$var$canvasToBlob(canvas, mimeType);
            $14b0e53c727d0f3f$var$downloadBlob(blob, renderState.filename);
        } catch (error) {
            this.setState({
                error: error.message || "Could not download the logo."
            });
        } finally{
            this.setState({
                isDownloading: false
            });
        }
    }
    renderOptionGroup(label, name, options) {
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
            class: "db mb3"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "fw6 mb2"
        }, label), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("select", {
            class: "input-reset ba b--black-20 br2 pa2 w-100 bg-white",
            value: this.state[name],
            onInput: (event)=>this.updateField(name, event.target.value)
        }, options.map((option)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("option", {
                key: option.value,
                value: option.value
            }, option.label))));
    }
    render() {
        const { background: background, error: error, format: format, height: height, isDownloading: isDownloading, isLoading: isLoading, margin: margin, previewUrl: previewUrl, width: width } = this.state;
        const renderState = this.getRenderState();
        const backgroundOptions = $14b0e53c727d0f3f$var$getBackgroundOptions({
            mode: this.state.mode,
            format: format
        });
        const previewFrameStyle = renderState ? {
            width: `${renderState.width}px`,
            height: `${renderState.height}px`
        } : null;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "bg-dark-blue white flex justify-center pv4"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "w-100 mw7 ph2 tl"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
            class: "f2 mt0"
        }, "Logo Downloader"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
            class: "measure-wide"
        }, "Pick the logo artwork, export format, background, margin, and final size. The logo is always centered and scaled without distortion."), isLoading && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Loading logo files..."), !isLoading && renderState && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "flex flex-wrap items-start",
            style: $14b0e53c727d0f3f$var$formLayoutStyle
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "flex-auto",
            style: $14b0e53c727d0f3f$var$columnStyle
        }, this.renderOptionGroup("Logo", "logo", $14b0e53c727d0f3f$var$LOGO_OPTIONS), this.renderOptionGroup("Background mode", "mode", $14b0e53c727d0f3f$var$MODE_OPTIONS), this.renderOptionGroup("Format", "format", $14b0e53c727d0f3f$var$FORMAT_OPTIONS), this.renderOptionGroup("Background color", "background", backgroundOptions), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "flex flex-wrap",
            style: $14b0e53c727d0f3f$var$fieldRowStyle
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
            class: "db mb3 ph2",
            style: $14b0e53c727d0f3f$var$halfFieldStyle
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "fw6 mb2"
        }, "Width (px)"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
            class: "input-reset ba b--black-20 br2 pa2 w-100",
            inputMode: "numeric",
            min: "1",
            type: "number",
            value: width,
            onInput: (event)=>this.updateField("width", event.target.value)
        })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
            class: "db mb3 ph2",
            style: $14b0e53c727d0f3f$var$halfFieldStyle
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "fw6 mb2"
        }, "Height (px)"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
            class: "input-reset ba b--black-20 br2 pa2 w-100",
            inputMode: "numeric",
            min: "1",
            placeholder: "auto",
            type: "number",
            value: height,
            onInput: (event)=>this.updateField("height", event.target.value)
        }))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
            class: "db mb3"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "fw6 mb2"
        }, "Minimum margin (px)"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
            class: "input-reset ba b--black-20 br2 pa2 w-100",
            inputMode: "numeric",
            min: "0",
            type: "number",
            value: margin,
            onInput: (event)=>this.updateField("margin", event.target.value)
        })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "pa3 br2 ba b--black-10 bg-white mb3"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "fw6 mb2"
        }, "Output"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "mb1"
        }, "Final size: ", renderState.width, " x ", renderState.height), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "mb1"
        }, "Background: ", background), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "truncate"
        }, "Filename: ", renderState.filename), format === "jpg" && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "mt2 f6 mid-gray"
        }, "JPG exports always use an opaque background.")), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Button), {
            disabled: isDownloading,
            onClick: ()=>this.handleDownload(),
            type: "button"
        }, isDownloading ? "Preparing Download..." : "Download Logo"), error && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
            class: "dark-red mt3 mb0"
        }, error)), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "flex-auto",
            style: $14b0e53c727d0f3f$var$columnStyle
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
            class: "mt0 mb2"
        }, "Preview", " ", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "f5 fw2 karla"
        }, "(scroll side-to-side if needed)")), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            style: $14b0e53c727d0f3f$var$previewViewportStyle
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "ba b--black-10 br3 overflow-hidden flex items-center justify-center",
            style: background === "transparent" ? {
                ...$14b0e53c727d0f3f$var$checkerboardBackground,
                ...previewFrameStyle
            } : previewFrameStyle
        }, previewUrl && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            alt: "Generated logo preview",
            class: "db",
            height: renderState.height,
            src: previewUrl,
            style: $14b0e53c727d0f3f$var$previewImageStyle,
            width: renderState.width
        }))))), !isLoading && !renderState && !error && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Pick a logo option to begin."), !isLoading && error && !renderState && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
            class: "dark-red mb0"
        }, error)));
    }
}


(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $14b0e53c727d0f3f$export$b17936400621def7), null), document.getElementById("logoApp"));





var $8dabddc7c017326a$export$2e2bcd8739ae039 = [
    {
        details: {
            firstName: "Xchart",
            lastName: "Support",
            name: "Xchart Support"
        },
        apiId: "support"
    },
    {
        details: {
            firstName: "Henrik",
            lastName: "Joreteg"
        },
        apiId: "henrik"
    },
    {
        details: {
            firstName: "Travis",
            lastName: "Coulter"
        },
        apiId: "travis"
    },
    {
        details: {
            firstName: "Miranda",
            lastName: "Moquist"
        },
        apiId: "miranda"
    }
];


const $11da8c29d95d962d$var$sizeFields = [
    {
        name: "size",
        label: "Size (in pixels)",
        type: "decimal",
        onInput: true,
        maxLenBefore: 4,
        maxLenAfter: 0
    }
];
const $11da8c29d95d962d$var$fields = [
    {
        name: "data",
        label: "The url/data to embed",
        onInput: true
    },
    {
        name: "format",
        label: "Image format",
        choices: [
            (0, $1dcfb6b13a3657f8$exports.choice)("png", "png", $11da8c29d95d962d$var$sizeFields),
            (0, $1dcfb6b13a3657f8$exports.choice)("jpg", "jpg", $11da8c29d95d962d$var$sizeFields),
            (0, $1dcfb6b13a3657f8$exports.choice)("svg")
        ]
    },
    {
        name: "logo",
        label: "Include Logo",
        choices: [
            (0, $1dcfb6b13a3657f8$exports.choice)("Yes", true),
            (0, $1dcfb6b13a3657f8$exports.choice)("No", false)
        ]
    }
];
// const getVCardUrl = id => `http://localhost:3002/vcard/${id}`
const $11da8c29d95d962d$var$getVCardUrl = (id)=>`https://api.xchart.com/vcard/${id}`;
const $11da8c29d95d962d$var$fetchVCard = (id)=>fetch($11da8c29d95d962d$var$getVCardUrl(id)).then((res)=>res.text());
class $11da8c29d95d962d$export$2491b8aa5098e13f extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.state = {
            data: "https://xchart.com",
            format: "svg",
            size: "400",
            logo: true,
            vcards: []
        };
    }
    componentDidMount() {
        Promise.all((0, $8dabddc7c017326a$export$2e2bcd8739ae039).map(({ apiId: apiId })=>$11da8c29d95d962d$var$fetchVCard(apiId))).then((contactResults)=>{
            this.setState({
                vcards: contactResults
            });
        });
    }
    render() {
        const { data: data, size: size, format: format, logo: logo, vcards: vcards } = this.state;
        const processedFields = (0, $1dcfb6b13a3657f8$exports.buildQuestionList)($11da8c29d95d962d$var$fields, this.state, {});
        let url;
        if (!data) url = null;
        if (data) {
            url = `https://api.xchart.com/fns/qr?data=${encodeURIComponent(data)}`;
            if (format !== "svg") {
                url += `&format=${format}`;
                url += size ? `&size=${size}` : "";
            }
            if (!logo) url += `&addLogo=false`;
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "bg-white dark-blue flex justify-center"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "w-100 mw7 ph2 tl"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
            class: "f2"
        }, "QR Generator"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, processedFields.map((item)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Question), {
                key: item.name,
                updateValue: (val)=>{
                    this.setState({
                        [item.name]: val
                    });
                },
                item: item
            }))), url && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "pv2"
        }, "URL: ", url), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "flex items-center"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Button), {
            className: "mr2 nowrap",
            onClick: (e)=>{
                e.preventDefault();
                e.stopImmediatePropagation();
                location = url + "&download=true";
            },
            type: "button"
        }, "Download Image"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.CopyButton), {
            buttonText: "Copy URL To Clipboard",
            className: "nowrap",
            text: url
        }))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "mv3"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", null, "Preview:"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            className: "shadow-2",
            src: url,
            height: size || 200,
            width: size || 200
        }))))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "bg-white dark-blue flex justify-center"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "w-100 mw7 ph2 tl"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
            class: "f2"
        }, "Contacts"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Scannable Contact Cards"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "flex items-center flex-wrap justify-between gap3"
        }, (0, $8dabddc7c017326a$export$2e2bcd8739ae039).map(({ apiId: apiId, details: details }, index)=>{
            const vcard = vcards[index];
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                key: apiId
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
                className: "mb3"
            }, details.name || `${details.firstName} ${details.lastName}`), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                className: "mb3"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
                href: $11da8c29d95d962d$var$getVCardUrl(apiId),
                download: true
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.IconButton), {
                icon: "download"
            }, "Download Contact Card"))), vcard && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
                src: `https://api.xchart.com/fns/qr?data=${encodeURIComponent(vcard)}`,
                width: "350"
            }));
        })))));
    }
}


(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $11da8c29d95d962d$export$2491b8aa5098e13f), null), document.getElementById("app"));





const $0967e84fdcf791dc$var$fields = [
    {
        name: "urlToWrite",
        label: "The url/data to encode",
        onInput: true
    }
];
class $0967e84fdcf791dc$export$63e297f492d8bb78 extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.scanClick = this.scanClick.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.writeClick = this.writeClick.bind(this);
        this.state = {
            urlToWrite: "https://xchart.com/business-card",
            messages: [],
            mode: "idle"
        };
        this.abortController = null; // Tracks abort controller
    }
    log(message) {
        const newMessages = [
            ...this.state.messages,
            message
        ];
        if (newMessages.length > 10) newMessages.shift();
        this.setState({
            messages: newMessages
        });
    }
    initReader() {
        if (!this.ndef) this.ndef = new window.NDEFReader();
        return this.ndef;
    }
    async scanClick() {
        try {
            const ndef = this.initReader();
            this.abortController = new AbortController(); // New controller
            this.setState({
                mode: "reading"
            });
            await ndef.scan({
                signal: this.abortController.signal
            });
            this.log("> Scan started");
            ndef.addEventListener("readingerror", ()=>{
                this.log("Argh! Cannot read data from the NFC tag. Try another one?");
            });
            ndef.addEventListener("reading", ({ message: message, serialNumber: serialNumber })=>{
                this.log(`> Serial Number: ${serialNumber}`);
                if (message.records.length === 0) {
                    this.log("> No records found on the tag");
                    return;
                }
                message.records.forEach((record, index)=>{
                    let decodedData = "";
                    if (record.data instanceof DataView) {
                        const uint8Array = new Uint8Array(record.data.buffer);
                        decodedData = new TextDecoder().decode(uint8Array);
                    } else if (typeof record.data === "string") decodedData = record.data;
                    else decodedData = `[Unsupported data format]`;
                    this.log(`> Record ${index + 1}: Type: ${record.recordType}, Data: ${decodedData}`);
                });
            });
        } catch (error) {
            if (error.name === "AbortError") this.log("> Scan cancelled");
            else this.log("Argh! " + error);
            this.setState({
                mode: "idle"
            });
        }
    }
    async writeClick() {
        this.log("User clicked write button");
        this.abortController = new AbortController(); // New controller for writing
        this.setState({
            mode: "writing"
        });
        const urlToWrite = this.state.urlToWrite;
        try {
            const ndef = this.initReader();
            await ndef.write({
                records: [
                    {
                        recordType: "url",
                        data: urlToWrite
                    }
                ]
            }, {
                signal: this.abortController.signal
            } // Pass AbortSignal
            );
            this.log("> Wrote " + urlToWrite);
        } catch (error) {
            if (error.name === "AbortError") this.log("> Write cancelled");
            else this.log("Argh! " + error);
        } finally{
            this.setState({
                mode: "idle"
            });
        }
    }
    cancelClick() {
        if (this.abortController) {
            this.abortController.abort(); // Cancel scan or write
            this.abortController = null;
            this.setState({
                mode: "idle"
            });
            this.log("> Operation cancelled");
        } else this.log("No active operation to cancel");
    }
    render() {
        const processedFields = (0, $1dcfb6b13a3657f8$exports.buildQuestionList)($0967e84fdcf791dc$var$fields, this.state, {});
        const { messages: messages, mode: mode } = this.state;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "bg-white dark-blue flex justify-center"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "w-100 mw7 ph2 tl"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
            class: "f2"
        }, "NFC Writer / Reader"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, processedFields.map((item)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Question), {
                key: item.name,
                updateValue: (val)=>{
                    this.setState({
                        [item.name]: val
                    });
                },
                item: item
            }))), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "mv2 flex items-center gap3"
        }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Button), {
            large: true,
            onClick: this.scanClick,
            disabled: mode !== "idle"
        }, "Scan"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Button), {
            large: true,
            onClick: this.writeClick,
            disabled: mode !== "idle"
        }, "Write"), mode !== "idle" && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1dcfb6b13a3657f8$exports.Button), {
            large: true,
            onClick: this.cancelClick
        }, "Cancel")), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, "Messages"), messages.map((message, i)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                key: i
            }, message)))));
    }
}


(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $0967e84fdcf791dc$export$63e297f492d8bb78), null), document.getElementById("nfcApp"));




//# sourceMappingURL=index.5ae63db8.js.map
